(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
      'ui.router', 'ngMaterial', 'webStorageModule',  'angularUtils.directives.dirPagination', 'angular.filter',
      'darthwade.dwLoading', 'infinite-scroll', 'ngFileUpload', 'ui.select', 'ngMaterialSidemenu', 'rzSlider']);
})();

/**
 * Created by gomahesh on 2017-05-17.
 */
/**
 * Created by GGowda on 3/15/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ProfileInterestInfoController', ProfileInterestInfoController);

  /** @ngInject */
  function ProfileInterestInfoController($scope, shopService, $mdDialog, $loading, INTEREST_TYPE, profileService,
                                         $state, dateFilter, $window, IMAGE_URL, utilService) {
    /* jshint validthis: true */
    var vm = this;
    vm.updateProfileInterest = updateProfileInterest;
    vm.changePath = changePath;
    vm.shareProfile = shareProfile;
    vm.updateInterestStatusMsg = updateInterestStatusMsg;
    vm.declineInterest = declineInterest;
    vm.showInterestAcceptConfirm = showInterestAcceptConfirm;
    vm.searchInterestByMatrimonyId = searchInterestByMatrimonyId;
    vm.clearSearchInterestByMatrimonyId = clearSearchInterestByMatrimonyId;
    vm.fromMatrimonyId = '';
    vm.toMatrimonyId = '';

    var ProfileInterest = function() {
      vm.profileInterests = [];
      vm.totalProfileInterests = 0;
      vm.busy = false;
      vm.pageNo = 0;
      vm.pageSize = 4;
    };


    (function getProfileInterestTemplate() {
      return profileService.getProfileInterestTemplate().then(function(response) {
        vm.profileInterestTemplate = response.data;
      })
    })();

    function updateInterestStatusMsg(profileInterestId, interestStatus) {
      $loading.start('updatingInterest');
      profileService.updateProfileInterestOfReasonMsg(profileInterestId, interestStatus).then(function(response) {
        // var index =  _.findIndex(vm.profileInterests, function(o) { return o.id == profileInterestId });
        //   vm.profileInterests[index] = response.data;
        $loading.finish('updatingInterest');
      }, function() {
        $loading.finish('updatingInterest');
      })
    }

    function updateProfileInterest(interestStatus, profileInterest, fromMatrimonyId, toMatrimonyId,
        fromShopId, toShopId) {
      $loading.start('updatingInterest');
      interestStatus.fromMatrimonyId = fromMatrimonyId;
      interestStatus.toMatrimonyId = toMatrimonyId;
      if(fromShopId) {
        interestStatus.fromShopId = fromShopId;
      }

      if(toShopId) {
        interestStatus.fromShopId = fromShopId;
      }


      profileService.changeProfileInterestStatus(profileInterest.id, fromMatrimonyId, toMatrimonyId,
        interestStatus).then(function(response) {
        var index =  _.findIndex(vm.profileInterests, function(o) { return o.id == profileInterest.id; });
        vm.profileInterests[index] = response.data;
        $loading.finish('updatingInterest');
      }, function() {
        $loading.finish('updatingInterest');
      });
    }

    function getProfileInterestForShopUser() {
      $loading.start('shopDashBoardInterests');
      return profileService.getProfileInterestByProfileId($scope.main.currentSession.profileBasicInfo.id, vm.pageNo,
        vm.pageSize, INTEREST_TYPE.PROFILE_INTEREST)
        .then(function(response) {
          vm.profileInterests.push(response.data.results);
          vm.profileInterests = _.flatten(vm.profileInterests);
          vm.busy = false;
          vm.lastPage = vm.profileInterests.length == response.data.totalElements ? true : false;
          vm.pageNo++;
          $loading.finish('shopDashBoardInterests');
        });

    }


    function clearSearchInterestByMatrimonyId() {
      vm.pageNo = 0;
      vm.profileInterests.length = 0;
      vm.fromMatrimonyId = '';
      vm.toMatrimonyId = '';
      getProfileInterestForShop();
    }

    function searchInterestByMatrimonyId() {
      console.log("Hello");
      if(vm.fromMatrimonyId == '' &&  vm.toMatrimonyId == '') {
        alert('Please enter from matrimony id or to matrimony id');
        return;
      } 
      vm.pageNo = 0;
      vm.profileInterests.length = 0;
      getProfileInterestForShop();
    }

    function getProfileInterestForShop() {
      $loading.start('shopDashBoardInterests');
      return shopService.findProfileInterestByShopId($scope.main.currentSession.shop.id, vm.pageNo,
        vm.pageSize, INTEREST_TYPE.PROFILE_INTEREST, vm.fromMatrimonyId, vm.toMatrimonyId).then(function(response) {
        vm.profileInterests.push(response.data.results);
        vm.profileInterests = _.flatten(vm.profileInterests);
        vm.busy = false;
        vm.lastPage = vm.profileInterests.length == response.data.totalElements ? true : false;
        vm.pageNo++;
        $loading.finish('shopDashBoardInterests');
      });
    }

    ProfileInterest.prototype.nextPage = function() {
      if (vm.busy) return;
      if(vm.lastPage) return;
      vm.busy = true;

      if($scope.main.currentSession.roles.includes("ROLE_ADMIN") || $scope.main.currentSession.roles.includes("ROLE_EMPLOYEE")) {
        getProfileInterestForShop();
      } else if($scope.main.currentSession.roles.includes("ROLE_USER")) {
        getProfileInterestForShopUser();
      }


    };
    $scope.profileInterest = new ProfileInterest();

    $scope.showProfile = function(ev, shopId, matrimonyId) {
      $scope.shopId = shopId;
      $scope.matrimonyId = matrimonyId;
      $scope.isInterestInfo = true;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: 'profile.tmpl.html',
        targetEvent: ev,
        clickOutsideToClose:true,
        scope: $scope,        // use parent scope in template
        preserveScope: true
      });
    };

    $scope.showShop = function(ev, shopId) {
      $scope.shopId = shopId;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: 'shop.tmpl.html',
        targetEvent: ev,
        clickOutsideToClose:true,
        scope: $scope,        // use parent scope in template
        preserveScope: true
      });
    };

    function shareProfile(p, ev) {
      utilService._shareWhatsApImage(p, $scope.main.currentSession.shop, ev);
    }

    function changePath(stateName, profileName, matrimonyId, param) {
      $state.go(stateName, param);
    }

    function showInterestAcceptConfirm(ev, status, profileInterest, fromMatrimonyId, toMatrimonyId) {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm()
            .title('Would you like to Accept Interest Behalf Of Interest Receiver?')
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Confirm!')
            .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        updateProfileInterest(status, profileInterest, fromMatrimonyId, toMatrimonyId);

      }, function() {
      });
    };

    function declineInterest(ev, status, profileInterest, fromMatrimonyId, toMatrimonyId, fromShopId, toShopId) {
      showDeclineInterestDialog(ev, status, profileInterest, 'decline-interest.tmpl.html', fromMatrimonyId, toMatrimonyId,
      fromShopId, toShopId)
    }
    function showDeclineInterestDialog($event, status, profileInterest, dialogView, fromMatrimonyId, toMatrimonyId,
        fromShopId, toShopId)  {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        targetEvent: $event,
        templateUrl: dialogView,
        locals: {
          status : status,
          fromMatrimonyId : fromMatrimonyId,
          profileInterest : profileInterest,
          toMatrimonyId : toMatrimonyId,
          fromShopId : fromShopId,
          toShopId : toShopId
        },
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        controller: DialogController,
        controllerAs: 'dc',
        clickOutsideToClose: true
      });

      function DialogController($scope, $mdDialog, status, fromMatrimonyId, toMatrimonyId, profileInterest,
        fromShopId, toShopId) {

        $scope.closeDialog = function() {
          $mdDialog.hide();
        };

        $scope.declineInterest = function(declineReason) {
          if (!this.declineInterestForm.$valid) {
            return;
          }
          status.msg = declineReason;
          $scope.piic.updateProfileInterest(status, profileInterest, fromMatrimonyId, toMatrimonyId, fromShopId, toShopId);
          $mdDialog.hide();
        }
      }
    }
  }
})();

/**
 * Created by gomahesh on 2017-05-18.
 */
/**
 * Created by GGowda on 3/15/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('MobileNoInfoController', MobileNoInfoController);

  /** @ngInject */
  function MobileNoInfoController($scope, shopService, $loading, INTEREST_TYPE, profileService, $mdDialog ) {
    /* jshint validthis: true */
    var vm = this;
    vm.updateMobileNoInfo = updateMobileNoInfo;
    //vm.getMobileNo = getMobileNo;

    (function getProfileInterestTemplate() {
      return profileService.getProfileInterestTemplate().then(function(response) {
        vm.profileInterestTemplate = response.data;
      })
    })();

    var MobileNoInfo = function() {
      vm.busy = false;
      vm.totalMobileNoInfoInterests = 0;
      vm.pageNo = 0;
      vm.pageSize = 4;
      vm.mobileNoInfoInterests = [];
    };

    function getMobileNoRequestForShopEmp() {
      shopService.findMobileNoRequestByShopId($scope.main.currentSession.shop.id, vm.pageNo,
        vm.pageSize, INTEREST_TYPE.MOBILE_NO_INFO).then(function(response) {
        vm.mobileNoInfoInterests.push(response.data.results);
        vm.mobileNoInfoInterests = _.flatten(vm.mobileNoInfoInterests);
        vm.busy = false;
        vm.lastPage = vm.mobileNoInfoInterests.length == response.data.totalElements ? true : false;
        vm.pageNo++;
        $loading.finish('mobileNoInfoInterests');
      });
    }

    function getMobileNoRequestForShopUser() {
      shopService.findMobileNoRequestByProfileId($scope.main.currentSession.profileBasicInfo.id, vm.pageNo,
        vm.pageSize, INTEREST_TYPE.MOBILE_NO_INFO).then(function(response) {
        vm.mobileNoInfoInterests.push(response.data.results);
        vm.mobileNoInfoInterests = _.flatten(vm.mobileNoInfoInterests);
        vm.busy = false;
        vm.lastPage = vm.mobileNoInfoInterests.length == response.data.totalElements ? true : false;
        vm.pageNo++;
        $loading.finish('mobileNoInfoInterests');
      });
    }

    MobileNoInfo.prototype.nextPage = function() {
      if (vm.busy) return;
      if(vm.lastPage) return;
      vm.busy = true;
      $loading.start('mobileNoInfoInterests');

      if(($scope.main.currentSession.roles.includes('ROLE_ADMIN') || $scope.main.currentSession.roles.includes('ROLE_EMPLOYEE')) ) {
        getMobileNoRequestForShopEmp();
      } else if($scope.main.currentSession.roles.includes('ROLE_USER')) {
        getMobileNoRequestForShopUser();
      }
    };
    $scope.mobileNoInfo = new MobileNoInfo();

    function updateMobileNoInfo(interestStatus, mobileNoRequest) {
      interestStatus.fromMatrimonyId = mobileNoRequest.fromProfile.matrimonyId;
      interestStatus.toMatrimonyId = mobileNoRequest.toProfile.matrimonyId;
      mobileNoRequest.mobileNoRequestStatus.push(interestStatus);

      profileService.updateProfileInterestToKnowContactNo(mobileNoRequest).then(function(response) {
        var index =  _.findIndex(vm.mobileNoInfoInterests, function(o) { return o.id == mobileNoRequest.id; });
        vm.mobileNoInfoInterests[index] = response.data;
      });
    }

    $scope.showProfile = function(ev, shopId, matrimonyId) {
      $scope.shopId = shopId;
      $scope.matrimonyId = matrimonyId;
      $scope.isInterestInfo = true;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: 'profile.tmpl.html',
        targetEvent: ev,
        clickOutsideToClose:true,
        scope: $scope,        // use parent scope in template
        preserveScope: true
      });
    };

    $scope.showShop = function(ev, shopId) {
      $scope.shopId = shopId;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: 'shop.tmpl.html',
        targetEvent: ev,
        clickOutsideToClose:true,
        scope: $scope,        // use parent scope in template
        preserveScope: true
      });
    };

  }
})();

/**
 * Created by GGowda on 3/15/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('KnowMoreInfoController', KnowMoreInfoController);

  /** @ngInject */
  function KnowMoreInfoController($scope, shopService, $loading, INTEREST_TYPE, profileService) {
    /* jshint validthis: true */
    var vm = this;
    vm.updateKnowMoreInfo = updateKnowMoreInfo;

    (function getProfileInterestTemplate() {
      return profileService.getProfileInterestTemplate().then(function(response) {
        vm.profileInterestTemplate = response.data;
      })
    })()

    var KnowMoreInfo = function() {
      vm.busy = false;
      vm.totalKnowMoreInfoInterests = 0;
      vm.pageNo = 1;
      vm.pageSize = 4;
      vm.knowMoreInfoInterests = [];
    };

    KnowMoreInfo.prototype.nextPage = function() {
      if (vm.busy) return;
      vm.busy = true;

      var totalKnowMoreInfoLength = vm.knowMoreInfoInterests.length;
      if (vm.totalKnowMoreInfoInterests == 0 || vm.totalKnowMoreInfoInterests > totalKnowMoreInfoLength) {
        $loading.start('knowMoreInfoInterests');

        return shopService.findProfileInterestByShopId($scope.main.currentSession.shop.id, vm.pageNo,
          vm.pageSize, INTEREST_TYPE.KNOW_MORE_INFO).then(function(response) {
          vm.knowMoreInfoInterests = response.data.results;
          vm.totalKnowMoreInfoInterests = response.data.totalElements;

          vm.busy = false;
          vm.pageNo++;
          $loading.finish('knowMoreInfoInterests');
        });
      }
    };
    $scope.knowMoreInfo = new KnowMoreInfo();

    function updateKnowMoreInfo(interestStatus, profileInterest) {
      profileInterest.moreInfoRequestStatus.push(interestStatus);

      profileService.updateProfileInterestToKnowMoreInfo(profileInterest).then(function(response) {
       var index =  _.findIndex(vm.knowMoreInfoInterests, function(o) { return o.id == profileInterest.id; });
        vm.knowMoreInfoInterests[index] = response.data;
      });
    }

  }
})();

(function() {
    'use strict';
  
    angular.module('anchePedheMatrimony').controller('contactNoIssueController', contactNoIssueController);
  
    /** @ngInject */
    function contactNoIssueController($scope, shopService, $loading, profileService, $mdDialog ) {
      /* jshint validthis: true */
      var vm = this;
      vm.changeContactNoIssueStatus = changeContactNoIssueStatus;

      (function getProfileInterestTemplate() {
        return profileService.getProfileInterestTemplate().then(function(response) {
          vm.profileInterestTemplate = response.data;
        })
      })();

      var ContactNoIssueInfo = function() {
        vm.busy = false;
        vm.totalContactNoIssue = 0;
        vm.pageNo = 0;
        vm.pageSize = 4;
        vm.contactNoIssues = [];
      };

      function getContactNoIssueForShopEmp() {
        shopService.getContactNoIssueByShopId($scope.main.currentSession.shop.id, vm.pageNo,
          vm.pageSize).then(function(response) {
          vm.contactNoIssues.push(response.data.content);
          vm.contactNoIssues = _.flatten(vm.contactNoIssues);
          vm.busy = false;
          vm.lastPage = vm.contactNoIssues.length == response.data.totalElements ? true : false;
          vm.pageNo++;
          $loading.finish('contactNoIssues');
        });
      }

      function getContactNoIssueForShopUser() {
        profileService.getContactNoIssueByMatrimonyId($scope.main.currentSession.profileBasicInfo.matrimonyId, vm.pageNo,
          vm.pageSize).then(function(response) {
          vm.contactNoIssues.push(response.data.content);
          vm.contactNoIssues = _.flatten(vm.contactNoIssues);
          vm.busy = false;
          vm.lastPage = vm.contactNoIssues.length == response.data.totalElements ? true : false;
          vm.pageNo++;
          $loading.finish('contactNoIssues');
        });
      }


      ContactNoIssueInfo.prototype.nextPage = function() {
        if (vm.busy) return;
        if(vm.lastPage) return;
        vm.busy = true;
        $loading.start('contactNoIssues');
  
        if(($scope.main.currentSession.roles.includes('ROLE_ADMIN') || $scope.main.currentSession.roles.includes('ROLE_EMPLOYEE')) &&
        $scope.main.currentSession.permissions.includes('CONTACTNO_ISSUE')) {
          getContactNoIssueForShopEmp();
        } else if($scope.main.currentSession.roles.includes('ROLE_USER')) {
          getContactNoIssueForShopUser();
        }
      };
      $scope.contactNoIssueInfo = new ContactNoIssueInfo();

      function changeContactNoIssueStatus(ev, data) {
        changeContactNoIssueStatusDialog(ev, 'contact-no-issue-status-change.tmpl.html', data)
      }

      function changeContactNoIssueStatusDialog($event, dialogView, data)  {
        var parentEl = angular.element(document.body);
        $mdDialog.show({
          parent: parentEl,
          targetEvent: $event,
          templateUrl: dialogView,
          locals: {
            data : data
          },
          scope: $scope,        // use parent scope in template
          preserveScope: true,
          controller: DialogController,
          controllerAs: 'dc',
          clickOutsideToClose: true
        });

        function DialogController($scope, $mdDialog, shopService, data) {

          $scope.closeDialog = function() {
            $mdDialog.hide();
          };

          $scope.updateContactNumberIssue = function(status, msg) {
            if (!this.reportIssueForm.$valid) {
              return;
            }

            data.issueStatus = status;
            data.msg = msg;

            shopService.updateContactNumberIssue(data).then(function(res) {
              var index =  _.findIndex($scope.cnisc.contactNoIssues, function(o) { return o.id == data.id; });
              $scope.cnisc.contactNoIssues[index] = res.data;
              $mdDialog.hide();
            })
          }
        }
      }
    }
})();
(function() {
  'use strict';

  angular
      .module('anchePedheMatrimony')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .directive('validateEmail', validateEmail);

  /** @ngInject */
  function validateEmail() {
    var directive = {
      restrict: 'E',
      require: '?ngmodel',
      link: validateEmailFn
    };

    return directive;

    /** @ngInject */
    function validateEmailFn(scope, elm, attrs, ctrl) {
      if (ctrl && ctrl.$validators.email) {

        // this will overwrite the default Angular email validator
        ctrl.$validators.email = function(val) {
          /*return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);*/
          /*scope.elmt = document.activeElement.name;*/
          if (val == undefined || val == "") {
            return true;
          }
          if(!val.match(/\S+@\S+\.\S+/)){ // Jaymon's / Squirtle's solution
            // Do something
            return false;
          }
          if( val.indexOf(' ')!=-1 || val.indexOf('..')!=-1){
            // Do something
            return false;
          }
          return true;
        };
      }
    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .directive('numbersOnly', numbersOnly);

  /** @ngInject */
  function numbersOnly() {
    var directive = {
      require: 'ngModel',
      link: numbersOnlyFn
    };

    return directive;

    /** @ngInject */
    function numbersOnlyFn(scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9]/g, '');

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }
      ngModelCtrl.$parsers.push(fromUser);
    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .directive('lowerThan', lowerThan);

  /** @ngInject */
  function lowerThan() {
    var directive = {
      require: 'ngModel',
      link: lowerThanFn
    };

    return directive;

    /** @ngInject */
    function lowerThanFn($scope, $element, $attrs, ctrl) {
      var validate = function(viewValue) {
        var comparisonModel = $attrs.lowerThan;

        if(!viewValue || !comparisonModel){
          // It's valid because we have nothing to compare against
          ctrl.$setValidity('lowerThan', true);
        }

        // It's valid if model is lower than the model we're comparing against
        ctrl.$setValidity('lowerThan', parseInt(viewValue, 10) <= parseInt(comparisonModel, 10) );
        return viewValue;
      };

      ctrl.$parsers.unshift(validate);
      ctrl.$formatters.push(validate);

      $attrs.$observe('lowerThan', function(){
        return validate(ctrl.$viewValue);
      });

    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .directive('apiValidate', apiValidate);

  /** @ngInject */
  function apiValidate($compile) {
    var directive = {
      restrict: 'E',
      require: '?ngmodel',
      link: ApiValidateLinkFn
    };

    return directive;

    /** @ngInject */
    function ApiValidateLinkFn(scope, elm) {
      var template = '<div class="error" ng-show="errorStatus || errorDetails">' +
        '<label ng-show="errorStatus">{{errorStatus}}</label>' +
        '<div ng-hide="errorStatus" ng-repeat="error in errorDetails">' +
        '{{error.code}}' +
        '</div></div>';

      elm.html('').append($compile(template)(scope));
    }
  }

})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('utilService', utilService);

  function utilService(profileService, $mdDialog, IMAGE_URL, dateFilter) {
    const heightArr =[
      {
        "id": "5063114bd386d8fadbd6b000",
        "value": "4 Ft 5 In",
        "category": 134
        },
        {
        "id": "5063114bd386d8fadbd6b001",
        "value": "4 Ft 6 In",
        "category": 135
        },
        {
        "id": "5063114bd386d8fadbd6b002",
        "value": "4 Ft 7 In",
        "category": 136
        },
        {
        "id": "5063114bd386d8fadbd6b003",
        "value": "4 Ft 8 In",
        "category": 137
        },
        {
        "id": "5063114bd386d8fadbd6b004",
        "value": "4 Ft 9 In",
        "category": 138
        },
        {
        "id": "5063114bd386d8fadbd6b005",
        "value": "4 Ft 10 In",
        "category": 139
        },
        {
        "id": "5063114bd386d8fadbd6b006",
        "value": "4 Ft 11 In",
        "category": 140
        },
        {
        "id": "5063114bd386d8fadbd6b007",
        "value": "5Ft",
        "category": 141
        },
        {
        "id": "5063114bd386d8fadbd6b008",
        "value": "5 Ft 1 In",
        "category": 142
        },
        {
        "id": "5063114bd386d8fadbd6b009",
        "value": "5 Ft 2 In",
        "category": 143
        },
        {
        "id": "5063114bd386d8fadbd6b010",
        "value": "5 Ft 3 In",
        "category": 144
        },
        {
        "id": "5063114bd386d8fadbd6b011",
        "value": "5 Ft 4 In",
        "category": 145
        },
        {
        "id": "5063114bd386d8fadbd6b012",
        "value": "5 Ft 5 In",
        "category": 146
        },
        {
        "id": "5063114bd386d8fadbd6b013",
        "value": "5 Ft 6 In",
        "category": 147
        },
        {
        "id": "5063114bd386d8fadbd6b014",
        "value": "5 Ft 7 In",
        "category": 148
        },
        {
        "id": "5063114bd386d8fadbd6b015",
        "value": "5 Ft 8 In",
        "category": 149
        },
        {
        "id": "5063114bd386d8fadbd6b016",
        "value": "5 Ft 9 In",
        "category": 150
        },
        {
        "id": "5063114bd386d8fadbd6b018",
        "value": "5 Ft 10 In",
        "category": 151
        },
        {
        "id": "5063114bd386d8fadbd6b019",
        "value": "5 Ft 11 In",
        "category": 152
        },
        {
        "id": "5063114bd386d8fadbd6b020",
        "value": "6Ft",
        "category": 153
        },
        {
        "id": "5063114bd386d8fadbd6b021",
        "value": "6 Ft 1 In",
        "category": 154
        },
        {
        "id": "5063114bd386d8fadbd6b022",
        "value": "6 Ft 2 In",
        "category": 155
        },
        {
        "id": "5063114bd386d8fadbd6b023",
        "value": "6 Ft 3 In",
        "category": 156
        },
        {
        "id": "5063114bd386d8fadbd6b024",
        "value": "6 Ft 4 In",
        "category": 157
        },
        {
        "id": "5063114bd386d8fadbd6b025",
        "value": "6 Ft 5 In",
        "category": 158
        },
        {
        "id": "5063114bd386d8fadbd6b026",
        "value": "6 Ft 6 In",
        "category": 159
        },
        {
        "id": "5063114bd386d8fadbd6b027",
        "value": "6 Ft 7 In",
        "category": 160
        },
        {
        "id": "5063114bd386d8fadbd6b028",
        "value": "6 Ft 8 In",
        "category": 161
        },
        {
        "id": "5063114bd386d8fadbd6b029",
        "value": "6 Ft 9 In",
        "category": 162
        },
        {
        "id": "5063114bd386d8fadbd6b030",
        "value": "6 Ft 10 In",
        "category": 163
        },
        {
        "id": "5063114bd386d8fadbd6b031",
        "value": "6 Ft 11 In",
        "category": 164
        },
        {
        "id": "5063114bd386d8fadbd6b032",
        "value": "7Ft",
        "category": 165
        }
    ];
    var service = {
      _calculateAge: _calculateAge,
      _numDifferentiation: _numDifferentiation,
      _getDateObject: _getDateObject,
      _getTimeObject: _getTimeObject,
      _getDateTime: _getDateTime,
      _getRandomNumber: _getRandomNumber,
      _isRecentProfile: _isRecentProfile,
      _shareWhatsApImage: _shareWhatsApImage,
      _getHeightByCm: _getHeightByCm,
      _setCurrentImage: _setCurrentImage,
      _calculateAgeByYear: _calculateAgeByYear
    };

    return service;

    function _calculateAge(birthday) { // birthday is a date
      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    function _calculateAgeByYear(year, month, day) {
      if(angular.isUndefined(year) || year == null) {return;} else {
        month = (typeof month !== 'undefined') ?  month : new Date().getMonth();
        day = (typeof day !== 'undefined') ?  day : new Date().getDate();
        var date = new Date(year, month, day);
        var ageDifMs = Date.now() - date.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      }
    }

    function _isRecentProfile(profileCreatedOn) { // birthday is a date
      var currentDate = new Date();
      var profileCreatedDate = new Date(profileCreatedOn);
      if(currentDate.getUTCFullYear() == profileCreatedDate.getUTCFullYear()
        &&  currentDate.getUTCMonth() == profileCreatedDate.getUTCMonth()) {
        var days = currentDate.getUTCDate() - profileCreatedDate.getUTCDate();
        return days <= 2;
      }
      return false;

    }

    function  _numDifferentiation(val) {
      if(val >= 10000000) val = (val/10000000).toFixed(2) + ' Cr';
      else if(val >= 100000) val = (val/100000).toFixed(2) + ' Lac';
      else if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
      return val;
    }

    function _getDateObject() {
      var dateObj ={
        "dd":  ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16",
          "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
        "mm": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October",
          "November", "December"],
        "yyyy": ["1950", "1951", "1952", "1953", "1954", "1955", "1956", "1957", "1958", "1959", "1960", "1961", "1962", "1963", "1964", 
          "1965",  "1966", "1967", "1968", "1969",  "1970", "1971", "1972", "1973", "1974", "1975", "1976", "1977", "1978", "1979", "1980", "1981",
          "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994",
          "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"]
      }
      return dateObj;
    }
    function _getTimeObject() {
      var timeObj ={
        "hr": ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
        "min": ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15",
          "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32",
          "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49",
          "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
        "amOrPm": ["AM", "PM"]
      }
      return timeObj;
    }

    function _getDateTime(year, month, day, hours, minutes, seconds) {
      var options = {
        weekday: "long", year: "numeric", month: "short",
        day: "numeric", hour: "2-digit", minute: "2-digit"
      };

      var d = new Date(year, month-1, day, hours, minutes, seconds);
      return d.toLocaleTimeString("en-us", options);
    }

    function _getRandomNumber() {
      return new Date().getTime();
    }

    function _getHeightByCm(val) {
      return heightArr.find(function(height){ if(height.category === val){return height}});
    }

    function _setCurrentImage(i, profile) {
      //vm.curImage = vm.curImage+""+profile.matrimonyId
      profile.cur = i;
      if(i>profile.profileImages.length){
        profile.cur =1;
      } else if(i===0) {
        profile.cur = profile.profileImages.length;
      }
      //vm.className = profile.cur+""+profile.matrimonyId;
      var path = profile.profileImages[profile.cur-1].originalImage.replace(/\/\/+/g, '/');
      if(!path.startsWith('/')) {
        path = '/'+path;
      }
      profile.className = {
        "width": "400px",
        "height": "400px",
        "cursor": "pointer",
        "border-radius": "3px",
        "background" : 'url('+IMAGE_URL+path+') center top / cover no-repeat'
      }
    }

    function getImagePath(orgImagePath) {
      var path = orgImagePath.replace(/\/\/+/g, '/');
      if(!path.startsWith('/')) {
        path = '/'+path;
      }
      return path;
    }

    function _shareWhatsApImage(profile, shop, ev, addMobileno) {
      var parentEl = angular.element(document.body);
      profileService.getWhatsApProfileByMatrimonyId(profile.matrimonyId).then(function (res) {
        profile = res.data;

        $mdDialog.show({
          parent: parentEl,
          targetEvent: ev,
          templateUrl: 'canvas.tmpl.html',
          clickOutsideToClose: true,
          controller: 'PrintController',
          cancel: 'I\'m a cat person'
        })

        var images = [];
        function preloadImages(srcs, imgs, callback) {
          var img;
          var remaining = srcs.length;
          for (var i = 0; i < srcs.length; i++) {
              img = new Image();
              img.crossOrigin = "Anonymous";
              img.onload = function() {
                  --remaining;
                  if (remaining <= 0) {
                      callback();
                  }
              };
              img.src = srcs[i];
              imgs.push(img);
          }
        }
        try {
          var imageSrcs = ["/assets/Scan.jpg",IMAGE_URL + getImagePath(profile.profileImages[0].originalImage)];
          if(profile.horoscopeImage) {
            imageSrcs.push(IMAGE_URL + getImagePath(profile.horoscopeImage.originalImage))
          } else if(profile.profileImages[1] == undefined) {
            imageSrcs.push(IMAGE_URL + getImagePath(profile.profileImages[0].originalImage));
          } else {
            imageSrcs.push(IMAGE_URL + getImagePath(profile.profileImages[1].originalImage));
          }
          if(shop.logoUrl) {
            imageSrcs.push(IMAGE_URL + getImagePath(shop.logoUrl));
          }
          preloadImages(imageSrcs, images, myFunction);
        } catch (error) {
          var imageSrcs = ["/assets/Scan.jpg"];
          preloadImages(imageSrcs, images, myFunction);
        }

        function myFunction() {
          var MAX_HEIGHT = 800;
          var MAX_WIDTH = 1000;

          var canvas = document.querySelector("#myCanvas");
          for(var i=1; i < images.length; i++) {
            if(images[i].height > MAX_HEIGHT && images[i].width > MAX_WIDTH ) {
              images[i].width *= MAX_WIDTH / images[i].width;
              images[i].height = MAX_HEIGHT;
            } else if(images[i].height > MAX_HEIGHT) {
              images[i].width *= MAX_HEIGHT / images[i].height;
              images[i].height = MAX_HEIGHT;
            }else if(images[i].width > MAX_WIDTH) {
              images[i].width *= MAX_WIDTH / images[i].width;
              images[i].height = MAX_HEIGHT;
            } else {
              images[i].width = 500;
              images[i].height = 625;
            }
          }


          var ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, images[0].width, images[0].height);


          canvas.width =  images[0].width;
          canvas.height = images[0].height+100;
          ctx.drawImage(images[0], -60, 0, images[0].width, images[0].height);

          ctx.fillStyle = "#FFFF";
          ctx.fillRect(0, 0, 1700, 220);
          ctx.fillStyle = "#FFBF00";
          ctx.fillRect(200, 40, 1450, 150);
          if(shop.logoUrl) {
            ctx.drawImage(images[images.length-1], 65, 40, 150, 150);
          } else {
            ctx.fillRect(65, 40, 1550, 150);
          }

          ctx.font='800 50px Arial';
          ctx.fillStyle = "#170761";
          ctx.fillText(shop.shopName, 350, 100);
          ctx.fillStyle = "#141314";
          ctx.font = "800 35px Helvetica";
          //ctx.fillRect(0,0,400,32);
          ctx.fillText("Contact No. +91 "+shop.mobileNo, 350, 170);
          ctx.fillText(shop.websiteUrl, 950, 170);
          //ctx.drawImage(images[1], 300, 60, images[0].width, images[0].height);
          var val = 280;
          var xAxis = 650;
          ctx.font = "bold 24px sans-serif";
          ctx.fillStyle = "#194fe3";
          ctx.fillText(profile.profileName, xAxis, val);
          if(profile.mobileNo && addMobileno) {
            var mobileNo = profile.mobileNo;
            for(var i=0; i< profile.familyContactInfo.length; i++) {
              mobileNo += " "+profile.familyContactInfo[i].mobileNo;
            }
            ctx.fillText(mobileNo, xAxis, val+40);
          }
          ctx.fillText(profile.matrimonyId, xAxis, val = val+90);

          if(profile.dontNoDOB) {
            ctx.fillText(_calculateAge(new Date(profile.dob))+" yrs", xAxis, val = val+55);
          } else {
            var birthDate = dateFilter(new Date(profile.dob), "dd MMMM yyyy");
            var res = birthDate.split(/[ ,]+/);
            var dateOfBirth = res[0]+"-"+res[1]+"-"+res[2];
            ctx.fillText(dateOfBirth, xAxis, val = val+55);
          }

          if(profile.birthTime && profile.birthTime.indexOf(undefined) == -1) {
            ctx.fillText(profile.birthTime, xAxis, val = val+45);
            if(profile.birthPlace != null && profile.birthPlace.indexOf(undefined) == -1) {
              ctx.fillText("@ "+profile.birthPlace, xAxis+120, val);
            }
          } else {
            ctx.fillText("", xAxis, val = val+45);
          }


          ctx.fillText(profile.height.value, xAxis, val = val+40);
          ctx.fillText(profile.vegOrNonVeg, xAxis, val = val+45);
          ctx.fillText(profile.motherTongue, xAxis, val = val+45);
          ctx.fillText(profile.martialStatus, xAxis, val = val+45);

          ctx.fillText(profile.caste, xAxis, val = val+55);
          ctx.fillText(profile.subCaste, xAxis, val = val+45);
          ctx.fillText(profile.raasi, xAxis, val = val+45);
          ctx.fillText(profile.star, xAxis, val = val+40);
          ctx.fillText(profile.gothram != null ? profile.gothram : "Not Specified", xAxis, val = val+45);
          ctx.fillText(profile.highestEducation, xAxis, val = val+40);
          ctx.fillText(profile.employedIn+" / "+profile.occupation, xAxis, val = val+45);
          //ctx.fillText(profile.occupation, xAxis, val = val+45);
          ctx.fillText(profile.annualIncome > 0 ? _numDifferentiation(profile.annualIncome) : "Not Specified", xAxis, val = val+155);

          ctx.fillText(profile.fatherName == undefined ? "": profile.fatherName, xAxis, val = val+50);
          ctx.fillText(profile.fatherStatus == null? "": profile.fatherStatus, xAxis, val = val+45);

          ctx.fillText(profile.motherName == undefined ? "": profile.motherName, xAxis, val = val+45);
          ctx.fillText(profile.motherStatus == null? "": profile.motherStatus, xAxis, val = val+45);

          ctx.fillText(profile.familyStatus, xAxis, val = val+45);

          var noOfBrothers = profile.noOfBrothers == null ? "": profile.noOfBrothers == 0 ? 0 : profile.noOfBrothers;
          var noOfBrothersMarried = profile.noOfBrothers == null || profile.brothersMarried == null ? "" : (profile.noOfBrothers == 0 ? "" : (profile.brothersMarried == 0 ? 0 : profile.brothersMarried))
          ctx.fillText(noOfBrothers, xAxis+220, val = val+48);
          ctx.fillText(noOfBrothersMarried, xAxis+462, val);

          var noOfSisters = profile.noOfSisters == null ? "": profile.noOfSisters == 0 ? 0 : profile.noOfSisters;
          var noOfSistersMarried = profile.noOfSisters == null || profile.sistersMarried == null ? "": (profile.noOfSisters == 0 ? "" : (profile.sistersMarried==0 ? 0 : profile.sistersMarried));
          ctx.fillText(noOfSisters, xAxis+220, val = val+37);
          ctx.fillText(noOfSistersMarried, xAxis+462, val);

          var str = "";
          if(profile.propertyDetails != null &&  profile.propertyDetails.length > 0) {
            for(var i=0; i < profile.propertyDetails.length; i++) {
              str = str+ " "+ profile.propertyDetails[i].propertyType;
            }
          }
          ctx.fillText(str, xAxis-570, val = val+70);

          val = val+140;
          if(profile.moreInfoAboutFamily) {
            var temp =val;
            var x = 125;
            var l = profile.moreInfoAboutFamily.length/x;
            var res = [];
            for(var i=0; i< l;i++) {
              res.push(profile.moreInfoAboutFamily.slice(x*i, x*(i+1)));
            }

            for(var i=0; i< res.length; i++) {
              ctx.fillText(res[i], xAxis-565, val);
              val = val+25;
            }
            val = temp;
          }
          ctx.fillText(profile.currentLivingCity, xAxis+360, val = val+190);
          ctx.fillText(profile.currentLivingState, xAxis+570, val);
          ctx.fillText(profile.currentLivingCountry, xAxis+750, val);

          ctx.fillText(profile.familyResidingTaluk != null? profile.familyResidingTaluk: "", xAxis+140, val = val+110);
          ctx.fillText(profile.familyResidingDistrict != null? profile.familyResidingDistrict: "", xAxis+360, val);
          ctx.fillText(profile.familyResidingState != null? profile.familyResidingState: "", xAxis+570, val);

          // if(profile.partnerPreference) {
          //   var str="";
          //   for(var i in profile.partnerPreference) {str+=i+":"+profile.partnerPreference[i]+", ";}
          //   str = str.substring(0, str.length-2);

          //   ctx.fillText(str, xAxis+670, val);
          // }

          if(profile.partnerPreference) {
            val += 100;
            var x = 125;
            var str="";
            for(var i in profile.partnerPreference) {
              if(profile.partnerPreference[i] == null || profile.partnerPreference[i] == ""
              ||  profile.partnerPreference[i] == 0) {
                continue;
              }
              if(i.indexOf('fHeightPref') > -1 || i.indexOf('tHeightPref') > -1) {
                var obj  = heightArr.find(function(o) {
                  return o.category == profile.partnerPreference[i];
                })
                profile.partnerPreference[i] = obj.value;
              }
              str+=i+":"+profile.partnerPreference[i]+", ";
            }
            str = str.replace("fYearPref", "From Year").replace("tYearPref", "To Year")
            .replace("fHeightPref", "From Height").replace("tHeightPref", "To Height").replace("motherTonguePref", "Mother Tongue")
            .replace("highestEducationPref", "Education").replace("occupationPref", "Occupation")
            .replace("annualIncomePreFrom", "Annual Income").replace("castePref", "Caste")
            .replace("subCastePref", "Subcaste").replace("aboutPartner", "About Partner")
            .replace("employedInPref", "Employed In").replace("countryPref", "Country")
            .replace("statePref", "State")
            .replace("cityPref", "Citry").replace("martialStatusPref", "Martial Status")
            .replace("starPref", "Star");
            str = str.substring(0, str.length-2);
            var l = str.length/x;
            var res = [];
            for(var i=0; i< l;i++) {
              res.push(str.slice(x*i, x*(i+1)));
            }

            for(var i=0; i< res.length; i++) {
              ctx.fillText(res[i], xAxis-565, val);
              val += 30;
            }
          }
          try {
            ctx.drawImage(images[1], 1150, 240, images[1].width, images[1].height);

            ctx.drawImage(images[2], 1150, 910, images[2].width, images[2].height);
          } catch (error) {

          }



          var canvasImage = document.getElementById("cImage");
          canvasImage.src = canvas.toDataURL();
        }
      })
    }

  }
})();

(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('PrintController', PrintController);

  /** @ngInject */
  function PrintController($scope, $mdDialog) {
    $scope.print = function(){

      //window.print();
    }
    $scope.closeDialog = function() {
      // Easily hides most recent dialog shown...
      // no specific instance reference is needed.
      $mdDialog.hide();
    };
  }

})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').filter('statusFilter', statusFilter);

  function statusFilter() {
    return function(items, ids){
      var arrayToReturn = [];
      if(items == undefined) {
        return '';
      }
      for (var i=0; i < items.length; i++){
        for (var j=0; j < ids.length; j++) {
          if (items[i].id == ids[j]) {
            arrayToReturn.push(items[i]);
          }
        }
      }

      return arrayToReturn;
    };
  }
})();

(function() {
  'use strict';

  angular.module('anchePedheMatrimony').filter('dateTime', dateTime);

  function dateTime() {
    return function(dateTimeObj) {
      if(dateTimeObj == undefined) {
        return '';
      }

      var options = {
        weekday: "long", year: "numeric", month: "short",
        day: "numeric", hour: "2-digit", minute: "2-digit"
      };

      var d = new Date(dateTimeObj.year, dateTimeObj.monthValue-1, dateTimeObj.dayOfMonth, dateTimeObj.hour,
        dateTimeObj.minute, dateTimeObj.second);

      return d.toLocaleTimeString("en-us", options);
    };
  }
})();
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').filter('propsFilter', propsFilter);

  function propsFilter() {
    return function(items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function(item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').filter('propFilter', propFilter);

  function propFilter() {
    return function(items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function(item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();

/**
 * Created by gomahesh on 8/31/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').directive('format', format);

  function format($filter) {
    return {
      require: '?ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;


        ctrl.$formatters.unshift(function () {
          return $filter(attrs.format)(ctrl.$modelValue)
        });


        ctrl.$parsers.unshift(function (viewValue) {
          var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, '');
          elem.val($filter(attrs.format)(plainNumber));
          return plainNumber;
        });
      }
    };
  }
})();

/**
 * Created by GGowda on 3/18/2016.
 */
(function(global) {
    var AnchePedheMatrimony = function(fName, lName, lang) {
   return new AnchePedheMatrimony.init(fName, lName, lang);
  }

  var supportedLangs = ['en', 'es'],
    greetings = {
      en: 'Hello',
      es: 'Hola'
    },
    formalGreetings = {
      en: 'Greetings',
      es: 'Saludos'
    };

  AnchePedheMatrimony.prototype = {
    fullName: function() {
      return this.fName + ' : ' + this.lName;
    },
    validate: function() {
      if(supportedLangs.indexOf(this.lang) == -1) {
        throw "Invalid Language"
      }
    },
    greeting: function() {
      return greetings[this.lang] + ' ' + this.fName + '!';
    },
    formalGreeting: function() {
      return formalGreetings['en'] + ' , ' + this.fullName();
    },
    greet: function() {
      return this;
    },
    log: function() {
      return this;
    },
    setLang: function(lang) {
      this.lang = lang;
      this.validate();

      return this;
    }
  };

  AnchePedheMatrimony.init = function(fName, lName, lang) {
    var self = this;
    self.fName = fName || "Default";
    self.lName = lName || "Default";
    self.lang = lang || "Default";
  }

  AnchePedheMatrimony.init.prototype = AnchePedheMatrimony.prototype;

  global.AnchePedheMatrimony = global.A$ = AnchePedheMatrimony;

}(window));

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('shopService', shopService);

  shopService.$inject = ['$http', '$q', 'URL', 'sessionManagerService', 'Upload'];

  function shopService($http, $q, URL, sessionManagerService, Upload) {
    var service = {
      createShop: createShop,
      findCurrentMonthShopProfileByShopIdAndProfileStatus: findCurrentMonthShopProfileByShopIdAndProfileStatus,
      findProfileInterestByShopId: findProfileInterestByShopId,
      findMobileNoRequestByShopId: findMobileNoRequestByShopId,
      findMobileNoRequestByProfileId: findMobileNoRequestByProfileId,
      findProfileInterestNotAcceptedByShopId: findProfileInterestNotAcceptedByShopId,
      getShopProfilesByShopIdForShopUser: getShopProfilesByShopIdForShopUser,
      // getShopProfilesByShopIdForShopEmp: getShopProfilesByShopIdForShopEmp,
      getProfileByShopIdAndProfileStatus: getProfileByShopIdAndProfileStatus,
      getNotMatchedProfileInterest: getNotMatchedProfileInterest,
      getLastMonthShopPaymentInfo: getLastMonthShopPaymentInfo,
      getShopPaymentsByShopId: getShopPaymentsByShopId,
      getShopProfileCountByShopId: getShopProfileCountByShopId,
      getCurrentMonthShopProfileCountByShopId: getCurrentMonthShopProfileCountByShopId,
      getShopByShopId: getShopByShopId,
      getShopProfileByShopIdAndProfileStatus: getShopProfileByShopIdAndProfileStatus,
      getCurrentMonthShopPaymentInfo: getCurrentMonthShopPaymentInfo,
      updateShopLastActive: updateShopLastActive,
      getProfileMobileNoByShopIdAndProfileId: getProfileMobileNoByShopIdAndProfileId,
      getShopByMobileNo: getShopByMobileNo,
      getShopByWebsiteUrl: getShopByWebsiteUrl,
      getShopPackagePlanByShopId: getShopPackagePlanByShopId,
      getSuccessStoryByShopId: getSuccessStoryByShopId,
      saveSuccessStory: saveSuccessStory,
      getBureauProfiles: getBureauProfiles,
      getContactNoIssueByShopId: getContactNoIssueByShopId,
      updateContactNumberIssue: updateContactNumberIssue,
      getOffer: getOffer
    };
    return service;

    function getOffer(shopId, data) {
      var deferred = $q.defer();
      $http.post(URL+'/offer/'+shopId, data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }
    function createShop(data) {
      var deferred = $q.defer();
      $http.post(URL+'/create-shop', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopProfilesByShopIdForShopUser(shopId, caste, gender, page, size,
      otherBureauProfile, anchepedheMarriageBureau, otherClientViewYourProfiles) {
      var deferred = $q.defer();
      $http.post(URL+'/profile/for-user?caste='+caste+'&gender='+gender+
      '&page='+page+'&size='+size+'&shopId='+shopId
      +'&otherBureauProfile='+otherBureauProfile+'&anchepedheMarriageBureau='+anchepedheMarriageBureau
      +'&otherClientViewYourProfiles='+otherClientViewYourProfiles, {}).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getBureauProfiles(shopId, page, size, filter, regex, anchepedheMarriageBureau, otherBureauProfile,
        otherClientViewYourProfiles, othrPfVwCtNo, allwOnlyMbPfWhShwCtNo, allBureauProfile) {
      var deferred = $q.defer();
      $http.post(URL+'/profile/for-emp?page='+page+'&size='+size+'&regex='+regex+'&shopId='+shopId
        +'&anchepedheMarriageBureau='+anchepedheMarriageBureau+'&otherBureauProfile='+otherBureauProfile
        +'&otherClientViewYourProfiles='+otherClientViewYourProfiles
        +'&othrPfVwCtNo='+othrPfVwCtNo
        +'&allwOnlyMbPfWhShwCtNo='+allwOnlyMbPfWhShwCtNo+'&allBureauProfile='+allBureauProfile, filter).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    // function getShopProfilesByShopIdForShopEmp(shopId,page, size, filter, regex, otherBureauProfile,
    //     anchepedheBureauProfile, anchepedheMarriageBureau) {
    //   var deferred = $q.defer();
    //   $http.post(URL+'/shop/profile/for-shop-emp?&page='+page+'&size='+size+'&regex='+regex+'&shopId='+shopId
    //     +'&otherBureauProfile='+otherBureauProfile+'&anchepedheBureauProfile='+anchepedheBureauProfile+'&anchepedheMarriageBureau='
    //     +anchepedheMarriageBureau, filter).then(function(result) {
    //       deferred.resolve(result);
    //     }, function() {
    //       deferred.reject();
    //     }
    //   );
    //   return deferred.promise;
    // }

    function getContactNoIssueByShopId(shopId, page, size) {
      var deferred = $q.defer();
      $http.get(URL+'/contactno-issue/shop/'+shopId+'?page='+page+'&size='+size)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function updateContactNumberIssue(data) {
      var deferred = $q.defer();
      $http.put(URL + '/contactno-issue/update', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function findProfileInterestByShopId(shopId, page, size, interestType, fromMatrimonyId, toMatrimonyId) {
      var deferred = $q.defer();
      $http.get(URL+'/profile-interest/shop?shopId='+shopId+'&interestType='+interestType+'&page='+page+'&size='+size+'&fromMatrimonyId='+
        fromMatrimonyId+'&toMatrimonyId='+toMatrimonyId).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function findMobileNoRequestByShopId(shopId, page, size, interestType) {
      var deferred = $q.defer();
      $http.get(URL+'/mobileno-request/shop/'+shopId+'?interestType='+interestType+'&page='+page+'&size='+size).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function findMobileNoRequestByProfileId(profileId, page, size, interestType) {
      var deferred = $q.defer();
      $http.get(URL+'/mobileno-request/profile/'+profileId+'?interestType='+interestType+'&page='+page+'&size='+size).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function findProfileInterestNotAcceptedByShopId(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/profileInterest/shop/'+shopId+'/notAccepted').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getProfileByShopIdAndProfileStatus(profileStatus, shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/profile?profileStatus='+profileStatus).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getNotMatchedProfileInterest() {
      var deferred = $q.defer();
      $http.get(URL+'/profile-interest/not-matched').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getLastMonthShopPaymentInfo(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/last-month-payment-info').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function updateShopLastActive(shopId) {
      var data = {};
      var deferred = $q.defer();
      $http.put(URL+'/shop/'+shopId+'/update-last-active', data).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopProfileCountByShopId(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/shop-profile-count').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getCurrentMonthShopProfileCountByShopId(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/current-month-profile-count').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopByShopId(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopByMobileNo(mobileNo) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/get-bymobileno?mobileNo='+mobileNo).then(function(result) {
          sessionManagerService.setNotLoginData({shop:result.data});
          deferred.resolve(result.data);

        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopByWebsiteUrl(websiteUrl) {
      var deferred = $q.defer();
      $http.post(URL+'/shop/websiteUrl', {'websiteUrl':websiteUrl}).then(function(result) {
          sessionManagerService.setNotLoginData({shop:result.data.shop});
          deferred.resolve(result.data);

        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopProfileByShopIdAndProfileStatus(shopId, profileStatus, page, size) {
      var deferred = $q.defer();
      var req = {
        shopId: shopId,
        profileStatus: profileStatus
      }
      $http.post(URL+'/profile/profile-status?page='+page+'&size='+size, req)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function findCurrentMonthShopProfileByShopIdAndProfileStatus(shopId, profileStatus, page, size) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/profile/profileStatus/'+profileStatus+'/currentMonthProfile?page='+page+
      '&size='+size).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getCurrentMonthShopPaymentInfo(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/current-month-payment-info').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopPaymentsByShopId(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/shop-payment-info').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getProfileMobileNoByShopIdAndProfileId(shopId, profileId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/profile/'+profileId).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getSuccessStoryByShopId(shopId, page, size) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/success-story?page='+page+'&size='+size).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getShopPackagePlanByShopId(shopId) {
      var deferred = $q.defer();
      $http.get(URL+'/shop/'+shopId+'/package-plan').then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function saveSuccessStory(file, shopId, successStoryJson) {
      var deferred = $q.defer();

      Upload.upload({
        url: URL + '/upload-success-story?resourceName=profile&shopId=' +shopId,
        data: {
          file: file,
          successStoryJson: JSON.stringify(successStoryJson)
        }
      }).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }
  }
})();


/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').service('sessionManagerService', sessionManagerService);

  sessionManagerService.$inject = ['webStorage'];

  function sessionManagerService(webStorage) {
    var EMPTY_SESSION = "";
    var userData;

    this.setNotLoginData = function(data) {
      webStorage.session.set("notLoginData", data, false);
    }

    this.getNotLoginData = function() {
      var data = webStorage.session.get("notLoginData");
      return data;
    }

    this.setUserData = function (data) {
      userData = data;
    }

    this.getUserData = function () {
      return userData;
    }

    this.setSessionData = function(data) {
      webStorage.session.set("currentSession", data, false);
    }

    this.getSessionData = function() {
      var data = webStorage.session.get("currentSession");
      return data;
    }

    this.setBreadCrumbSession = function(bData) {
      webStorage.session.set("bDataSession", bData, false);
    }

    this.getBreadCrumbSession = function() {
      var bData = webStorage.session.get("bDataSession");
      return bData;
    }

    this.setPreviousUrl = function (url) {
      webStorage.session.set("previousURL", url, false);
    }

    this.getPreviousUrl = function () {
      return webStorage.session.get("previousURL");;
    }

    this.removePreviousUrl = function() {
      webStorage.session.remove("previousURL");
    }

    this.setPackagePlanSession = function(bData) {
      webStorage.local.set("packagePlanSession", bData, false);
    }

    this.getPackagePlanSession = function() {
      var bData = webStorage.local.get("packagePlanSession");
      return bData;
    }

    this.clear = function() {
      webStorage.session.remove("currentSession");
      webStorage.session.remove("bDataSession");
      webStorage.local.remove("packagePlanSession")
      return EMPTY_SESSION;
    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('profileService', profileService);

  profileService.$inject = ['$http', '$q', 'URL', 'Upload', 'sessionManagerService', '$rootScope'];

  function profileService($http, $q, URL, Upload, sessionManagerService, $rootScope) {
    var profile;
    var partnerPreference;
    var service = {
      createProfile: createProfile,
      createPartnerPreference: createPartnerPreference,
      deleteProfile: deleteProfile,
      deleteImage: deleteImage,
      getPartnerPreferenceByMatrimonyId: getPartnerPreferenceByMatrimonyId,
      createProfileInterest: createProfileInterest,
      getProfileByMatrimonyId: getProfileByMatrimonyId,
      getProfileInterest: getProfileInterest,
      getMobileNoRequest: getMobileNoRequest,
      getProfileInterestByProfileId: getProfileInterestByProfileId,
      getProfileTemplate: getProfileTemplate,
      getPartnerPreferenceTemplate: getPartnerPreferenceTemplate,
      getNotificationByMatrimonyId: getNotificationByMatrimonyId,
      countProfileInterestNotSeen: countProfileInterestNotSeen,
      getProfileShortListByMatrimonyId: getProfileShortListByMatrimonyId,
      getProfileShortListedByMe: getProfileShortListedByMe,
      getProfileInterestTemplate: getProfileInterestTemplate,
      getMatchingProfiles: getMatchingProfiles,
      changeProfileInterestStatus: changeProfileInterestStatus,
      getMatchingProfilesBySearchQuery: getMatchingProfilesBySearchQuery,
      profileShortList: profileShortList,
      updateAllNotificationByMatrimonyId: updateAllNotificationByMatrimonyId,
      updateProfile: updateProfile,
      updatePartnerPreference: updatePartnerPreference,
      updateProfileLastActive: updateProfileLastActive,
      updateNotificationById: updateNotificationById,
      updateNotificationPopUp: updateNotificationPopUp,
      uploadMultipleProfileImage: uploadMultipleProfileImage,
      updateMemberPackagePlan: updateMemberPackagePlan,
      uploadProfileImage: uploadProfileImage,
      getMemberPackagePlanByMatrimonyId: getMemberPackagePlanByMatrimonyId,
      verifyEmailMobileNo: verifyEmailMobileNo,
      createProfileInterestToKnowContactNo: createProfileInterestToKnowContactNo,
      updateProfileInterestToKnowContactNo: updateProfileInterestToKnowContactNo,
      createProfileInterestToKnowMoreInfo: createProfileInterestToKnowMoreInfo,
      updateProfileInterestToKnowMoreInfo: updateProfileInterestToKnowMoreInfo,
      updateMobileNo: updateMobileNo,
      updateEmail: updateEmail,
      getShopProfileCount: getShopProfileCount,
      uploadHoroscopeImage: uploadHoroscopeImage,
      deleteHoroscopeImage: deleteHoroscopeImage,
      activateProfile: activateProfile,
      getFilterData: getFilterData,
      createProfileValidation: createProfileValidation,
      sendOTPToMobile: sendOTPToMobile,
      verifyOTPToChangeMobileNo: verifyOTPToChangeMobileNo,
      verifyOTPToVerifyMobileNo: verifyOTPToVerifyMobileNo,
      checkUserExist: checkUserExist,
      registerProfile: registerProfile,
      updateProfileInterestOfReasonMsg: updateProfileInterestOfReasonMsg,
      getProfileStatusOptions: getProfileStatusOptions,
      activateProfileAsPartialFreeMember: activateProfileAsPartialFreeMember,
      setProfile: setProfile,
      getProfile: getProfile,
      setPartnerPreference: setPartnerPreference,
      getPartnerPreference: getPartnerPreference,
      viewContactNumber: viewContactNumber,
      reportContactNumberIssue: reportContactNumberIssue,
      getReportContactNumberIssue: getReportContactNumberIssue,
      getContactNoIssueByMatrimonyId: getContactNoIssueByMatrimonyId,
      getWhatsApProfileByMatrimonyId: getWhatsApProfileByMatrimonyId,
      viewContactNumberForOfferPackage: viewContactNumberForOfferPackage
    };
    return service;

    function setProfile(p) {
      profile = p;
    }
    function getProfile() {
       return profile;
    }

    function setPartnerPreference(pf) {
      partnerPreference = pf;
    }

    function getPartnerPreference() {
      return partnerPreference;
    }

    function getProfileTemplate() {
      var deferred = $q.defer();
      $http.get(URL + '/profile/template')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getPartnerPreferenceTemplate() {
      var deferred = $q.defer();
      $http.get(URL + '/profile/partner-pref/template')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function createProfile(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile/create', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateProfile(data) {
      var deferred = $q.defer();
      $http.put(URL + '/profile/update', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function createPartnerPreference(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile/partner-pref/create', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getProfileByMatrimonyId(matrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/profile/?matrimonyId='+matrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }


    function getWhatsApProfileByMatrimonyId(matrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/profile/'+matrimonyId+'/whatsap')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }
    function uploadProfileImage(file, matrimonyId, isMainPhoto, shopId) {
      var deferred = $q.defer();
      var fd = new FormData();
      fd.append('file', file);

      $http.post(URL + '/upload-profile-image?resourceName=profile&matrimonyId=' + matrimonyId +
        '&shopId=' + shopId, fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      }).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    function uploadMultipleProfileImage(files, matrimonyId, shopId, profileStatus) {
      var deferred = $q.defer();
      Upload.upload({
        url: URL + '/image/upload?resourceName=profile&matrimonyId=' + matrimonyId + '&shopId=' +
        shopId+'&status='+profileStatus,
        objectKey: '',
        data: {
          file: files
        }
      }).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    function uploadHoroscopeImage(file, matrimonyId, shopId, profileStatus) {
      var deferred = $q.defer();
      Upload.upload({
        url: URL + '/image/horoscope?resourceName=profile&matrimonyId=' + matrimonyId + '&shopId=' +
        shopId,
        objectKey: '',
        data: {
          file: file
        }
      }).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    function deleteImage(data) {
      var deferred = $q.defer();
      $http.put(URL + '/image/delete', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });

      return deferred.promise;
    }

    function deleteHoroscopeImage(data) {
      var deferred = $q.defer();
      $http.put(URL + '/delete-horoscope-image' , data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });

      return deferred.promise;
    }

    function getPartnerPreferenceByMatrimonyId(matrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/profile/partner-pref?matrimonyId=' + matrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updatePartnerPreference(data) {
      var deferred = $q.defer();
      $http.put(URL + '/profile/partner-pref/update', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function createProfileInterest(data, fromMatrimonyId, toMatrimonyId) {
      var deferred = $q.defer();
      $http.post(URL + '/create-profile-interest?fromMatrimonyId='+fromMatrimonyId+'&toMatrimonyId='+toMatrimonyId, data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function changeProfileInterestStatus(profileInterestId, fromMatrimonyId, toMatrimonyId, data) {
      var deferred = $q.defer();
      $http.put(URL + '/update-profile-interest/' + profileInterestId + '?fromMatrimonyId=' + fromMatrimonyId +
        '&toMatrimonyId=' + toMatrimonyId, data).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function updateProfileInterestOfReasonMsg(profileInterestId, interestStatus) {
      var deferred = $q.defer();
      $http.put(URL + '/update-profile-interest/' + profileInterestId + '/reason-msg',
        interestStatus).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function getProfileInterest(fromMatrimonyId, toMatrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/profile-interest?fromMatrimonyId=' + fromMatrimonyId + '' +
        '&toMatrimonyId=' + toMatrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getMobileNoRequest(fromMatrimonyId, toMatrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/mobileno-request?fromMatrimonyId=' + fromMatrimonyId + '' +
        '&toMatrimonyId=' + toMatrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getProfileInterestByProfileId(profileId, page, size, interestType) {
      var deferred = $q.defer();
      $http.get(URL + '/profile-interest/profile/' + profileId + '?page=' + page + '&size=' + size + '&interestType=' + interestType)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getMatchingProfiles(matrimonyId, caste, page, size, gender, shopId,
        otherClientViewYourProfiles, anchepedheMarriageBureau, casteNoBar, neverMarried,
        othrPfVwCtNo, allwOnlyMbPfWhShwCtNo) {
      var deferred = $q.defer();
      $http.get(URL + '/profile/matches?matrimonyId=' + matrimonyId +'&caste='+caste+ '&page=' + page + '&size=' + size
        + '&gender=' + gender+'&shopId='+shopId
        +'&otherClientViewYourProfiles='+otherClientViewYourProfiles
        +'&anchepedheMarriageBureau='+anchepedheMarriageBureau
        +'&casteNoBar='+casteNoBar+'&neverMarried='+neverMarried
        +'&othrPfVwCtNo='+othrPfVwCtNo+'&allwOnlyMbPfWhShwCtNo='+allwOnlyMbPfWhShwCtNo).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getMatchingProfilesBySearchQuery(partnerPref, caste, matrimonyId, page, size, gender, shopId,
      otherClientViewYourProfiles, anchepedheMarriageBureau, casteNoBar, neverMarried,
      othrPfVwCtNo, allwOnlyMbPfWhShwCtNo) {
      var deferred = $q.defer();
      $http.post(URL + '/profile/search?matrimonyId='+ matrimonyId+'&caste='+caste+'&page='+page+'&size='+size+
        '&gender='+ gender+'&shopId='+shopId
        +'&otherClientViewYourProfiles='+otherClientViewYourProfiles
        +'&anchepedheMarriageBureau='+anchepedheMarriageBureau
        +'&casteNoBar='+casteNoBar+'&neverMarried='+neverMarried
        +'&othrPfVwCtNo='+othrPfVwCtNo+'&allwOnlyMbPfWhShwCtNo='+allwOnlyMbPfWhShwCtNo, partnerPref).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function profileShortList(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile-shortlist', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getProfileShortListedByMe(matrimonyId, page, size) {
      var deferred = $q.defer();
      $http.get(URL + '/profile-interest/shortlisted-by-me/' + matrimonyId + '?page=' + page + '&size=' + size)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getProfileShortListByMatrimonyId(fromMatrimonyId, toMatrimonyId, toProfileShopId) {
      var deferred = $q.defer();
      $http.get(URL + '/profile-shortlist?fromMatrimonyId=' + fromMatrimonyId + '&toMatrimonyId=' +
        '' + toMatrimonyId+'&toProfileShopId='+toProfileShopId).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function updateProfileLastActive(profileId) {
      var data = {};
      var deferred = $q.defer();
      $http.put(URL + '/profile/' + profileId + '/update-last-active', data).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function deleteProfile(profileId) {
      var data = {};
      var deferred = $q.defer();
      $http.post(URL + '/profile/' + profileId + '/delete', data).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function getProfileInterestTemplate() {
      var deferred = $q.defer();
      $http.get(URL + '/profile-interest/template')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function verifyEmailMobileNo(profile) {
      var deferred = $q.defer();
      $http.post(URL + '/profile/verifyEmailMobileNo', profile).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function updateMemberPackagePlan(packagePlan) {
      var deferred = $q.defer();
      $http.post(URL + '/profileInterest/update-packageplan', packagePlan)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getMemberPackagePlanByMatrimonyId(matrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/profileInterest/packageplan?matrimonyId=' + matrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function countProfileInterestNotSeen(profileId, matrimonyId, shopId) {
      var deferred = $q.defer();
      $http.get(URL + '/profileInterest/notification/count-not-viewed?profileId='
        +profileId+'&matrimonyId='+matrimonyId+'&shopId='+shopId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getNotificationByMatrimonyId(matrimonyId, page, size) {
      var deferred = $q.defer();
      $http.get(URL + '/notification' + '?matrimonyId=' + matrimonyId + '&page=' + page + '&size=' + size)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateNotificationById(notificationId) {
      var deferred = $q.defer();
      $http.put(URL + '/notification/' + notificationId, {})
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateAllNotificationByMatrimonyId(matrimonyId) {
      var deferred = $q.defer();
      $http.put(URL + '/notification/all?matrimonyId=' + matrimonyId, {})
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateNotificationPopUp(notificationPopUp) {
      var deferred = $q.defer();
      $http.put(URL + '/notification/update-notification-popup', notificationPopUp)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function createProfileInterestToKnowMoreInfo(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile-interest/know-moreinfo', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateProfileInterestToKnowMoreInfo(data) {
      var deferred = $q.defer();
      $http.put(URL + '/profile-interest/update/know-moreinfo', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function createProfileInterestToKnowContactNo(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile-interest/know-contactno', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateProfileInterestToKnowContactNo(data) {
      var deferred = $q.defer();
      $http.put(URL + '/profile-interest/update/know-contactno', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function viewContactNumber(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile-interest/view-contactno', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function viewContactNumberForOfferPackage(fromMatrimonyId, toMatrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/profile-interest/view-contactno/offer?fromMatrimonyId='+fromMatrimonyId
        +'&toMatrimonyId='+toMatrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function reportContactNumberIssue(data) {
      var deferred = $q.defer();
      $http.post(URL + '/contactno-issue/save', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getContactNoIssueByMatrimonyId(matrimonyId, page, size) {
      var deferred = $q.defer();
      $http.get(URL+'/contactno-issue/profile/'+matrimonyId+'?page='+page+'&size='+size)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getReportContactNumberIssue(fromMatrimonyId, toMatrimonyId) {
      var deferred = $q.defer();
      $http.get(URL + '/contactno-issue/find?fromMatrimonyId='+fromMatrimonyId+'&toMatrimonyId='+toMatrimonyId)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function updateMobileNo(obj,profileId) {
      var deferred = $q.defer();
      $http.put(URL +'/profile/'+profileId+'/update-mobileno', obj)
        .then(function(result) {
            deferred.resolve(result);
          }, function() {
            deferred.reject();
          }
        );
      return deferred.promise;
    }

    function updateEmail(newEmail, profileId) {
      var deferred = $q.defer();
      $http.put(URL+'/profile/'+profileId+'/update-email?newEmail='+newEmail, {})
        .then(function(result) {
            deferred.resolve(result);
          }, function() {
            deferred.reject();
          }
        );
      return deferred.promise;
    }

    function getShopProfileCount(shopId, caste, gender, partnerPref, casteNoBar, neverMarried,
      otherClientViewYourProfiles, anchepedheMarriageBureau, othrPfVwCtNo, allwOnlyMbPfWhShwCtNo) {
      var deferred = $q.defer();
      $http.post(URL +'/profile/current-month-profile-count?shopId='+shopId+'&caste='+caste+'&gender='+gender
        +'&casteNoBar='+casteNoBar+'&neverMarried='+neverMarried
        +'&otherClientViewYourProfiles='+otherClientViewYourProfiles
        +'&anchepedheMarriageBureau='+anchepedheMarriageBureau
        +'&othrPfVwCtNo='+othrPfVwCtNo+'&allwOnlyMbPfWhShwCtNo='+allwOnlyMbPfWhShwCtNo, partnerPref)
        .then(function(result) {
            deferred.resolve(result);
          }, function() {
            deferred.reject();
          }
        );
      return deferred.promise;
    }

    function activateProfile(profileId, obj) {
      var deferred = $q.defer();
      $http.post(URL+'/profile/'+profileId+'/activate', obj)
        .then(function(result) {
            deferred.resolve(result);
          }, function() {
            deferred.reject();
          }
        );
      return deferred.promise;
    }

    function activateProfileAsPartialFreeMember(profileId) {
      var deferred = $q.defer();
      $http.post(URL+'/profile/'+profileId+'/partial-activate', {})
        .then(function(result) {
            deferred.resolve(result);
          }, function() {
            deferred.reject();
          }
        );
      return deferred.promise;
    }

    function getFilterData(shopId, data, regex, otherBureauProfile, anchepedheMarriageBureau,
      otherClientViewYourProfiles, othrPfVwCtNo, allwOnlyMbPfWhShwCtNo, allBureauProfile) {
      var deferred = $q.defer();
      $http.post(URL+'/profile/filter?shopId='+shopId+'&regex='+regex+'&otherBureauProfile='+otherBureauProfile
        +'&anchepedheMarriageBureau='+anchepedheMarriageBureau+'&otherClientViewYourProfiles='+otherClientViewYourProfiles
        +'&othrPfVwCtNo='+othrPfVwCtNo
        +'&allwOnlyMbPfWhShwCtNo='+allwOnlyMbPfWhShwCtNo+'&allBureauProfile='+allBureauProfile, data)
        .then(function(result) {
            deferred.resolve(result);
          }, function() {
            deferred.reject();
          }
        );
      return deferred.promise;
    }

    function createProfileValidation(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile/create-validation/mb', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function(error) {
          deferred.reject(error.data);
        });
      return deferred.promise;
    }

    function sendOTPToMobile(data) {
      var deferred = $q.defer();
      $http.post(URL + '/otp/send/mobile', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function(error) {
          deferred.reject(error.data);
        });
      return deferred.promise;
    }

    function verifyOTPToChangeMobileNo(data) {
      var deferred = $q.defer();
      $http.post(URL + '/otp/verify/mobile-change', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function(error) {
          deferred.reject(error.data);
        });
      return deferred.promise;
    }

    function verifyOTPToVerifyMobileNo(data) {
      var deferred = $q.defer();
      $http.post(URL + '/otp/verify/mobile-verify', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function(error) {
          deferred.reject(error.data);
        });
      return deferred.promise;
    }

    function checkUserExist(data) {
      var deferred = $q.defer();
      $http.post(URL + '/profile/create-validation/self-user', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function(error) {
          deferred.reject(error.data);
        });
      return deferred.promise;
    }

    function registerProfile(files, profile, password, shopUniqueId) {
      var deferred = $q.defer();
      Upload.upload({
        url: URL + '/profile/register',
        objectKey: '',
        data: {
          file: files,
          registerProfile: new Blob([JSON.stringify({profile: profile, password: password, shopUniqueId: shopUniqueId})], {
            type: "application/json"
          })
        }
      }).then(function(result) {
        result.data.permissions = result.data.permissions.map(function(val) {
          return val.authority;
        })
        if(result.data.roles.includes("ROLE_ADMIN") || result.data.roles.includes("ROLE_EMPLOYEE") || result.data.roles.includes("ROLE_USER")) {
          sessionManagerService.setUserData(result.data);
          $rootScope.$broadcast("UserAuthenticationSuccessEvent", result.data);
          deferred.resolve(result);
        } else {
          deferred.reject();
        }
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    function getProfileStatusOptions() {
      var deferred = $q.defer();
      $http.get(URL + '/profile/status')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }
  }
})();

/**
 * Created by gomahesh on 2017-05-12.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('paymentService', paymentService);

  paymentService.$inject = ['$http', '$q', 'URL', 'transformRequestAsFormPost'];

  function paymentService($http, $q, URL, transformRequestAsFormPost) {
    var service = {
      createPaymentRequest : createPaymentRequest,
      createInstamojoPaymentRequest: createInstamojoPaymentRequest,
      instamojoSplitPaymentRequest: instamojoSplitPaymentRequest,
      razorpayOrder: razorpayOrder,
      razorpayRouteOrder: razorpayRouteOrder,
    }

    return service;

    function createPaymentRequest(data, auth) {
      var deferred = $q.defer();

      $http({
        method: "post",
        url: URL + '/payment-gateway/payment-request',
        transformRequest: transformRequestAsFormPost,
        data: data,
        headers : {'Content-Type': 'application/x-www-form-urlencoded', 'Authorization' : 'Basic '+auth}
      }).then(function(result) {
        deferred.resolve(result);
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    function createInstamojoPaymentRequest(data) {
      var deferred = $q.defer();
      $http.post(URL + '/payment-gateway/create-payment-request', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function instamojoSplitPaymentRequest(data, shopId, profileId) {
      var deferred = $q.defer();
      $http.post(URL + '/payment-gateway/split-payment-request?shopId='+shopId+'&profileId='+profileId, data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function razorpayOrder(payload) {
      var deferred = $q.defer();
      $http.post(URL + '/razorpay/order', payload)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function razorpayRouteOrder(payload) {
      var deferred = $q.defer();
      $http.post(URL + '/razorpay/route/order', payload)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }
  }
})();

/**
 * Created by gomahesh on 2017-07-02.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').service('paginationTrackerService', paginationTrackerService);


  function paginationTrackerService() {
    var profileMatch;
    var myShopProfile;
    var otherShopProfile;
    var anchepedheShopProfile;
    var searchProfile = {};
    var filter;
    var filterObj;
    var filterArray;
    var regex;
    var age;
    var height;
    var otherFilter;
    var otherFilterObj;
    var otherFilterArray;
    var otherRegex;
    var otherAge;
    var otherHeight;
    var quickSrch;

    var anchepedheFilter;
    var anchepedheFilterObj;
    var anchepedheFilterArray;
    var anchepedheRegex;
    var anchepedheAge;
    var anchepedheHeight;
    var isShowDeletedProfile;

    this.setShowDeletedProfile = function(val) {
      isShowDeletedProfile = val;
    }

    this.getShowDeletedProfile = function() {
      return isShowDeletedProfile;
    }
    
    this.setPaginationProfileMatch = function(pageNo) {
      profileMatch = pageNo;
    }

    this.getPaginationProfileMatch = function () {
      return profileMatch;
    }

    this.setPaginationShopProfile = function(pageNo) {
      myShopProfile = pageNo;
    }

    this.getPaginationShopProfile = function () {
      return myShopProfile;
    }

    this.setPaginationOtherShopProfile = function(pageNo) {
      otherShopProfile = pageNo;
    }

    this.getPaginationOtherShopProfile = function () {
      return otherShopProfile;
    }

    this.setPaginationAnchepedheShopProfile = function(pageNo) {
      anchepedheShopProfile = pageNo;
    }

    this.getPaginationAnchepedheShopProfile = function () {
      return anchepedheShopProfile;
    }

    this.setPaginationSearchProfile = function(pageNo) {
      searchProfile["pageNo"] = pageNo;
    }

    this.getPaginationSearchProfile = function () {
      return searchProfile["pageNo"];
    }

    this.setPaginationSearchProfilePartnerPref = function (pref) {
      searchProfile["partnerPref"] = pref;
    }

    this.getPaginationSearchProfilePartnerPref = function () {
      return searchProfile["partnerPref"];
    }

    this.setFilter = function (val) {
      filter = val;
    }

    this.getFilter = function () {
      return filter;
    }

    this.setFilterObj = function (val) {
      filterObj = val;
    }

    this.getFilterObj = function () {
      return filterObj;
    }

    this.setFilterArray = function (val) {
      filterArray = val;
    }

    this.getFilterArray = function () {
      return filterArray;
    }

    

    this.setRegex = function (val) {
      regex = val;
    }

    this.getRegex = function () {
      return regex;
    }

    this.setAge = function(val) {
      age = val
    }

    this.getAge = function() {
      return age;
    }

    this.setHeight = function(val) {
      height = val
    }

    this.getHeight = function() {
      return height;
    }

    this.setOtherFilter = function (val) {
      otherFilter = val;
    }

    this.getOtherFilter = function () {
      return otherFilter;
    }

    this.setOtherFilterObj = function (val) {
      otherFilterObj = val;
    }

    this.getOtherFilterObj = function () {
      return otherFilterObj;
    }

    this.setOtherFilterArray = function (val) {
      otherFilterArray = val;
    }

    this.getOtherFilterArray = function () {
      return otherFilterArray;
    }

    this.setOtherRegex = function (val) {
      otherRegex = val;
    }

    this.getOtherRegex = function () {
      return otherRegex;
    }

    this.setOtherAge = function(val) {
      otherAge = val
    }

    this.getOtherAge = function() {
      return otherAge;
    }

    this.setOtherHeight = function(val) {
      otherHeight = val
    }

    this.getOtherHeight = function() {
      return otherHeight;
    }

    this.setAnchepedheFilter = function (val) {
      anchepedheFilter = val;
    }

    this.getAnchepedheFilter = function () {
      return anchepedheFilter;
    }

    this.setAnchepedheFilterObj = function (val) {
      anchepedheFilterObj = val;
    }

    this.getAnchepedheFilterObj = function () {
      return anchepedheFilterObj;
    }

    this.setAnchepedheFilterArray = function (val) {
      anchepedheFilterArray = val;
    }

    this.getAnchepedheFilterArray = function () {
      return anchepedheFilterArray;
    }

    this.setAnchepedheRegex = function (val) {
      anchepedheRegex = val;
    }

    this.getAnchepedheRegex = function () {
      return anchepedheRegex;
    }

    this.setAnchepedheAge = function(val) {
      anchepedheAge = val
    }

    this.getAnchepedheAge = function() {
      return anchepedheAge;
    }

    this.setAnchepedheHeight = function(val) {
      anchepedheHeight = val
    }

    this.getAnchepedheHeight = function() {
      return anchepedheHeight;
    }

    this.resetSearchProfile = function() {
      searchProfile = {};
    }

    this.setQuickSrch = function(val) {
      this.quickSrch = val;
    }

    this.getQuickSrch = function() {
      return this.quickSrch;
    }
  }
})();

/**
 * Created by gomahesh on 9/25/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').service('notificationModelService', notificationModelService);

  notificationModelService.$inject = ['profileService'];

  function notificationModelService(profileService) {
    var notification = {};

    this.getNotificationByMatrimonyId = function (matrimonyId, page, size) {
      profileService.getNotificationByMatrimonyId(matrimonyId, page, size).then(function(response) {
          notification = response.data;
      })
    };

    this.getNotificationObject = function () {
      return notification;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('loginSignUpService', loginSignUpService);

  loginSignUpService.$inject = ['$http', '$q', 'URL', '$rootScope', 'sessionManagerService'];

  function loginSignUpService($http, $q, URL, $rootScope, sessionManagerService) {
    var service = {
      checkAuthenticate: checkAuthenticate,
      createEmployeeUser: createEmployeeUser,
      forgotPassword: forgotPassword,
      resetPassword: resetPassword,
      changePassword: changePassword,
      verifyMobileNo: verifyMobileNo,
      verifyOtpForForgotPassword: verifyOtpForForgotPassword,
      getShopRolePermissionByUserId: getShopRolePermissionByUserId,
      getUsersByUserId: getUsersByUserId
    };
    return service;

    function checkAuthenticate(name, password, data) {
      var deferred = $q.defer();
      data.username = name;
      data.password = password;
      var notLoginData = sessionManagerService.getNotLoginData();
      if(!isNaN(data.username)  && notLoginData.shop.shopUniqueId) {
        data.username = notLoginData.shop.shopUniqueId + data.username
      }
      data.websiteUrl = notLoginData.shop.websiteUrl;
      $http.post(URL+'/account/user/login', data)
        .then(function(result) {
          result.data.permissions = result.data.permissions.map(function(val) {
            return val.authority;
          })
          if(result.data.roles.includes("ROLE_ADMIN") || result.data.roles.includes("ROLE_EMPLOYEE") || result.data.roles.includes("ROLE_USER")) {
            sessionManagerService.setUserData(result.data);
            $rootScope.$broadcast("UserAuthenticationSuccessEvent", result.data);
            deferred.resolve(result);
          } else {
            deferred.reject();
          }
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function createEmployeeUser(data) {
      var deferred = $q.defer();
      $http.post(URL+'/account/user/create-employee', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function forgotPassword(shopUniqueId, mobileNo) {
      var deferred = $q.defer();
      var data = {};
      data.shopUniqueId = shopUniqueId;
      data.mobileNo = mobileNo;
      $http.post(URL+'/otp/forgot-password', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function verifyOtpForForgotPassword(data) {
      var deferred = $q.defer();
      $http.post(URL+'/otp/verify/forgot-password', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function resetPassword(mobileNo, newPassword) {
      var deferred = $q.defer();
      var data = {};
      data.mobileNo = mobileNo;
      data.newPassword = newPassword;
      $http.post(URL+'/otp/reset-password', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function changePassword(id, mobileNo, newPassword) {
      var deferred = $q.defer();
      var data = {};
      data.mobileNo = mobileNo;
      data.newPassword = newPassword;
      $http.post(URL+'/account/user/'+id+'/change-password', data).then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function verifyMobileNo(mobileNo) {
      var deferred = $q.defer();
      $http.get(URL + '/account/user/verify-mobileno?mobileNo=' + mobileNo )
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getShopRolePermissionByUserId(userId) {
      var deferred = $q.defer();
      $http.get(URL + '/account/user/'+userId+'/role-pemission')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function getUsersByUserId(userId) {
      var deferred = $q.defer();
      $http.get(URL + '/account/user/'+userId+'/list')
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        });
      return deferred.promise;
    }
  }
})();


/**
 * Created by gomahesh on 2017-05-29.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('transformRequestAsFormPost', transformRequestAsFormPost);

  function transformRequestAsFormPost() {
    var service = {
      transformRequest: transformRequest
    };
    return service;

    function transformRequest( data, getHeaders ) {
      var headers = getHeaders();
      headers[ "Content-type" ] = "application/x-www-form-urlencoded; charset=utf-8";
      return( serializeData( data ) );
    }

    function serializeData( data ) {
      // If this is not an object, defer to native stringification.
      if ( ! angular.isObject( data ) ) {
        return( ( data == null ) ? "" : data.toString() );
      }
      var buffer = [];
      // Serialize each key in the object.
      for ( var name in data ) {
        if ( ! data.hasOwnProperty( name ) ) {
          continue;
        }
        var value = data[ name ];
        buffer.push(
          encodeURIComponent( name ) +
          "=" +
          encodeURIComponent( ( value == null ) ? "" : value )
        );
      }
      // Serialize the buffer and clean it up for transportation.
      var source = buffer
          .join( "&" )
          .replace( /%20/g, "+" )
        ;
      return( source );
    }

  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('requestNotificationChannel', requestNotificationChannel);

  requestNotificationChannel.$inject = ['$rootScope'];

  function requestNotificationChannel($rootScope) {
    // private notification messages
    var _START_REQUEST_ = '_START_REQUEST_';
    var _END_REQUEST_ = '_END_REQUEST_';
    // publish start request notification

    var service = {
      requestStarted: requestStarted,
      requestEnded: requestEnded,
      onRequestStarted: onRequestStarted,
      onRequestEnded: onRequestEnded
    };
    return service;

    function requestStarted() {
      $rootScope.$broadcast(_START_REQUEST_);
      $rootScope.blockUI = true;
    }
    // publish end request notification
    function requestEnded() {
      $rootScope.$broadcast(_END_REQUEST_);
      $rootScope.blockUI = false;
    }
    // subscribe to start request notification
    function onRequestStarted($scope, handler) {
      $scope.$on(_START_REQUEST_, function () {
        handler();
      });
    }
    // subscribe to end request notification
    function onRequestEnded($scope, handler) {
      $scope.$on(_END_REQUEST_, function () {
        handler();
      });
    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('httpInterceptor', httpInterceptor);

  httpInterceptor.$inject = ['$q', '$injector', '$location', '$rootScope'];

  function httpInterceptor($q, $injector, $location, $rootScope) {
    var $http, notificationChannel;
    /*function removeErrors() {
     var $= jQuery();
     var $inputs = $(':input');
     $inputs.each(function () {
     $(this).removeClass("validationerror");
     });
     }*/

    return {
      response: function (response) {
        delete $rootScope.errorStatus;
        delete $rootScope.errorDetails;

        /*removeErrors();*/
        // get $http via $injector because of circular dependency problem
        $http = $http || $injector.get('$http');

        // don't send notification until all requests are complete
        if ($http.pendingRequests.length < 1) {
          // get requestNotificationChannel via $injector because of circular dependency problem
          notificationChannel = notificationChannel || $injector.get('requestNotificationChannel');
          // send a notification requests are complete
          notificationChannel.requestEnded();
        }

        if (response.config && response.config.method == "GET") {
          return response;
        } else {
          if (response.data && response.data.commandId) {
            //Maker checker is enabled or performing actions of maker checker
            if (response.config.url.indexOf('makercheckers/') > 0) {
              //return response for maker checker actions(approve or delete)
              return response;
            } else {
              //redirect if maker checker is enabled
              $location.path('/viewMakerCheckerTask/' + response.data.commandId);
            }
          } else {
            //when no maker checker enabled
            return response;
          }
        }

        return response || $q.when(response);
      },
      responseError: function (response) {
        // get $http via $injector because of circular dependency problem
        $http = $http || $injector.get('$http');
        /*removeErrors();*/

        // don't send notification until all requests are complete
        if ($http.pendingRequests.length < 1) {
          // get requestNotificationChannel via $injector because of circular dependency problem
          notificationChannel = notificationChannel || $injector.get('requestNotificationChannel');
          // send a notification requests are complete
          notificationChannel.requestEnded();
        }
        if (response.status == 0 || response.status == -1) {
          //$rootScope.errorStatus = 'No connection. Verify application is running.';
        } else if (response.status == 401) {
          $rootScope.errorStatus = 'Unauthorized';
        } else if (response.status == 404) {
          $rootScope.errorStatus = 'Requested page not found. [404]';
        } else if (response.status == 405) {
          $rootScope.errorStatus = 'HTTP verb not supported [405]';
        } else if (response.status == 500) {
          $rootScope.errorStatus = 'Internal Server Error [500].';
        } else {
          var jsonErrors = angular.fromJson(angular.toJson(response.data));
          var valErrors = jsonErrors.errors;
          var errorArray = new Array();
          var arrayIndex = 0;
          for (var i in valErrors) {
            var temp = valErrors[i];
            // add error class to input in dialog
            var errorObj = new Object();
            errorObj.field = temp.parameterName;
            errorObj.code = temp.defaultUserMessage;
            errorObj.args = {params: []};
            for (var j in temp.args) {
              errorObj.args.params.push({value: temp.args[j].value});
            }

            errorArray[arrayIndex] = errorObj;
            arrayIndex++;
          }
          $rootScope.errorDetails = errorArray;
        }
        return $q.reject(response);
      }
    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').provider('httpService', httpService);

  function httpService() {
    var requestInterceptors = {};

    this.addRequestInterceptor = function(id, interceptorFn) {
      requestInterceptors[id] = interceptorFn;
    };

    this.removeRequestInterceptor = function(id) {
      delete requestInterceptors[id];
    };

    this.$get = ['$http', function ($http) {
      var HttpService = function() {
        this.setAuthorization = function(key) {
          $http.defaults.headers.common.Authorization = "Basic " + key;
        };

        this.cancelAuthorization = function() {
          delete $http.defaults.headers.common.Authorization;
        };
      };
      return new HttpService();
    }];
  }
})();


(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

/**
 * Created by GGowda on 3/10/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').factory('codeValueService', codeValueService);

  codeValueService.$inject = ['$http', '$q', 'URL'];

  function codeValueService($http, $q, URL) {
    var service = {
      getCodeByName: getCodeByName
    };
    return service;

    function getCodeByName(nameVal) {
      var deferred = $q.defer();
      var data = {"name" : nameVal}
      $http.post(URL+'/code', data)
        .then(function(result) {
          deferred.resolve(result);
        }, function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }
  }
})();

/**
 * Created by GGowda on 3/17/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController($scope, loginSignUpService, $stateParams, $window, sessionManagerService, reg,
    $mdDialog, $loading) {
    /* jshint validthis: true */
    var vm = this;
    vm.host = $window.location.host;
    vm.reg = reg;
    vm.shopUniqueId = vm.reg.shop.shopUniqueId || "";
    vm.toUpperCaseUrl = toUpperCaseUrl;
    $scope.otpForm = {
      showResetPasswordForm : false,
      showPasswordChangeSuccess: false,
      verifyMobileOTPFailure: false
    };

    if(sessionManagerService.getNotLoginData()) {
      vm.shopName = sessionManagerService.getNotLoginData().shop.shopName;
    }

    vm.forgotPassword = forgotPassword;
    vm.resetPassword = resetPassword;

    function forgotPassword(ev, forgotPasswordForm) {
      if(!forgotPasswordForm.$valid)    {
        return !1;
      }
      $loading.start("continueBtn");
      
      var notLoginData = sessionManagerService.getNotLoginData();
      loginSignUpService.forgotPassword(notLoginData.shop.shopUniqueId ,vm.mobileNo).then(function() {
        vm.errorUser = false;
        $loading.finish("continueBtn");
        showOTPVerifyDialog(ev);
      }, function() {
        vm.errorUser = true;
        $loading.finish("continueBtn");
      });
    }

    function showOTPVerifyDialog(ev, shopUniqueId) {
      $mdDialog.show({
        templateUrl: 'otp-verify.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          pm: vm
        },
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        controller: OTPVerifyDialogController,
        controllerAs: 'otp',
        fullscreen: false // Only for -xs, -sm breakpoints.
      })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });

    }

    function OTPVerifyDialogController($scope, $mdDialog, pm, loginSignUpService, $loading) {
      var vm = this;
      vm.mobileNo = pm.mobileNo;

      vm.verifyOtp = function(form) {
        if(form.$valid) {
          $loading.start("otpVerifyBtn");
          loginSignUpService.verifyOtpForForgotPassword({'mobileNo': pm.mobileNo, 'otpNo': vm.otpNo}).then(function(res) {
            vm.errorMsg = false;
            pm.optNo = vm.otpNo;
            $scope.otpForm.showResetPasswordForm = true;
            $mdDialog.cancel();
            $loading.finish("otpVerifyBtn");
          }, function() {
            vm.errorMsg = true;
            $loading.finish("otpVerifyBtn");
          })
        }
      }

      vm.cancel = function() {
        $mdDialog.cancel();
      };
    }

    function resetPassword(resetPasswordForm) {
      if(!resetPasswordForm.$valid)    {
        return !1;
      }
      loginSignUpService.resetPassword(vm.shopUniqueId+vm.mobileNo, vm.newPassword).then(function() {
        $scope.otpForm.showPasswordChangeSuccess = true;
      });
    }

    function toUpperCaseUrl(s) {
      if (typeof s !== 'string') return '';
      if(s.indexOf('localhost') > -1) {
        return;
      } else if(s.indexOf('www.anchepedhematrimony.com') > -1) {
        return 'AnchepedheMatrimony.com'
      } else {
        var splitArray = s.split('.');
        s = s.substring(4)  
        return splitArray[1].charAt(0).toUpperCase() + splitArray[1].slice(1)
          +'.'+splitArray[2].charAt(0).toUpperCase() + splitArray[2].slice(1);
      }
    }
  }
})();

(function() {
    'use strict';
  
    angular.module('anchePedheMatrimony').controller('SuccessStoryController', SuccessStoryController);
  
    /** @ngInject */
    function SuccessStoryController($scope, shopService, $loading) {
        var vm = this;
        vm.tabValue = 0;
        vm.afterResizingImages = afterResizingImages;
        vm.beforeResizingImages = beforeResizingImages;
        vm.saveSuccessStory = saveSuccessStory;
        vm.successStoryJson = {};

        var page = 0;
        $scope.currentPage = page+1;
        vm.pageSize = 5;
        vm.pageChangeHandler = pageChangeHandler;

        
        vm.successStoryImage = {
            photo: false,
            name: "image3",
            to: "",
            invalidFile: ""
        }
        getSuccessStoryByShopId();

        function  afterResizingImages(file) {
            $loading.finish('imageLoading')
        }
      
        function  beforeResizingImages(file) {
            $loading.start('imageLoading');
        }

        function saveSuccessStory() {
            if(!$scope.successStoryForm.$valid) {
                return !1;
            }
            $loading.start('successStoryBtn');
            vm.successStoryJson.shopId = $scope.main.currentSession.shop.id;
            shopService.saveSuccessStory(vm.successStoryImage.photo, $scope.main.currentSession.shop.id,
                vm.successStoryJson).then(function(res) {
                page = 0;
                $scope.currentPage = page+1;
                $loading.finish('successStoryBtn');
                vm.tabValue = 0;
                getSuccessStoryByShopId();                
                vm.successStoryJson = {};
                vm.successStoryImage.photo = false;
            })
        }

        function  getSuccessStoryByShopId() {
            shopService.getSuccessStoryByShopId($scope.main.currentSession.shop.id, page,
                vm.pageSize).then(function(res) {
                vm.successStory = res.data.content;
                vm.totalSuccessStory = res.data.totalElements;
            }, function() {
                vm.successStory = [];
            })
        }

        function pageChangeHandler(newPageNumber) {
            page = newPageNumber-1;
            getSuccessStoryByShopId();
        }

        (function() {
            var homeLink = !$scope.main.currentSession.profileBasicInfo ? '/myShopProfile' : '/profileMatch';
      
            var bData = [{
              name: "Home",
              seourl: homeLink
            }, {
              name: 'Success Story',
              seourl: ""
            }];
            $scope.$emit("updateBreadcrum",bData);
          }())
    }
})();

/**
 * Created by GGowda on 1/9/2016.
 */

(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('SignUpController', SignUpController);

  /** @ngInject */
  function SignUpController(profileService, $scope, $location, shopService, utilService, $rootScope,
                      $window, codeValueService, $loading) {
    /* jshint validthis: true */
    var vm = this;

    vm.ageObj = {};
    vm.getCities = getCities;
    vm.continueToCreateProfile = continueToCreateProfile;
    vm.createAccountAndShop = createAccountAndShop;
    vm.dateObj = utilService._getDateObject();
    vm.getStates = getStates;
    vm.profile = {};
    vm.reset = reset;
    vm.shop = {};
    vm.user = {};

    /*getProfileTemplate();

    function getProfileTemplate() {
      return profileService.getProfileTemplate().then(function(response) {
        vm.profileTemplate = response.data;
        vm.profile.caste =  "Vokkaliga Gowda";
      });
    }*/

    function reset() {
      vm.user = {};
      vm.profile = {};
      vm.shop = {};
      vm.signUpForm.$setPristine();
      vm.signUpForm.$setUntouched();
      vm.signUpShopForm.$setPristine();
      vm.signUpShopForm.$setUntouched();
    }

    function continueToCreateProfile() {
      profileService.verifyEmailMobileNo(vm.profile).then(function() {
        vm.user.isAnchePedheUser = true;
        $rootScope.profile = vm.profile;
        $rootScope.user = vm.user;
        $rootScope.ageObj = vm.ageObj;
        $location.path('/create-update-profile');
      }, function() {
          $window.scroll(0,0);
      })

    }

    function getStates(){
      if (vm.profile.currentLivingCountry == 'India') {
        codeValueService.getCodeByName(vm.profile.currentLivingCountry).then(function(response) {
          vm.stateOptions = response.data;
        });
      } else {
        vm.profile.currentLivingCity = '';
      }
    }

    function getCities(){
      if(!vm.cityOptions) {
        codeValueService.getCodeByName(vm.profile.currentLivingState).then(function(response) {
          vm.cityOptions = response.data;
        });
      }
    }

    function createAccountAndShop() {
      if(!$scope.signUpShopForm.$valid) {
        return !1;
      }
      $loading.start("signUp");
      vm.shop.shopCreatedOn = new Date().getTime();
      vm.shop.shopUpdatedOn = new Date().getTime();

      return shopService.createShop(vm.shop).then(function() {
        $loading.finish("signUp");
        $location.path('/anchePedheMessage/shop');
      }, function () {
        $loading.finish("signUp");
      });
    }
  }
})();

/**
 * Created by GGowda on 3/16/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ShopProfileByProfileStatusController',
    ShopProfileByProfileStatusController);

  /** @ngInject */
  function ShopProfileByProfileStatusController(shopService, $scope, $stateParams, $state, $loading, dateFilter) {
    /* jshint validthis: true */
    var vm = this;
    var page= 0;

    vm.changePath = changePath;
    vm.pageChangeHandler = pageChangeHandler;
    vm.shareProfile = shareProfile;
    vm.pageSize = 4;

    getShopProfileByShopIdAndProfileStatus();

    function getShopProfileByShopIdAndProfileStatus() {
      $loading.start('shopProfile');
      if($stateParams.currentMonthProfile.indexOf("true") > -1) {
        return shopService.findCurrentMonthShopProfileByShopIdAndProfileStatus(
          $scope.main.currentSession.shop.id, $stateParams.profileStatus, page,vm.pageSize)
          .then(function(response) {
            vm.shopProfiles = response.data.content;
            vm.totalShopProfiles = response.data.totalElements;
            $loading.finish('shopProfile');
            return vm.shopProfiles;
          }, function (error) {
            $loading.finish('shopProfile');
          }
        );
      } else {
        return shopService.getShopProfileByShopIdAndProfileStatus($scope.main.currentSession.shop.id,
          $stateParams.profileStatus, page,vm.pageSize).then(function(response) {
            vm.shopProfiles = response.data.content;
            vm.totalShopProfiles = response.data.totalElements;
            $loading.finish('shopProfile');
            return vm.shopProfiles;
          }, function (error) {
            $loading.finish('shopProfile');
          }
        );
      }
    }

    function pageChangeHandler(newPageNo) {
      page = newPageNo - 1;
      getShopProfileByShopIdAndProfileStatus();
    }

    function changePath(stateName, profileName, matrimonyId, param) {
      $state.go(stateName, param);
    }

    function shareProfile(profile, shop) {
      var c = document.getElementById("canvas"+profile.id);
      var ctx = c.getContext("2d");
      var img = document.getElementById(profile.id);
      ctx.drawImage(img, 0, 55, 170, 180);
      ctx.fillStyle = "#EAEDED";
      ctx.fillRect(0,0,400,52);
      //ctx.font = "25px sans-serif";
      ctx.font='700 30px Arial';
      ctx.fillStyle = "red";
      ctx.fillText(profile.shopName, 5, 25);
      ctx.fillStyle = "blue";
      ctx.font = "8pt Helvetica";
      //ctx.fillRect(0,0,400,32);
      ctx.fillText("+91 "+shop.mobileNo, 5, 45);
      ctx.fillStyle = "#EAEDED";
      ctx.fillRect(175,55,250,190);
      ctx.font = "8pt Helvetica";
      ctx.fillStyle = "red";
      ctx.fillText("Name: "+profile.profileName, 200, 65);

      var birthDate = dateFilter(new Date(profile.dob), $scope.main.df);
      var res = birthDate.split(/[ ,]+/)
      ctx.fillText("DOB: "+res[0]+"-"+res[1]+"-"+res[2], 200, 85);
      ctx.fillText("Education: "+profile.highestEducation, 200, 105);
      ctx.fillText("Occupation: "+profile.occupation, 200, 125);
      ctx.fillText("Caste: "+profile.caste, 200, 145);
      if(profile.caste.indexOf("Vishwakarma") > -1 || profile.caste.indexOf("Arya Vysya") > -1) {
        ctx.fillText("Gothra(m): "+profile.gothram, 200, 165);
        ctx.fillText("Star: "+profile.star, 200, 185);
        ctx.fillText("Rashi: "+profile.raasi, 200, 205);
      } else {
        ctx.fillText("Subcaste: "+profile.subCaste, 200, 165);
        ctx.fillText("Star: "+profile.star, 200, 185);
        ctx.fillText("Rashi: "+profile.raasi, 200, 205);
      }

      ctx.fillStyle = "#EAEDED";
      ctx.fillRect(0,240,400,25);
      ctx.font = "600 15px Helvetica";
      ctx.fillStyle = "blue";
      ctx.fillText("For more info please login "+shop.websiteUrl, 5,253);
      $window.location.href=c.toDataURL();
    }
  }
})();

/**
 * Created by GGowda on 2/12/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('MyShopProfileController', MyShopProfileController);

  /** @ngInject */
  function MyShopProfileController(shopService, $scope, $state, $loading, utilService, profileService, $window,
                                   dateFilter, paginationTrackerService, $mdDialog, $q, codeValueService, sessionManagerService) {
    /* jshint validthis: true */
    var vm = this;
    angular.element("#loadingProfifle").removeClass('load');
    vm.utilService = utilService;

    // var matrimonyId = ($scope.main.currentSession.roles.includes('ROLE_ADMIN') || $scope.main.currentSession.roles.includes('ROLE_EMPLOYEE'))  ? "" : $scope.main.currentSession.profileBasicInfo
    //     .matrimonyId;
    var caste = $scope.main.currentSession.roles.includes("ROLE_ADMIN") || $scope.main.currentSession.roles.includes("ROLE_EMPLOYEE") ? "" : $scope.main.currentSession.profileBasicInfo.caste;
    vm.isShowDeletedProfile = angular.isUndefined(paginationTrackerService.getShowDeletedProfile())? false: paginationTrackerService.getShowDeletedProfile();
    var fn = vm.isShowDeletedProfile? getDeletedProfile : getShopProfilesByShopIdForShopEmp;
    
    var gender =  $scope.main.currentSession.roles.includes("ROLE_ADMIN") || $scope.main.currentSession.roles.includes("ROLE_EMPLOYEE") ? "" : $scope.main.currentSession.profileBasicInfo.gender;
    vm.page = angular.isUndefined(paginationTrackerService.getPaginationShopProfile()) ?
      0 : paginationTrackerService.getPaginationShopProfile();
    var filterObj= angular.isUndefined(paginationTrackerService.getFilterObj()) ?
      {} : paginationTrackerService.getFilterObj();
    var selArray = angular.isUndefined(paginationTrackerService.getFilterArray()) ?
      [{memberType:[]}, {profileStatus:[]}, {gender:[]}, {vegOrNonVeg: []}, {caste:[]},{subCaste:[]}, {highestEducation:[]},
        {star:[]}, {employedIn:[]}, {occupation:[]}, {martialStatus:[]},
        {currentLivingCountry: []}, {currentLivingState: []}, {currentLivingCity: []}, {motherTongue: []}, {casteNoBar: []}, {religion: []}] : paginationTrackerService.getFilterArray();

    vm.filter = angular.isUndefined(paginationTrackerService.getFilter()) ? {} : paginationTrackerService.getFilter();
    vm.regex = angular.isUndefined(paginationTrackerService.getRegex()) ? "" : paginationTrackerService.getRegex();
    
    if(angular.isDefined(paginationTrackerService.getAge())) {
      vm.fromAge = paginationTrackerService.getAge().fromAge;
      vm.toAge = paginationTrackerService.getAge().toAge;
    }
    if(angular.isDefined(paginationTrackerService.getHeight())) {
      vm.fromHeight = paginationTrackerService.getHeight().fromHeight;
      vm.toHeight = paginationTrackerService.getHeight().toHeight;
    }


    $scope.currentPage = vm.page+1;
    vm.changePath  = changePath;
    vm.pageChangeHandler = pageChangeHandler;
    vm.shareProfile = shareWhatsApImage;
    vm.pageSize = 16;
    vm.filterChange = filterChange;
    vm.checkIfExist = checkIfExist;
    vm.searchProfile = searchProfile;
    vm.clearAllFilters = clearAllFilters;
    vm.submitAge = submitAge;
    vm.submitHeight = submitHeight;
    vm.setCurrentImage = setCurrentImage;
    vm.reset = reset;
    vm.defaultShowBureauProfilesTypeChange = defaultShowBureauProfilesTypeChange;

    fn();

    function changePath(stateName, profileName, matrimonyId, param, profileStatus) {
      //if(profileStatus == "Delete Profile") return;
      $state.go(stateName, param);
    }

    function getShopProfilesByShopId() {
      $loading.start('shopProfile');
      if($scope.main.currentSession.profileBasicInfo.casteNoBar) {
        caste= '';
      }
      return shopService.getShopProfilesByShopIdForShopUser($scope.main.currentSession.shop.id, caste,
        gender, vm.page, vm.pageSize,false,
        $scope.main.currentSession.shop.anchepedheMarriageBureau,
        $scope.main.currentSession.shop.otherClientViewYourProfiles).then(function(response) {
          vm.shopProfiles = response.data.results;
          vm.totalShopProfiles = response.data.total;
          for(var i=0; i < vm.shopProfiles.length; i++) {
            vm.shopProfiles[i].imageRandomNo = utilService._getRandomNumber()
          }
          $loading.finish('shopProfile');
          return vm.shopProfiles;
        }
      );
    }

    function defaultShowBureauProfilesTypeChange() {
      vm.page = 0;
      $scope.currentPage = vm.page+1;
      vm.isShowDeletedProfile = false;
      clearAllFilters();
    }

    function getShopProfilesByShopIdForShopEmp() {
      $loading.start('shopProfile');
      var allBureauProfile = false;
      var otherBureauProfile = false;
      var anchepedheMarriageBureau = false;

      if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'All') {
        allBureauProfile = true;
        otherBureauProfile = false;
        anchepedheMarriageBureau = false;
      } else if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'My') {
        allBureauProfile = false;
        otherBureauProfile = false;
        anchepedheMarriageBureau = false;
      } else if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'Other') {
        allBureauProfile = false;
        otherBureauProfile = true;
        anchepedheMarriageBureau = false;
      } 
      return shopService.getBureauProfiles($scope.main.currentSession.shop.id, vm.page,
        vm.pageSize, {filter:filterObj, fromAge: vm.fromAge, toAge: vm.toAge, fromHeight: vm.fromHeight,
          toHeight: vm.toHeight}, vm.regex, $scope.main.currentSession.shop.anchepedheMarriageBureau, otherBureauProfile,
          $scope.main.currentSession.shop.otherClientViewYourProfiles,
          $scope.main.currentSession.shop.othrPfVwCtNo,
          $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo, allBureauProfile).then(function(response) {
            vm.shopProfiles = response.data.results;
            vm.total = response.data.total;

          for(var i=0; i < vm.shopProfiles.length; i++) {
            vm.shopProfiles[i].imageRandomNo = utilService._getRandomNumber()
          }

          $loading.finish('shopProfile');
          angular.element("#loadingProfifle").addClass('load');

          return vm.shopProfiles;
        }
      );
    }

    function pageChangeHandler(newPageNumber) {
      vm.page = newPageNumber-1;
      paginationTrackerService.setPaginationShopProfile(vm.page);
      fn();
    }


    (function getPartnerPreferenceTemplate () {
      return profileService.getPartnerPreferenceTemplate().then(function(response) {
        vm.partnerPreferenceTemplate = response.data;
      });
    })();

    (function () {
      if($scope.main.currentSession.roles.includes("ROLE_USER")) {
        var shopId = $scope.main.currentSession.profileBasicInfo.shopId;
        var caste = $scope.main.currentSession.profileBasicInfo.caste;
        var casteNoBar = $scope.main.currentSession.profileBasicInfo.casteNoBar;
        var neverMarried = $scope.main.currentSession.profileBasicInfo.martialStatus == "Never Married" || false;

        var gender = $scope.main.currentSession.profileBasicInfo.gender;
        profileService.getShopProfileCount(shopId, caste, false, gender, {},
          casteNoBar, neverMarried).then(function (res) {
          vm.shopProfileCount = res.data;
        })
      }
    })();


    function shareWhatsApImage(profile, shop, ev) {
      utilService._shareWhatsApImage(profile, $scope.main.currentSession.shop, ev, vm.addMobileno);
    }

    function filterChange(parent, child) {
      $loading.start('filter');
      vm.page = 0;
      $scope.currentPage = vm.page+1;
      generateFilterObject(parent, child);
      gO(parent, child);
      paginationTrackerService.setFilterObj(filterObj);
      paginationTrackerService.setFilterArray(selArray);
      paginationTrackerService.setFilter(vm.filter);

      getShopProfilesByShopIdForShopEmp();
      getFilterData().then(function () {
        $loading.finish('filter');
      });
    }

    function submitAge() {
      if(angular.isUndefined(vm.fromAge) || angular.isUndefined(vm.toAge)) {
        alert("Sorry, please select age range.")
        return;
      } else if(vm.fromAge > vm.toAge) {
        alert("Sorry, Invalid age range. "+vm.fromAge+" to "+vm.toAge+".")
        return;
      }
      $loading.start('filter');
      getShopProfilesByShopIdForShopEmp();
      getFilterData().then(function(data) {
        $loading.finish('filter');
        if(data.length > 0) {
          paginationTrackerService.setAge({fromAge: vm.fromAge, toAge: vm.toAge});
        }
      });
    }

    function submitHeight() {
      if(angular.isUndefined(vm.fromHeight) || angular.isUndefined(vm.toHeight)) {
        alert("Sorry, please select age range.")
        return;
      } else if(vm.fromHeight > vm.toHeight) {
        alert("Sorry, Invalid age range. "+vm.fromHeight+" to "+vm.toHeight+".")
        return;
      }
      $loading.start('filter');
      getShopProfilesByShopIdForShopEmp();
      $loading.start('filter');
      getFilterData().then(function(data) {
        //$loading.finish('filter');
        if(data.length > 0) {
          paginationTrackerService.setHeight({fromHeight: vm.fromHeight, toHeight: vm.toHeight});
        }
      });
    }

    function getFilterData() {
      var deferred = $q.defer();
      var allBureauProfile = false;
      var otherBureauProfile = false;
      var anchepedheMarriageBureau = false;

      if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'All') {
        allBureauProfile = true;
        otherBureauProfile = false;
        anchepedheMarriageBureau = false;
      } else if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'My') {
        allBureauProfile = false;
        otherBureauProfile = false;
        anchepedheMarriageBureau = false;
      } else if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'Other') {
        allBureauProfile = false;
        otherBureauProfile = true;
        anchepedheMarriageBureau = false;
      }
      profileService.getFilterData($scope.main.currentSession.shop.id, {selArr:selArray,
        fromAge: vm.fromAge, toAge: vm.toAge, fromHeight: vm.fromHeight, toHeight: vm.toHeight},
        vm.regex, otherBureauProfile, $scope.main.currentSession.shop.anchepedheMarriageBureau,
        $scope.main.currentSession.shop.otherClientViewYourProfiles,
        $scope.main.currentSession.shop.othrPfVwCtNo,
        $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo, allBureauProfile)
        .then(function(response) {
          $loading.finish('filter');
          if(response.data.length < 1) {
            alert("No Data Found. Please change the query.")
           // $loading.finish('filter');
            return;
          }
        vm.filter = generateCompData(response.data);
        deferred.resolve(response.data);
        
      }).catch(function (error) {
        deferred.reject();
      });
      return deferred.promise;
    }

    function generateFilterObject(parent, child) {
      if(child["isChecked"] === true) {
        if(!filterObj.hasOwnProperty(parent)) {
          filterObj[parent] = [];
        }
        filterObj[parent].push(child.name);
      } else if(child["isChecked"] === false) {
        var i =  _.findIndex(filterObj[parent], function(o) { return o == child.name; });
        filterObj[parent].splice(i, 1);
        if(filterObj[parent].length === 0) {
          delete filterObj[parent];
        }

      }
      return filterObj;
    }

    function gO(parent, child) {
      if(child["isChecked"] === true) {
        for(var i in selArray){
          if(!selArray[i].hasOwnProperty(parent)) {
            if(selArray[i][Object.keys(selArray[i])[0]].length !== 0 &&
              JSON.stringify(selArray[i][Object.keys(selArray[i])[0]]).indexOf(parent) > -1) {

              for(var j in selArray[i][Object.keys(selArray[i])[0]]) {
                if(JSON.stringify(selArray[i][Object.keys(selArray[i])[0]][j]).indexOf(parent) > -1) {
                  var l = selArray[i][Object.keys(selArray[i])[0]][j][Object.keys(selArray[i][Object.keys(selArray[i])[0]][j])[0]];
                  l.push({"$eq":["$"+parent, child.name]});
                }
              }
            } else {
              selArray[i][Object.keys(selArray[i])[0]].push({"$or": [{"$eq":["$"+parent, child.name]}]});
            }
          }
        }
      } else if(child["isChecked"] === false) {
        for(var i in selArray) {
          for(var j in selArray[i][Object.keys(selArray[i])[0]]) {
            for(var k in selArray[i][Object.keys(selArray[i])[0]][j]["$or"]) {
              if(JSON.stringify(selArray[i][Object.keys(selArray[i])[0]][j]["$or"][k]).indexOf(child.name) > -1) {
                selArray[i][Object.keys(selArray[i])[0]][j]["$or"].splice(k, 1);
                if(selArray[i][Object.keys(selArray[i])[0]][j]["$or"].length == 0) {
                  delete selArray[i][Object.keys(selArray[i])[0]][j]["$or"];
                }
              }
            }
            if(Object.keys(selArray[i][Object.keys(selArray[i])[0]][j])[0] === undefined) {
              selArray[i][Object.keys(selArray[i])[0]].splice(j,1);
            }
          }
        }
      }

    }

    function generateCompData(resData) {
      console.log("---generateCompData started---")
      for(var i=0; i < vm.filter.length; i++) {
        var obj =  _.find(resData, {id:vm.filter[i].id});
        for (var j = 0; j < vm.filter[i].values.length; j++) {
          if(vm.filter[i].values[j].isChecked) {
            try{
              var valueObj =  _.find(obj.values, {name: vm.filter[i].values[j].name});
              valueObj.isChecked = vm.filter[i].values[j].isChecked;
            } catch(msg) {
              console.log(msg);
              vm.filter[i].values[j].isChecked = false;
              filterChange(vm.filter[i].id, vm.filter[i].values[j]);
            }
          }
        }
      }
      console.log("---generateCompData finished---")
      return resData;
    }

    (function () {
      $loading.start('filter');
      if(!$scope.main.currentSession.roles.includes("ROLE_USER")) {
        var allBureauProfile = false;
      var otherBureauProfile = false;
      var anchepedheMarriageBureau = false;

      if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'All') {
        allBureauProfile = true;
        otherBureauProfile = false;
        anchepedheMarriageBureau = false;
      } else if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'My') {
        allBureauProfile = false;
        otherBureauProfile = false;
        anchepedheMarriageBureau = false;
      } else if($scope.main.currentSession.shop.defaultShowBureauProfilesType == 'Other') {
        allBureauProfile = false;
        otherBureauProfile = true;
        anchepedheMarriageBureau = false;
      }
        profileService.getFilterData($scope.main.currentSession.shop.id,
          {selArr:selArray, fromAge: vm.fromAge, toAge: vm.toAge, fromHeight: vm.fromHeight, toHeight: vm.toHeight},
          vm.regex, otherBureauProfile, $scope.main.currentSession.shop.anchepedheMarriageBureau,
          $scope.main.currentSession.shop.otherClientViewYourProfiles,
          $scope.main.currentSession.shop.othrPfVwCtNo,
          $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo, allBureauProfile).then(function(response) {
            vm.filter = generateCompData(response.data);
            $loading.finish('filter');
        })
      }

      codeValueService.getCodeByName('Age-Pref').then(function(response) {
        vm.ageOptions = response.data;
        /*$loading.finish('createUpdateProfile');*/
      });
      codeValueService.getCodeByName('Height').then(function(response) {
        vm.heightOptions = response.data;
        /*$loading.finish('createUpdateProfile');*/
      });
    })();



    function reset() {
      vm.page = 0;
      $scope.currentPage = vm.page+1;
      if(vm.isShowDeletedProfile) {
        paginationTrackerService.setShowDeletedProfile(vm.isShowDeletedProfile);
        fn = getDeletedProfile;
        getDeletedProfile();
      } else {
        paginationTrackerService.setShowDeletedProfile(vm.isShowDeletedProfile);
        fn = getShopProfilesByShopIdForShopEmp;
        getShopProfilesByShopIdForShopEmp();
        getFilterData().then(function () {
          $loading.finish('filter');
        });
      }
    }

    function getDeletedProfile() {
      $loading.start('shopProfile');
      shopService.getShopProfileByShopIdAndProfileStatus($scope.main.currentSession.shop.id,
        'Delete Profile', vm.page,vm.pageSize).then(function(response) {
          vm.shopProfiles = response.data.content;
          vm.totalShopProfiles = response.data.totalElements;

          for(var i=0; i < vm.shopProfiles.length; i++) {
            vm.shopProfiles[i].imageRandomNo = utilService._getRandomNumber()
          }
          $loading.finish('shopProfile');
          return vm.shopProfiles;
        }, function (error) {
          $loading.finish('shopProfile');
        }
      );
    }

    function checkIfExist(val1, val2) {
      var obj = JSON.parse(JSON.stringify(val1));
      return  _.find(obj.values, {isChecked:true}) !== undefined ? true : false;
    }

    function searchProfile() {
      getShopProfilesByShopIdForShopEmp();
      getFilterData();
      paginationTrackerService.setRegex(vm.regex);
    }

    function clearAllFilters() {
      $loading.start('filter');
      paginationTrackerService.setFilterObj(undefined);
      paginationTrackerService.setFilterArray(undefined);
      paginationTrackerService.setAge(undefined);
      paginationTrackerService.setHeight(undefined);
      filterObj = {};
      selArray = [{memberType:[]}, {profileStatus:[]}, {gender:[]},{vegOrNonVeg: []}, {caste:[]}, {subCaste:[]}, {highestEducation:[]},
        {star:[]}, {employedIn:[]}, {occupation:[]}, {martialStatus:[]}, {currentLivingCountry: []}, {currentLivingState: []}, {currentLivingCity: []}, {motherTongue: []},
        {casteNoBar: []}, {religion: []}];
      vm.filter = {};
      vm.fromAge = undefined;
      vm.toAge = undefined;
      vm.fromHeight = undefined;
      vm.toHeight = undefined;
      vm.page = 0;

      getShopProfilesByShopIdForShopEmp();
      getFilterData().then(function () {
        $loading.finish('filter');
      });
    }

    function setCurrentImage(i, profile) {
      utilService._setCurrentImage(i, profile);
    }

  }

})();


  /**
 * Created by GGowda on 3/15/2016.
 */
  (function() {
    'use strict';

    angular.module('anchePedheMatrimony').controller('ShopPaymentController', ShopPaymentController);

    /** @ngInject */
    function ShopPaymentController(shopService, $scope, $state, $loading) {
      /* jshint validthis: true */
      var vm = this;
      vm.changePath = changePath;

      getCurrentMonthShopProfileCountByShopId();
      getCurrentMonthShopPaymentInfo();
      getLastMonthShopPaymentInfo();
      getShopPaymentsByShopId();
      getShopProfileCountByShopId();


      function getLastMonthShopPaymentInfo() {
        $loading.start('lastMonthShopPaymentInfo');
        return shopService.getLastMonthShopPaymentInfo($scope.main.currentSession.shop.id)
          .then(function(response) {
            $loading.finish('lastMonthShopPaymentInfo');
            return vm.lastMonthShopPaymentInfo = response.data;
          }
        )
      }

      function getCurrentMonthShopPaymentInfo() {
        $loading.start('currentMonthShopPaymentInfo');
        return shopService.getCurrentMonthShopPaymentInfo($scope.main.currentSession.shop.id)
          .then(function(response) {
              $loading.finish('currentMonthShopPaymentInfo');
              return vm.currentMonthShopPaymentInfo = response.data;
            }
          )
      }

      function getShopProfileCountByShopId() {
        $loading.start('shopProfileCount');
        return shopService.getShopProfileCountByShopId($scope.main.currentSession.shop.id)
          .then(function(response) {
            $loading.finish('shopProfileCount');
            return vm.shopProfileCount = response.data;
          }
        )
      }

      function getCurrentMonthShopProfileCountByShopId() {
        $loading.start('currentMonthShopProfileCounts');
        return shopService.getCurrentMonthShopProfileCountByShopId($scope.main.currentSession.shop.id)
          .then(function(response) {
            $loading.finish('currentMonthShopProfileCounts');
            return vm.currentMonthShopProfileCounts = response.data;
          }
        )
      }

      function changePath(stateName, profileStatus, param) {
        $state.go(stateName, param);
      }

      function getShopPaymentsByShopId() {
        $loading.start('shopPayment');
        return shopService.getShopPaymentsByShopId($scope.main.currentSession.shop.id)
          .then(function(response) {
            $loading.finish('shopPayment');
            return vm.shopPayment = response.data;
        })
      }
    }
  })();

/**
 * Created by GGowda on 3/15/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ShopDashBoardController', ShopDashBoardController);

  /** @ngInject */
  function ShopDashBoardController($scope, shopService, $loading, $timeout, profileService) {
    /* jshint validthis: true */
    var vm = this;

    vm.showProfileInterestInfo = false;
    vm.showKnowMoreInfo = false;
    vm.showMobileNoInfo = false;

    if($scope.hmc.totalNotViewedNotification > 0) {
      (function() {
        var notificationPopUp = {};
        if($scope.main.currentSession.roles.includes("ROLE_USER")) {
          notificationPopUp.profileId = $scope.main.currentSession.profileBasicInfo.id;
        } else {
          notificationPopUp.shopId = $scope.main.currentSession.shop.id;
        }
        notificationPopUp.lastActive = new Date().getTime();

        $timeout(function () {
          profileService.updateNotificationPopUp(notificationPopUp)
            .then(function(res) {
              $scope.hmc.notification.notificationPopUp = res.data;
              $scope.hmc.totalNotViewedNotification = 0;
              $scope.hmc.notification.interestStatusCount = 0;
              $scope.hmc.notification.mobileNoRequestStatusCount = 0;
              $scope.hmc.notification.contactNoIssueCount = 0;
              //$scope.hmc.notification.callRequestStatusCount = 0;
            });
        }, 20000);
      })();
    }
  }
})();

/**
 * Created by GGowda on 3/16/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ShopController', ShopController);

  /** @ngInject */
  function ShopController(shopService, $stateParams, $q, $scope, $loading) {
    /* jshint validthis: true */
    var vm = this;
    $loading.start('shop');

    function getShopByShopId() {
      var shopId = $stateParams.shopId != undefined ? $stateParams.shopId : $scope.shopId;
      shopService.getShopByShopId(shopId).then(function(response) {
        return vm.shop = response.data;
      })
    }

    function getShopProfileCountByShopId() {
      /*return shopService.getShopProfileCountByShopId($stateParams.shopId)
        .then(function(response) {
          return vm.shopProfileCount = response.data;
        }
      )*/
    }

    $q.all([getShopByShopId(),getShopProfileCountByShopId()]).then(function () {
      $loading.finish('shop');
    });

  }
})();

/**
 * Created by GGowda on 3/16/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('SettingController', SettingController);

  /** @ngInject */
  function SettingController($scope, loginSignUpService, $log, $loading, profileService, $mdDialog, $timeout,
                             sessionManagerService, $state) {
    /* jshint validthis: true */
    var vm = this;

    vm.changePassword = changePassword;
    vm.changeMobileNo = changeMobileNo;
    vm.changeEmail = changeEmail;
    vm.getShopRolePermissions = getShopRolePermissions;
    vm.getEmployees = getEmployees;
    vm.onboardEmployee = onboardEmployee;
    vm.initAddUser = initAddUser;
    vm.initEditUser = initEditUser;
    vm.getPermissions = getPermissions;
    vm.changeEmployeePassword = changeEmployeePassword;

    function initAddUser() {
      vm.user = {
        mobileNo: "",
        password: "",
        roleName: "",
        action: "CREATE_EMPLOYEE",
        done:false
      }
    }

    function initEditUser(user) {
      vm.selectedUserId = user.id;
      vm.user = {
        id: user.id,
        mobileNo: user.mobileNo.length > 10 ? user.mobileNo.substring(user.mobileNo.length-10, user.mobileNo.length): user.mobileNo,
        roleName: user.roles[0],
        password: "",
        action: "EDIT_USER",
        done:false
      } 
    }

    function getPermissions(roleName) {
      var rolePermission = vm.rolePermissions.find(function(val){ 
        return val.roleName == roleName;
      });
      return rolePermission.permissions;
    }

    function validateUserInfo() {
      if(!vm.user.mobileNo || vm.user.mobileNo == "") {
        alert("Enter mobile number.")
      } else if(vm.user.mobileNo.length != 10) {
        alert("Enter valid Mobile Number.")
      } else if(!vm.user.password || vm.user.password == "") {
        alert("Enter password.")
      } else if(vm.user.password.length < 4) {
        alert("Enter minimum of 4 character password.")
      } else if(!vm.user.roleName || vm.user.roleName == "") {
        alert("Please select role.")
      }
    }
    function onboardEmployee(adduserForm) {
      validateUserInfo()
      if(adduserForm.$valid) {
        $loading.start("createUserBtn");
        loginSignUpService.createEmployeeUser({
          mobileNo: $scope.main.currentSession.shop.shopUniqueId != null? $scope.main.currentSession.shop.shopUniqueId+vm.user.mobileNo: vm.user.mobileNo,
          password: vm.user.password,
          roles: [vm.user.roleName],
          parentUserId:  $scope.main.currentSession.shop.parentUserId == null? $scope.main.currentSession.shop.userId: $scope.main.currentSession.shop.parentUserId
        }).then(function(res) {
          vm.user.done = true;
          vm.userList.push(res.data);
          $loading.finish("createUserBtn");
        }, function() {
          $loading.finish("createUserBtn");
        })
      }
    }

    function getEmployees() {
      var userId = $scope.main.currentSession.shop.parentUserId == null 
        || $scope.main.currentSession.shop.parentUserId == ""? 
        $scope.main.currentSession.shop.userId: $scope.main.currentSession.shop.parentUserId;
      loginSignUpService.getUsersByUserId(userId).then(function(res) {
        vm.userList = res.data;
      })
    }

    function getShopRolePermissions() {
      var userId = $scope.main.currentSession.shop.parentUserId == null 
        || $scope.main.currentSession.shop.parentUserId == ""? 
        $scope.main.currentSession.shop.userId: $scope.main.currentSession.shop.parentUserId;
      loginSignUpService.getShopRolePermissionByUserId(userId).then(function(res) {
        vm.rolePermissions = res.data;
      })
    }

    function changeEmployeePassword(resetPasswordForm, event) {
      validateUserInfo();
      if(resetPasswordForm.$valid) {
        loginSignUpService.changePassword(vm.user.id, vm.user.mobileNo, vm.user.password).then(function() {
          vm.user = {};
          vm.selectedUserId = "";
          $mdDialog.show(
            $mdDialog.alert()
              .targetEvent(event)
              .clickOutsideToClose(true)
              .parent('body')
              .title('Password Changed Successfully.')
              .textContent('If you have changed the same password, which you have logged in then please logout and login again.')
              .ok('Ok')
          );
        })
      }
    }

    function changePassword(resetPassform) {
      if(!resetPassform.$valid) {
        return !1;
      }
      $loading.start("settingBtn");
      loginSignUpService.changePassword($scope.main.currentSession.id, "", $scope.sc.newPassword).then(function() {
        vm.passwordSaveSuccess = true;
        $loading.finish("settingBtn");
        $timeout(function () {
          $scope.main.logout();
        }, 3000);

      }, function() {
        $log.debug('error');
        $loading.finish("settingBtn");
      });
    }


    vm.otpCond = {
      showMobileOTPForm : false,
      verifyMobileOTPSuccess: false,
      verifyMobileOTPFailure: false
    }


    vm.sendOTPToMobile = function () {
      profileService.sendOTPToMobile({'profileId': $scope.main.currentSession.profileBasicInfo.id,
        'mobileNo': $scope.sc.newMobileNo, shopUniqueId: $scope.main.currentSession.shop.shopUniqueId}).then(function () {
        vm.otpCond.showMobileOTPForm = true;
      })
    };

    vm.verifyMobileNo = function (mobileNo) {
      loginSignUpService.verifyMobileNo($scope.main.currentSession.shop.shopUniqueId+mobileNo).then(function () {

      }, function () {
        vm.mobileNoExist = true;
      });
    }

    function verifyMobileNoExist(mobileNo) {
      return  loginSignUpService.verifyMobileNo(mobileNo);

    }

    vm.verifyMobileOTP = function () {
      if(!$scope.MobileOTPForm.$valid) {
        return !1;
      }
      profileService.verifyOTPToChangeMobileNo({'profileId': $scope.main.currentSession.profileBasicInfo.id,
        'newMobileNo':vm.newMobileNo, 'oldMobileNo':vm.oldMobileNo,'otpNo': vm.OTPNo,
        'shopUniqueId': $scope.main.currentSession.shop.shopUniqueId}).then(function () {
          vm.otpCond.verifyMobileOTPSuccess = true;
          $timeout(function () {
            $scope.main.currentSession.profileBasicInfo.mobileNo = $scope.sc.newMobileNo;
            $scope.sc.oldMobileNo = $scope.sc.newMobileNo;
            $mdDialog.hide();
            $scope.main.logout();
            $state.go('account.login');
          }, 5000)

        }, function () {
          vm.otpCond.verifyMobileOTPFailure = true;
        })
    }

    function changeMobileNo(resetMobileNoForm, ev) {
      if(!resetMobileNoForm.$valid) {
        return !1;
      }
      var mobileNo = vm.newMobileNo;
      if($scope.main.currentSession.shop.shopUniqueId != null && $scope.main.currentSession.shop.shopUniqueId != "") {
        mobileNo = $scope.main.currentSession.shop.shopUniqueId+mobileNo;
      }
      verifyMobileNoExist(mobileNo).then(function() {
        $mdDialog.show({
          templateUrl: 'mobileno-change-verify.tmpl.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          targetEvent: ev,
          scope: $scope,        // use parent scope in template
          preserveScope: true,
          fullscreen: false // Only for -xs, -sm breakpoints.
        })
          .then(function(answer) {
            $scope.status = 'You said the information was "' + answer + '".';
          }, function() {
            $scope.status = 'You cancelled the dialog.';
          });
      }, function(){
        vm.mobileNoExist = true;
      })
    }

    function changeEmail(resetEmailForm) {
      vm.msg = $scope.sc.oldEmail == $scope.sc.newEmail || false;
      if(!resetEmailForm.$valid || vm.msg) {
        return !1;
      }

      $loading.start("settingBtn");

      profileService.updateEmail($scope.sc.newEmail, $scope.main.currentSession.profileBasicInfo.id).then(function (res) {
        $loading.finish("settingBtn");
        $scope.sc.oldEmail = $scope.sc.newEmail;
        delete $scope.sc.newEmail;
        resetEmailForm.newEmail.$dirty = false;
        resetEmailForm.$submitted = false;
        vm.emailSaveSuccess = true;
        $timeout(function () {
          vm.emailSaveSuccess = false;
        }, 2000);
        $scope.main.currentSession.profileBasicInfo.email = res.data.email;
        sessionManagerService.setSessionData($scope.main.currentSession);
      });
    }
  }
})();

/**
 * Created by GGowda on 3/16/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(profileService, $scope, $log, $state, $mdToast, notification,
                          $mdDialog, $timeout, sessionManagerService, $loading) {

    var profileInfo = $scope.main.currentSession.profileBasicInfo;
    var matrimonyId = profileInfo !== null && profileInfo !== undefined ? profileInfo.matrimonyId : '';
    var vm = this;
    vm.getImagePath =getImagePath;

    vm.mobileNotVerified = {
      showMobileOTPForm : false,
      verifyMobileOTPSuccess: false,
      verifyMobileOTPFailure: false
    };

    vm.changePathFromNotification = changePathFromNotification;
    vm.totalNotViewedNotification = 0;
    vm.updateNotificationById = updateNotificationById;
    vm.updateAllNotificationByMatrimonyId = updateAllNotificationByMatrimonyId;

    function updateAllNotificationByMatrimonyId() {
      return profileService.updateAllNotificationByMatrimonyId(matrimonyId)
        .then(function() {
          vm.currentSession.notifications.totalElements = 0;
          vm.currentSession.notifications = {};
          $log.debug('updated all notification');
        })
    }


    (function() {
      for(var key in notification) {
        if(key != "notificationPopUp")  {
          vm.totalNotViewedNotification +=  notification[key];
        }
        vm.notification = notification;
      }
    })();

    // (function getNotificationByMatrimonyId() {
    //   return profileService.getNotificationByMatrimonyId(matrimonyId, 0, 4).then(function(response) {
    //     vm.notifications = response.data.content;
    //   })
    // })();


    function  updateNotificationById(notificationId) {
      profileService.updateNotificationById(notificationId).then(function() {
        console.log("success");
        var index = $scope.main._.findIndex(vm.notifications, function(o) { return o.id == notificationId; });
        if(index > -1) {
          vm.notifications[index].viewed = !0;
        }
      });
    }

    

    function changePathFromNotification(stateName, profileName, matrimonyId, param, notificationId, isViewed,
                                        profileDeleted) {
      $state.go(stateName, param);
    }

    vm.showEmailToast = function() {
      var toast = $mdToast.simple()
        .textContent('Hi, You Have Not Added Your Email Address (mandatory). ' +
          'Click here to add email.')
        .action('ADD')
        .highlightAction(true)
        .highlightClass('md-accent')// Accent is used by default, this just demonstrates the usage.
        .position("top right")
        .hideDelay(130000);

      $mdToast.show(toast).then(function(response) {
        if ( response == 'ok' ) {
          addMandatoryEmail();
        }
      });
    }

    function addMandatoryMobileNo() {
      $mdDialog.show({
        templateUrl: 'add-mobileno.tmpl.html',
        parent: angular.element(document.body),
        preserveScope: true,
        $scope: $scope,
        clickOutsideToClose:false,
        controller: EmailController,
        controllerAs: 'tc',
        fullscreen: false // Only for -xs, -sm breakpoints.
      })
        .then(function(answer) {
          console.log("addEmail");
        }, function() {
          console.log("addEmail");
        })
    }

    function addMandatoryEmail() {
      $mdDialog.show({
        templateUrl: 'add-email.tmpl.html',
        parent: angular.element(document.body),
        preserveScope: true,
        $scope: $scope,
        clickOutsideToClose:false,
        controller: EmailController,
        controllerAs: 'tc',
        fullscreen: false // Only for -xs, -sm breakpoints.
      })
        .then(function(answer) {
          console.log("addEmail");
        }, function() {
          console.log("addEmail");
        })
    }

    function EmailController(profileService, $loading) {
      var vn = this;
      vn.logout = function () {
        $mdDialog.hide();
        $scope.main.logout();
      }

      vn.addMobileNo = function (form) {
        if(!form.$valid) {
          return !1;
        }
      }
      vn.addEmail = function (form) {
        if(!form.$valid) {
          return !1;
        }
        $loading.start("addEmailBtn");

        profileService.updateEmail( vn.email,
            $scope.main.currentSession.profileBasicInfo.id).then(function (res) {
          $loading.finish("addEmailBtn");
          vn.emailSaved = true;
          $scope.main.currentSession.profileBasicInfo.email = res.data.email;
          $scope.main.currentSession.profileBasicInfo.emailVerified = res.data.emailVerified;
          sessionManagerService.setSessionData($scope.main.currentSession);

          $timeout(function () {
            $mdDialog.hide();
          }, 2000)
        });
      }
    }

    function addImage() {
      $mdDialog.show({
        templateUrl: 'add-profile-images.tmpl.html',
        parent: angular.element(document.body),
        preserveScope: true,
        $scope: $scope,
        clickOutsideToClose:false,
        controller: ProfileImageController,
        controllerAs: 'pi',
        fullscreen: false // Only for -xs, -sm breakpoints.
      })
        .then(function(answer) {
          console.log("addImage");
        }, function() {
          console.log("addImage");
        })
    }

    function ProfileImageController(profileService, $loading) {
      var vn = this;
      vn.items = [
        {
          photo: false,
          name: "image1",
          to: "",
          isMainPhoto: false,
          image: "./assets/images/no_image.png",
          invalidFile: ""
        },
        {
          photo: false,
          name: "image2",
          to: "",
          isMainPhoto: false,
          image: "./assets/images/no_image.png",
          invalidFile: ""
        }
      ];

      vn.afterResizingImages = function(file) {
        $loading.finish('imageLoading')
      }

      vn.beforeResizingImages = function(file) {
        $loading.start('imageLoading');
      }

      vn.logout = function () {
        $mdDialog.hide();
        $scope.main.logout();
      }
      vn.uploadImage = function (form) {
        if(!form.$valid) {
          return !1;
        }

        var profile = $scope.main.currentSession.profileBasicInfo;

        var deleteImages = [];
        deleteImages.push({originalImage: profile.profileImages[0].originalImage});
        deleteImages.push({originalImage: profile.profileImages[1].originalImage});

        // profileService.deleteImage(deleteImages).then(function() {
        //   console.log("images deleted")
        // }, function () {
        //   console.log("images not deleted")
        // });

        var files = [];
        files.push(vn.items[0].photo);
        files.push(vn.items[1].photo);

        $loading.start('uploadImageBtn');
        profileService.uploadMultipleProfileImage(files, profile.matrimonyId, profile.shopId, profile.profileStatus)
          .then(function (res) {
            $loading.finish('uploadImageBtn');
            $scope.main.currentSession.profileBasicInfo = res.data;
            
            $scope.main.currentSession.profileBasicInfo.showPopupImageUpload = false;
            sessionManagerService.setSessionData($scope.main.currentSession);
            $mdDialog.hide();
            if($scope.main.currentSession.profileBasicInfo.email == null) {
              addMandatoryEmail();
            }
          });


      }
    }

    vm.sendOTPToMobile = function () {
      $loading.start("verifyMobileBtn");
      vm.mobileNotVerified.showMobileOTPForm = true;
      profileService.sendOTPToMobile({'profileId': $scope.main.currentSession.profileBasicInfo.id,
        'mobileNo': $scope.main.currentSession.profileBasicInfo.mobileNo}).then(function () {
        vm.mobileNotVerified.showMobileOTPForm = true;
        $loading.finish("verifyMobileBtn");
      }, function () {

      })
    };

    vm.verifyMobileNo = function (mobileVerifyOTPForm,otpNo) {
      if(!mobileVerifyOTPForm.$valid) {
        return !1;
      }
      $loading.start("verifyMobileBtn");
      profileService.verifyOTPToVerifyMobileNo({'profileId': $scope.main.currentSession.profileBasicInfo.id,
        'mobileNo': $scope.main.currentSession.profileBasicInfo.mobileNo, 'otpNo': otpNo}).then(function () {
        vm.mobileNotVerified.verifyMobileOTPSuccess = true;
        $scope.main.currentSession.profileBasicInfo.mobileNoVerified = true;
        sessionManagerService.setSessionData($scope.main.currentSession);
        profileService.updateProfileLastActive($scope.main.currentSession.profileBasicInfo.id);
        $loading.finish("verifyMobileBtn");
        $timeout(function () {
          $mdDialog.hide();
          if($scope.main.currentSession.profileBasicInfo.email == null) {
            addMandatoryEmail();
          }
        }, 2000)
      }, function () {
        $loading.finish("verifyMobileBtn");
        vm.mobileNotVerified.verifyMobileOTPFailure = true;
      });
    }

    function getImagePath(orgImagePath) {
      return orgImagePath.replace(/\/\/+/g, '/');
    }

    function showMobileNotVerifiedDialog() {
      // $mdDialog.show({
      //   templateUrl: 'mobileno-verify.tmpl.html',
      //   parent: angular.element(document.body),
      //   scope: $scope,        // use parent scope in template
      //   preserveScope: true,
      //   fullscreen: false // Only for -xs, -sm breakpoints.
      // })
      //   .then(function(answer) {
      //     $scope.status = 'You said the information was "' + answer + '".';
      //   }, function() {
      //     $scope.status = 'You cancelled the dialog.';
      //   });
    }

    if($scope.main.currentSession.roles.includes("ROLE_USER") && !$scope.main.currentSession.profileBasicInfo.mobileNoVerified
       && $scope.main.currentSession.profileBasicInfo.memberType == "MBW Member") {
      //showMobileNotVerifiedDialog();
    } else if($scope.main.currentSession.roles.includes("ROLE_USER") && $scope.main.currentSession.shop.optPopup
      && !$scope.main.currentSession.profileBasicInfo.mobileNoVerified) {
      //showMobileNotVerifiedDialog();
    } else if($scope.main.currentSession.roles.includes("ROLE_USER")) {
      if($scope.main.currentSession.profileBasicInfo.memberType == "APW Member"
          && $scope.main.currentSession.profileBasicInfo.showPopupImageUpload) {
        addImage();
      } else if($scope.main.currentSession.profileBasicInfo.email == null ||
        angular.isUndefined($scope.main.currentSession.profileBasicInfo.email)) {
        addMandatoryEmail();
      }
    }
  }
})();

(function() {
    'use strict';
  
    angular.module('anchePedheMatrimony').controller('SearchProfileNotLoggedInController', SearchProfileNotLoggedInController);
  
    /** @ngInject */
    function SearchProfileNotLoggedInController(profileService, $scope, paginationTrackerService, IMAGE_URL,
                                      $loading, sessionManagerService, utilService, $mdDialog, $timeout,
                                      $location, $window) {
        $loading.start("searchNotProfileBtn");
        var qSrch = paginationTrackerService.getQuickSrch();
        var vm = this;
        vm.host = $window.location.host;
        vm.partnerPreference = {};
        var page = 1;
        vm.pageSize = 10;
        vm.imageUrl = IMAGE_URL;
        $scope.currentPage = page;
        var shop = sessionManagerService.getNotLoginData()['shop'];
        findProfileMatchesByQuery();

        vm.setCurrentImage = setCurrentImage;
        vm.pageChangeHandler = pageChangeHandler;

        function login() {
            $mdDialog.show({
                templateUrl: 'login.tmpl.html',
                parent: angular.element(document.body),
                preserveScope: true,
                $scope: $scope,
                clickOutsideToClose:true,
                controller: NotLoggedInController,
                controllerAs: 'nlc',
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
                console.log("login");
            }, function() {
                console.log("login");
            })
        }

        function NotLoggedInController(loginSignUpService, $loading, httpService,sessionManagerService,
            $log, $location) {
            var vn = this;
            vn.diaglog =  $mdDialog;
            vn.authenticate = function(form) {
                if(!form.$valid) {
                    return !1;
                }
                $loading.start("loginBtn");
                loginSignUpService.checkAuthenticate(vn.user.name, vn.user.password, {}).then(function(res) {
                    $loading.finish("loginBtn");
                    httpService.setAuthorization(res.data['base64EncodedAuthenticationKey']);
                    if (sessionManagerService.getUserData().shopEmp) {
                    $location.path('/myShopProfile');
                    } else if(sessionManagerService.getUserData().roles.includes("ROLE_USER")) {
                    $location.path('/multiple-accounts');
                    }
                    $timeout(function () {
                        $mdDialog.hide();
                      }, 1000)
                }, function (error) {
                    vn.errorStatus = true;
                    $loading.finish("loginBtn");
                    $log.info("error "+error);
                });
            }
        }

        function setCurrentImage(i, profile) {
            utilService._setCurrentImage(i, profile);
        }

        function pageChangeHandler(pageNo) {
            page = pageNo;
            $scope.currentPage = page;
            $location.path('/register');
        }

        function findProfileMatchesByQuery() {
            $loading.start("searchNotProfileBtn");
            var neverMarried = qSrch.martialStatus === 'neverMarried';;
            var casteNoBar = qSrch.caste === 'casteNoBar';

            var caste = casteNoBar ? "Any" : qSrch.caste;
            var gender = qSrch.gender === 'Male' ? 'Female' : 'Male';
        
            vm.partnerPreference.fYearPref = (new Date().getFullYear() - qSrch.fAge);
            vm.partnerPreference.tYearPref = (new Date().getFullYear() - qSrch.tAge);
        
            return   profileService.getMatchingProfilesBySearchQuery(vm.partnerPreference, caste,
                "", page, vm.pageSize, gender, shop.id, shop.otherClientViewYourProfiles,
                shop.anchepedheMarriageBureau, casteNoBar, neverMarried, shop.othrPfVwCtNo,
                shop.allwOnlyMbPfWhShwCtNo).then(function(response) {
                    $loading.finish("searchNotProfileBtn");
                    vm.profileMatches = response.data.results;
                    vm.totalProfileMatch = response.data.total;
                }
            );
        }
                                      
    }
})();
/**
 * Created by GGowda on 3/16/2016.
 */
(function () {
  'use strict';

  angular.module('anchePedheMatrimony').controller('SearchProfilesController', SearchProfilesController);

  /** @ngInject */
  function SearchProfilesController(profileService, $scope, codeValueService, paginationTrackerService, IMAGE_URL,
    $loading, $state, utilService) {
    /* jshint validthis: true */
    var vm = this;
    vm.utilService = utilService;
    vm.page = angular.isUndefined(paginationTrackerService.getPaginationSearchProfile()) ? 0 :
      paginationTrackerService.getPaginationSearchProfile();
    vm.pageSize = 16;
    vm.total = 0;
    if (angular.isDefined(paginationTrackerService.getPaginationSearchProfilePartnerPref())) {
      vm.partnerPreference = paginationTrackerService.getPaginationSearchProfilePartnerPref();
      $loading.start("searchProfile");
      //vm.profileMatches = [];
      findProfileMatchesByQuery();
    } else {
      callInit(false);
    }
    $scope.currentPage = vm.page;

    vm.changePath = changePath;
    vm.gender = $scope.main.currentSession.profileBasicInfo.gender;
    vm.getCities = getCities;
    vm.getPartnerPreferenceByMatrimonyId = getPartnerPreferenceByMatrimonyId;
    vm.getPartnerPreferenceTemplate = getPartnerPreferenceTemplate;
    vm.imageUrl = IMAGE_URL;
    vm.findProfileMatchesByQuery = findProfileMatchesByQuery;
    vm.getSubCaste = getSubCaste;
    vm.getStates = getStates;
    vm.pageChangeHandler = pageChangeHandler;
    vm.setCityPref = setCityPref;
    vm.setCountryPref = setCountryPref;
    vm.setHighestEducationPref = setHighestEducationPref;
    vm.setMartialStatusPref = setMartialStatusPref;
    vm.setOccupationPref = setOccupationPref;
    vm.setStatePref = setStatePref;
    vm.setSubCastePref = setSubCastePref;
    vm.callInit = callInit;
    vm.clearSearchTerm = clearSearchTerm;
    vm.checkIfExist = checkIfExist;
    vm.setEmployedInPref = setEmployedInPref;
    vm.setMotherTonguePref = setMotherTonguePref;
    vm.setCastePref = setCastePref;
    vm.setCurrentImage = setCurrentImage;
    vm.searchTerm;
    vm.searchByMatrimonyId = searchByMatrimonyId;
    vm.setStarPref = setStarPref;
    vm.searchSubmit = searchSubmit;
    vm.next = next;
    vm.previous = previous;
    vm.getMatchingProfilesByPageNo = getMatchingProfilesByPageNo;
    vm.submitPageNo;


    function searchByMatrimonyId() {
      if ($scope.searchByMatrimonyIDForm.$invalid) {
        return false;
      }

      $state.go('home.profile', { "matrimonyId": vm.matrimonyId.toUpperCase(), shopId: "" });
    }

    function clearSearchTerm() {
      vm.searchTerm = '';
    };

    function checkIfExist(item, values) {
      if (item == "" || angular.isUndefined(item)) {
        return true;
      } else {
        return JSON.stringify(values).toLowerCase().indexOf(item) > -1;
      }
    }

    function callInit(isNotActive) {
      if (!isNotActive) {
        getPartnerPreferenceByMatrimonyId();
        getPartnerPreferenceTemplate();
        getCaste();
      }
    }
    function changePath(stateName, profileName, matrimonyId, param) {
      $state.go(stateName, param);
    }

    function getPartnerPreferenceTemplate() {
      if (angular.isUndefined(vm.partnerPreferenceTemplate)) {
        return profileService.getPartnerPreferenceTemplate().then(function (response) {
          vm.partnerPreferenceTemplate = response.data;
          return vm.partnerPreferenceTemplate;
        });
      }
    }

    function getPartnerPreferenceByMatrimonyId() {
      var shopId = null;
      if ($scope.main.currentSession.profileBasicInfo) {
        shopId = $scope.main.currentSession.profileBasicInfo.shopId;
      }

      if (angular.isUndefined(vm.partnerPreference)) {
        $loading.start("searchProfile");
        return profileService.getPartnerPreferenceByMatrimonyId($scope.main.currentSession.profileBasicInfo.matrimonyId,
          shopId).then(function (response) {
            vm.partnerPreference = response.data;

            if (angular.isDefined(vm.partnerPreference) && vm.partnerPreference != "") {
              vm.partnerPreference.fromYearPref = utilService._calculateAgeByYear(vm.partnerPreference.fYearPref, 0, 1);
              vm.partnerPreference.toYearPref = utilService._calculateAgeByYear(vm.partnerPreference.tYearPref);
              getSubCaste(vm.partnerPreference.castePref[0]);

              if (vm.partnerPreference.statePref.length > 0) {
                getStates();
              }
            } else {
              vm.partnerPreference = {};
              vm.partnerPreference.castePref = [];
              if (!$scope.main.currentSession.profileBasicInfo.casteNoBar) {
                vm.partnerPreference.castePref.push($scope.main.currentSession.profileBasicInfo.caste);
                getSubCaste($scope.main.currentSession.profileBasicInfo.caste);
              } else {
                vm.partnerPreference.castePref.push('Any');
              }

              vm.partnerPreference.martialStatusPref = [];
              if ($scope.main.currentSession.profileBasicInfo.martialStatus.indexOf('Never Married') > -1) {
                vm.partnerPreference.martialStatusPref.push('Never Married')
              } else {
                vm.partnerPreference.martialStatusPref.push('Any')
              }

              vm.partnerPreference.motherTonguePref = [];
              vm.partnerPreference.motherTonguePref.push($scope.main.currentSession.profileBasicInfo.motherTongue);
            }
            $loading.finish("searchProfile");
            return vm.partnerPreference;
          });
      } else {
        // vm.partnerPreference.fYearPref = utilService._calculateAgeByYear(vm.partnerPreference.fYearPref, 0, 1);
        // vm.partnerPreference.tYearPref = utilService._calculateAgeByYear(vm.partnerPreference.tYearPref);
        getSubCaste($scope.main.currentSession.profileBasicInfo.caste);
      }

    }

    function getCaste() {
      return codeValueService.getCodeByName('Hindu').then(function (response) {
        vm.casteOptions = response.data;
      });
    };

    function getSubCaste(casteVal) {
      return codeValueService.getCodeByName(casteVal).then(function (response) {
        vm.subCasteOptions = response.data;
        return vm.subCasteOptions;
      });
    }

    function setMotherTonguePref(val) {
      var val1 = vm.partnerPreference.motherTonguePref;
      if (angular.isDefined(val) && val == 'Any') {
        vm.partnerPreference.motherTonguePref = [];
        vm.partnerPreference.motherTonguePrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.motherTonguePref, 'Any');
      }
    }

    function setMartialStatusPref(val) {
      var val1 = vm.partnerPreference.martialStatusPref;
      if (val != undefined && val == 'Any') {
        vm.partnerPreference.martialStatusPref = [];
      } else if (val1 != undefined && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.martialStatusPref, 'Any');
      }
    }

    function setHighestEducationPref(val) {
      var val1 = vm.partnerPreference.highestEducationPref;
      if (val != undefined && val == 'Any') {
        vm.partnerPreference.highestEducationPref = [];
      } else if (val1 != undefined && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.highestEducationPref, 'Any');
      }
    }

    function setOccupationPref(val) {
      var val1 = vm.partnerPreference.occupationPref;
      if (val != undefined && val == 'Any') {
        vm.partnerPreference.occupationPref = [];
      } else if (val1 != undefined && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.occupationPref, 'Any');
      }
    }

    function setCastePref(val) {
      var val1 = vm.partnerPreference.castePref;
      if (angular.isDefined(val) && (val == 'Any' || val == "Other")) {
        vm.partnerPreference.castePref = [];
        vm.partnerPreference.castePrefMandatory = false;
      } else if (angular.isDefined(val1) && (val1.indexOf('Any') > -1 || val1.indexOf('Other') > -1)) {
        $scope.main._.pull(vm.partnerPreference.castePref, 'Any');
        $scope.main._.pull(vm.partnerPreference.castePref, 'Other');
      } else if (angular.isDefined(vm.partnerPreference.castePref) &&
        vm.partnerPreference.castePref.length > 0 &&
        vm.partnerPreference.castePref.indexOf(val) > -1) {

        //unchecked
        codeValueService.getCodeByName(val).then(function (response) {
          $scope.main._.pullAllBy(vm.subCasteOptions, response.data.values, 'value');

          if (vm.subCasteOptions.length > 0) {
            vm.subCasteOptions.splice(0, 0, {
              category: null,
              id: "1",
              value: "Any"
            });
            vm.subCasteOptions.push({
              category: null,
              id: "999",
              value: "Other"
            })
          }

          var stringyfyvalues = JSON.stringify(response.data.values);
          $scope.main._.remove(vm.partnerPreference.subCastePref, function (val) {
            return stringyfyvalues.indexOf(val) > -1;
          });
        });
      } else if (!$scope.main.currentSession.profileBasicInfo.casteNoBar
        && !$scope.main.currentSession.profileBasicInfo.subCasteNoBar) {
        getSubCasteOptions(val);
      }
    }

    function setSubCastePref(val) {
      var val1 = vm.partnerPreference.subCastePref;
      if (val != undefined && val == 'Any') {
        vm.partnerPreference.subCastePref = [];
      } else if (val1 != undefined && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.subCastePref, 'Any');
      }
    }

    function setCountryPref(val) {
      var countryPref = vm.partnerPreference.countryPref;
      var val1 = angular.isDefined(countryPref) ? countryPref : [];
      if (angular.isDefined(val) && val == 'Any') {
        vm.partnerPreference.countryPref = [];
        vm.partnerPreference.countryPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.countryPref, 'Any');
      } else if (val.indexOf('India') > -1 && val1.indexOf('India') < 0) {
        getStates();
      } else if (val.indexOf('India') > -1 && val1.indexOf('India') > -1) {
        //when country india unselect
        vm.partnerPreference.statePref = [];
        vm.partnerPreference.cityPref = [];
        vm.stateOptions = [];
        vm.cityOptions = [];
      }
    }

    function setEmployedInPref(val) {
      var val1 = vm.partnerPreference.employedInPref;
      if (angular.isDefined(val) && val == 'Any') {
        vm.partnerPreference.employedInPref = [];
        vm.partnerPreference.employedInPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.employedInPref, 'Any');
      }
    }

    function setStarPref(val) {
      var val1 = vm.partnerPreference.starPref;
      if (angular.isDefined(val) && val == 'Any') {
        vm.partnerPreference.starPref = [];
      } else if (angular.isDefined(val1) && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.starPref, 'Any');
      }
    }

    function setStatePref(val) {
      var val1 = vm.partnerPreference.statePref;
      if (angular.isDefined(val) && val == 'Any') {
        vm.partnerPreference.statePref = [];
        vm.partnerPreference.statePrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf('Any') > -1) {
        $scope.main._.pull(vm.partnerPreference.statePref, 'Any');
      } else if (angular.isDefined(vm.partnerPreference.statePref) &&
        vm.partnerPreference.statePref.length > 0 &&
        vm.partnerPreference.statePref.indexOf(val) > -1) {

        //unchecked
        codeValueService.getCodeByName(val).then(function (response) {
          $scope.main._.pullAllBy(vm.cityOptions, response.data.values, 'value');

          if (vm.cityOptions.length > 0) {
            vm.cityOptions.splice(0, 0, {
              category: null,
              id: "1",
              value: "Any"
            });
            vm.cityOptions.push({
              category: null,
              id: "999",
              value: "Other"
            })
          }

          var stringyfyvalues = JSON.stringify(response.data.values);
          $scope.main._.remove(vm.partnerPreference.cityPref, function (val) {
            return stringyfyvalues.indexOf(val) > -1;
          });
        });
      } else {
        getCities(val);
      }
    }

    function setCityPref(val) {
      var val1 = vm.partnerPreference.cityPref;
      if (angular.isDefined(val) && (val == 'Any' || val == "Other")) {
        vm.partnerPreference.cityPref = [];
        vm.partnerPreference.cityPrefMandatory = false;
      } else if (angular.isDefined(val1) && (val1.indexOf('Any') > -1 || val1.indexOf('Other') > -1)) {
        $scope.main._.pull(vm.partnerPreference.cityPref, 'Any');
        $scope.main._.pull(vm.partnerPreference.cityPref, 'Other');
      }
    }

    function getStates() {
      return codeValueService.getCodeByName('India').then(function (response) {
        vm.partnerPreference.statePref = [];
        vm.partnerPreference.cityPref = [];
        vm.stateOptions = response.data.values;
        return vm.stateOptions;
      });
    }

    vm.cityOptions = [];
    function getCities(val) {
      if (val && val.indexOf('Any') == -1) {
        codeValueService.getCodeByName(val).then(function (response) {
          if (vm.cityOptions.length > 0) {
            vm.cityOptions = $scope.main._.initial(vm.cityOptions)
          }
          vm.cityOptions = $scope.main._.unionBy(vm.cityOptions, response.data.values, 'value');
        });
      }
    }

    function getMatchingProfilesByPageNo() {
      if (isNaN(vm.submitPageNo)) {
        vm.submitPageNo = '';
        alert('Please enter page no.');
      } else if (vm.submitPageNo < 0) {
        vm.submitPageNo = '';
        alert('Please enter valid page no.');
      } else {
        vm.page = vm.submitPageNo - 1;
        if (vm.page > vm.total) {
          alert('Please enter valid page no.')
        } else {
          paginationTrackerService.setPaginationSearchProfile(vm.page);
          findProfileMatchesByQuery('searchProfile');
        }
      }

    }

    function findProfileMatchesByQuery(loader) {
      if (angular.isDefined($scope.spc) && angular.isDefined($scope.spc.preferenceForm) && !$scope.spc.preferenceForm.$valid) {
        return !1;
      }
      $loading.start(loader);
      if (angular.isUndefined(vm.partnerPreference.annualIncomePreFrom)) {
        vm.partnerPreference.annualIncomePreFrom = 0;
      }

      var caste = $scope.main.currentSession.profileBasicInfo.caste;
      var casteNoBar = $scope.main.currentSession.profileBasicInfo.casteNoBar;
      var neverMarried = $scope.main.currentSession.profileBasicInfo.martialStatus == "Never Married" || false;

      vm.partnerPreference.fYearPref = (new Date().getFullYear() - vm.partnerPreference.fromYearPref);
      vm.partnerPreference.tYearPref = (new Date().getFullYear() - vm.partnerPreference.toYearPref);

      return profileService.getMatchingProfilesBySearchQuery(vm.partnerPreference, caste,
        $scope.main.currentSession.profileBasicInfo.matrimonyId,
        vm.page, vm.pageSize, $scope.main.currentSession.profileBasicInfo.gender,
        $scope.main.currentSession.profileBasicInfo.shopId,
        $scope.main.currentSession.shop.otherClientViewYourProfiles,
        $scope.main.currentSession.shop.anchepedheMarriageBureau,
        casteNoBar, neverMarried,
        $scope.main.currentSession.shop.othrPfVwCtNo, $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo)
        .then(function (response) {
          paginationTrackerService.setPaginationSearchProfilePartnerPref(vm.partnerPreference);
          vm.profileMatches = response.data.results;
          vm.totalProfileMatch = response.data.total;
          vm.total = Math.ceil(response.data.total / vm.pageSize);

          $loading.finish(loader);
        }
        );
    }

    function pageChangeHandler(pageNo) {
      page = pageNo;
      $scope.currentPage = page;
      paginationTrackerService.setPaginationSearchProfile(page);
      findProfileMatchesByQuery();
    }

    function setCurrentImage(i, profile) {
      utilService._setCurrentImage(i, profile);
    }

    function next() {
      vm.page++;
      paginationTrackerService.setPaginationSearchProfile(vm.page);
      findProfileMatchesByQuery('searchProfile');
    }

    function previous() {
      vm.page--;
      paginationTrackerService.setPaginationSearchProfile(vm.page);
      findProfileMatchesByQuery('searchProfile');
    }

    function searchSubmit() {
      paginationTrackerService.setPaginationSearchProfile(vm.page);
      findProfileMatchesByQuery('searchProfileBtn');
    }
  }
})();

/**
 * Created by GGowda on 3/12/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ProfileShortListedByMeController',
        ProfileShortListedByMeController);

  /** @ngInject */
  function ProfileShortListedByMeController(profileService, $scope, $state, $loading) {
    var page = 0;
    /* jshint validthis: true */
    var vm = this;

    vm.changePath = changePath;
    vm.getProfileShortListedByMe = getProfileShortListedByMe;
    vm.pageSize = 10;
    vm.pageChangeHandler = pageChangeHandler;

    getProfileShortListedByMe();

    function getProfileShortListedByMe() {
      $loading.start("profileShortListedByMe");
      return profileService.getProfileShortListedByMe($scope.main.currentSession.profileBasicInfo.matrimonyId, page,
        vm.pageSize).then(function(response) {
          vm.profileShortListedByMe = response.data.content;
          vm.totalProfileShortListedByMe = response.data.totalElements;
          $loading.finish("profileShortListedByMe");
          return vm.profileShortListedByMe;
        }
      );
    }

    function pageChangeHandler(pageNo) {
      page = pageNo-1;
      getProfileShortListedByMe();
    }

    function changePath(stateName, profileName, matrimonyId, param, profileDeleted) {
      $state.go(stateName, param);
    }

  }
})();

/**
 * Created by GGowda on 3/12/2016.
 */
(function () {
  "use strict";

  angular
    .module("anchePedheMatrimony")
    .controller("ProfileMatchController", ProfileMatchController);

  /** @ngInject */
  function ProfileMatchController(
    $scope,
    profileService,
    $state,
    $loading,
    paginationTrackerService,
    utilService,
    shopService
  ) {
    var vm = this;
    vm.page = angular.isUndefined(
      paginationTrackerService.getPaginationProfileMatch()
    )
      ? 0
      : paginationTrackerService.getPaginationProfileMatch();

    $scope.currentPage = vm.page;

    vm.changePath = changePath;
    vm.pageSize = 16;
    vm.pageChangeHandler = pageChangeHandler;
    vm.getMatchingProfiles = getMatchingProfiles;
    vm.utilService = utilService;
    vm.setCurrentImage = setCurrentImage;
    vm.next = next;
    vm.previous = previous;
    vm.getMatchingProfilesByPageNo = getMatchingProfilesByPageNo;
    vm.submitPageNo;

    (function () {
      var shopId = $scope.main.currentSession.profileBasicInfo.shopId;
      var caste = $scope.main.currentSession.profileBasicInfo.caste;
      var gender = $scope.main.currentSession.profileBasicInfo.gender;
      var casteNoBar = $scope.main.currentSession.profileBasicInfo.casteNoBar;
      var neverMarried =
        $scope.main.currentSession.profileBasicInfo.martialStatus ==
        "Never Married" || false;

      var partnerPreference =
        $scope.main.currentSession.partnerPreference != null &&
          $scope.main.currentSession.partnerPreference != "" &&
          angular.isDefined($scope.main.currentSession.partnerPreference)
          ? $scope.main.currentSession.partnerPreference
          : {};
      profileService
        .getShopProfileCount(
          $scope.main.currentSession.shop.id,
          caste,
          gender,
          partnerPreference,
          casteNoBar,
          neverMarried,
          $scope.main.currentSession.shop.otherClientViewYourProfiles,
          $scope.main.currentSession.shop.anchepedheMarriageBureau,
          $scope.main.currentSession.shop.othrPfVwCtNo,
          $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo
        )
        .then(function (res) {
          vm.shopProfileCount = res.data;
        });
    })();

    function setCurrentImage(i, profile) {
      utilService._setCurrentImage(i, profile);
    }

    getMatchingProfiles();
    getOffer();

    function getOffer() {
      if (!$scope.main.currentSession.packagePlan.paidMemberExpired) return;
      var shopId = $scope.main.currentSession.shop.id;
      var data = {
        caste: $scope.main.currentSession.profileBasicInfo.caste,
      };
      shopService.getOffer(shopId, data).then(function (res) {
        vm.offer = res.data;
      });
    }

    function changePath(stateName, profileName, matrimonyId, param) {
      $state.go(stateName, param);
    }

    function getMatchingProfilesByPageNo() {
      if (isNaN(vm.submitPageNo)) {
        vm.submitPageNo = '';
        alert('Please enter page no.');
      } else if (vm.submitPageNo < 0) {
        vm.submitPageNo = '';
        alert('Please enter valid page no.');
      } else {
        vm.page = vm.submitPageNo - 1;
        if (vm.page > vm.total) {
          alert('Please enter valid page no.')
        } else {
          paginationTrackerService.setPaginationProfileMatch(vm.page);
          getMatchingProfiles();
        }
      }

    }

    function getMatchingProfiles() {
      $loading.start("profileMatches");
      var caste = $scope.main.currentSession.profileBasicInfo.caste;
      var casteNoBar = $scope.main.currentSession.profileBasicInfo.casteNoBar;
      var neverMarried =
        $scope.main.currentSession.profileBasicInfo.martialStatus ==
        "Never Married" || false;

      return profileService
        .getMatchingProfiles(
          $scope.main.currentSession.profileBasicInfo.matrimonyId,
          caste,
          vm.page,
          vm.pageSize,
          $scope.main.currentSession.profileBasicInfo.gender,
          $scope.main.currentSession.profileBasicInfo.shopId,
          $scope.main.currentSession.shop.otherClientViewYourProfiles,
          $scope.main.currentSession.shop.anchepedheMarriageBureau,
          casteNoBar,
          neverMarried,
          $scope.main.currentSession.shop.othrPfVwCtNo,
          $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo
        )
        .then(function (response) {
          vm.profileMatches = response.data.results;
          vm.total = Math.ceil(response.data.total / vm.pageSize);
          $loading.finish("profileMatches");
        });
    }

    function pageChangeHandler(newPageNumber) {
      page = newPageNumber;
      paginationTrackerService.setPaginationProfileMatch(page);
      getMatchingProfiles();
    }

    function next() {
      vm.page++;
      paginationTrackerService.setPaginationProfileMatch(vm.page);
      getMatchingProfiles();
    }

    function previous() {
      vm.page--;
      paginationTrackerService.setPaginationProfileMatch(vm.page);
      getMatchingProfiles();
    }
  }
})();

/**
 * Created by GGowda on 3/16/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ProfileInterestDetailController', ProfileInterestDetailController);

  function ProfileInterestDetailController($stateParams, profileService, $scope, $state, $loading) {
    /* jshint validthis: true */
    var vm = this;

    vm.changePath = changePath;

    getProfileInterest();

    function getProfileInterest() {
      $loading.start("profileInterestDetail");
      return profileService.getProfileInterest($stateParams.fromMatrimonyId, $stateParams.toMatrimonyId)
        .then(function(response) {
          vm.profileInterest = response.data;
          $loading.finish("profileInterestDetail");
        }
      );
    }

    function changePath(stateName, profileName, matrimonyId, param) {
      $state.go(stateName, param);
    }
  }
})();

/**
 * Created by GGowda on 3/12/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ProfileInterestController', ProfileInterestController);

  /** @ngInject */
  function ProfileInterestController(profileService, $scope, $state, $loading) {
    /* jshint validthis: true */
    var vm = this;

    var profileId = $scope.main.currentSession.profileBasicInfo.id;
    var page = 1;

    vm.action= "";
    vm.changePath  = changePath;
    vm.findInterestSentOrReceiveMember = findInterestSentOrReceiveMember;
    vm.getInboxProfileInterests = getInboxProfileInterests;
    vm.getSentProfileInterests = getSentProfileInterests;
    vm.linkClicked = !1;
    vm.pageSize = 4;
    vm.pageChangeHandler = pageChangeHandler;
    vm.selected = 0;

    getInboxProfileInterests();

    function getProfileInterests() {
      $loading.start("profileInterests");
      return profileService.getProfileInterestByMatrimonyId(profileId, page, vm.pageSize, vm.action)
        .then(function(response) {
          vm.profileInterests = response.data.results;
          vm.totalProfileInterest = response.data.totalElements;
          $loading.finish("profileInterests");
          return  vm.profileInterests;
        });
    }

    function getInboxProfileInterests () {
      vm.action= "inbox";
      vm.selected = 0;

      getProfileInterests();
    }

    function getSentProfileInterests() {
      vm.action = "sent";
      vm.selected = 1;

      getProfileInterests();
    }

    function pageChangeHandler(newPageNumber) {
      page = newPageNumber;
      getProfileInterests();
    }


    function changePath(stateName, profileName, matrimonyId, param, profileDeleted) {
      if(profileDeleted) return;
      $state.go(stateName, param);
    }

    function findInterestSentOrReceiveMember(val) {
      if (val.fromProfile.matrimonyId != $scope.main.currentSession.profileBasicInfo.matrimonyId) {
        vm.interestMember = val.fromProfile;
        return  vm.interestMember;
      } else {
        vm.interestMember = val.toProfile;
        return  vm.interestMember;
      }
    }
  }
})();

/**
 * Created by GGowda on 3/12/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(profileService, $scope, $stateParams, IMAGE_URL, codeValueService, $mdDialog, $q,
                              $loading, $state, sessionManagerService, utilService, dateFilter, $location, $anchorScroll,
                              loginSignUpService) {
    /* jshint validthis: true */
    var vm = this;

    vm.utilService = utilService;
    vm.changePath = changePath;
    vm.deleteProfile = deleteProfile;
    vm.editProfilelInfo = false;
    vm.editPartnerPrefInfo   = false;
    vm.profileNoFound = false;

    vm.imageUrl = IMAGE_URL;
    vm.getProfileInterest  = getProfileInterest;
    vm.getProfileShortListByMatrimonyId = getProfileShortListByMatrimonyId;
    vm.getProfileByMatrimonyId = getProfileByMatrimonyId;
    vm.getPartnerPreferenceByMatrimonyId = getPartnerPreferenceByMatrimonyId;
    vm.interestAcceptOrInterestDeclined = interestAcceptOrInterestDeclined;
    vm.openMenu = openMenu;
    vm.setCurrentImage = setCurrentImage;
    vm.shortListProfile = shortListProfile;
    vm.createUpdateInterest = createUpdateInterest;
    vm.createUpdateInterestToKnowMoreInfo = createUpdateInterestToKnowMoreInfo;
    vm.viewContactNumber = viewContactNumber;
    vm.createUpdateInterestToKnowMobileNo = createUpdateInterestToKnowMobileNo;
    vm.changeMobileNo = changeMobileNo;
    vm.changePassword = changePassword;
    vm.activateProfile = activateProfile;
    vm.getCountryCode = getCountryCode;
    vm.declineInterest = declineInterest;
    vm.getProfileStatusOptions = getProfileStatusOptions;
    vm.goToTop = goToTop;
    vm.goto = goto;
    vm.shareWhatsApImage = shareWhatsApImage;
    vm.getAgeByYear = getAgeByYear;
    vm.editProfile = editProfile;
    vm.editPartnerPreference = editPartnerPreference;
    vm.reportContactNoIssue = reportContactNoIssue;
    vm.openChangePasswordDialog = openChangePasswordDialog;
    var originatorEv;
    vm.cur = 1;

    $loading.start('profile');
    this.openMenu = function($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    };

    function editProfile() {
      profileService.setProfile(vm.profile);
      $state.go('home.updateProfile');
    }

    function editPartnerPreference() {
      profileService.setProfile(vm.profile);
      profileService.setPartnerPreference(vm.partnerPreference);
      $state.go('home.updatePartnerPreference');
    }

    function shareWhatsApImage(profile, ev) {
      utilService._shareWhatsApImage(profile, $scope.main.currentSession.shop, ev);
    }

    function getAgeByYear(year, month, day) {
      return utilService._calculateAgeByYear(year, month, day);
    }
    this.redial = function() {
      $mdDialog.show(
        $mdDialog.alert()
          .targetEvent(originatorEv)
          .clickOutsideToClose(true)
          .parent('body')
          .title('Suddenly, a redial')
          .textContent('You just called a friend; who told you the most amazing story. Have a cookie!')
          .ok('That was easy')
      );

      originatorEv = null;
    };

      $q.all([getProfileByMatrimonyId(), getProfileInterest(), getProfileInterestTemplate(),
        getProfileShortListByMatrimonyId(), getMobileNoRequest(),getPartnerPreferenceByMatrimonyId(), getReportIssue()]).then(function () {
        getProfileStatusOptions();
        if(vm.profileInterest) {
          if(vm.profileInterest.fromProfile.matrimonyId != $scope.main.currentSession.profileBasicInfo.matrimonyId) {
            vm.profile.profileImages = vm.profileInterest.fromProfile.profileImages;
          }
        }

        for(var i=0; i < vm.profile.profileImages.length; i++) {
          vm.profile.profileImages[i].imageRandomNo = utilService._getRandomNumber();
        }
        if(vm.profile.profileImages.length > 0) {
          vm.currentImage = {
            "width": "300px",
            "height": "400px",
            "cursor": "pointer",
            "border-radius": "3px",
            "background" : 'url('+vm.imageUrl+getImagePath(vm.profile.profileImages[0].originalImage)+') center top / cover no-repeat'
          }

        }

        $loading.finish('profile');
    })

    function filterProfileStatusOptions(values) {
      if(vm.profile.profileStatus ==='Partial Member') {
        vm.profileStatusOptions = values.filter(function(status) {
          return status.code === 'Free Member'
          || status.code === 'Partial Assisted Member'
          || status.code === 'Assisted Free Member';
        });
      } else if(vm.profile.profileStatus ==='Partial Assisted Member') {
        vm.profileStatusOptions = values.filter(function(status) {
          return status.code === 'Free Member'
          || status.code === 'Partial Member'
          || status.code === 'Assisted Free Member';
        });
      } else if(vm.profile.profileStatus === 'Free Member') {
        vm.profileStatusOptions = values.filter(function(status) {
          return status.code === 'Assisted Free Member';
        });
      } else if(vm.profile.profileStatus === 'Assisted Free Member') {
        vm.profileStatusOptions = values.filter(function(status) {
          return status.code === 'Free Member';
        });
      } else if(vm.profile.profileStatus === 'Paid Member') {
        vm.profileStatusOptions = values.filter(function(status) {
          return status.code === 'Assisted Paid Member';
        });
      } else if(vm.profile.profileStatus === 'Assisted Paid Member') {
        vm.profileStatusOptions = values.filter(function(status) {
          return status.code === 'Paid Member';
        });
      } else {
        vm.profileStatusOptions = values;
      };

    }

    function getProfileStatusOptions() {
      if($scope.main.currentSession.shop.anchepedheMarriageBureau || $scope.main.currentSession.shop.id == '5e5e1485cc3b8177d9f0bdab') {
        profileService.getProfileStatusOptions().then(function(res) {
          vm.tempProfileStatusOptions = res.data;
          filterProfileStatusOptions(vm.tempProfileStatusOptions);
        })
      }
    }

    function getCountryCode() {
      codeValueService.getCodeByName('Country-Code').then(function(response) {
        vm.countryCodeOptions = response.data;
      });
    }

    function getProfileByMatrimonyId() {
      var excludeField = !1;
      var matrimonyId = $stateParams.matrimonyId != undefined ? $stateParams.matrimonyId : $scope.matrimonyId;
      return profileService.getProfileByMatrimonyId(matrimonyId)
        .then(function(response) {
          vm.profile = response.data;
          var birthDate = dateFilter(new Date(vm.profile.dob), $scope.main.df);
          var res = birthDate.split(/[ ,]+/)
          //vm.profile.dateOfBirth = res[0]+"-"+res[1]+"-"+res[2];
         /* var index = $scope.main._.findIndex(vm.profile.profileImages, function(image) {
            return image.isMainPhoto == true;
          });*/
          /*var imageMainPhoto = vm.profile.profileImages[index];*/
      }, function() {
        vm.profileNoFound = true
        $loading.finish('profile');
      });
    }

    function getProfileInterest() {
      var deferred = $q.defer();
      var matrimonyId = $stateParams.matrimonyId != undefined ? $stateParams.matrimonyId : $scope.matrimonyId;
      if ($scope.main.currentSession.roles.includes('ROLE_USER')) {
        profileService.getProfileInterest($scope.main.currentSession.profileBasicInfo.matrimonyId,
          matrimonyId).then(function(response) {
            vm.profileInterest = response.data;
            deferred.resolve(response.data);
            return vm.profileInterest;
          });
      }
      return;
    }

    function getReportIssue() {
      var deferred = $q.defer();
      var matrimonyId = $stateParams.matrimonyId != undefined ? $stateParams.matrimonyId : $scope.matrimonyId;
      if ($scope.main.currentSession.roles.includes('ROLE_USER')) {
        profileService.getReportContactNumberIssue($scope.main.currentSession.profileBasicInfo.matrimonyId,
          matrimonyId).then(function(response) {
            vm.reportIssue = response.data;
            deferred.resolve(response.data);
            return vm.reportIssue;
          });
      }
      return;
    }

    function getMobileNoRequest() {
      var deferred = $q.defer();
      var matrimonyId = $stateParams.matrimonyId != undefined ? $stateParams.matrimonyId : $scope.matrimonyId;
      if ($scope.main.currentSession.roles.includes('ROLE_USER')) {
        profileService.getMobileNoRequest($scope.main.currentSession.profileBasicInfo.matrimonyId,
          matrimonyId).then(function(response) {
          vm.mobileNoRequest = response.data;
          /*vm.isMobileNoViewed = false;
           for(var i=0; i < response.data.mobileNoRequestStatus.length; i++) {
           if(response.data.mobileNoRequestStatus[i].fromMatrimonyId ==
           $scope.main.currentSession.profileBasicInfo.matrimonyId) {
           vm.isMobileNoViewed= true;
           }
           }*/
          deferred.resolve(response.data);
        });
      }
    }

    function getProfileShortListByMatrimonyId() {
      if ($scope.main.currentSession.roles.includes('ROLE_USER')) {
        var matrimonyId = $stateParams.matrimonyId != undefined ? $stateParams.matrimonyId : $scope.matrimonyId;
        return profileService.
          getProfileShortListByMatrimonyId($scope.main.currentSession.profileBasicInfo.matrimonyId,
          matrimonyId).then(function(response) {
            vm.profileShortList = response.data;
            return vm.profileShortList;
          })
      }
      return;
    }

    function getPartnerPreferenceByMatrimonyId() {
      $loading.start("partnerPreference");
      profileService.getPartnerPreferenceByMatrimonyId($stateParams.matrimonyId, $stateParams.shopId)
        .then(function(response) {
          vm.partnerPreference = response.data;
          getHeightOptions();
          $loading.finish("partnerPreference");
        })
    }

    function setCurrentImage(i) {
      vm.cur = i;
      if(i>vm.profile.profileImages.length){
        vm.cur =1;
      } else if(i===0) {
        vm.cur = vm.profile.profileImages.length;
      }
      vm.currentImage = {
        "width": "300px",
        "height": "400px",
        "cursor": "pointer",
        "border-radius": "3px",
        "background" : 'url('+vm.imageUrl+getImagePath(vm.profile.profileImages[vm.cur-1].originalImage)+') center top / cover no-repeat'
      }
    }

    function getImagePath(orgImagePath) {
      var path = orgImagePath.replace(/\/\/+/g, '/');
      if(!path.startsWith('/')) {
        path = '/'+path;
      }
      return path;
    }

    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }

    function interestAcceptOrInterestDeclined(status, fromMatrimonyId, toMatrimonyId) {
      return profileService.changeProfileInterestStatus(vm.profileInterest.id, fromMatrimonyId, toMatrimonyId, status)
        .then(function(response) {
          vm.profileInterest = response.data;
          return vm.profileInterest;
        }
      );
    }

    function shortListProfile() {
      if($scope.main.currentSession.packagePlan.paidMemberExpired) {
        return;
      } else if (vm.profileShortList != '') {
        vm.profileShortList.shortListed = !vm.profileShortList.shortListed;
      } else {
        vm.profileShortList = getProfileInterestObject();
        vm.profileShortList.shortListed = !0;
        vm.profileShortList.shortListedOn = new Date().getTime();
      }
      $loading.start("shortListBtn");
      profileService.profileShortList(vm.profileShortList).then(function(response) {
        vm.profileShortList = response.data;
        $loading.finish("shortListBtn");
      })
    }

    function getProfileInterestObject() {
      var profileInterest = {};

      profileInterest.profileMobileNoRequired = $scope.main.currentSession.shop.profileMobileNoRequired;
      profileInterest.profileEmailRequired = $scope.main.currentSession.shop.profileEmailRequired;
      profileInterest.fromProfile = {
        "id": $scope.main.currentSession.profileBasicInfo.id,
        "matrimonyId": $scope.main.currentSession.profileBasicInfo.matrimonyId,
        "profileName": $scope.main.currentSession.profileBasicInfo.profileName,
        "dob": $scope.main.currentSession.profileBasicInfo.dob,
        "highestEducation": $scope.main.currentSession.profileBasicInfo.highestEducation,
        "occupation": $scope.main.currentSession.profileBasicInfo.occupation,
        "annualIncome": $scope.main.currentSession.profileBasicInfo.annualIncome,
        "height": $scope.main.currentSession.profileBasicInfo.height,
        "shopId": $scope.main.currentSession.profileBasicInfo.shopId,
        "shopName": $scope.main.currentSession.profileBasicInfo.shopName,
        "caste":  $scope.main.currentSession.profileBasicInfo.caste,
        "subCaste":  $scope.main.currentSession.profileBasicInfo.subCaste,
        "memberType": $scope.main.currentSession.profileBasicInfo.memberType
      }

      profileInterest.fromProfile.profileImages = $scope.main.currentSession.profileBasicInfo.profileImages;

      profileInterest.toProfile = {
        "id": vm.profile.id,
        "matrimonyId": vm.profile.matrimonyId,
        "profileName": vm.profile.profileName,
        "dob": vm.profile.dob,
        "highestEducation": vm.profile.highestEducation,
        "occupation": vm.profile.occupation,
        "annualIncome": vm.profile.annualIncome,
        "height": vm.profile.height,
        "shopId": vm.profile.shopId,
        "shopName": vm.profile.shopName,
        "caste":  vm.profile.caste,
        "subCaste":  vm.profile.subCaste,
        "memberType": vm.profile.memberType
      }

      profileInterest.toProfile.profileImages = vm.profile.profileImages;

      return profileInterest;
    }

    function getHeightOptions() {
      return codeValueService.getCodeByName('Height').then(function(response) {
        var fromHeight = $scope.main. _.find(response.data.values, function(o)
        { return o.category == vm.partnerPreference.fromHeightPref ;
        });
        vm.fromHeightInCm =  angular.isDefined(fromHeight) ? fromHeight.value : "";

        var toHeight = $scope.main. _.find(response.data.values, function(o)
        { return o.category == vm.partnerPreference.toHeightPref ;
        });
        vm.toHeightInCm = angular.isDefined(toHeight) ? toHeight.value : "";
      })
    }

    function getProfileInterestTemplate() {
      return profileService.getProfileInterestTemplate().then(function(response) {
        vm.profileInterestTemplate = response.data;
      })
    }

    function showErrorDialog(ev) {
      /*var alert = $mdDialog.alert({
        title: 'To send Interest to this member, Upgrade your membership',
        textContent: 'If yes please contact AnchePedhe employee @ 8550000875. ' +
        'For more information please check your package plan.',
        ok: 'Ok I Got It'
      });
      $mdDialog.show( alert ).finally(function() {
          alert = undefined;
        }
      );*/

      var confirm = $mdDialog.confirm()
        .title('Please Upgrade Your Membership')
        .textContent('This feature available only for Paid Member.')
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('Click Here To Upgrade Membership!')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        $state.go('home.payment');
      }, function() {
        console.log("cancel");
      });
    }

    function activateProfile(profileId) {
      if (!this.activateForm.$valid) {
        return;
      }

      var obj = {password: $scope.main.currentSession.shop.defaultPassword || "amma"};
      if(angular.isDefined(this.profileStatus)) {
        obj.profileStatus = this.profileStatus;
      }

      obj.shopUniqueId = "";
      if($scope.main.currentSession.shop.shopUniqueId) {
        obj.shopUniqueId = $scope.main.currentSession.shop.shopUniqueId;
      }

      $loading.start("activateProfile");
      profileService.activateProfile($scope.pc.profile.id, obj).then(function(response) {
        $loading.finish("activateProfile");
        vm.profile = angular.isDefined(response.data.profileBasicInfo)? response.data.profileBasicInfo : response.data;
        if($scope.main.currentSession.shop.anchepedheMarriageBureau) {
          vm.profileStatus = "";
          filterProfileStatusOptions(vm.tempProfileStatusOptions);
        }
      }, function () {
        $loading.finish("activateProfile");
      });
    }

    function deleteProfile(ev) {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm()
       .title('Would you like to continue for delete this Profile ?')
       .textContent("Once Profile get deleted it can't be reverted back.")
       .ariaLabel('Lucky day')
       .targetEvent(ev)
       .ok('Delete Profile')
       .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        $loading.start("deleteProfile");
        profileService.deleteProfile($scope.pc.profile.id).then(function(response) {
          $scope.pc.profile = response.data;
          $loading.finish("deleteProfile");
          if(angular.isDefined($scope.main.currentSession) && $scope.main.currentSession.roles.includes("ROLE_USER")) {
            $scope.main.currentSession = sessionManagerService.clear();
            $state.go('account.login');
          } else {
            if($stateParams.isOtherBureau && Boolean($stateParams.isOtherBureau)) {
              $state.go('home.otherShopProfileOrIndividualProfile');
            } else {
              $state.go('home.myShopProfile');
            }
          }
        });

      }, function() {
        $scope.status = 'You decided to keep your debt.';
      });
    };

    function changePath(stateName, profileName, matrimonyId, param) {
      $state.go(stateName, param);
    }

    function createUpdateInterest(interestStatus, fromMatrimonyId, toMatrimonyId, ev) {
      interestStatus.fromMatrimonyId = fromMatrimonyId;
      interestStatus.toMatrimonyId = toMatrimonyId;
      if ((vm.profileInterest == '' || angular.isUndefined(vm.profileInterest)) && interestStatus.id == 700) {
        if ($scope.main.currentSession.packagePlan.noOfIntererestRemaining == 0 ||
          $scope.main.currentSession.packagePlan.paidMemberExpired) {
          showErrorDialog(ev);
          return;
        }
        vm.profileInterest = getProfileInterestObject();
        vm.profileInterest.interestStatus = [];
        vm.profileInterest.interestStatus.push(interestStatus);
        showProfileInterestDialog(ev, vm.profileInterest, "profile-interest.tmpl.html", fromMatrimonyId, toMatrimonyId);
      } else if(interestStatus.id == 700) {
        vm.profileInterest.interestStatus.push(interestStatus);
        showProfileInterestDialog(ev, vm.profileInterest, "profile-interest.tmpl.html", fromMatrimonyId, toMatrimonyId);
      } else {
        $loading.start('interestAcceptDecline');
        profileService.changeProfileInterestStatus(vm.profileInterest.id, fromMatrimonyId,
          toMatrimonyId, interestStatus).then(function(response) {
          vm.profileInterest = response.data;
          vm.profileInterest.interestStatus.push(interestStatus);
          $loading.finish('interestAcceptDecline');
        }, function() {
          $loading.finish('interestAcceptDecline');
        });
      }
    }

    function createUpdateInterestToKnowMoreInfo(interestStatus, ev, toMatrimonyId) {
      if ($scope.main.currentSession.packagePlan.noOfMoreInfoRequestRemaining == 0 ||
        $scope.main.currentSession.packagePlan.paidMemberExpired) {
        showErrorDialog(ev);
        return;
      } else if ((angular.isUndefined(vm.profileInterest) || vm.profileInterest == '') && interestStatus.id == 1200) {
        vm.profileInterest = getProfileInterestObject();
        vm.profileInterest.interestStatus = [];
        vm.profileInterest.moreInfoRequestStatus = [];
        vm.profileInterest.mobileNoRequestStatus = [];
      }

      interestStatus.fromMatrimonyId = $scope.main.currentSession.profileBasicInfo.matrimonyId;
      interestStatus.toMatrimonyId = toMatrimonyId;
      showKnowMoreInfoDialog(ev, vm.profileInterest, interestStatus);
    }

    function createUpdateInterestToKnowMobileNo(interestStatus, ev, toMatrimonyId) {
      if ($scope.main.currentSession.packagePlan.noOfMobileNoRequestRemaining == 0 ||
        $scope.main.currentSession.packagePlan.paidMemberExpired) {
        showErrorDialog(ev);
        return;
      } else if (!vm.mobileNoRequest && interestStatus.id == 1300) {
        vm.mobileNoRequest = getProfileInterestObject();
        vm.mobileNoRequest.mobileNoRequestStatus = [];
      }

      interestStatus.fromMatrimonyId = $scope.main.currentSession.profileBasicInfo.matrimonyId;
      interestStatus.toMatrimonyId = toMatrimonyId;
      vm.mobileNoRequest.mobileNoRequestStatus.push(interestStatus);

      profileService.createProfileInterestToKnowContactNo(vm.mobileNoRequest).then(function(response) {
        vm.mobileNoRequest = response.data.mobileNoRequest;

        /*for(var i=0; i < response.data.profileInterest.mobileNoRequestStatus.length; i++) {
          if(response.data.profileInterest.mobileNoRequestStatus[i].fromMatrimonyId ==
            $scope.main.currentSession.profileBasicInfo.matrimonyId) {
            vm.isMobileNoViewed= true;
          }
        }*/

        if(angular.isDefined(response.data.packagePlan)) {
          $scope.main.currentSession.packagePlan = response.data.packagePlan;
          sessionManagerService.setSessionData($scope.main.currentSession);
        }
      });
    }

    function viewContactNumberForOfferPackage(toMatrimonyId) {
      var fromMatrimonyId =  $scope.main.currentSession.profileBasicInfo.matrimonyId;
      profileService.viewContactNumberForOfferPackage(fromMatrimonyId, toMatrimonyId).then(function(response) {
        vm.mobileNoRequest = response.data.mobileNoRequest;

        if(angular.isDefined(response.data.packagePlan)) {
          $scope.main.currentSession.packagePlan = response.data.packagePlan;
          sessionManagerService.setSessionData($scope.main.currentSession);
        }
      });
    }

    function viewContactNumber(interestStatus, ev, toMatrimonyId) {
      if ($scope.main.currentSession.packagePlan.noOfMobileNoRequestRemaining == 0 ||
        $scope.main.currentSession.packagePlan.paidMemberExpired) {
        showErrorDialog(ev);
        return;
      } else if($scope.main.currentSession.packagePlan.offeredPackage) {
        viewContactNumberForOfferPackage(toMatrimonyId);
        return;
      } else if (!vm.mobileNoRequest && interestStatus.id == 2600) {
        vm.mobileNoRequest = getProfileInterestObject();
        vm.mobileNoRequest.mobileNoRequestStatus = [];
      }

      interestStatus.fromMatrimonyId = $scope.main.currentSession.profileBasicInfo.matrimonyId;
      interestStatus.toMatrimonyId = toMatrimonyId;
      vm.mobileNoRequest.mobileNoRequestStatus.push(interestStatus);

      $loading.start("mobileNoBtn");
      profileService.viewContactNumber(vm.mobileNoRequest).then(function(response) {
        vm.mobileNoRequest = response.data.mobileNoRequest;

        if(angular.isDefined(response.data.packagePlan)) {
          $scope.main.currentSession.packagePlan = response.data.packagePlan;
          sessionManagerService.setSessionData($scope.main.currentSession);
        }
        $loading.finish("mobileNoBtn");
      });
    }

    function showKnowMoreInfoDialog($event, profileInterest, interestStatus)  {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        targetEvent: $event,
        templateUrl: 'know-more-info.tmpl.html',
        locals: {
          profileInterest : profileInterest,
          interestStatus : interestStatus
        },
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        controller: KnowMoreInfoController,
        controllerAs: 'kc',
        clickOutsideToClose: true
      });

      function KnowMoreInfoController($scope, $mdDialog, profileInterest, interestStatus) {
        var self = this;
        self.interestStatus = interestStatus;
        self.profileInterest = profileInterest;
        $scope.closeDialog = function() {
          $mdDialog.hide();
        };

        $scope.saveKnowMoreInfo = function() {
          if (!this.askMoreInfoForm.$valid) {
            return;
          } else {
            self.interestStatus.msg = "+91"+self.mobileNo;
            self.profileInterest.moreInfoRequestStatus.push(interestStatus);

            profileService.createProfileInterestToKnowMoreInfo(self.profileInterest).then(function(response) {
              vm.profileInterest = response.data.profileInterest;
              if(angular.isDefined(response.data.packagePlan)) {
                $scope.main.currentSession.packagePlan = response.data.packagePlan;
                sessionManagerService.setSessionData($scope.main.currentSession);
              }
              $mdDialog.hide();
            });
          }
        }
      }
    }

    function showProfileInterestDialog($event, profileInterest, dialogView, fromMatrimonyId, toMatrimonyId)  {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        targetEvent: $event,
        templateUrl: dialogView,
        locals: {
          profileInterest : profileInterest,
          fromMatrimonyId : fromMatrimonyId,
          toMatrimonyId : toMatrimonyId
        },
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        controller: DialogController,
        controllerAs: 'dc',
        clickOutsideToClose: true
      });

      function DialogController($scope, $mdDialog, profileInterest, profileService, fromMatrimonyId, toMatrimonyId) {
        $scope.astrologyChecked = "";

        $scope.closeDialog = function() {
          $scope.pc.profileInterest = "";
          $mdDialog.hide();
        };

        $scope.saveProfileInterest = function() {
          if (!this.profileInterestForm.$valid) {
            return;
          }
          $scope.pc.profileInterest.interestStatus[0].astrologyChecked = this.dc.astrologyChecked;
          if(angular.isDefined(this.dc.astrologyMatched) && this.dc.astrologyMatched) {
            $scope.pc.profileInterest.interestStatus[0].astrologyMatched = this.dc.astrologyMatched;
          }

          if (this.profileInterestForm.$valid) {
            $loading.start('interestBtn');
            $mdDialog.hide();
            profileService.createProfileInterest($scope.pc.profileInterest, fromMatrimonyId,
              toMatrimonyId).then(function(response) {
                $scope.pc.profileInterest = response.data.profileInterest;
                $scope.main.currentSession.packagePlan = response.data.packagePlan;
                sessionManagerService.setSessionData($scope.main.currentSession);
                $loading.finish('interestBtn');

            }, function(){

            });
          }
        }
      }
    }

    function changeMobileNo() {
      vm.msg = $scope.pc.profile.mobileNo == $scope.pc.newMobileNo || false;
      if(!$scope.pc.resetMobileNoForm.$valid || vm.msg) {
        return !1;
      }

      var obj = {
        newMobileNo: $scope.pc.newMobileNo,
        newCountryCode:  $scope.pc.newCountryCode
      }
      $loading.start("settingBtn");
      profileService.updateMobileNo(obj, $scope.pc.profile.id).then(function (res) {
        vm.showMobileNoSuccessMsg = !0;
        $loading.finish("settingBtn");
        $scope.pc.newMobileNo = '';
        $scope.pc.newCountryCode = '';
        if($scope.main.currentSession.roles.includes("ROLE_USER")) {
          $scope.main.logout();
        } else {
          vm.tabValue = 0;
          $scope.pc.profile = res.data;
        }

      },function () {
        $loading.finish("settingBtn");
      });
    }

    function goto(id) {
      // set the location.hash to the id of
      // the element you wish to scroll to.
      $location.hash(id);

      // call $anchorScroll()
      $anchorScroll();
    };

    function goToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    function changePassword() {
      if(!$scope.pc.changePasswordForm.$valid || vm.msg) {
        return !1;
      }
      $loading.start("settingBtn");
      loginSignUpService.changePassword(vm.profile.userId, "", $scope.pc.newPassword).then(function() {
        $loading.finish("settingBtn");
        $scope.pc.newPassword = '';
        $mdDialog.show(
          $mdDialog.alert()
            .targetEvent(event)
            .clickOutsideToClose(true)
            .parent('body')
            .title('Password Changed Successfully.')
            .ok('Ok')
        );
      })
    }

    function openChangePasswordDialog(ev) {
      $scope.pc.newPassword = $scope.main.currentSession.shop.defaultPassword;
       $mdDialog.show({
        templateUrl: 'changepassword.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        clickOutsideToClose:true,
        controller: changePasswordDialogController,
        fullscreen: false // Only for -xs, -sm breakpoints.
      })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
    }

    function changePasswordDialogController($scope, $mdDialog) {

      $scope.cancel = function() {
        $mdDialog.cancel();
      };

      $scope.saveNewPassword = function(answer) {
        console.log("answer ")
      };
    }

    $scope.showAdvanced = function(ev, imagePath) {
      $scope.imagePath = imagePath;
      $mdDialog.show({
        templateUrl: 'horoscope.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        clickOutsideToClose:true,
        controller: HoroscopeDialogController,
        fullscreen: false // Only for -xs, -sm breakpoints.
      })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
    };

    function HoroscopeDialogController($scope, $mdDialog) {
      $scope.hide = function() {
        $mdDialog.hide();
      };

      $scope.cancel = function() {
        $mdDialog.cancel();
      };

      $scope.answer = function(answer) {
        $mdDialog.hide(answer);
      };
    }

    function declineInterest(ev, status, fromMatrimonyId, toMatrimonyId) {
      showDeclineInterestDialog(ev, status, 'profile-decline-interest.tmpl.html', fromMatrimonyId, toMatrimonyId)
    }

    function reportContactNoIssue(ev) {
      console.log($scope.main.currentSession.profileBasicInfo.matrimonyId+" "+vm.profile.matrimonyId);
      showDeclineInterestDialog(ev, '', 'report-issue.tmpl.html', $scope.main.currentSession.profileBasicInfo.matrimonyId, vm.profile.matrimonyId);
    }


    function showDeclineInterestDialog($event, status, dialogView, fromMatrimonyId, toMatrimonyId)  {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        targetEvent: $event,
        templateUrl: dialogView,
        locals: {
          status : status,
          fromMatrimonyId : fromMatrimonyId,
          toMatrimonyId : toMatrimonyId
        },
        scope: $scope,        // use parent scope in template
        preserveScope: true,
        controller: DialogController,
        controllerAs: 'dc',
        clickOutsideToClose: true
      });

      function DialogController($scope, $mdDialog, status, fromMatrimonyId, toMatrimonyId, profileService, $loading) {

        $scope.closeDialog = function() {
          $mdDialog.hide();
        };

        $scope.declineInterest = function(declineReason) {
          if (!this.declineInterestForm.$valid) {
            return;
          }
          status.msg = declineReason;
          $scope.pc.createUpdateInterest(status, fromMatrimonyId, toMatrimonyId);
          $mdDialog.hide();
        }

        $scope.reportContactNumberIssue = function(issueReason) {
          if (!this.reportIssueForm.$valid) {
            return;
          }
          $loading.start("mobileNoIssueBtn");
          var data = {
            fromShopId: $scope.main.currentSession.shop.id,
            fromShopName: $scope.main.currentSession.shop.shopName,
            fromMatrimonyId: fromMatrimonyId,
            fromProfileName: $scope.main.currentSession.profileBasicInfo.profileName,
            fromProfileImageUrl: $scope.main.currentSession.profileBasicInfo.profileImages[0].originalImage,
            toShopId: $scope.pc.profile.shopId,
            toShopName: $scope.pc.profile.shopName,
            toMatrimonyId: toMatrimonyId,
            toProfileName: $scope.pc.profile.profileName,
            toProfileImageUrl: $scope.pc.profile.profileImages[0].originalImage,
            toContactNumber: $scope.pc.mobileNoRequest.mobileNoRequestStatus[0].msg,
            issueType: issueReason
          }

          profileService.reportContactNumberIssue(data).then(function(res) {
            $scope.pc.reportIssue = res.data;
            $loading.finish("mobileNoIssueBtn");
          })
        }
      }
    }
  }
})();

/**
 * Created by GGowda on 3/12/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony')
    .controller('CreateUpdateProfileController', CreateUpdateProfileController);

  /** @ngInject */
  function CreateUpdateProfileController($scope,  profileService, codeValueService, utilService, dateFilter, $rootScope,
                                         $window,  $state, $stateParams, $loading, sessionManagerService, MEMBER_TYPE,
                                         paginationTrackerService, $q) {
    var vm = this;

    vm.addOneMoreContact = addOneMoreContact;
    vm.addOneMoreProperty = addOneMoreProperty;
    vm.addOneMoreSibling = addOneMoreSibling;
    vm.ageObj = {};
    vm.birthTimeObj = {};
    vm.clearSearchTerm = clearSearchTerm;
    vm.createUpdateProfile = createUpdateProfile;
    vm.checkIfExist = checkIfExist;
    vm.deleteImages = [];
    vm.getFamilyLeavingCities = getFamilyLeavingCities;
    vm.fileUploadSuccess  = fileUploadSuccess;
    vm.getCities = getCities;
    vm.getGothram = getGothram;
    vm.getRaasi = getRaasi;
    vm.getStates = getStates;
    vm.getCasteOptions = getCasteOptions;
    vm.getSubCasteOptions = getSubCasteOptions;
    vm.getSubCasteSubOptions = getSubCasteSubOptions;
    vm.getReligiousValueOptions = getReligiousValueOptions;
    vm.handleUpload = handleUpload;
    vm.partnerPref = {};
    vm.profileImages = [];
    vm.removeProperty = removeProperty;
    vm.shop = {};
    vm.siblingInfo = false;
    vm.user = {};
    vm.getImagePath = getImagePath;                                     
    vm.afterResizingImages = afterResizingImages;
    vm.beforeResizingImages = beforeResizingImages;

    $loading.start('createUpdateProfile');
    $q.all([getProfileTemplate(), getAnnualIncomeFrom(), getStates()]).then(function () {
      $loading.finish('createUpdateProfile');
    });

    // (function () {
    //   getProfileTemplate(), getAnnualIncomeFrom(), getGothram(), getStates('India');
    // })()


    function getStates(country) {
      /*$loading.start('createUpdateProfile');*/
      if (angular.isUndefined(vm.stateOptions) && country == 'India' ) {
        codeValueService.getCodeByName(country).then(function(response) {
          vm.stateOptions = response.data;
          /*$loading.finish('createUpdateProfile');*/
        });
      } /*else {
        vm.profile.currentLivingCity = '';
      }*/
    }

    function getCities(state){
      /* $loading.start('createUpdateProfile');*/
      codeValueService.getCodeByName(state).then(function(response) {
        vm.cityOptions = response.data;
        /*$loading.finish('createUpdateProfile');*/
      });
    }

    function getFamilyLeavingCities(state){
      /* $loading.start('createUpdateProfile');*/
      codeValueService.getCodeByName(state).then(function(response) {
        vm.familyCityOptions = response.data;
        /*$loading.finish('createUpdateProfile');*/
      });
    }

    if ($state.is('home.createProfile')) {
      if ($rootScope.profile && $rootScope.user && $rootScope.ageObj) {
        vm.user = $rootScope.user;
        vm.profile  = $rootScope.profile;
        vm.ageObj = $rootScope.ageObj;
        delete $rootScope.profile;
        delete $rootScope.user;
      } else {
        vm.user.isAnchePedheUser = false;
        vm.profile = {};
        vm.profile.dontNoDOB = false;
        if($scope.main.currentSession.shop.expertiseReligion.length == 1) {
          vm.profile.religion = $scope.main.currentSession.shop.expertiseReligion[0];
          getCasteOptions(vm.profile.religion);
        }

        vm.ageObj = {};
      }
      vm.profile.familyResidingState = 'Karnataka';
      vm.horoImage = {
        photo: false,
        name: "image3",
        to: "",
        invalidFile: ""
      }

      vm.items = [
        {
          photo: false,
          name: "image1",
          to: "",
          isMainPhoto: false,
          image: "./assets/images/no_image.png",
          invalidFile: ""
        },
        {
          photo: false,
          to: "",
          isMainPhoto: false,
          image: "./assets/images/no_image.png",
          invalidFile: ""
        }
      ];
      vm.profile.citizenship = 'India';
    } else {
      vm.editProfilelInfo = true;
      if(angular.isUndefined(profileService.getProfile())) {
        $state.go('home.myShopProfile');
      }
      vm.profile = angular.copy(profileService.getProfile());
      vm.tempDontNoDOB = vm.profile.dontNoDOB ? vm.profile.dontNoDOB : '';
      vm.profileImages = vm.profile.profileImages;
      vm.horoscopeImage = vm.profile.horoscopeImage;

      if(vm.profile.dontNoDOB) {
        vm.age = utilService._calculateAge(new Date(vm.profile.dob));
      }
      getCasteOptions(vm.profile.religion);
      getSubCasteOptions(vm.profile.caste);

      if(vm.profile.religion === "Muslim") {
        getReligiousValueOptions();
      }

      if(vm.profile.subCasteSub) {
        getSubCasteSubOptions(vm.profile.subCaste)
      }
      var birthDate = dateFilter(new Date(vm.profile.dob), $scope.main.df);
      var res = birthDate.split(/[ ,]+/)
      vm.ageObj.date =res[0];
      vm.ageObj.month=res[1];
      vm.ageObj.year=res[2];
      //vm.profile.height = vm.profile.height.category;
      if(vm.profile.birthTime) {
        res = vm.profile.birthTime.split(":");
        vm.birthTimeObj.hr = res[0];
        vm.birthTimeObj.min = res[1];
        vm.birthTimeObj.amOrPm = res[2];
      }

      getStates('India');
      if (vm.profile.currentLivingState) {
        getCities(vm.profile.currentLivingState);
      }
      if(vm.profile.familyLivingInState) {
        getFamilyLeavingCities(vm.profile.familyLivingInState);
      }

      if(vm.horoscopeImage) {
        vm.horoImage = {
          photo: false,
          name: "image3",
          image: vm.horoscopeImage.originalImage,
          to: "",
          invalidFile: ""
        }
      } else {
        vm.horoImage = {
          photo: false,
          name: "image3",
          invalidFile: ""
        }
      }

      if(vm.profileImages.length > 0) {
        vm.items = [
          {
            photo: false,
            name: "image1",
            to: '',
            isMainPhoto: false,
            image: $scope.main.getImagePath(vm.profile.profileImages[0].originalImage),
            invalidFile: ""
          },
          {
            photo: false,
            name: "image2",
            to: '',
            isMainPhoto: false,
            image: vm.profile.profileImages[1] != undefined ?  $scope.main.getImagePath(vm.profile.profileImages[1].originalImage) : "./assets/images/no_image.png",
            invalidFile: ""
          }
        ];
      } else {
        vm.items = [
          {
            photo: false,
            name: "image1",
            to: "",
            isMainPhoto: false,
            image: "./assets/images/no_image.png"
          },
          {
            photo: false,
            name: "image2",
            to: "",
            isMainPhoto: false,
            image: "./assets/images/no_image.png"
          }
        ];
      }

      codeValueService.getCodeByName(vm.profile.star).then(function(response) {
        vm.raasiOptions = response.data;
      })
    }

    function getProfileTemplate() {
      $loading.start('createUpdateProfile');
      return profileService.getProfileTemplate().then(function(response) {
        vm.profileTemplate = response.data;
        $loading.finish('createUpdateProfile');
        if(angular.isDefined(vm.profile) && angular.isDefined(vm.profile.height)) {
          var i =  _.findIndex(vm.profileTemplate.heightOptions.values, function(height) {
            return height.category == vm.profile.height.category;
          });
          vm.profile.height = vm.profileTemplate.heightOptions.values[i];
        }
      });
    }

    if (vm.profile.siblings == null || angular.isUndefined(vm.profile.siblings) || vm.profile.siblings.length == 0) {
      vm.profile.siblings = [{
        "siblingType": "",
        "educationWorkInfo": "",
        "martialStatus": ""
      }];
    }

    if (vm.profile.familyContactInfo == null && vm.profile.familyContactInfo  == undefined
      || vm.profile.familyContactInfo.length == 0) {
      vm.profile.familyContactInfo = [{
        "relationShipType": "",
        "name": "",
        "mobileNo": ""
      }];
    }

    if (vm.profile.propertyDetails == null || angular.isUndefined(vm.profile.propertyDetails)
        || vm.profile.propertyDetails.length == 0) {
      vm.profile.propertyDetails = [{
        "propertyType": "",
        "propertyLocatedCity": "",
        "moreInfoAboutProperty": ""
      }];
    }

    vm.profile.annualIncomeCurrency = "Rs";
    //vm.profile.religion =  "Hindu";

    function getCastes() {
      $loading.start('createUpdateProfile');
      return codeValueService.getCodeByName('Caste').then(function(response) {
        vm.casteOptions = response.data;
        $loading.finish('createUpdateProfile');
      });
    }

    function getReligiousValueOptions() {
      if(vm.religiousValueOptions) {
        return
      }
     codeValueService.getCodeByName("Religious-Value").then(function (response) {
        vm.religiousValueOptions = response.data;
      });
    }

    function getCasteOptions(val) {
      return codeValueService.getCodeByName(val).then(function (response) {
        vm.casteOptions = response.data;
      });
    }

    function getSubCasteOptions(val) {
      $loading.start('createUpdateProfile');
      $q.all([getSubcaste(val), getGothram(val+"-Gothram")]).then(function(){
        $loading.finish('createUpdateProfile');
      })
    }

    function getSubcaste(val) {
      return codeValueService.getCodeByName(val).then(function(response) {
        vm.subCasteOptions = response.data;
      });
    }

    function getSubCasteSubOptions(val) {
      return codeValueService.getCodeByName(val).then(function(response) {
        vm.subCasteSubOptions = response.data;
      });
    }

    /*codeValueService.getCodeByName('Karnataka').then(function(response) {
     vm.cityOptions = response.data;
     });
     */
    function getAnnualIncomeFrom() {
      return  codeValueService.getCodeByName('Annual-Income-From').then(function(response) {
        vm.annualIncomeOptions = response.data;
        $loading.finish('createUpdateProfile');
      });
    }

    function getRaasi(star){
      codeValueService.getCodeByName(star).then(function(response) {
        vm.raasiOptions = response.data;
      });
    }

    function getGothram(val){
      codeValueService.getCodeByName(val).then(function(response) {
        vm.gothramOptions = response.data;
        $loading.finish('createUpdateProfile');

      });
    }

    vm.dateObj = utilService._getDateObject();
    vm.timeObj = utilService._getTimeObject();

    function addOneMoreSibling() {
      vm.errorSiblingShow = false;
      var tempObj = vm.profile.siblings[vm.profile.siblings.length-1];

      if (tempObj.siblingType == '' || tempObj.martialStatus == '') {
        vm.errorSiblingShow = true;
        return;
      }

      vm.profile.siblings.push({
        "siblingType": "",
        "educationWorkInfo": "",
        "martialStatus": ""
      });
    }

    function addOneMoreContact() {
      vm.errorContactInfoShow = false;
      var tempObj = vm.profile.familyContactInfo[vm.profile.familyContactInfo.length-1];

      if (angular.isUndefined(tempObj.relationShipType ) || tempObj.relationShipType == '' ||
        angular.isUndefined( tempObj.mobileNo) || tempObj.mobileNo == '' || tempObj.mobileNo.length < 10) {
        vm.errorContactInfoShow = true;
        return;
      }

      vm.profile.familyContactInfo.push({
        "relationShipType": "",
        "name": "",
        "mobileNo": ""
      });
    }

    function addOneMoreProperty() {
      vm.errorPropertyInfoShow = false;
      vm.indexInfo = '';
      var tempObj = vm.profile.propertyDetails[vm.profile.propertyDetails.length-1];

      if (tempObj.propertyType == "") {
        vm.errorPropertyInfoShow = true;
        vm.indexInfo = vm.profile.propertyDetails.indexOf(tempObj);
        return;
      }

      vm.profile.propertyDetails.push({
        "propertyType": "",
        "propertyLocatedCity": "",
        "moreInfoAboutProperty": ""
      });

    }

    function removeProperty(index) {
      $scope.main._.pullAt(vm.profile.propertyDetails,index);
    }

    function createUpdateProfile() {
      if(!$scope.profileForm.$valid) {
        return !1;
      }
      $loading.start('createUpdateProfileBtn');
      $scope.main. _.remove(vm.profile.familyContactInfo, function(n) {
        return n.relationShipType == "" || n.mobileNo == "" || n.mobileNo.length < 10;
      });

      $scope.main._.remove(vm.profile.siblings, function(n) {
        return n.siblingType == "" || n.martialStatus == "";
      });

      $scope.main._.remove(vm.profile.propertyDetails, function(n) {
        return n.propertyType == "";
      });

      if(!vm.profile.havingProperty) {
        vm.profile.propertyDetails = [];
      }

      vm.profile.annualIncome = isNaN(parseInt(vm.profile.annualIncome)) ? 0 : parseInt(vm.profile.annualIncome);
      vm.profile.dateFormat = $scope.main.df;
      vm.profile.birthTime = vm.birthTimeObj.hr+":"+vm.birthTimeObj.min+":"
      + vm.birthTimeObj.amOrPm;

      if(vm.profile.dontNoDOB) {
        var birthYear = new Date().getUTCFullYear() - vm.age;
        vm.profile.dob = new Date("01 January"+" "+birthYear).getTime();
        vm.profile.dateOfBirth = "01"+"-"+"January"+"-"+birthYear;
      } else {
        vm.profile.dob = new Date(vm.ageObj.date+" "+vm.ageObj.month+" "+vm.ageObj.year).getTime();
        vm.profile.dateOfBirth = vm.ageObj.date+"-"+vm.ageObj.month+"-"+vm.ageObj.year;
      }

      vm.profile.locale = "en";

     if (vm.profile.currentLivingCountry != 'India') {
        vm.profile.currentLivingState = '';
      }

      if ($state.is('home.createProfile')) {
        if($window.location.host.indexOf('anchepedhematrimony.com') > -1) {
          vm.profile.memberType = MEMBER_TYPE.ANCHEPEDHE_WEBSITE;
        } else {
          vm.profile.memberType = MEMBER_TYPE.MARRIAGE_BUREAU;
        }

        if($scope.main.currentSession.shop) {
          vm.profile.shopId = $scope.main.currentSession.shop.id;
          vm.profile.shopName = $scope.main.currentSession.shop.shopName;
          vm.profile.shopWebsiteUrl = $scope.main.currentSession.shop.websiteUrl;
          vm.profile.shopEmail = $scope.main.currentSession.shop.email;
          vm.profile.shopMobileNo = $scope.main.currentSession.shop.mobileNo;
          vm.user.shopUser = false;
          vm.user.shopEmp = true;
        }

        vm.profile.profileImages = vm.profileImages;
        vm.profile.otherClientViewYourProfiles = $scope.main.currentSession.shop.otherClientViewYourProfiles;
        vm.profile.anchepedheMarriageBureau = $scope.main.currentSession.shop.anchepedheMarriageBureau;
        profileService.createProfile(vm.profile).then(function(response) {

          profileService.setProfile(response.data);
          var files = [];
          files.push(vm.items[0].photo);
          if(angular.isDefined(vm.items[1].photo)) {
            files.push(vm.items[1].photo);
          }

          profileService.uploadMultipleProfileImage(files, response.data.matrimonyId, response.data.shopId,
            response.data.profileStatus)
            .then(function (res) {

              if(vm.horoImage.photo != false && vm.horoImage.photo != undefined) {
                profileService.uploadHoroscopeImage(vm.horoImage.photo, res.data.matrimonyId, res.data.shopId)
                  .then(function (res) {

                  }, function (err) {

                  })
              }
              $state.go('home.createPartnerPreference');
              paginationTrackerService.setPaginationShopProfile(0);
            }, function (response) {
              if (response.status > 0) {
                $scope.errorMsg = response.status + ': ' + response.data;
              }
            });
        }, function (){
          //vm.profile.height = vm.profile.height.category;
          $window.scroll(0,0);
          $loading.finish('createUpdateProfileBtn');
        });
      } else {
        /*Edit Profile*/
        delete vm.profile.lastActive;

        var files = [];
        var deleteImages = [];
        for(var i in  vm.items) {
          if(vm.items[i].photo) {
            files.push(vm.items[i].photo)
            // if(!(vm.items[i].image.indexOf('no_image.png') > -1)) {
            //   deleteImages.push({originalImage: vm.items[i].image});
            // }

            vm.profile.profileImages.length > 0 &&  _.remove(vm.profile.profileImages, function(image) {
              if(vm.items[i].image.contains(image.originalImage)) {
                deleteImages.push({originalImage: image.originalImage});
                return true;
              } else if(image.originalImage.contains(vm.items[i].image)) {
                deleteImages.push({originalImage: vm.items[i].image});
                return true;
              }
              return false;
            });

            // vm.profile.profileBlurImages.length > 0 &&  _.remove(vm.profile.profileBlurImages, function(image) {
            //   return image.originalImage == vm.items[i].blurImage;
            // });
          }
        }


        if(vm.horoImage.photo) {
          var deleteHoroscopeImage = {originalImage: vm.horoImage.image}
          profileService.deleteHoroscopeImage(deleteHoroscopeImage).then(function() {
            console.log("horoscope images deleted successfully")
          }, function () {
            console.log("horoscope images not deleted")
          });
        }

        profileService.updateProfile(vm.profile).then(function(response) {
          if($scope.main.currentSession.roles.includes("ROLE_USER")) {
            $scope.main.currentSession.profileBasicInfo = response.data;
            sessionManagerService.setSessionData($scope.main.currentSession);
            paginationTrackerService.resetSearchProfile();
          }
          if(files.length > 0) {
            profileService.uploadMultipleProfileImage(files, response.data.matrimonyId, response.data.shopId,
              response.data.profileStatus).then(function (res) {
                console.log("Image uploaded successfully");
              delete response.data.lastActive;
              response.data = res.data;

              if($scope.main.currentSession.roles.includes("ROLE_USER")) {
                $scope.main.currentSession.profileBasicInfo.profileImages = res.data.profileImages;
                sessionManagerService.setSessionData($scope.main.currentSession);
              }

              $state.transitionTo('home.profile', {matrimonyId:vm.profile.matrimonyId, shopId: vm.profile.shopId}, {
                reload: true,
                inherit: false,
                notify: true
              });
            }, function (response) {
              if (response.status > 0) {
                $scope.errorMsg = response.status + ': ' + response.data;
              }
            });
          } else {
            $loading.finish('createUpdateProfileBtn');
            $state.transitionTo('home.profile', {matrimonyId:vm.profile.matrimonyId, shopId: vm.profile.shopId}, {
              reload: true,
              inherit: false,
              notify: true
            });
          }

          if(vm.horoImage.photo != undefined && vm.horoImage.photo) {
            profileService.uploadHoroscopeImage(vm.horoImage.photo, response.data.matrimonyId, response.data.shopId)
              .then(function (res) {
                delete response.data.lastActive;
                response.data = res.data;

                if($scope.main.currentSession.roles.includes("ROLE_USER")) {
                  $scope.main.currentSession.profileBasicInfo.horoscopeImage = res.data.horoscopeImage;
                  sessionManagerService.setSessionData($scope.main.currentSession);
                }

                $state.transitionTo($state.current, $stateParams, {
                  reload: true,
                  inherit: false,
                  notify: true
                });
              }, function (err) {

              })
          }
        }, function() {
          $loading.finish('createUpdateProfileBtn');
          //vm.profile.height = vm.heightCategory;
          $window.scroll(0,0);
        });
        if(angular.isDefined(deleteImages) && deleteImages.length > 0) {
          profileService.deleteImage(deleteImages).then(function() {
            console.log("images deleted successfully")
          }, function () {
            console.log("images not deleted")
          });
  
        }
      }
    };
    

    function getImagePath(orgImagePath) {
      var path = orgImagePath.replace(/\/\/+/g, '/');
      if(!path.startsWith('/')) {
        path = '/'+path;
      }
      return path;
    }

    function handleUpload($files, $event, $flow, item) {
      if (vm.profileImages.length > 0) {
        _.remove(vm.profileImages, function(image) {
          return vm.items[i].image.contains(image.originalImage);
        });
        if(item.image != "./assets/images/no_image.png") {
          vm.deleteImages.push({originalImage: item.image});
        }
      }

      if(angular.isDefined($event.srcElement)&&($event.srcElement !== null)) {
        var input = angular.element($event.srcElement);
      } else {
        input = angular.element($event.originalTarget)
      }

      if (input.scope().item) {
        if(input.scope().item.photo) {
          input.scope().item.photo.cancel();
        }
        input.scope().item.photo = $files[0];
      } else {
        for(var i = 0; i < $files.length; i++) {
          vm.items.push({photo: $files[i]});
        }
      }
    }

    function  fileUploadSuccess(res, item) {
      var location = JSON.parse(res);
      vm.profileImages.push(location);
      item.image = location.originalImage;
    }

    function  afterResizingImages(file) {
      $loading.finish('imageLoading')
    }

    function  beforeResizingImages(file) {
      $loading.start('imageLoading');
    }

    vm.searchTerm;
    function clearSearchTerm() {
      vm.searchTerm = '';
    };


    function checkIfExist(item, values) {
      if(item  == "" || angular.isUndefined(item)) {
        return true;
      } else {
        return JSON.stringify(values).toLowerCase().indexOf(item) > -1 || JSON.stringify(values).toUpperCase().indexOf(item) > -1;
        /*return JSON.stringify(values).search(/item/)  > -1*/;
      }
    }

    vm.createProfileValidation = function() {
      var shopUniqueId = "";
      if($scope.main.currentSession.shop.shopUniqueId) {
        shopUniqueId = $scope.main.currentSession.shop.shopUniqueId;
      }
      var obj = {
        mobileNo: vm.profile.mobileNo,
        shopId: $scope.main.currentSession.shop.id,
        shopUniqueId: shopUniqueId
      };
      profileService.createProfileValidation(obj).then(function (res) {
        vm.errorMsg = '';
      }, function (error) {
        vm.errorMsg = error.defaultUserMessage;
      });
    }

    vm.sameAsFamilyLocation = function() {
      if(vm.isSameAsLoc) {
        vm.profile.familyResidingState = vm.profile.currentLivingState;
        vm.getFamilyLeavingCities(vm.profile.familyResidingState);
        vm.profile.familyResidingDistrict = vm.profile.currentLivingCity;
        vm.profile.familyResidingTaluk = vm.profile.currentLivingTaluk;
      } else {
        delete vm.profile.familyResidingState;
        delete vm.profile.familyResidingDistrict;
        delete vm.profile.familyResidingTaluk;
      }
    }


    vm.sameAsAncestralOrigin = function() {
      if(vm.isSameAsAncOrg) {
        vm.profile.ancestralOrigin = vm.profile.currentLivingCity;
        if(vm.profile.currentLivingTaluk)
          vm.profile.ancestralOrigin += ", "+vm.profile.currentLivingTaluk;
      } else {
        delete vm.profile.ancestralOrigin;
      }
    }
  }
})();

/**
 * Created by GGowda on 3/13/2016.
 */
(function() {
  "use strict";

  angular
    .module("anchePedheMatrimony")
    .controller(
      "CreateUpdatePartnerPreferenceController",
      CreateUpdatePartnerPreferenceController
    );

  /** @ngInject */
  function CreateUpdatePartnerPreferenceController(
    $scope,
    profileService,
    codeValueService,
    $state,
    $loading,
    $q,
    sessionManagerService,
    paginationTrackerService,
    utilService
  ) {
    var vm = this;

    vm.clearSearchTerm = clearSearchTerm;
    vm.checkIfExist = checkIfExist;
    vm.createUpdatePartnerPreference = createUpdatePartnerPreference;
    vm.getCities = getCities;
    /*vm.getStates = getStates;*/
    vm.setCastePref = setCastePref;
    vm.setCityPref = setCityPref;
    vm.setCountryPref = setCountryPref;
    vm.setEmployedInPref = setEmployedInPref;
    vm.setHighestEducationPref = setHighestEducationPref;
    vm.setMartialStatusPref = setMartialStatusPref;
    vm.setOccupationPref = setOccupationPref;
    vm.setStatePref = setStatePref;
    vm.setSubCastePref = setSubCastePref;
    vm.setSubCasteSubPref = setSubCasteSubPref;
    vm.getSubCasteSubOptions = getSubCasteSubOptions;
    vm.setMotherTonguePref = setMotherTonguePref;
    vm.stateOptions = [];
    vm.searchTerm;
    vm.profile = profileService.getProfile();
    vm.editPartnerPrefInfo = true;

    const age = utilService._calculateAge(new Date(vm.profile.dob));
    const height = vm.profile.height;

    $loading.start("partnerPrefer");

    vm.heightSlider = {
      minValue: 150,
      maxValue: 159,
      options: {
        floor: 134,
        ceil: 165,
        minRange: 3,
        pushRange: true,
        translate: function(value) {
          var a = utilService._getHeightByCm(value);
          return a.value;
        }
      }
    };

    vm.ageSlider = {
      minValue: 24,
      maxValue: 29,
      options: {
        floor: 18,
        ceil: 60,
        minRange: 2,
        pushRange: true,
        translate: function(value) {
          if (value != 18 && value != 60) {
            return value + " Yrs";
          } else {
            return value;
          }
        }
      }
    };

    if (vm.profile.gender === "Male") {
      vm.ageSlider.options.floor = age - 12;
      vm.ageSlider.options.ceil = age + 12;
    } else {
      vm.ageSlider.options.floor = age - 12;
      vm.ageSlider.options.ceil = age + 12;
    }

    function getStates() {
      codeValueService.getCodeByName("India").then(function(response) {
        /*vm.stateOptions = $scope.main._.intersectionBy(response.data.values, vm.stateOptions, 'value');*/
        vm.stateOptions = response.data.values;
      });
    }

    vm.cityOptions = [];
    function getCities(val) {
      if (val.indexOf("Any") == -1) {
        codeValueService.getCodeByName(val).then(function(response) {
          if (vm.cityOptions.length > 0) {
            vm.cityOptions = $scope.main._.initial(vm.cityOptions);
          }
          vm.cityOptions = $scope.main._.unionBy(
            vm.cityOptions,
            response.data.values,
            "value"
          );
        });
      }
    }

    function setCountryPref(val) {
      var countryPref = vm.partnerPreference.countryPref;
      var val1 = angular.isDefined(countryPref) ? countryPref : [];
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.countryPref = [];
        vm.partnerPreference.countryPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.countryPref, "Any");
      } else if (val.indexOf("India") > -1 && val1.indexOf("India") < 0) {
        getStates();
      } else if (val.indexOf("India") > -1 && val1.indexOf("India") > -1) {
        //when country india unselect
        vm.partnerPreference.statePref = [];
        vm.partnerPreference.cityPref = [];
        vm.stateOptions = [];
        vm.cityOptions = [];
      }
    }

    if (
      $state.is("home.createPartnerPreference") ||
      ($state.is("home.updatePartnerPreference") &&
        (profileService.getPartnerPreference() == undefined ||
          profileService.getPartnerPreference() == ""))
    ) {
      vm.editPartnerPrefInfo = false;
      vm.casteNoBar = vm.profile.casteNoBar;
      vm.subCasteNoBar = vm.profile.subCasteNoBar;
      vm.gender = vm.profile.gender;

      if (vm.profile.gender === "Male") {
        vm.ageSlider.maxValue = age;
        vm.ageSlider.minValue = age - 4;

        vm.heightSlider.maxValue = height.category;
        vm.heightSlider.minValue =
          height.category - 6 >= 140 ? height.category - 6 : 134;
      } else {
        vm.ageSlider.minValue = age;
        vm.ageSlider.maxValue = age + 4;

        vm.heightSlider.minValue = height.category;
        vm.heightSlider.maxValue = height.category + 7;
      }
      vm.partnerPreference = {};
      vm.partnerPreference.castePref = [];
      if (!vm.casteNoBar) {
        vm.caste = vm.profile.caste;
        vm.partnerPreference.castePref.push(vm.caste);
        if (!vm.subCasteNoBar) {
          getSubCasteOptions(vm.caste);
        }
      }
      getCasteOptions(vm.profile.religion);

      vm.partnerPreference.martialStatusPref = [];
      if (vm.profile.martialStatus.indexOf("Never Married") > -1) {
        vm.partnerPreference.martialStatusPref.push("Never Married");
      } else {
        vm.partnerPreference.martialStatusPref.push("Any");
      }

      vm.partnerPreference.motherTonguePref = [];
      vm.partnerPreference.motherTonguePref.push(vm.profile.motherTongue);
    } else {
      vm.casteNoBar = vm.profile.casteNoBar;
      vm.subCasteNoBar = vm.profile.subCasteNoBar;
      vm.gender = vm.profile.gender;
      vm.caste = vm.profile.caste;
      getCasteOptions(vm.profile.religion);
      if (!vm.casteNoBar && !vm.subCasteNoBar) {
        getSubCasteOptions(vm.caste);
      }

      vm.partnerPreference = angular.copy(
        profileService.getPartnerPreference()
      );

      if(vm.partnerPreference.fYearPref == null) {
        if (vm.profile.gender === "Male") {
          vm.ageSlider.maxValue = age;
          vm.ageSlider.minValue = age - 4;

          vm.heightSlider.maxValue = height.category;
          vm.heightSlider.minValue =
            height.category - 6 >= 140 ? height.category - 6 : 134;
        } else {
          vm.ageSlider.minValue = age;
          vm.ageSlider.maxValue = age + 4;

          vm.heightSlider.minValue = height.category;
          vm.heightSlider.maxValue = height.category + 7;
        }

        vm.partnerPreference.castePref = [];
        if (!vm.casteNoBar) {
          vm.caste = vm.profile.caste;
          vm.partnerPreference.castePref.push(vm.caste);
          if (!vm.subCasteNoBar) {
            getSubCasteOptions(vm.caste);
          }
        }

        vm.partnerPreference.martialStatusPref = [];
        if (vm.profile.martialStatus.indexOf("Never Married") > -1) {
          vm.partnerPreference.martialStatusPref.push("Never Married");
        } else {
          vm.partnerPreference.martialStatusPref.push("Any");
        }

        vm.partnerPreference.motherTonguePref = [];
        vm.partnerPreference.motherTonguePref.push(vm.profile.motherTongue);
      } else {
        vm.ageSlider.minValue = utilService._calculateAgeByYear(
          vm.partnerPreference.fYearPref,
          0,
          1
        );
        vm.ageSlider.maxValue = utilService._calculateAgeByYear(
          vm.partnerPreference.tYearPref
        );

        vm.heightSlider.minValue = vm.partnerPreference.fHeightPref;
        vm.heightSlider.maxValue = vm.partnerPreference.tHeightPref;
      }

      if (vm.partnerPreference.statePref) {
        getStates();
        for (var i = 0; i < vm.partnerPreference.statePref.length; i++) {
          getCities(vm.partnerPreference.statePref[i]);
        }
      }

      if (
        vm.partnerPreference.subCastePref &&
        vm.partnerPreference.subCastePref.length > 0
      ) {
        for (var i = 0; i < vm.partnerPreference.subCastePref.length; i++) {
          getSubCasteSubOptions(vm.partnerPreference.subCastePref[i]);
        }
      }
    }

    /*$rootScope.$on("ProfileData", function(event, data) {
     console.log("data "+data);
     getSubCasteOptions(data.caste);
     });*/

    $q.all([getPartnerPreferenceTemplate()]).then(function() {
      $loading.finish("partnerPrefer");
    });

    function getSubCasteOptions(val) {
      return codeValueService.getCodeByName(val).then(function(response) {
        vm.subCasteOptions = response.data;
      });
    }

    function createUpdatePartnerPreference() {
      if (!$scope.preferenceForm.$valid) {
        return !1;
      }

      vm.partnerPreference.matrimonyId = vm.profile.matrimonyId;
      vm.partnerPreference.profileId = vm.profile.id;

      if ($scope.main.currentSession.shopBasicInfo) {
        vm.partnerPreference.shopId = $scope.main.currentSession.shop.id;
      }

      if (angular.isUndefined(vm.partnerPreference.annualIncomePreFrom)) {
        vm.partnerPreference.annualIncomePreFrom = 0;
      }

      const currentDate = new Date();

      vm.partnerPreference.fYearPref =
        currentDate.getFullYear() - vm.ageSlider.minValue;
      vm.partnerPreference.tYearPref =
        currentDate.getFullYear() - vm.ageSlider.maxValue;

      vm.partnerPreference.fHeightPref = vm.heightSlider.minValue;
      vm.partnerPreference.tHeightPref = vm.heightSlider.maxValue;

      if (
        $state.is("home.createPartnerPreference") ||
        ($state.is("home.updatePartnerPreference") &&
          (profileService.getPartnerPreference() == undefined ||
            profileService.getPartnerPreference() == ""))
      ) {
        vm.partnerPreference.profileId = vm.profile.id;

        $loading.start("createUpdatePartnerPreferBtn");
        profileService.createPartnerPreference(vm.partnerPreference).then(
          function() {
            $loading.finish("createUpdatePartnerPreferBtn");
            // if (!$scope.main.currentSession) {
            //   $state.go('home.anchePedheMessage.profile');
            // } else {
            //   $state.go('home.myShopProfile');
            // }
            $state.transitionTo(
              "home.profile",
              {
                matrimonyId: vm.profile.matrimonyId,
                shopId: vm.profile.shopId
              },
              {
                reload: true,
                inherit: false,
                notify: true
              }
            );
          },
          function() {
            $loading.finish("createUpdatePartnerPreferBtn");
          }
        );
      } else {
        $loading.start("createUpdatePartnerPreferBtn");

        profileService.updatePartnerPreference(vm.partnerPreference).then(
          function(res) {
            $scope.main.currentSession.partnerPreference = res.data;
            sessionManagerService.setSessionData($scope.main.currentSession);

            if ($scope.main.currentSession.shopUser) {
              paginationTrackerService.resetSearchProfile();
            }
            $loading.finish("createUpdatePartnerPreferBtn");
            $state.transitionTo(
              "home.profile",
              {
                matrimonyId: vm.profile.matrimonyId,
                shopId: vm.profile.shopId
              },
              {
                reload: true,
                inherit: false,
                notify: true
              }
            );
          },
          function() {
            $loading.finish("createUpdatePartnerPreferBtn");
          }
        );
      }
    }

    /*function getVokkaligaSubCastes() {
     return codeValueService.getCodeByName('Vokkaliga-Gowda').then(function(response) {
     vm.subCasteOptions = response.data;
     });
     }*/

    function getPartnerPreferenceTemplate() {
      return profileService
        .getPartnerPreferenceTemplate()
        .then(function(response) {
          vm.partnerPreferenceTemplate = response.data;
        });
    }

    function setHighestEducationPref(val) {
      var val1 = vm.partnerPreference.highestEducationPref;
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.highestEducationPref = [];
        vm.partnerPreference.highestEducationPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.highestEducationPref, "Any");
      }
    }

    function setOccupationPref(val) {
      var val1 = vm.partnerPreference.occupationPref;
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.occupationPref = [];
        vm.partnerPreference.occupationPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.occupationPref, "Any");
      }
    }

    /*function setSubCastePref(val) {
     var val1 = vm.partnerPreference.subCastePref;
     if (angular.isDefined(val) && val == 'Any') {
     vm.partnerPreference.subCastePref = [];
     vm.partnerPreference.subCastePrefMandatory = false;
     } else if (angular.isDefined(val1) && val1.indexOf('Any') > -1) {
     $scope.main._.pull(vm.partnerPreference.subCastePref, 'Any');
     }
     }*/

    function setMartialStatusPref(val) {
      var val1 = vm.partnerPreference.martialStatusPref;
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.martialStatusPref = [];
        vm.partnerPreference.martialStatusPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.martialStatusPref, "Any");
      }
    }

    function setEmployedInPref(val) {
      var val1 = vm.partnerPreference.employedInPref;
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.employedInPref = [];
        vm.partnerPreference.employedInPrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.employedInPref, "Any");
      }
    }

    function setStatePref(val) {
      var val1 = vm.partnerPreference.statePref;
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.statePref = [];
        vm.partnerPreference.statePrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.statePref, "Any");
      } else if (
        angular.isDefined(vm.partnerPreference.statePref) &&
        vm.partnerPreference.statePref.length > 0 &&
        vm.partnerPreference.statePref.indexOf(val) > -1
      ) {
        //unchecked
        codeValueService.getCodeByName(val).then(function(response) {
          $scope.main._.pullAllBy(
            vm.cityOptions,
            response.data.values,
            "value"
          );

          if (vm.cityOptions.length > 0) {
            vm.cityOptions.splice(0, 0, {
              category: null,
              id: "1",
              value: "Any"
            });
            vm.cityOptions.push({ category: null, id: "999", value: "Other" });
          }

          var stringyfyvalues = JSON.stringify(response.data.values);
          $scope.main._.remove(vm.partnerPreference.cityPref, function(val) {
            return stringyfyvalues.indexOf(val) > -1;
          });
        });
      } else {
        getCities(val);
      }
    }

    function setCityPref(val) {
      var val1 = vm.partnerPreference.cityPref;
      if (angular.isDefined(val) && (val == "Any" || val == "Other")) {
        vm.partnerPreference.cityPref = [];
        vm.partnerPreference.cityPrefMandatory = false;
      } else if (
        angular.isDefined(val1) &&
        (val1.indexOf("Any") > -1 || val1.indexOf("Other") > -1)
      ) {
        $scope.main._.pull(vm.partnerPreference.cityPref, "Any");
        $scope.main._.pull(vm.partnerPreference.cityPref, "Other");
      }
    }

    function createUprodatePartnerPreference() {
      if (!$scope.preferenceForm.$valid) {
        return !1;
      }

      vm.partnerPreference.matrimonyId = vm.profile.matrimonyId;

      if ($scope.main.currentSession.shop) {
        vm.partnerPreference.shopId = $scope.main.currentSession.shop.id;
      }

      if (angular.isUndefined(vm.partnerPreference.annualIncomePreFrom)) {
        vm.partnerPreference.annualIncomePreFrom = 0;
      }

      const currentDate = new Date();

      vm.partnerPreference.fYearPref =
        currentDate.getFullYear() - vm.ageSlider.minValue;
      vm.partnerPreference.tYearPref =
        currentDate.getFullYear() - vm.ageSlider.maxValue;

      vm.partnerPreference.fHeightPref = vm.heightSlider.minValue;
      vm.partnerPreference.tHeightPref = vm.heightSlider.maxValue;

      if (
        $state.is("home.createPartnerPreference") ||
        ($state.is("home.updatePartnerPreference") &&
          (profileService.getPartnerPreference() == undefined ||
            profileService.getPartnerPreference() == ""))
      ) {
        vm.partnerPreference.profileId = vm.profile.id;

        $loading.start("createUpdatePartnerPreferBtn");
        profileService.createPartnerPreference(vm.partnerPreference).then(
          function() {
            $loading.finish("createUpdatePartnerPreferBtn");
            // if (!$scope.main.currentSession) {
            //   $state.go('home.anchePedheMessage.profile');
            // } else {
            //   $state.go('home.myShopProfile');
            // }
            $state.transitionTo(
              "home.profile",
              {
                matrimonyId: vm.profile.matrimonyId,
                shopId: vm.profile.shopId
              },
              {
                reload: true,
                inherit: false,
                notify: true
              }
            );
          },
          function() {
            $loading.finish("createUpdatePartnerPreferBtn");
          }
        );
      } else {
        $loading.start("createUpdatePartnerPreferBtn");

        profileService.updatePartnerPreference(vm.partnerPreference).then(
          function(res) {
            $scope.main.currentSession.partnerPreference = res.data;
            sessionManagerService.setSessionData($scope.main.currentSession);

            if ($scope.main.currentSession.roles.includes("ROLE_USER")) {
              paginationTrackerService.resetSearchProfile();
            }
            $loading.finish("createUpdatePartnerPreferBtn");
            $state.transitionTo(
              "home.profile",
              {
                matrimonyId: vm.profile.matrimonyId,
                shopId: vm.profile.shopId
              },
              {
                reload: true,
                inherit: false,
                notify: true
              }
            );
          },
          function() {
            $loading.finish("createUpdatePartnerPreferBtn");
          }
        );
      }
    }

    function clearSearchTerm() {
      vm.searchTerm = "";
    }

    function checkIfExist(item, values) {
      if (item == "" || angular.isUndefined(item)) {
        return true;
      } else {
        return (
          JSON.stringify(values)
            .toLowerCase()
            .indexOf(item) > -1
        );
      }
    }

    function setSubCastePref(val) {
      var val1 = vm.partnerPreference.subCastePref;
      if ((angular.isDefined(val) && val == "Any") || val == "Other") {
        vm.partnerPreference.subCastePref = [];
        vm.partnerPreference.subCastePrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.subCastePref, "Any");
      } else if (
        angular.isDefined(vm.partnerPreference.subCastePref) &&
        vm.partnerPreference.subCastePref.length > 0 &&
        vm.partnerPreference.subCastePref.indexOf(val) > -1
      ) {
        if (
          val.indexOf("Deshastha") == 0 ||
          val.indexOf("Iyengar") == 0 ||
          val.indexOf("Iyer") == 0 ||
          val.indexOf("Madhwa") == 0 ||
          val.indexOf("Saraswat") == 0 ||
          val.indexOf("Smartha") == 0
        ) {
          //unchecked
          codeValueService.getCodeByName(val).then(function(response) {
            $scope.main._.pullAllBy(
              vm.subCasteSubPrefOptions,
              response.data.values,
              "value"
            );

            if (vm.subCasteSubPrefOptions.length > 0) {
              vm.subCasteSubPrefOptions.splice(0, 0, {
                category: null,
                id: "1",
                value: "Any"
              });
              vm.subCasteSubPrefOptions.push({
                category: null,
                id: "999",
                value: "Other"
              });
            }
            if (vm.partnerPreference.subCasteSubPref.length > 0) {
              var stringyfyvalues = JSON.stringify(response.data.values);
              $scope.main._.remove(
                vm.partnerPreference.subCasteSubPref,
                function(val) {
                  return stringyfyvalues.indexOf(val) > -1;
                }
              );
            }
          });
        }
      } else {
        getSubCasteSubOptions(val);
      }
    }

    function setSubCasteSubPref(val) {
      var val1 = vm.partnerPreference.subCasteSubPref;
      if (angular.isDefined(val) && (val == "Any" || val == "Other")) {
        vm.partnerPreference.subCasteSubPref = [];
        vm.partnerPreference.subCasteSubPrefMandatory = false;
      } else if (
        angular.isDefined(val1) &&
        (val1.indexOf("Any") > -1 || val1.indexOf("Other") > -1)
      ) {
        $scope.main._.pull(vm.partnerPreference.subCasteSubPref, "Any");
        $scope.main._.pull(vm.partnerPreference.subCasteSubPref, "Other");
      }
    }

    vm.subCasteSubPrefOptions = [];
    function getSubCasteSubOptions(val) {
      if (val.indexOf("Any") == -1) {
        if (
          val.indexOf("Deshastha") == 0 ||
          val.indexOf("Iyengar") == 0 ||
          val.indexOf("Iyer") == 0 ||
          val.indexOf("Madhwa") == 0 ||
          val.indexOf("Saraswat") == 0 ||
          val.indexOf("Smartha") == 0
        ) {
          codeValueService.getCodeByName(val).then(function(response) {
            if (vm.subCasteSubPrefOptions.length > 0) {
              vm.subCasteSubPrefOptions = $scope.main._.initial(
                vm.subCasteSubPrefOptions
              );
            }
            vm.subCasteSubPrefOptions = $scope.main._.unionBy(
              vm.subCasteSubPrefOptions,
              response.data.values,
              "value"
            );
          });
        }
      }
    }

    function setCastePref(val) {
      var val1 = vm.partnerPreference.castePref;
      if (angular.isDefined(val) && (val == "Any" || val == "Other")) {
        vm.partnerPreference.castePref = [];
        vm.partnerPreference.castePrefMandatory = false;
      } else if (
        angular.isDefined(val1) &&
        (val1.indexOf("Any") > -1 || val1.indexOf("Other") > -1)
      ) {
        $scope.main._.pull(vm.partnerPreference.castePref, "Any");
        $scope.main._.pull(vm.partnerPreference.castePref, "Other");
      } else if (
        angular.isDefined(vm.partnerPreference.castePref) &&
        vm.partnerPreference.castePref.length > 0 &&
        vm.partnerPreference.castePref.indexOf(val) > -1
      ) {
        //unchecked
        codeValueService.getCodeByName(val).then(function(response) {
          $scope.main._.pullAllBy(
            vm.subCasteOptions,
            response.data.values,
            "value"
          );

          if (vm.subCasteOptions.length > 0) {
            vm.subCasteOptions.splice(0, 0, {
              category: null,
              id: "1",
              value: "Any"
            });
            vm.subCasteOptions.push({
              category: null,
              id: "999",
              value: "Other"
            });
          }

          var stringyfyvalues = JSON.stringify(response.data.values);
          $scope.main._.remove(vm.partnerPreference.subCastePref, function(
            val
          ) {
            return stringyfyvalues.indexOf(val) > -1;
          });
        });
      } //else if((()=>{vm.partnerPreference.castePref}) && !vm.casteNoBar && !vm.subCasteNoBar) {
      else {
        if (vm.partnerPreference.castePref.length === 0) {
          getSubCasteOptions(val);
        } else {
          vm.partnerPreference.subCastePref = [];
        }
      }
    }

    function getCasteOptions(val) {
      return codeValueService.getCodeByName(val).then(function(response) {
        vm.casteOptions = response.data;
      });
    }

    function setMotherTonguePref(val) {
      var val1 = vm.partnerPreference.motherTonguePref;
      if (angular.isDefined(val) && val == "Any") {
        vm.partnerPreference.motherTonguePref = [];
        vm.partnerPreference.motherTonguePrefMandatory = false;
      } else if (angular.isDefined(val1) && val1.indexOf("Any") > -1) {
        $scope.main._.pull(vm.partnerPreference.motherTonguePref, "Any");
      }
    }
  }
})();


/**
 * Created by gomahesh on 2017-05-12.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('PaymentController', PaymentController);

  /** @ngInject */
  function PaymentController(paymentService, $scope, $stateParams, $loading,
                             codeValueService, $filter, $sce, $window, URL, WEB_HOOK_URL, shopService,
                             profileService, $state) {

    var vm = this;
    vm.makePayment = makePayment;
    vm.payWithRazorpay = payWithRazorpay;
    vm.createPayment = createPayment;
    vm.splitPayment = splitPayment;
    vm.getProfileByMatrimonyId = getProfileByMatrimonyId;
    var webhookUrl = WEB_HOOK_URL.noOffer;
    vm.selectedMatrimonyId = $stateParams.matrimonyId != undefined ? $stateParams.matrimonyId : "";
    vm.profileBasicInfo;
    vm.shopMobileNo =  $scope.main.currentSession.shop.mobileNo;

    if($scope.main.currentSession.roles.includes('ROLE_USER')) {
      vm.profileBasicInfo = $scope.main.currentSession.profileBasicInfo;
      getPackageOptions();
    }
    function getPackageOptions() {
      $loading.start("payment");
      var shopId = $scope.main.currentSession.shop.id;
      var data = {
        caste: vm.profileBasicInfo.caste
      };
      shopService.getOffer(shopId, data).then(function(response) {
        vm.packageOptions = response.data.values;
        vm.selectedPackage = _.last(response.data.values);
        webhookUrl = WEB_HOOK_URL.offer;
        $loading.finish("payment");
      }, function() {
        shopService.getShopPackagePlanByShopId($scope.main.currentSession.shop.id).then(function (response) {
          vm.packageOptions = response.data.values;
          if($scope.main.currentSession.roles.includes('ROLE_ADMIN') || $scope.main.currentSession.roles.includes('ROLE_EMPLOYEE')) {
            calConvenienceAmnt();
          }
          vm.selectedPackage = _.last(response.data.values);
          $loading.finish("payment");
        });
      });
    }

    function calConvenienceAmnt() {
      for(var i=1; i< vm.packageOptions.length; i++) {
        var amount = parseInt(vm.packageOptions[i].value);
        var shopPercentageAmt = amount * ($scope.main.currentSession.shop.percentageAmount / 100);
        //per 2 %
        var percentageAmnt = 2 / 100;
        //3 rs per tranx
        var perTxnAmt = 3;
        //GST 18 %
        var gstAmnt = 18 / 100;
        var partialconvenienceAmt = ((percentageAmnt * shopPercentageAmt) + perTxnAmt);
        vm.packageOptions[i]['convenienceAmnt'] = Math.ceil(partialconvenienceAmt +
        ((partialconvenienceAmt * gstAmnt) + shopPercentageAmt));
      }
    }

    function getProfileByMatrimonyId(form) {
      if (!form.$valid) {
        return !1;
      }
      $loading.start('profile');
      profileService.getProfileByMatrimonyId(vm.selectedMatrimonyId)
        .then(function(response) {
          vm.profileBasicInfo = response.data;
          $loading.finish('profile');
          if(vm.profileBasicInfo.profileStatus === 'Free Member' || vm.profileBasicInfo.profileStatus === 'Paid Member') {
            getPackageOptions();
          }
      }, function() {
        $loading.finish('profile');
      });
    }

    vm.selectPackage = function(val) {
      vm.selectedPackage =  _.find(vm.packageOptions, {id:val});
    };

    //Rzpay Money Gateway
    function makePayment() {
      if($scope.main.currentSession.roles.includes('ROLE_ADMIN') || $scope.main.currentSession.roles.includes('ROLE_EMPLOYEE')) {
        createRzpayOrder();
      } else if($scope.main.currentSession.roles.includes('ROLE_USER')) {
        createRzpaySplitPaymentOrder();
      }
    }

    //For marriage bureau
    function createRzpayOrder() {
      var profile = vm.profileBasicInfo;
      var payload = {
        "amount": parseInt(vm.selectedPackage.value),
        "profileId": profile.id,
        "matrimonyId": profile.matrimonyId,
        "shopId": profile.shopId,
        "convenienceAmount":  parseInt(vm.selectedPackage.convenienceAmnt)*100
      };
      console.log(payload);
      $loading.start("paymentBtn");
      paymentService.razorpayOrder(payload).then(function(res) {
        $loading.finish("paymentBtn");
        showRzpayPaymentPopup(res, res.data.convenienceAmount);
      }, function(error) {
        $loading.finish("paymentBtn");
        alert('Error occured.');
      });
    }

    //For marriage bureau user
    function createRzpaySplitPaymentOrder() {
      // call api to create order_id
      var profile = vm.profileBasicInfo;
      var payload = {
        "amount": parseInt(vm.selectedPackage.value),
        "profileId": profile.id,
        "matrimonyId": profile.matrimonyId,
        "shopId": profile.shopId,
      };
      $loading.start("paymentBtn");
      paymentService.razorpayRouteOrder(payload).then(function(res) {
        $loading.finish("paymentBtn");
        showRzpayPaymentPopup(res, res.data.amount);
      }, function(error) {
        $loading.finish("paymentBtn");
        alert('Error occured.');
      })
    }

    function showRzpayPaymentPopup(res, amount) {
      if(res.data && res.data.id) {
        var prefill = {};
        if($scope.main.currentSession.roles.includes('ROLE_ADMIN') || $scope.main.currentSession.roles.includes('ROLE_EMPLOYEE')) {
          prefill ={
            'contact': $scope.main.currentSession.shop.mobileNo,
            'email': $scope.main.currentSession.shop.email,
          }
        } else if($scope.main.currentSession.roles.includes('ROLE_USER')) {
         prefill = {
          'contact': $scope.main.currentSession.profileBasicInfo ?  $scope.main.currentSession.profileBasicInfo.mobileNo : $scope.main.currentSession.shop.mobileNo,
          'email':  $scope.main.currentSession.profileBasicInfo ? $scope.main.currentSession.profileBasicInfo.email : $scope.main.currentSession.shop.email,
          }
        }
        $loading.start("paymentBtn");
        const options = {
          key: 'rzp_live_8LDylYYJLiCQ5x',
          amount: parseInt(amount)*100, // amount should be in paise format to display Rs 1255 without decimal point
          currency: 'INR',
          name: '', // company name or product name
          description: '',  // product description
          order_id: res.data.id, // order_id created by you in backend
          modal: {
            // We should prevent closing of the form when esc key is pressed.
            escape: false,
          },
          notes: {
            // include notes if any
          },
          theme: {
            color: '#0c238a'
          },
          prefill: prefill
        };
        options.handler = (function(response, error) {
          options.response = response;
          console.log(response);
          console.log(options);
          $loading.finish("paymentBtn")
          if($scope.main.currentSession.roles.includes('ROLE_USER')) {
            $state.go('home.packagePlan');
          } else {
            $state.go('home.profile', {matrimonyId: vm.profileBasicInfo.matrimonyId, shopId: vm.profileBasicInfo.shopId});
          }
          // call your backend api to verify payment signature & capture transaction
        });
        options.modal.ondismiss = (function(){
          // handle the case when user closes the form while transaction is in progress
          console.log('Transaction cancelled.');
          $loading.finish("paymentBtn")
        });
        const rzp = window.Razorpay(options);
        rzp.open();
      }
    }
    function payWithRazorpay() {
      const options = {
        key: 'rzp_live_8LDylYYJLiCQ5x',
        amount: 10000, // amount should be in paise format to display Rs 1255 without decimal point
        currency: 'INR',
        name: '', // company name or product name
        description: '',  // product description
        order_id: "order_OFV0TnPZB9Rc6N", // order_id created by you in backend
        modal: {
          // We should prevent closing of the form when esc key is pressed.
          escape: false,
        },
        notes: {
          // include notes if any
        },
        theme: {
          color: '#0c238a'
        },
        prefill: {
          'contact': $scope.main.currentSession.profileBasicInfo.mobileNo || $scope.main.currentSession.shop.mobileNo,
          'email': $scope.main.currentSession.profileBasicInfo.email || $scope.main.currentSession.shop.email,
        }
      };
      options.handler = (function(response, error) {
        options.response = response;
        console.log(response);
        console.log(options);
        $loading.finish("paymentBtn")
        alert('Payment Success');
        if($scope.main.currentSession.roles.includes('ROLE_USER')) {
          $location.path('/myShopProfile');
        }
        // call your backend api to verify payment signature & capture transaction
      });
      options.modal.ondismiss = (function(){
        // handle the case when user closes the form while transaction is in progress
        console.log('Transaction cancelled.');
        alert('Transaction cancelled.')
        $loading.finish("paymentBtn")
      });
      const rzp = window.Razorpay(options);
      rzp.open();
    }

    function createPayment() {
        vm.selectedUser();
      /*var payload = {
        "amount": '1000',
        "name": $scope.main.currentSession.profileBasicInfo.profileName,
        "email": $scope.main.currentSession.profileBasicInfo.email,
        "phone": $scope.main.currentSession.profileBasicInfo.mobileNo,
        "redirectUrl": $window.location.origin+"/packagePlan",
        "webhook": WEB_HOOK_URL,
        "currency": "INR",
        "purpose": $scope.main.currentSession.profileBasicInfo.shopId+"-"+$scope.main.currentSession.profileBasicInfo.id
      }

      $loading.start("paymentBtn");
      paymentService.createInstamojoPaymentRequest(payload).then(function(d){
        //$loading.finish("paymentBtn");
        $scope.data = d;
        console.log("data "+d);
        $window.location.href = d.data.paymentOptions.paymentUrl;
      });*/
      console.log(payload);
    }

    function splitPayment() {
      var profile = vm.profileBasicInfo;
      var memberType = profile.memberType;
      var percentageAmount = $scope.main.currentSession.shop.percentageAmount;
      var payload = {
        "amount": vm.selectedPackage.value,
        "name": profile.profileName,
        "redirectUrl": $window.location.origin+"/packagePlan",
        "webhookUrl": URL + webhookUrl,
        "currency": "INR",
        "purpose": vm.selectedPackage.id,
        "partnerPercentFee": parseInt(percentageAmount)
      }
      payload["phone"] = profile.mobileNo;
      payload["email"] = profile.email || $scope.main.currentSession.shop.email;
    
      $loading.start("paymentBtn");

      paymentService.instamojoSplitPaymentRequest(payload, profile.shopId, profile.id).then(function(d){
        //$loading.finish("paymentBtn");
        $scope.data = d;
        console.log("data "+d);
        $window.location.href = d.data.paymentUrl+"?embed=form";
      });
    }
   
  }
})();

/**
 * Created by gomahesh on 9/4/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('PackagePlanController', PackagePlanController);

  /** @ngInject */
  function PackagePlanController($scope, profileService, sessionManagerService) {
    /* jshint validthis: true */
    
    (function getMemberPackagePlanByMatrimonyId(matrimonyId) {
      return profileService.getMemberPackagePlanByMatrimonyId(matrimonyId).then(function(response) {
        $scope.main.currentSession.packagePlan = response.data;
        sessionManagerService.setSessionData($scope.main.currentSession);
      })
    })($scope.main.currentSession.profileBasicInfo.matrimonyId)
  }

})();

/**
 * Created by GGowda on 12/4/2015.
 */
(function () {
  "use strict";

  angular
    .module("anchePedheMatrimony")
    .controller(
      "OtherShopProfileOrIndividualProfileController",
      OtherShopProfileOrIndividualProfileController
    );

  /** @ngInject */
  function OtherShopProfileOrIndividualProfileController(
    shopService,
    $scope,
    $state,
    $loading,
    utilService,
    paginationTrackerService,
    profileService,
    codeValueService,
    $q
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.utilService = utilService;
    var gender = $scope.main.currentSession.roles.includes("ROLE_ADMIN") || $scope.main.currentSession.roles.includes("ROLE_EMPLOYEE")
      ? ""
      : $scope.main.currentSession.profileBasicInfo.gender;
    var caste =$scope.main.currentSession.roles.includes("ROLE_ADMIN") || $scope.main.currentSession.roles.includes("ROLE_EMPLOYEE")
      ? ""
      : $scope.main.currentSession.profileBasicInfo.caste;
    vm.page = angular.isUndefined(
      paginationTrackerService.getPaginationOtherShopProfile()
    )
      ? 0
      : paginationTrackerService.getPaginationOtherShopProfile();
    var fn = $scope.main.currentSession.roles.includes("ROLE_ADMIN") || $scope.main.currentSession.roles.includes("ROLE_EMPLOYEE")
      ? getOtherBureauProfiles
      : getProfilesForUser;

    vm.changePath = changePath;
    vm.pageChangeHandler = pageChangeHandler;
    vm.pageSize = 16;

    $scope.currentPage = vm.page+1;

    vm.filterChange = filterChange;
    vm.checkIfExist = checkIfExist;
    vm.searchProfile = searchProfile;
    vm.clearAllFilters = clearAllFilters;
    vm.submitAge = submitAge;
    vm.submitHeight = submitHeight;
    vm.shareProfile = shareProfile;
    vm.setCurrentImage = setCurrentImage;

    var filterObj = angular.isUndefined(
      paginationTrackerService.getOtherFilterObj()
    )
      ? {}
      : paginationTrackerService.getOtherFilterObj();
    var selArray = angular.isUndefined(
      paginationTrackerService.getOtherFilterArray()
    )
      ? [
          { gender: [] },
          { vegOrNonVeg: []},
          { caste: [] },
          { subCaste: [] },
          { highestEducation: [] },
          { star: [] },
          { employedIn: [] },
          { occupation: [] },
          { martialStatus: [] },
          { currentLivingCountry: [] },
          { currentLivingState: [] },
          { currentLivingCity: [] },
          { motherTongue: [] },
          { casteNoBar: [] },
          { religion: [] },
        ]
      : paginationTrackerService.getOtherFilterArray();

    vm.filter = angular.isUndefined(paginationTrackerService.getOtherFilter())
      ? {}
      : paginationTrackerService.getOtherFilter();
    vm.regex = angular.isUndefined(paginationTrackerService.getOtherRegex())
      ? ""
      : paginationTrackerService.getOtherRegex();
    if (angular.isDefined(paginationTrackerService.getOtherAge())) {
      vm.fromAge = paginationTrackerService.getOtherAge().fromAge;
      vm.toAge = paginationTrackerService.getOtherAge().toAge;
    }
    if (angular.isDefined(paginationTrackerService.getOtherHeight())) {
      vm.fromHeight = paginationTrackerService.getOtherHeight().fromHeight;
      vm.toHeight = paginationTrackerService.getOtherHeight().toHeight;
    }

    fn();

    
    /*$scope.currentSession.shopEmp ? $scope.checkPath('/shopProfiles') : '';*/

    function changePath(stateName, profileName, matrimonyId, param) {
      // var bData;
      // if (!$scope.main.currentSession.shopEmp) {
      //   bData = [
      //     {
      //       name: "Home",
      //       seourl: "/profileMatch",
      //     },
      //     {
      //       name: "Other Bureau Profile",
      //       seourl: "/otherShopProfileOrIndividualProfile",
      //     },
      //     {
      //       name: profileName + " " + " (" + matrimonyId + ")",
      //       seourl: "",
      //     },
      //   ];
      // } else {
      //   bData = [
      //     {
      //       name: "Home",
      //       seourl: "/myShopProfile",
      //     },
      //     {
      //       name: "Other Bureau Profile",
      //       seourl: "/otherShopProfileOrIndividualProfile",
      //     },
      //     {
      //       name: profileName + " " + " (" + matrimonyId + ")",
      //       seourl: "",
      //     },
      //   ];
      // }

      $state.go(stateName, param);
    }

    function shareProfile(profile, shop, ev) {
      utilService._shareWhatsApImage(
        profile,
        $scope.main.currentSession.shop,
        ev
      );
    }

    function getOtherBureauProfiles() {
      $loading.start("otherShopProfiles");
      return shopService
        .getBureauProfiles(
          $scope.main.currentSession.shop.id,
          vm.page,
          vm.pageSize,
          {
            filter: filterObj,
            fromAge: vm.fromAge,
            toAge: vm.toAge,
            fromHeight: vm.fromHeight,
            toHeight: vm.toHeight,
          },
          vm.regex,
          $scope.main.currentSession.shop.anchepedheMarriageBureau,
          true,
          $scope.main.currentSession.shop.otherClientViewYourProfiles,
          $scope.main.currentSession.shop.othrPfVwCtNo,
          $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo
        )
        .then(function (response) {
          vm.profiles = response.data.results;
          vm.total = response.data.total;
          $loading.finish("otherShopProfiles");
          for (var i = 0; i < vm.profiles.length; i++) {
            vm.profiles[i].imageRandomNo = utilService._getRandomNumber();
          }
          return vm.profiles;
        });
    }

    function getProfilesForUser() {
      $loading.start("otherShopProfiles");
      if ($scope.main.currentSession.profileBasicInfo.casteNoBar) {
        caste = "";
      }
      shopService
        .getShopProfilesByShopIdForShopUser(
          $scope.main.currentSession.shop.id,
          caste,
          gender,
          vm.page,
          vm.pageSize,
          true,
          $scope.main.currentSession.shop.anchepedheMarriageBureau,
          $scope.main.currentSession.shop.otherClientViewYourProfiles
        )
        .then(function (response) {
          vm.profiles = response.data.content;
          vm.total = Math.ceil(response.data.total / vm.pageSize);
          $loading.finish("otherShopProfiles");
          for (var i = 0; i < vm.profiles.length; i++) {
            vm.profiles[i].imageRandomNo = utilService._getRandomNumber();
          }
          return vm.profiles;
        });
    }

    function pageChangeHandler(newPageNumber) {
      vm.page = newPageNumber - 1;
      paginationTrackerService.setPaginationOtherShopProfile(vm.page);
      fn();
    }

    (function () {
      if ($scope.main.currentSession.roles.includes("ROLE_USER")) {
        var shopId = $scope.main.currentSession.profileBasicInfo.shopId;
        var caste = $scope.main.currentSession.profileBasicInfo.caste;
        var casteNoBar = $scope.main.currentSession.profileBasicInfo.casteNoBar;
        var neverMarried =
          $scope.main.currentSession.profileBasicInfo.martialStatus ==
            "Never Married" || false;
        var gender = $scope.main.currentSession.profileBasicInfo.gender;
        profileService
          .getShopProfileCount(
            shopId,
            caste,
            true,
            gender,
            {},
            casteNoBar,
            gender
          )
          .then(function (res) {
            vm.shopProfileCount = res.data;
          });
      } else {
        profileService
          .getFilterData(
            $scope.main.currentSession.shop.id,
            {
              selArr: selArray,
              fromAge: vm.fromAge,
              toAge: vm.toAge,
              fromHeight: vm.fromHeight,
              toHeight: vm.toHeight,
            },
            vm.regex,
            true,
            $scope.main.currentSession.shop.anchepedheMarriageBureau,
            $scope.main.currentSession.shop.otherClientViewYourProfiles,
            $scope.main.currentSession.shop.othrPfVwCtNo,
            $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo
          )
          .then(function (response) {
            vm.filter = generateCompData(response.data);
          });
        codeValueService.getCodeByName("Age-Pref").then(function (response) {
          vm.ageOptions = response.data;
          /*$loading.finish('createUpdateProfile');*/
        });
        codeValueService.getCodeByName("Height").then(function (response) {
          vm.heightOptions = response.data;
          /*$loading.finish('createUpdateProfile');*/
        });
      }
    })();

    function filterChange(parent, child) {
      $loading.start("filter");
      generateFilterObject(parent, child);
      gO(parent, child);
      paginationTrackerService.setOtherFilterObj(filterObj);
      paginationTrackerService.setOtherFilterArray(selArray);
      paginationTrackerService.setOtherFilter(vm.filter);

      $loading.start("otherShopProfiles");
      getOtherBureauProfiles();
      getFilterData().then(function () {
        $loading.finish("filter");
      });
    }

    function submitAge() {
      if (angular.isUndefined(vm.fromAge) || angular.isUndefined(vm.toAge)) {
        alert("Sorry, please select age range.");
        return;
      } else if (vm.fromAge > vm.toAge) {
        alert(
          "Sorry, Invalid age range. " + vm.fromAge + " to " + vm.toAge + "."
        );
        return;
      }
      $loading.start("filter");
      getOtherBureauProfiles();
      getFilterData().then(function (data) {
        $loading.finish("filter");
        if (data.length > 0) {
          paginationTrackerService.setOtherAge({
            fromAge: vm.fromAge,
            toAge: vm.toAge,
          });
        }
      });
    }

    function submitHeight() {
      if (
        angular.isUndefined(vm.fromHeight) ||
        angular.isUndefined(vm.toHeight)
      ) {
        alert("Sorry, please select age range.");
        return;
      } else if (vm.fromHeight > vm.toHeight) {
        alert(
          "Sorry, Invalid age range. " +
            vm.fromHeight +
            " to " +
            vm.toHeight +
            "."
        );
        return;
      }
      $loading.start("filter");
      getOtherBureauProfiles();
      getFilterData().then(function (data) {
        $loading.finish("filter");
        if (data.length > 0) {
          paginationTrackerService.setOtherHeight({
            fromHeight: vm.fromHeight,
            toHeight: vm.toHeight,
          });
        }
      });
    }

    function getFilterData() {
      var deferred = $q.defer();
      profileService
        .getFilterData(
          $scope.main.currentSession.shop.id,
          {
            selArr: selArray,
            fromAge: vm.fromAge,
            toAge: vm.toAge,
            fromHeight: vm.fromHeight,
            toHeight: vm.toHeight,
          },
          vm.regex,
          true,
          $scope.main.currentSession.shop.anchepedheMarriageBureau,
          $scope.main.currentSession.shop.otherClientViewYourProfiles,
          $scope.main.currentSession.shop.othrPfVwCtNo,
          $scope.main.currentSession.shop.allwOnlyMbPfWhShwCtNo
        )
        .then(function (response) {
          if (response.data.length < 1) {
            alert("No Data Found. Please change the query.");
            $loading.finish("filter");
            return;
          }
          vm.filter = generateCompData(response.data);
          deferred.resolve(response.data);
        })
        .catch(function (error) {
          deferred.reject();
        });
      return deferred.promise;
    }

    function generateFilterObject(parent, child) {
      if (child["isChecked"] === true) {
        if (!filterObj.hasOwnProperty(parent)) {
          filterObj[parent] = [];
        }
        filterObj[parent].push(child.name);
      } else if (child["isChecked"] === false) {
        var i = _.findIndex(filterObj[parent], function (o) {
          return o == child.name;
        });
        filterObj[parent].splice(i, 1);
        if (filterObj[parent].length === 0) {
          delete filterObj[parent];
        }
      }
      return filterObj;
    }

    function gO(parent, child) {
      if (child["isChecked"] === true) {
        for (var i in selArray) {
          if (!selArray[i].hasOwnProperty(parent)) {
            if (
              selArray[i][Object.keys(selArray[i])[0]].length !== 0 &&
              JSON.stringify(selArray[i][Object.keys(selArray[i])[0]]).indexOf(
                parent
              ) > -1
            ) {
              for (var j in selArray[i][Object.keys(selArray[i])[0]]) {
                if (
                  JSON.stringify(
                    selArray[i][Object.keys(selArray[i])[0]][j]
                  ).indexOf(parent) > -1
                ) {
                  var l =
                    selArray[i][Object.keys(selArray[i])[0]][j][
                      Object.keys(
                        selArray[i][Object.keys(selArray[i])[0]][j]
                      )[0]
                    ];
                  l.push({ $eq: ["$" + parent, child.name] });
                }
              }
            } else {
              selArray[i][Object.keys(selArray[i])[0]].push({
                $or: [{ $eq: ["$" + parent, child.name] }],
              });
            }
          }
        }
      } else if (child["isChecked"] === false) {
        for (var i in selArray) {
          for (var j in selArray[i][Object.keys(selArray[i])[0]]) {
            for (var k in selArray[i][Object.keys(selArray[i])[0]][j]["$or"]) {
              if (
                JSON.stringify(
                  selArray[i][Object.keys(selArray[i])[0]][j]["$or"][k]
                ).indexOf(child.name) > -1
              ) {
                selArray[i][Object.keys(selArray[i])[0]][j]["$or"].splice(k, 1);
                if (
                  selArray[i][Object.keys(selArray[i])[0]][j]["$or"].length == 0
                ) {
                  delete selArray[i][Object.keys(selArray[i])[0]][j]["$or"];
                }
              }
            }
            if (
              Object.keys(selArray[i][Object.keys(selArray[i])[0]][j])[0] ===
              undefined
            ) {
              selArray[i][Object.keys(selArray[i])[0]].splice(j, 1);
            }
          }
        }
      }
    }

    function generateCompData(resData) {
      for (var i = 0; i < vm.filter.length; i++) {
        var obj = _.find(resData, { id: vm.filter[i].id });
        for (var j = 0; j < vm.filter[i].values.length; j++) {
          if (vm.filter[i].values[j].isChecked) {
            try {
              var valueObj = _.find(obj.values, {
                name: vm.filter[i].values[j].name,
              });
              valueObj.isChecked = vm.filter[i].values[j].isChecked;
            } catch (msg) {
              console.log(msg);
              vm.filter[i].values[j].isChecked = false;
              filterChange(vm.filter[i].id, vm.filter[i].values[j]);
            }
          }
        }
      }

      return resData;
    }

    function checkIfExist(val1, val2) {
      var obj = JSON.parse(JSON.stringify(val1));
      return _.find(obj.values, { isChecked: true }) !== undefined
        ? true
        : false;
    }

    function searchProfile() {
      getOtherBureauProfiles();
      getFilterData();
      paginationTrackerService.setOtherRegex(vm.regex);
    }

    function clearAllFilters() {
      $loading.start("filter");
      paginationTrackerService.setOtherFilterObj(undefined);
      paginationTrackerService.setOtherFilterArray(undefined);
      paginationTrackerService.setOtherAge(undefined);
      paginationTrackerService.setOtherHeight(undefined);
      filterObj = {};
      selArray = [
        { gender: [] },
        { vegOrNonVeg: []},
        { caste: [] },
        { subCaste: [] },
        { highestEducation: [] },
        { star: [] },
        { employedIn: [] },
        { occupation: [] },
        { martialStatus: [] },
        { currentLivingCountry: [] },
        { currentLivingState: [] },
        { currentLivingCity: [] },
        { motherTongue: [] },
        { casteNoBar: [] },
        { religion: [] },
      ];
      vm.filter = {};
      vm.fromAge = undefined;
      vm.toAge = undefined;
      vm.fromHeight = undefined;
      vm.toHeight = undefined;
      vm.page = 0;

      getOtherBureauProfiles();
      getFilterData().then(function () {
        $loading.finish("filter");
      });
    }

    function setCurrentImage(i, profile) {
      utilService._setCurrentImage(i, profile);
    }
  }
})();

/**
 * Created by gomahesh on 9/20/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('NotificationController', NotificationController);

  /** @ngInject */
  function NotificationController(profileService, $scope, $loading) {
    var page = 0;
    var vm = this;

    vm.getNotificationByMatrimonyId = getNotificationByMatrimonyId;
    vm.pageChangeHandler = pageChangeHandler;
    vm.pageSize = 4;
    vm.updateNotificationById = updateNotificationById;

    getNotificationByMatrimonyId();

    function getNotificationByMatrimonyId() {
      $loading.start("notification");
      return profileService.getNotificationByMatrimonyId($scope.main.currentSession.profileBasicInfo.matrimonyId, page,
            vm.pageSize).then(function(response) {
        vm.notifications = response.data.content;
        vm.totalNotifications = response.data.totalElements;
        $loading.finish("notification");
      })
    }

    function pageChangeHandler(newPageNumber) {
      page = (newPageNumber-1) * 4;
      getNotificationByMatrimonyId();
    }

    

    function  updateNotificationById(notificationId) {
      profileService.updateNotificationById(notificationId).then(function() {
        console.log("success");
        var index = $scope.main._.findIndex(vm.notifications, function(o) { return o.id == notificationId; });
        if(index > -1) {
          vm.notifications[index].viewed = !0;
        }
      });
    }

    function changePathFromNotification(stateName, profileName, matrimonyId, param, notificationId, isViewed,
                                        profileDeleted) {
      if(profileDeleted) return;
      if(!isViewed) {
        updateNotificationById(notificationId);
      }
      
      $state.go(stateName, param);
    }
  }
})();

/**
 * Created by gomahesh on 2017-07-23.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('ProfileListController', ProfileListController);

  /** @ngInject */
  function ProfileListController($rootScope, sessionManagerService, $location, profileService, shopService, $q) {
    /* jshint validthis: true */
    var vm = this;
    vm.userData = sessionManagerService.getUserData() || sessionManagerService.getSessionData();

    var p = vm.userData.profileBasicInfo;
    $q.all([getShopByShopId(p.shopId),getMemberPackagePlanByMatrimonyId(p.matrimonyId),
      getPartnerPreferenceByMatrimonyIdAndShopId(p.matrimonyId)]).then(function () {
      $rootScope.$broadcast("UserAuthenticationSuccessEvent", vm.userData);
      $location.path('/profileMatch');
    }, function() {
      $location.path('/profileMatch');
      console.log("error");
    });
   

    function getShopByShopId(shopId) {
      var deferred = $q.defer();
      shopService.getShopByShopId(shopId).then(function(response) {
        vm.userData.shop = response.data;
        sessionManagerService.setSessionData(vm.userData);
        deferred.resolve(response.data);
      }, function() {
        deferred.reject();
      });
      return deferred.promise;
    }

    function getPartnerPreferenceByMatrimonyIdAndShopId(matrimonyId) {
      var deferred = $q.defer();
      profileService.getPartnerPreferenceByMatrimonyId(matrimonyId).then(function(response) {
        vm.userData.partnerPreference = response.data;
        deferred.resolve(response.data);
      }, function () {
        deferred.reject();
      });

      return deferred.promise;
    }

  function getMemberPackagePlanByMatrimonyId(matrimonyId) {
    var deferred = $q.defer();
    profileService.getMemberPackagePlanByMatrimonyId(matrimonyId).then(function(response) {
      vm.userData.packagePlan = response.data;
      sessionManagerService.setSessionData(vm.userData);
      deferred.resolve(response.data);
      //$location.path('/profileMatch');
    }, function() {
      deferred.reject();
    });
    return deferred.promise;
  }
  }
})();

/**
 * Created by GGowda on 11/11/2015.
 */
(function () {
  'use strict';

  angular.module('anchePedheMatrimony').controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($scope, loginSignUpService, shopService, $location, $log, $loading, httpService,
    sessionManagerService, reg, paginationTrackerService, $window) {
    /* jshint validthis: true */
    var vm = this;
    vm.host = $window.location.host;
    vm.reg = reg;
    vm.quickSrch = {};
    vm.quickSrch.gender = 'Female';
    vm.quickSrch.caste = 'Any';
    vm.quickSrch.martialStatus = 'neverMarried';

    vm.toUpperCaseUrl = toUpperCaseUrl;
    vm.toggleMenu = toggleMenu;
    vm.authenticate = authenticate;
    vm.quickSearch = quickSearch;

    vm.pageChangeHandler = pageChangeHandler;
    vm.successStory = [];
    vm.successStory.push(reg.successStory.content[0]);
    vm.totalSuccessStory = reg.successStory.totalElements > 4 ? 4 : reg.successStory.totalElements;
    vm.page = 0;

    function pageChangeHandler(newPageNumber) {
      vm.page = newPageNumber - 1;
      vm.successStory = [];
      vm.successStory.push(reg.successStory.content[vm.page]);
    }

    if (sessionManagerService.getNotLoginData()) {
      vm.shopName = '';
    }

    function toggleMenu() {
      var x = document.getElementById("myTopnav");
      if (x.className === "nav_container display-block") {
        x.className = "nav_container";
      } else {
        x.className = "nav_container display-block";
      }
    }

    function toUpperCaseUrl(s) {
      return;
      if (typeof s !== 'string') return '';
      if (s.indexOf('localhost') > -1) {
        return;
      } else if (s.indexOf('www.anchepedhematrimony.com') > -1) {
        return 'AnchepedheMatrimony.com'
      } else {
        var splitArray = s.split('.');
        s = s.substring(4)
        return splitArray[1].charAt(0).toUpperCase() + splitArray[1].slice(1)
          + '.' + splitArray[2].charAt(0).toUpperCase() + splitArray[2].slice(1);
      }
    }

    function quickSearch() {
      console.log(vm.quickSrch);
      if (!vm.quickSrch.fAge || !vm.quickSrch.tAge) {
        alert("Please enter age range");
        return;
      }

      if (vm.quickSrch.tAge < vm.quickSrch.fAge) {
        alert("Please enter valid age range");
        return;
      }
      if (vm.quickSrch.gender === 'Female' && vm.quickSrch.fAge < 18) {
        alert("Sorry, invalid age " + vm.quickSrch.fAge + " (Min. age is 18. Max. age is 70).");
        return;
      }

      if (vm.quickSrch.gender === 'Female' && vm.quickSrch.tAge < 18) {
        alert("Sorry, invalid age " + vm.quickSrch.tAge + " (Min. age is 18. Max. age is 70).");
        return;
      }

      if (vm.quickSrch.gender === 'Male' && vm.quickSrch.fAge < 21) {
        alert("Sorry, invalid age " + vm.quickSrch.fAge + " (Min. age is 21. Max. age is 70).");
        return;
      }

      if (vm.quickSrch.gender === 'Male' && vm.quickSrch.tAge < 21) {
        alert("Sorry, invalid age " + vm.quickSrch.tAge + " (Min. age is 21. Max. age is 70).");
        return;
      }

      if (vm.quickSrch.fAge > 70 || vm.quickSrch.tAge > 70) {
        alert("Maximum age allowed is 70");
        return;
      }

      paginationTrackerService.setQuickSrch(vm.quickSrch);
      $location.path('/sProfileNotLoggedIn');
    }

    function authenticate() {
      if (!$scope.loginForm.$valid) {
        return !1;
      }
      $loading.start("loginBtn");
      shopService.getShopByMobileNo(vm.user.name).then((function (_) {
        loginSignUpService.checkAuthenticate(vm.user.name, vm.user.password, {}).then(function (res) {
          $loading.finish("loginBtn");
          var notLoginData = sessionManagerService.getNotLoginData();
          shopService.getShopPackagePlanByShopId(notLoginData.shop.id).then(function (response) {
            var packageOptions = response.data.values;
            var packagePlansTemp = packageOptions.filter(function (item) { return item.id != 'Free'; })
            sessionManagerService.setPackagePlanSession(packagePlansTemp);
          })
          // httpService.setAuthorization(res.data['base64EncodedAuthenticationKey']);
          if (sessionManagerService.getUserData().roles.includes("ROLE_ADMIN") || sessionManagerService.getUserData().roles.includes("ROLE_EMPLOYEE")) {
            $location.path('/myShopProfile');
          } else if (sessionManagerService.getUserData().roles.includes("ROLE_USER")) {
            throw Error();
            //$location.path('/multiple-accounts');
          }
        }, function (error) {
          $loading.finish("loginBtn");
          $log.info("error " + error);

        });
      }))
    }

    $log.debug('LoginController');

  }
})();

(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(sessionManagerService, $location, utilService, $rootScope, $window, IMAGE_URL, shopService,
                          profileService, $log, URL, httpService, $scope) {
    $log.debug("MainController");

    var vm = this;

    vm.changePath = changePath;
    vm.checkPath = checkPath;
    vm.currentSession = "";
    vm.df = "dd MMMM yyyy";
    vm.findInterestSentOrReceiveMember = findInterestSentOrReceiveMember;
    vm.getAge = getAge;
    vm.getHeightByCm = getHeightByCm;
    vm.getFormatAmount = getFormatAmount;
    vm.imageUrl = IMAGE_URL;
    vm.logout = logout;
    vm.openMenu = openMenu;
    vm.URL = URL;
    vm._ =  $window._;
    vm.getImagePath = getImagePath;

    $rootScope.$on("logoEvent", function(event, data) {
      if(data) {
        vm.logoUrl = data;
      }
    });

    function getImagePath(orgImagePath) {
      var path = orgImagePath.replace(/\/\/+/g, '/');
      if(!path.startsWith('/')) {
        path = '/'+path;
      }
      return path;
    }

    $rootScope.$on("UserAuthenticationSuccessEvent", function(event, data) {
      $log.debug("UserAuthenticationSuccessEvent");
      sessionManagerService.setSessionData(data);
      vm.currentSession = sessionManagerService.getSessionData();
      httpService.setAuthorization(data.base64EncodedAuthenticationKey);
      updateLastActive();
    });

    if(sessionManagerService.getSessionData() != null && angular.isDefined(sessionManagerService.getSessionData())) {
      vm.currentSession = sessionManagerService.getSessionData();

      var currentActiveLink = $window.location.hash.replace("#","");
      if(currentActiveLink == '/login' || currentActiveLink == '/signUp' || currentActiveLink == '/' ||
            currentActiveLink == '/home') {
        /*currentActiveLink = vm.currentSession.profileBasicInfo ? '/profileMatch' : '/shopProfile';
        $rootScope.activeLink = currentActiveLink;
        $location.path($rootScope.activeLink);*/
      } else {
        $rootScope.activeLink = $window.location.hash.replace("#","");
        //$location.path($rootScope.activeLink);
        if(vm.currentSession.roles.includes("ROLE_USER")) {
          $location.path('/multiple-accounts');
        }
      }
      updateLastActive();
    } else if ($location.url().indexOf('/privacy-policy') != 0 && $location.url().indexOf('/terms') != 0 && $location.url().indexOf('/signUp') != 0 && $location.url().indexOf('/reset-password') != 0){
      $location.path('/login');
    }

    function updateLastActive () {
      if (vm.currentSession.roles.includes("ROLE_ADMIN") || vm.currentSession.roles.includes("ROLE_EMPLOYEE")) {
        updateShopLastActive(vm.currentSession.shop.id);
       
      } else if(vm.currentSession.roles.includes("ROLE_USER")) {
        updateProfileLastActive(vm.currentSession.profileBasicInfo.id);
      }
    }

    function updateProfileLastActive(profileId) {
      return profileService.updateProfileLastActive(profileId).then(function() {
        $log.debug('updated last profile active');
      })
    }

    function updateShopLastActive(shopId) {
      return shopService.updateShopLastActive(shopId).then(function() {
        $log.debug('updated last shop active');
      })
    }

    function getMemberPackagePlanByMatrimonyId(matrimonyId) {
      return profileService.getMemberPackagePlanByMatrimonyId(matrimonyId).then(function(response) {
        vm.currentSession.packagePlan = response.data;
        sessionManagerService.setSessionData(vm.currentSession);
      })
    }

    function changePath(url, shopName) {
      var bData = [];
      if (vm.currentSession.shopEmp) {
        bData.push({
          name: "Home",
          seourl: "/myShopProfile"
        });
      } else {
        bData.push({
          name: "Home",
          seourl: "/profileMatch"
        });
      }

      bData.push({
        name: shopName+' (Marriage Shop)',
        seourl: ""
      });

      vm.bData = bData;
      $location.path(url);
    }

    function checkPath(link) {
      $rootScope.activeLink = link;
      /* sessionManagerService/!*.setActiveLinkSession(link);*!/*/
    }

    function getAge(i) {
      var age = utilService._calculateAge(new Date(i));
      return age+ " Yrs";
    }

    function getHeightByCm(val) {
      return utilService._getHeightByCm(val);;
    }

    function getFormatAmount(amount) {
      var amt = utilService._numDifferentiation(amount);
      return amt;
    }

    function logout() {
      vm.currentSession = sessionManagerService.clear();
      httpService.cancelAuthorization();
      /*vm.currentSession = '';*/
      $location.path('/login');
    }

    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }

    function findInterestSentOrReceiveMember(val) {
      if (val.fromProfile.matrimonyId != vm.currentSession.profileBasicInfo.matrimonyId) {
        vm.interestMember = val.fromProfile;
        return  vm.interestMember;
      } else {
        vm.interestMember = val.toProfile;
        return  vm.interestMember;
      }
    }


  }
})();

/**
 * Created by GGowda on 2/10/2016.
 */
(function() {
    'use strict';

    angular.module('anchePedheMatrimony').controller('AnchePedheMessageController', AnchePedheMessageController);

    AnchePedheMessageController.$inject = ['$stateParams'];

    function AnchePedheMessageController($stateParams) {
        /* jshint validthis: true */
        var vm = this;

        if($stateParams.shopOrProfile == 'shop') {
            vm.shop = true;
        } else {
            vm.profile = true;
        }

    }
})();

/**
 * Created by GGowda on 11/11/2015.
 */
(function () {
    'use strict';

    angular.module('anchePedheMatrimony').controller('ComplianceController', ComplianceController);

    /** @ngInject */
    function ComplianceController($window, shopService, sessionManagerService) {
        /* jshint validthis: true */
        var vm = this;
        vm.host = $window.location.host;


        (function() {
            vm.packagePlan = sessionManagerService.getPackagePlanSession();
            vm.days = getDays()
            vm.plans = getPlans();
        })();

        function getDays() {
            var days = vm.packagePlan.map(function(element){
                return element.category.noOfDaysValid + ' days / ' + element.category.noOfAskMobileNo + ' Contacts';
            });
            return days.toString();

        }

        function getPlans() {
            var plans = vm.packagePlan.map(function(element) {
                return element.id;
            });
            return plans.toString();
        }
    }
})();

/**
 * Created by GGowda on 11/11/2015.
 */
(function () {
  'use strict';

  angular.module('anchePedheMatrimony').controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController($scope, $loading, utilService, profileService, codeValueService,
    sessionManagerService, $window, httpService, $location, MEMBER_TYPE, reg, $q, $rootScope, shopService) {
    /* jshint validthis: true */
    var vm = this;
    vm.reg = reg;
    vm.host = $window.location.host;
    vm.birthTimeObj = {};
    // we will store all of our form data in this object
    vm.profile = {};
    vm.checkUserExist = checkUserExist;
    vm.getCasteOptions = getCasteOptions;
    $scope.main.notLoginData = sessionManagerService.getNotLoginData();
    vm.profile.citizenship = 'India';
    vm.clearSearchTerm = clearSearchTerm;

    var shopUniqueId = "";
    if ($scope.main.notLoginData.shop.shopUniqueId) {
      shopUniqueId = $scope.main.notLoginData.shop.shopUniqueId;
    }

    vm.breadCrum = [{
      name: "Login",
      seourl: "/login"
    }, {
      name: 'register',
      seourl: ""
    }]

    vm.searchTerm;
    function clearSearchTerm() {
      vm.searchTerm = '';
    };

    if ($scope.main.notLoginData.shop && $scope.main.notLoginData.shop.expertiseReligion != null &&
      $scope.main.notLoginData.shop.expertiseReligion.length == 1) {
      vm.profile.religion = $scope.main.notLoginData.shop.expertiseReligion[0];
    }

    vm.ageObj = {};

    vm.horoImage = {
      photo: false,
      name: "image3",
      to: "",
      invalidFile: ""
    }

    vm.items = [
      {
        photo: false,
        name: "image1",
        to: "",
        isMainPhoto: false,
        image: "./assets/images/no_image.png",
        invalidFile: ""
      },
      {
        photo: false,
        name: "image2",
        to: "",
        isMainPhoto: false,
        image: "./assets/images/no_image.png",
        invalidFile: ""
      }
    ];
    vm.dateObj = utilService._getDateObject();
    vm.timeObj = utilService._getTimeObject();

    (function () {
      getProfileTemplate(), getAnnualIncomeFrom(), getGothram();
    })();

    vm.step = 1;

    vm.goToPersonalDetails = function (basicDetailsForm) {
      if (!basicDetailsForm.$valid) {
        return !1;
      }
      vm.step = 2;
    }

    vm.afterResizingImages = function (file) {
      $loading.finish('imageLoading')
    }

    vm.beforeResizingImages = function (file) {
      $loading.start('imageLoading');
    }

    function getProfileTemplate() {
      $loading.start('createUpdateProfile');
      return profileService.getProfileTemplate().then(function (response) {
        vm.profileTemplate = response.data;
        $loading.finish('createUpdateProfile');
        if (angular.isDefined(vm.profile) && angular.isDefined(vm.profile.height)) {
          var i = _.findIndex(vm.profileTemplate.heightOptions.values, function (height) {
            return height.category == vm.profile.height.category;
          });
          vm.profile.height = vm.profileTemplate.heightOptions.values[i];
        }
      });
    }

    function getAnnualIncomeFrom() {
      return codeValueService.getCodeByName('Annual-Income-From').then(function (response) {
        vm.annualIncomeOptions = response.data;
        $loading.finish('createUpdateProfile');
      });
    }

    function getGothram() {
      codeValueService.getCodeByName("Gothram").then(function (response) {
        vm.gothramOptions = response.data;
        $loading.finish('createUpdateProfile');

      });
    }

    vm.getStates = function (country) {
      /*$loading.start('createUpdateProfile');*/
      if (angular.isUndefined(vm.stateOptions) && country == 'India') {
        codeValueService.getCodeByName(country).then(function (response) {
          vm.stateOptions = response.data;
          /*$loading.finish('createUpdateProfile');*/
        });
      } /*else {
       vm.profile.currentLivingCity = '';
       }*/
    }

    vm.getCities = function (state) {
      /* $loading.start('createUpdateProfile');*/
      codeValueService.getCodeByName(state).then(function (response) {
        vm.cityOptions = response.data;
        /*$loading.finish('createUpdateProfile');*/
      });
    }

    function getCasteOptions(val) {
      return codeValueService.getCodeByName(val).then(function (response) {
        vm.casteOptions = response.data;
      });
    }


    vm.getSubCasteOptions = function (val) {
      return codeValueService.getCodeByName(val).then(function (response) {
        vm.subCasteOptions = response.data;
      });
    }

    vm.getSubCasteSubOptions = function (val) {
      if (val.indexOf('Deshastha') == 0 ||
        val.indexOf('Iyengar') == 0 || val.indexOf('Iyer') == 0 ||
        val.indexOf('Madhwa') == 0 || val.indexOf('Sarawat') == 0 ||
        val.indexOf('Smartha') == 0) {
        return codeValueService.getCodeByName(val).then(function (response) {
          vm.subCasteSubOptions = response.data;
        });
      }
    }

    vm.getReligiousValueOptions = function () {
      if (vm.religiousValueOptions) {
        return
      }
      codeValueService.getCodeByName("Religious-Value").then(function (response) {
        vm.religiousValueOptions = response.data;
      });
    }

    vm.checkIfExist = function (item, values) {
      if (item == "" || angular.isUndefined(item)) {
        return true;
      } else {
        return JSON.stringify(values).toLowerCase().indexOf(item) > -1 || JSON.stringify(values).toUpperCase().indexOf(item) > -1;
        /*return JSON.stringify(values).search(/item/)  > -1*/;
      }
    }

    vm.getRaasi = function (star) {
      codeValueService.getCodeByName(star).then(function (response) {
        vm.raasiOptions = response.data;
      });
    }

    function checkUserExist(mobileNo) {

      profileService.checkUserExist({ mobileNo: mobileNo, shopUniqueId: shopUniqueId }).then(function () {
        vm.mobileNoAlreadyExist = false;
      }, function () {
        vm.mobileNoAlreadyExist = true;
      })
    }

    function getShopByShopId(shopId) {
      var deferred = $q.defer();
      shopService.getShopByShopId(shopId).then(function (response) {
        vm.userData.shop = response.data;
        sessionManagerService.setSessionData(vm.userData);
        deferred.resolve(response.data);
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    }

    function getPartnerPreferenceByMatrimonyIdAndShopId(matrimonyId) {
      var deferred = $q.defer();
      profileService.getPartnerPreferenceByMatrimonyId(matrimonyId).then(function (response) {
        vm.userData.partnerPreference = response.data;
        deferred.resolve(response.data);
      }, function () {
        deferred.reject();
      });

      return deferred.promise;
    }

    function getMemberPackagePlanByMatrimonyId(matrimonyId) {
      var deferred = $q.defer();
      profileService.getMemberPackagePlanByMatrimonyId(matrimonyId).then(function (response) {
        vm.userData.packagePlan = response.data;
        sessionManagerService.setSessionData(vm.userData);
        deferred.resolve(response.data);
        //$location.path('/profileMatch');
      }, function () {
        deferred.reject();
      });
      return deferred.promise;
    }

    vm.registerProfile = function (pDetailForm, ev) {
      if (!vm.termsandprivacy) {
        // $mdDialog.show(
        //   $mdDialog.alert()
        //     .clickOutsideToClose(true)
        //     .title('This is an alert title')
        //     .textContent('You can specify some description text in here.')
        //     .ariaLabel('Alert Dialog Demo')
        //     .ok('Got it!')
        //     .targetEvent(ev)
        // );

        alert("Please read and confirm acceptance of our Terms and Conditions,\nPrivacy Policy, and to receive emails and telephonic communications from us.");
        return false;
      }

      if (!pDetailForm.$valid) {
        return !1;
      }



      $loading.start('createProfileBtn');
      if ($window.location.host.indexOf('anchepedhematrimony.com') > -1) {
        vm.profile.memberType = MEMBER_TYPE.ANCHEPEDHE_WEBSITE;
        vm.profile.anchepedheMarriageBureau = true;
      } else {
        vm.profile.memberType = MEMBER_TYPE.MARRIAGE_BUREAU_WEBSITE;
      }

      $scope.main._.remove(vm.profile.familyContactInfo, function (n) {
        return n.relationShipType == "" || n.mobileNo == "" || n.mobileNo.length < 10;
      });

      $scope.main._.remove(vm.profile.siblings, function (n) {
        return n.siblingType == "" || n.martialStatus == "";
      });

      if (vm.profile.employedIn == 'Business') {
        vm.profile.occupation = '';
        vm.moreInfoAboutJob = '';
      } else {
        vm.profile.occupationBusiness = '';
      }

      vm.profile.annualIncome = parseInt(vm.profile.annualIncome);
      vm.profile.dateFormat = $scope.main.df;
      vm.profile.birthTime = vm.birthTimeObj.hr + ":" + vm.birthTimeObj.min + ":"
        + vm.birthTimeObj.amOrPm;
      vm.profile.dob = new Date(vm.ageObj.date + " " + vm.ageObj.month + " " + vm.ageObj.year).getTime();
      vm.profile.dateOfBirth = vm.ageObj.date + "-" + vm.ageObj.month + "-" + vm.ageObj.year;
      vm.profile.locale = "en";

      if (vm.profile.currentLivingCountry != 'India') {
        vm.profile.currentLivingState = '';
      }

      vm.profile.shopId = $scope.main.notLoginData.shop.id;
      vm.profile.shopName = $scope.main.notLoginData.shop.shopName;
      vm.profile.shopWebsiteUrl = $scope.main.notLoginData.shop.websiteUrl;
      vm.profile.shopEmail = $scope.main.notLoginData.shop.email;
      vm.profile.shopMobileNo = $scope.main.notLoginData.shop.mobileNo;

      vm.profile.profileImages = vm.profileImages;
      vm.profile.otherClientViewYourProfiles = $scope.main.notLoginData.shop.otherClientViewYourProfiles;
      vm.profile.shopWebsiteMember = true;
      vm.profile.familyContactInfo = [];
      vm.profile.propertyDetails = [];

      var files = [];
      files.push(vm.items[0].photo);
      files.push(vm.items[1].photo);

      if (vm.horoImage.photo != false && vm.horoImage.photo != undefined) {
        files.push(vm.horoImage.photo);
      }

      profileService.registerProfile(files, vm.profile, vm.password, shopUniqueId).then(function (res) {
        sessionManagerService.setUserData(res.data);
        httpService.setAuthorization(res.data['base64EncodedAuthenticationKey']);
        //$location.path('/multiple-accounts');
        vm.userData = sessionManagerService.getUserData() || sessionManagerService.getSessionData();

        var p = vm.userData.profileBasicInfo;
        $q.all([getShopByShopId(p.shopId), getMemberPackagePlanByMatrimonyId(p.matrimonyId),
        getPartnerPreferenceByMatrimonyIdAndShopId(p.matrimonyId)]).then(function () {
          $rootScope.$broadcast("UserAuthenticationSuccessEvent", vm.userData);
          $location.path('/profileMatch');
        }, function () {
          $location.path('/profileMatch');
          console.log("error");
        });


        
      }, function () {
        $window.scroll(0, 0);
        $loading.finish('createProfileBtn');
      });
    }
  }
})();

/**
 * Created by GGowda on 3/17/2016.
 */
(function() {
  'use strict';

  angular.module('anchePedheMatrimony').controller('AccountController', AccountController);

  /** @ngInject */
  function AccountController($scope, $location, $log, sessionManagerService, reg, shopService, $rootScope) {
    var vm = this;
    $rootScope.$broadcast("logoEvent", reg.shop.logoUrl);
    // (function getPackageOptions() {
    //   shopService.getShopPackagePlanByShopId(reg.shop.id).then(function (response) {
    //     vm.packageOptions = response.data.values;
    //     var packagePlansTemp = vm.packageOptions.filter(function(item){ return item.id != 'Free';})
    //     sessionManagerService.setPackagePlanSession(packagePlansTemp);
    //   })
    // })();
    if($scope.main.currentSession && $scope.main.currentSession != "") {
      var link = $scope.main.currentSession.profileBasicInfo ? '/profileMatch' : '/myShopProfile';
      $location.path(link);
    } else if($location.url().indexOf('/privacy-policy') == -1 && $location.url().indexOf('/terms')  == -1 && $location.url().indexOf('/login')  == -1 && $location.url().indexOf('/signUp') == -1 &&
        $location.url().indexOf('/reset-password') == -1){
          $location.path('/login');
    }

    if(sessionManagerService.getNotLoginData()) {
      vm.shopName = sessionManagerService.getNotLoginData().shop.shopName;
    }

    $log.debug('AccountController');
  }
})();

(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, sessionManagerService, httpService) {
    var data = sessionManagerService.getSessionData();
    if(angular.isDefined(data) && data != null)  {
      httpService.setAuthorization(data.base64EncodedAuthenticationKey);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .config(routeConfig);

  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {

    $stateProvider
      .state('account', {
        url: '/account',
        templateUrl: 'app/account/account.html',
        controller: 'AccountController',
        controllerAs: 'ac',
        resolve: {
          reg: function (shopService, $window) {
            var host = $window.location.host;  // e.g. "admin.anchepedhematrimony.com" or "www.admin.anchepedhematrimony.com"
            // if host starts with "admin."
            if ($window.location.host.match(/^(www\.)?admin\./i)) {
              // remove "admin." prefix (and optional "www." before it)
              host = host.replace(/^(www\.)?admin\./i, "");
            }
            if (host.indexOf('www') < 0) {
              host = "www." + host;
            }
            return {
              shop: {
                "id": "",
                "shopImageUrl": null,
                "shopName": "",
                "shopAlias": null,
                "aboutUs": null,
                "matrimonySymbol": null,
                "address": {
                },
                "operatingSince": "",
                "shopCreatedOn": 1485697142203,
                "shopUpdatedOn": 1761046980159,
                "email": "",
                "shopStatus": "Active",
                "mobileNo": "",
                "empMetShopUser": true,
                "lastActive": 1761046980159,
                "websiteUrl": "",
                "expertiseReligion": [
                  "Hindu",
                  "Muslim - Shia",
                  "Muslim - Sunni",
                  "Muslim - Others",
                  "Christian",
                  "Jain - Digambar",
                  "Jain - Shwetambar",
                  "Jain - Others",
                  "Buddhist",
                  "Inter-Religion"
                ],
                "expertiseCaste": [
                  "Arya Vysya",
                  "Brahmin",
                  "Lingayath",
                  "Scheduled Caste (SC)",
                  "Vishwakarma",
                  "Vokkaliga/Gowda",
                  "Balija",
                  "Bhovi",
                  "Brahmin Saraswat",
                  "Devanga",
                  "Kuruba",
                  "Kuruhina Shetty",
                  "Scheduled Tribe (ST)",
                  "Yadav",
                  "Besta",
                  "Dhobi",
                  "Reddy",
                  "Intercaste",
                  "Don't Know",
                  "Kumbara",
                  "Kshatriyas",
                  "Ediga",
                  "Uppara",
                  "Vanniya Kula Kshatriyar",
                  "Mudaliyar",
                  "Thigala",
                  "Chettiar",
                  "Ganiga",
                  "96 Kuli Maratha",
                  "Agamudayar / Arcot / Thuluva Vellala",
                  "Kshatriya Raju",
                  "Bunt (Shetty)",
                  "Coorgi",
                  "Kamma",
                  "Devadiga",
                  "Dasa Banajiga",
                  "Billava",
                  "Nadar",
                  "Pattusali",
                  "Jain - Panchama",
                  "Bhavasar Kshatriya",
                  "Dommala",
                  "Pillai",
                  "Thiyya",
                  "Gounder",
                  "Bajantri",
                  "Vanniyar",
                  "Lambadi",
                  "Mogaveera",
                  "Urs",
                  "Togata",
                  "Kunchitiga",
                  "Padmasali",
                  "Maratha Kshatriya",
                  "Gangamathastha",
                  "Vysyas"
                ],
                "expertiseSubCaste": null,
                "expertiseLanguage": [
                  "Kannada",
                  "Telugu",
                  "Tamil",
                  "Marathi"
                ],
                "expertiseCountry": null,
                "expertiseState": null,
                "expertiseCity": null,
                "expertiseMinAge": 0,
                "expertiseMaxAge": 0,
                "percentageAmount": 0,
                "locatedCountry": "India",
                "locatedStates": [
                  "Karnataka"
                ],
                "locatedCities": [
                  "Bangalore",
                  "Mysore"
                ],
                "userId": "",
                "otherClientViewYourProfiles": true,
                "otherBureauProfile": false,
                "showImageForNonPaidMember": true,
                "paymentGatewaySetup": true,
                "partialActive": true,
                "anchepedheMarriageBureau": true,
                "profileEmailRequired": true,
                "profileMobileNoRequired": true,
                "othrPfVwCtNo": true,
                "allwOnlyMbPfWhShwCtNo": false,
                "shopUniqueId": null,
                "defaultPassword": "",
                "optPopup": false,
                "secondaryMobileNo": "",
                "websiteLogoUrl": "",
                "logoUrl": "",
                "bannerUrl": null,
                "maxEmployee": 10,
                "showMobileNoInPaymentScreen": false,
                "razorpayMerchantId": "",
                "defaultShowBureauProfilesType": ""
              },
              successStory: {
                "content": [
                  {
                    "shopId": "588df074cc3b812f3aaba015",
                    "imageURL": "///images/profile/588df074cc3b812f3aaba015/Success-Story/originalImage_k4su481_.png",
                    "message": "Congratulation both of you... ",
                    "groomName": "Abhishek ",
                    "brideName": "Tanushree",
                    "createdOn": 1561202585102
                  },
                  {
                    "shopId": "588df074cc3b812f3aaba015",
                    "imageURL": "///images/profile/588df074cc3b812f3aaba015/Success-Story/originalImage_9wy61a9pdvlnjt5_.jpg",
                    "message": "Congratulation both of you.",
                    "groomName": "Chiranth (APMG2914)",
                    "brideName": "Seema (APMB3325)",
                    "createdOn": 1561197188192
                  },
                  {
                    "shopId": "588df074cc3b812f3aaba015",
                    "imageURL": "///images/profile/588df074cc3b812f3aaba015/Success-Story/originalImage_j4ctq1z_.jpg",
                    "message": "Congratulation both of you",
                    "groomName": "APPAIAH(APMG102145)",
                    "brideName": "SHASHIKALA(APMB12547)",
                    "createdOn": 1548484051149
                  },
                  {
                    "shopId": "588df074cc3b812f3aaba015",
                    "imageURL": "///images/profile/588df074cc3b812f3aaba015/Success-Story/originalImage_k9vpefv533gf9_.jpg",
                    "message": "Anchepedhe Matrimony warm wishes to both of you on this special day. Happy wishes on your engagement and a beautiful life ahead!",
                    "groomName": "PRADEEP",
                    "brideName": "SHWETHA",
                    "createdOn": 1548313625555
                  }
                ],
                "last": false,
                "totalPages": 2,
                "totalElements": 8,
                "sort": [
                  {
                    "direction": "DESC",
                    "property": "createdOn",
                    "ignoreCase": false,
                    "nullHandling": "NATIVE",
                    "ascending": false,
                    "descending": true
                  }
                ],
                "first": true,
                "numberOfElements": 4,
                "size": 4,
                "number": 0
              }
            }
          }
        }
      })
      .state('account.about', {
        url: '^/about',
        templateUrl: 'app/account/about.html'
      })
      .state('server-error', {
        url: '^/server-error',
        templateUrl: 'app/server-error/server-error.html'
      })
      .state('account.termsofuse', {
        url: '^/terms',
        templateUrl: 'app/compliance/termsofuse.html',
        controller: 'ComplianceController',
        controllerAs: 'compc'
      })
      .state('account.privacypolicy', {
        url: '^/privacy-policy',
        templateUrl: 'app/compliance/privacypolicy.html',
        controller: 'ComplianceController',
        controllerAs: 'compc'
      })
      .state('account.paymentOption', {
        url: '^/paymentOption',
        templateUrl: 'app/account/paymentOption.html'
      })
      .state('account.register', {
        url: '^/register',
        templateUrl: 'app/account/register.html',
        controller: 'RegisterController',
        controllerAs: 'regc'
      })
      .state('account.sProfileNotLoggedIn', {
        url: '^/sProfileNotLoggedIn',
        templateUrl: 'app/search/searchProfileNotLoggedIn.html',
        controller: 'SearchProfileNotLoggedInController',
        controllerAs: 'spnlic'
      })
      .state('account.login', {
        url: '^/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .state('account.signUp', {
        url: '^/signUp',
        templateUrl: 'app/signUp/signUp.html',
        controller: 'SignUpController',
        controllerAs: 'suc'
      })
      .state('account.forgotPassword', {
        url: '^/forgotPassword',
        templateUrl: 'app/resetPassword/forgotPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'rpc'
      })
      .state('account.resetPassword', {
        url: '^/reset-password?mobileNo&otpNo',
        templateUrl: 'app/resetPassword/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'rpc'
      })
      .state('account.anchePedheMessage', {
        url: '^/anchePedheMessage/:shopOrProfile',
        templateUrl: 'app/anchePedheMessage/anchePedheMessage.html',
        controller: 'AnchePedheMessageController',
        controllerAs: 'apmc'
      })
      .state('welcome', {
        url: '/multiple-accounts',
        templateUrl: 'app/login/profileList.html',
        controller: 'ProfileListController',
        controllerAs: 'plc'
      })
      .state('home', {
        url: '/home',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'hmc',
        resolve: {

          // Example using function with simple return value.
          // Since it's not a promise, it resolves immediately.
          notification: function (sessionManagerService, profileService) {
            /*var profileId = "";
            var matrimonyId = "";
            if($scope.main.currentSession.profileBasicInfo) {
              profileId = $scope.main.currentSession.profileBasicInfo.id;
              matrimonyId = $scope.main.currentSession.profileBasicInfo.matrimonyId;
            }*/
            var sessionData = sessionManagerService.getSessionData();
            var profileId = "";
            var matrimonyId = "";
            var shopId = sessionData.shop.id;
            if (sessionData.profileBasicInfo) {
              profileId = sessionData.profileBasicInfo.id;
              matrimonyId = sessionData.profileBasicInfo.matrimonyId;
            }
            return profileService.countProfileInterestNotSeen(profileId, matrimonyId,
              shopId).then(function (response) {
                return response.data;
              })
          }
        }
      })
      .state('home.profileMatch', {
        url: '^/profileMatch',
        templateUrl: 'app/profileMatch/profileMatch.html',
        controller: 'ProfileMatchController',
        controllerAs: 'pmc'
      })
      .state('home.myShopProfile', {
        url: '^/myShopProfile',
        templateUrl: 'app/shopProfile/shopProfile.html',
        controller: 'MyShopProfileController',
        controllerAs: 'mspc'
      })
      .state('home.otherShopProfileOrIndividualProfile', {
        url: '^/otherShopProfileOrIndividualProfile',
        templateUrl: 'app/otherShopOrIndividual/otherShopProfileOrIndividualProfile.html',
        controller: 'OtherShopProfileOrIndividualProfileController',
        controllerAs: 'spc'
      })
      .state('home.anchepedheProfile', {
        url: '^/anchepedheprofile',
        templateUrl: 'app/otherShopOrIndividual/anchepedheProfile.html',
        controller: 'anchepedheProfileController',
        controllerAs: 'spc'
      })
      .state('home.profileInterest', {
        url: '^/profileInterest',
        templateUrl: 'app/shopDashBoard/shopDashBoard.html',
        controller: 'ShopDashBoardController',
        controllerAs: 'sdc'
      })
      .state('home.profileInterestDetail', {
        url: '^/profileInterestDetail?fromMatrimonyId&toMatrimonyId',
        templateUrl: 'app/profileInterest/profileInterestDetail.html',
        controller: 'ProfileInterestDetailController',
        controllerAs: 'pidc'
      })
      .state('home.profileShortListedByMe', {
        url: '^/profileShortListedByMe',
        templateUrl: 'app/profileShortList/profileShortListedByMe.html',
        controller: 'ProfileShortListedByMeController',
        controllerAs: 'psbmc'
      })
      .state('home.profile', {
        url: '^/profile?matrimonyId&shopId',
        templateUrl: 'app/profile/profile.html'
      })
      .state('home.shopDashBoard', {
        url: '^/shopDashBoard',
        templateUrl: 'app/shopDashBoard/shopDashBoard.html',
        controller: 'ShopDashBoardController',
        controllerAs: 'sdc'
      })
      .state('home.createProfile', {
        url: '^/create-profile',
        templateUrl: 'app/profile/createUpdateProfile.html'
      })
      .state('home.updateProfile', {
        url: '^/update-profile',
        templateUrl: 'app/profile/createUpdateProfile.html'
      })
      .state('home.createPartnerPreference', {
        url: '^/create-partnerpreference',
        templateUrl: 'app/profile/createUpdatePartnerPreference.html',
        controller: 'CreateUpdatePartnerPreferenceController',
        controllerAs: 'cuppc',
        resolve: {
          PreviousState: ["$state", "$window", "profileService", function ($state, $window, profileService) {
            var currentStateData = {
              Name: $state.current.name,
              Params: $state.params,
              URL: $state.href($state.current.name, $state.params),
              edit: false
            };

            if (profileService.getProfile() === undefined) {
              $window.location.href = $window.location.origin + "/myShopProfile";
            }
            return currentStateData;
          }]
        }
      })
      .state('home.updatePartnerPreference', {
        templateUrl: 'app/profile/createUpdatePartnerPreference.html',
        url: '^/update-partnerpreference',
        controller: 'CreateUpdatePartnerPreferenceController',
        controllerAs: 'cuppc',
        resolve: {
          PreviousState: ["$state", "$window", "profileService", function ($state, $window, profileService) {
            var currentStateData = {
              Name: $state.current.name,
              Params: $state.params,
              URL: $state.href($state.current.name, $state.params),
              edit: true
            };
            if (profileService.getProfile() === undefined) {
              $window.location.href = $window.location.origin + "/myShopProfile";
            }

            return currentStateData;
          }]
        }
      })
      .state('home.information', {
        url: '^/information',
        templateUrl: 'app/shopPayment/shopPayment.html',
        controller: 'ShopPaymentController',
        controllerAs: 'spc'
      })
      .state('home.shop', {
        url: '^/shop/:shopId',
        templateUrl: 'app/shop/shop.html'
      })
      .state('home.profileStatus', {
        url: '^/shop/profile/:profileStatus/:currentMonthProfile',
        templateUrl: 'app/shopProfile/shopProfile.html',
        controller: 'ShopProfileByProfileStatusController',
        controllerAs: 'mspc'
      })
      .state('home.searchProfile', {
        url: '^/searchProfile',
        templateUrl: 'app/search/searchProfile.html',
        controller: 'SearchProfilesController',
        controllerAs: 'spc'
      })
      .state('home.setting', {
        url: '^/setting',
        templateUrl: 'app/setting/setting.html',
        controller: 'SettingController',
        controllerAs: 'sc'
      })
      .state('home.packagePlan', {
        url: '^/packagePlan',
        templateUrl: 'app/packagePlan/packagePlan.html',
        controller: 'PackagePlanController',
        controllerAs: 'plc'
      })
      .state('home.payment', {
        url: '^/payment?matrimonyId',
        templateUrl: 'app/payment/payment.html',
        controller: 'PaymentController',
        controllerAs: 'payc'
      })
      .state('home.successStory', {
        url: '^/success-story',
        templateUrl: 'app/successStory/successStory.html',
        controller: 'SuccessStoryController',
        controllerAs: 'stc'
      })
      .state('home.notification', {
        url: '^/notification',
        templateUrl: 'app/notification/notification.html',
        controller: 'NotificationController',
        controllerAs: 'nc'
      });

    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/login');
  }
})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .constant("INTEREST_TYPE", {
      "PROFILE_INTEREST":"interestStatus",
      "KNOW_MORE_INFO":"moreInfoRequestStatus",
      "MOBILE_NO_INFO":"mobileNoRequestStatus"
    })
    .constant("MEMBER_TYPE", {
      "MARRIAGE_BUREAU":"MB Member",
      "MARRIAGE_BUREAU_WEBSITE":"MBW Member",
      "ANCHEPEDHE_WEBSITE":"APW Member"
    })
    .constant('URL', 'https://api.anchepedhe.com/matrimony-pwa')
    .constant('IMAGE_URL', 'https://anchepedhematrimony.sgp1.cdn.digitaloceanspaces.com')
    //.constant('URL', 'https://api.anchepedhe.com/matrimony-pwa')

    //.constant('URL', 'http://localhost:8080')
    //.constant('IMAGE_URL', 'http://localhost:8080')
    
    .constant('WEB_HOOK_URL', {
      noOffer:'/payment-gateway/instamojo/webhook',
      offer: '/payment-gateway/instamojo/webhook/offer'
    });
})();

(function() {
  'use strict';

  angular
    .module('anchePedheMatrimony')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, $mdThemingProvider, $provide, $windowProvider) {

    /*$compileProvider.debugInfoEnable(false);
    $httpProvider.useApplyAsync(true);*/

    var $window = $windowProvider.$get();

    if($window.location.origin.indexOf('localhost') == -1) {
      $provide.value('IMAGE_URL', $window.location.origin);
    } else {
      $provide.value('IMAGE_URL', 'http://localhost:8080');
    }


    console.log($window.location.origin);

    $httpProvider.defaults.useXDomain = true;
    /*delete $httpProvider.defaults.headers.common['X-Requested-With'];*/

    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    //Set headers
    $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

    $httpProvider.interceptors.push('httpInterceptor');
    // Enable log
    $logProvider.debugEnabled(true);


    /*$mdIconProvider
      .defaultIconSet("./assets/svg/avatars.svg", 128)
      .icon("menu", "./assets/svg/menu.svg", 24)
      .icon("share", "./assets/svg/share.svg", 24)
      .icon("google_plus", "./assets/svg/google_plus.svg", 512)
      .icon("hangouts", "./assets/svg/hangouts.svg", 512)
      .icon("twitter", "./assets/svg/twitter.svg", 512)
      .icon("phone", "./assets/svg/phone.svg", 512);
*/
    $mdThemingProvider.theme('default')
      .primaryPalette('red')
      .accentPalette('orange', {
        'default': '500' // use shade 200 for default, and keep all other shades the same
      });


  }

})();

angular.module("anchePedheMatrimony").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/about.html","<section class=\"advantage-flow\" id=\"howitworks\"><div class=\"container\"><div class=\"skewBoxContent\">How Matrimony Works?</div><div class=\"flowBox boxcol1\"><span class=\"icon1\"></span><div>Matrimony Bureaus Shop</div><p>Registered Matrimony Bureaus Will have Virtual Matrimony Bureau Shop in Matrimony Website, in which they will maintain their Clients Profile.</p></div><div class=\"arrow arrow-t\"></div><div class=\"flowBox boxcol2\"><span class=\"icon2\"></span><div>Profile Verify and Activate By Matrimony Employee</div><p>Once Matrimony Bureaus will create Client Profile. After that created Profile will be verified and activated.</p></div><div class=\"arrow\"></div><div class=\"flowBox boxcol7\"><span class=\"icon2\"></span><div>Search Profile across all Matrimony Bureaus</div><p>Check Profiles according to your preference in your Marriage Bureau Shop or Other Marriage Bureau Shops.</p></div><div class=\"arrow\"></div><div class=\"flowBox boxcol3\"><span class=\"icon3\"></span><div>Express Interests across all Matrimony Bureaus</div><p>Send Interest if any match found.</p></div><div class=\"arrow\"></div><div class=\"flowBox boxcol4\"><span class=\"icon4\"></span><div>Interest accepted By Other End</div><p>Once Interest expressed Profile accepts your Interest.</p></div><div class=\"arrow\"></div><div class=\"flowBox boxcol5\"><div>Meet the prospects</div><p>Your Marriage Bureau contacts prospects and facilitates a meeting based on mutual interest.</p></div><div class=\"arrow\"></div><div class=\"boxcol6\"></div><div class=\"arrow\"></div><div class=\"clr\"></div></div></section><div class=\"clr\"></div>");
$templateCache.put("app/account/account.html","<div ui-view=\"\"></div>");
$templateCache.put("app/account/paymentOption.html","<div ng-cloak=\"\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content class=\"md-padding mh-120 overflow_hidden\" flex=\"\" flex-gt-md=\"60\"><h1>Upgrade Membership for {{selectedPackage.category.noOfDaysValid}} days</h1><md-divider></md-divider><div ng-init=\"selectedPackage=ac.packageOptions[ac.packageOptions.length-1]\"></div><md-radio-group ng-model=\"selectedPackage\" class=\"md-padding radioButtondemoMultiColumn\" flex=\"\"><div ng-repeat=\"package in ac.packageOptions | filter: {value: \'!\' + \'Free\'}\" class=\"row\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><div flex=\"\" style=\"max-width:200px;\">{{package.id}}</div><md-radio-button flex=\"\" ng-value=\"package\" class=\"md-primary\">{{package.value}} Rs</md-radio-button></div></div></md-radio-group><md-divider></md-divider><div class=\"summary radioButtondemoMultiColumn mt10\" flex=\"\" layout=\"column\"><div flex-initial=\"\"><span class=\"title\">Benefits of Package</span>: <span class=\"md-checked\">{{selectedPackage.id}}</span></div><div><ul><li class=\"mt10\"><h3>1)You will be able to send only {{selectedPackage.category.noOfInterest}} interests to other members. When your Interest accepts by other member. Then your marriage bureau will arrange face to face meeting.</h3></li><li class=\"mt10\"><h3>3)You will be able to send {{selectedPackage.category.noOfAskMobileNo}} Ask Mobile Number Information request About Members to your marriage bureau. Once your marriage bureau receives request, then marriage bureau will able to send you the Mobile Number information.</h3></li></ul></div></div><div class=\"load mt20\" dw-loading=\"paymentBtn\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btn-new md-cornered md-primary\" ui-sref=\"account.login\">Make Payment</md-button></div></md-content></div><div class=\"clr\" style=\"height: 100px\"></div>");
$templateCache.put("app/account/register.html","<div class=\"newlogin\"><div class=\"first_page_container\" id=\"home\"><nav><div class=\"navigation_icon\" ng-click=\"vm.toggleMenu()\"></div><div class=\"logo_container\"><a ng-if=\"regc.reg.shop.websiteLogoUrl\" ui-sref=\"account.login\" title=\"{{::regc.reg.shop.shopName}}\"><img class=\"web-logo\" ng-src=\"{{::main.imageUrl}}{{::regc.reg.shop.websiteLogoUrl}}\" alt=\"{{::regc.reg.shop.shopName}}\" title=\"{{::regc.reg.shop.shopName}}\"></a></div><div id=\"myTopnav\" class=\"nav_container\"><ul><li class=\"\"><a ng-href=\"/login#about\" title=\"ABOUT\">ABOUT</a></li><li class=\"\"><a href=\"/login#how-it-works\" title=\"HOW IT WORKS\">HOW IT WORKS</a></li><li class=\"\"><a href=\"/login#plans\" title=\"PLANS\">PLANS</a></li><li class=\"\"><a href=\"/login\" title=\"LOG IN\">LOGIN</a></li><li class=\"\"><a href=\"/register\" title=\"REGISTER\">REGISTER</a></li><li class=\"\"><a href=\"/login#contact\" title=\"CONTACT\">CONTACT US</a></li></ul></div></nav></div></div><div class=\"register mt40\"><div layout=\"row\" layout-align=\"center center\" style=\"min-width: 990px;\"><md-content flex=\"50\"><div style=\"position:relative;width:670px\"><div class=\"step-line\">&nbsp;</div><div ng-switch=\"regc.step\"><div ng-switch-when=\"1\"><div class=\"step-arw-pos\" style=\"left:0px;\"><img src=\"../assets/images/big-arw-active.gif\" width=\"83\" height=\"10\" border=\"0\" alt=\"\"></div><div class=\"step-arw-pos\" style=\"left:240px;\"><img src=\"../assets/images/big-arw-inactive.gif\" width=\"83\" height=\"10\" border=\"0\" alt=\"\"></div><div class=\"fleft txt-center\" style=\"padding-right:140px;\"><div class=\"mediumhdrtxt boldtxt padb20\" style=\"color:#F8B107\">STEP 1</div><div class=\"smalltxt clr6 padl5\">BASIC DETAILS</div></div><div class=\"fleft txt-center\"><div class=\"mediumhdrtxt boldtxt padb20 clr8\">STEP 2</div><div class=\"smalltxt clr5\">PERSONAL DETAILS</div></div></div><div ng-switch-when=\"2\"><div class=\"step-arw-pos\" style=\"left:0px;\"><img src=\"../assets/images/big-arw-inactive.gif\" width=\"83\" height=\"10\" border=\"0\" alt=\"\"></div><div class=\"step-arw-pos\" style=\"left:240px;\"><img src=\"../assets/images/big-arw-active.gif\" width=\"83\" height=\"10\" border=\"0\" alt=\"\"></div><div class=\"fleft txt-center\" style=\"padding-right:140px;\"><div class=\"mediumhdrtxt boldtxt padb20\">STEP 1</div><div class=\"smalltxt clr5 padl5\">BASIC DETAILS</div></div><div class=\"fleft txt-center\"><div class=\"mediumhdrtxt boldtxt padb20 clr8\" style=\"color:#F8B107\">STEP 2</div><div class=\"smalltxt clr6\">PERSONAL DETAILS</div></div></div></div><br clear=\"all\"></div><h1 style=\"padding-top: 20px; padding-bottom: 20px; font-size: 16px; color: red; padding-left: 20px;\">Register For Free And Find Your Matches Across All Marriage Bureaus.</h1><api-validate></api-validate><div ng-switch=\"regc.step\"><div ng-switch-when=\"1\"><form name=\"basicDetailsForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"regc.goToPersonalDetails(basicDetailsForm)\"><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Basic Information</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Name</label> <input type=\"text\" ng-model=\"regc.profile.profileName\" name=\"profileName\" required=\"\" minlength=\"3\" md-maxlength=\"40\" maxlength=\"40\"></md-input-container></div><div ng-messages=\"basicDetailsForm.profileName.$error\" ng-if=\"basicDetailsForm.profileName.$dirty || basicDetailsForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"required\">Name is compulsory.</div><div class=\"error\" ng-message=\"minlength\">Name is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Name is too long.</div></div><div><label ng-class=\"{\'blue-color\' : regc.profile.gender}\">Select Gender</label><md-radio-group ng-model=\"regc.profile.gender\" layout=\"\" name=\"gender\" required=\"\"><md-radio-button value=\"Male\">Male</md-radio-button><md-radio-button value=\"Female\">Female</md-radio-button></md-radio-group></div><div ng-messages=\"basicDetailsForm.gender.$error\" ng-if=\"basicDetailsForm.gender.$dirty || basicDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Gender type is compulsory.</span></div><div layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Day (Date of Birth)</label><md-select ng-model=\"regc.ageObj.date\" name=\"dob\" required=\"\"><md-option ng-repeat=\"item in regc.dateObj.dd\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Month (Date of Birth)</label><md-select ng-model=\"regc.ageObj.month\" name=\"dob\" required=\"\"><md-option ng-repeat=\"item in regc.dateObj.mm\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Year (Date of Birth)</label><md-select ng-model=\"regc.ageObj.year\" name=\"dob\" required=\"\"><md-option ng-repeat=\"item in regc.dateObj.yyyy\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container></div><div ng-messages=\"basicDetailsForm.dob.$error\" ng-if=\"basicDetailsForm.dob.$dirty || basicDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Date of birth is compulsory.</span></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Email ID</label> <input type=\"email\" ng-model=\"regc.profile.email\" validate-email=\"\" name=\"email\" required=\"\"></md-input-container></div><div ng-messages=\"basicDetailsForm.email.$error\" ng-if=\"basicDetailsForm.email.$dirty || basicDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">You did not enter your email address.</span> <span class=\"error\" ng-message=\"email\">Your email address is invalid.</span></div><div layout=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Mother Tongue</label><md-select ng-model=\"regc.profile.motherTongue\" name=\"motherTongue\" required=\"\"><ul ng-repeat=\"(key, values) in regc.profileTemplate.motherTongueOptions.values | groupBy:\'category\'\"><li ng-if=\"key.indexOf(\'ANY\') == -1\"><span>{{key}}</span><md-option ng-repeat=\"option in values\" ng-value=\"option.value\">{{option.value}}</md-option></li></ul></md-select></md-input-container></div><div ng-messages=\"basicDetailsForm.motherTongue.$error\" ng-if=\"basicDetailsForm.motherTongue.$dirty || basicDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Mother Tongue is mandatory.</span></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Country Code {{regc.profile.countryCode}}</label><md-select ng-change=\"regc.profile.mobileNo=\'\'\" ng-model=\"regc.profile.countryCode\" name=\"countryCode\" required=\"\"><ul ng-repeat=\"(key, values) in regc.profileTemplate.countryCodeOptions.values | groupBy:\'category\'\"><li><span>{{key}}</span><md-option ng-repeat=\"option in values\" ng-value=\"option.value\">{{option.id}}</md-option></li></ul></md-select></md-input-container><div ng-if=\"regc.profile.countryCode.indexOf(\'+91\') > -1\" ng-init=\"regc.max=10;regc.min=10;\"></div><div ng-if=\"regc.profile.countryCode.indexOf(\'+91\') < 0\" ng-init=\"regc.max=12;regc.min=9;\"></div><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Mobile Number</label> <input type=\"text\" name=\"mobileNo\" ng-model=\"regc.profile.mobileNo\" numbers-only=\"\" ng-minlength=\"regc.min\" ng-maxlength=\"regc.max\" required=\"\"></md-input-container></div><div ng-messages=\"basicDetailsForm.countryCode.$error\" ng-if=\"basicDetailsForm.countryCode.$dirty || basicDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Country Code is compulsory.</span></div><div ng-messages=\"basicDetailsForm.mobileNo.$error\" ng-if=\"basicDetailsForm.mobileNo.$dirty || basicDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter only a valid mobile number.</span> <span class=\"error\" ng-message=\"maxlength\">Enter only a valid mobile number.</span></div><div class=\"error-allign\" ng-if=\"regc.profile.mobileNo.length > 9\" ng-init=\"regc.checkUserExist(regc.profile.mobileNo)\"><span ng-if=\"regc.mobileNoAlreadyExist\" class=\"error\">This mobile number already exist in this website. So please use a different mobile number</span></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Password</label> <input name=\"password\" ng-model=\"regc.password\" type=\"text\" maxlength=\"15\" ng-minlength=\"4\" ng-maxlength=\"15\" class=\"textbox_sml\" required=\"\"></md-input-container></div><div ng-messages=\"basicDetailsForm.password.$error\" ng-if=\"basicDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Password is required.</span> <span class=\"error\" ng-message=\"minlength\">Password should be minimum 4 characters.</span> <span class=\"error\" ng-message=\"maxlength\">Password should be maximum 15 characters.</span></div><div><label ng-class=\"{\'blue-color\' : regc.profile.vegOrNonVeg}\">Veg Or Non Veg ?</label><md-radio-group ng-model=\"regc.profile.vegOrNonVeg\" layout=\"\" name=\"vegOrNonVeg\" required=\"\"><md-radio-button value=\"Veg\">Veg</md-radio-button><md-radio-button value=\"Nov-Veg\">Non Veg</md-radio-button></md-radio-group></div><div ng-messages=\"basicDetailsForm.vegOrNonVeg.$error\" ng-if=\"basicDetailsForm.vegOrNonVeg.$dirty || basicDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Veg Or Non Veg is compulsory.</span></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Add Profile Images (Only .jpeg, .jpg)</span></md-card-header-text></md-card-header><md-card-content dw-loading=\"imageLoading\" class=\"load\" dw-loading-options=\"{text: \'Loading Image...\'}\"><div class=\"up-buttons\"><ul layout=\"row\" layout-align=\"space-around center\"><li ng-repeat=\"item in regc.items\"><div ng-if=\"item.invalidFile.$errorMessages\"><span class=\"error\" ng-if=\"item.invalidFile.$errorMessages.minSize\">Please upload a higher resolution image.</span> <span class=\"error\" ng-if=\"item.invalidFile.$errorMessages.maxSize\">Please upload image lesser than 20MB.</span></div><div class=\"thumbnail\" ng-if=\"!item.photo\"><div ng-if=\"item.image != \'./assets/images/no_image.png\'\"><img ng-src=\"{{main.imageUrl}}{{item.image}}\"> <span ng-init=\"item.to=1\"></span></div><div ng-if=\"item.image == \'./assets/images/no_image.png\'\"><img ng-src=\"{{item.image}}\"> <span ng-init=\"item.to=\'\'\"></span></div></div><div class=\"thumbnail\"><img ngf-thumbnail=\"item.photo\"></div><div ngf-select=\"regc.afterResizingImages($files)\" ngf-drop=\"\" ng-model=\"item.photo\" ngf-model-invalid=\"item.invalidFile\" ngf-resize=\"{width: 500, height: 800}\" ngf-resize-if=\"{width: 500, height: 500}\" ngf-fix-orientation=\"true\" ngf-before-model-change=\"regc.beforeResizingImages($files)\" ngf-max-files=\"1\" accept=\"image/*\" ngf-accept=\"\'image/*\'\" ngf-pattern=\"\'.jpeg,.jpg,.png\'\" ngf-drop-available=\"dropAvailable\"><span class=\"btn-small btn-primary cursor_default\" ng-if=\"(!item.photo) && item.to !=1\">Select image <input type=\"file\" ng-model=\"item.to\" name=\"{{item.name}}\" style=\"visibility: hidden; position: absolute;\" required=\"\"></span> <span class=\"btn-small btn-primary cursor_default prt7\" ng-model=\"item.photo\" ng-if=\"(item.photo || item.to ==1)\" ng-click=\"item.photo=\'\';item.to=\'\'\">Remove and Change</span></div></li></ul></div><div layout=\"row\" layout-align=\"space-around center\"><div flex=\"20\"><div ng-messages=\"basicDetailsForm.image1.$error\" ng-if=\"basicDetailsForm.image1.$error || basicDetailsForm.$submitted\" role=\"alert\"><span class=\"error prr46\" ng-message=\"required\">Image 1 is compulsory.</span></div></div><div flex=\"20\"><div ng-messages=\"basicDetailsForm.image2.$error\" ng-if=\"basicDetailsForm.image2.$error || basicDetailsForm.$submitted\" role=\"alert\"><span class=\"error prr46\" ng-message=\"required\">Image 2 is compulsory.</span></div></div></div></md-card-content></md-card><div class=\"error\" ng-if=\"basicDetailsForm.$submitted\"><div class=\"pt5\" ng-if=\"basicDetailsForm.$error.required.length > 0\"><span>You have not filled required fields. Please go and fill it!</span> <span ng-repeat=\"error in basicDetailsForm.$error.required\">{{error.$name}} <span ng-show=\"basicDetailsForm.$error.required.length-1 != $index\">,</span></span></div><div class=\"pt5\" ng-if=\"basicDetailsForm.$error.minlength.length > 0\"><span>You have not filled minimum length of fields. Please go and fill it!</span> <span ng-repeat=\"error in basicDetailsForm.$error.minlength\">{{error.$name}} <span ng-show=\"basicDetailsForm.$error.minlength.length-1 != $index\">,</span></span></div><div class=\"pt5\" ng-if=\"basicDetailsForm.$error.maxlength.length > 0\"><span>You have exceeded maximum length of fields. Please go and fill it!</span> <span ng-repeat=\"error in basicDetailsForm.$error.maxlength\">{{error.$name}} <span ng-show=\"basicDetailsForm.$error.maxlength.length-1 != $index\">,</span></span></div></div><div class=\"load\" layout=\"row\" layout-align=\"center center\"><md-button ng-disabled=\"regc.mobileNoAlreadyExist\" class=\"md-raised btn-new md-cornered md-primary\" type=\"submit\">Continue to Step 2</md-button></div></form></div><div ng-switch-when=\"2\"><form name=\"pDetailsForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"regc.registerProfile(pDetailsForm, $event)\"><md-card><md-card-header><md-card-header-text><span class=\"md-title\">More Personal Details</span></md-card-header-text></md-card-header><md-card-content><div><label ng-class=\"{\'blue-color\' : regc.profile.martialStatus}\">Martial Status</label><md-radio-group ng-model=\"regc.profile.martialStatus\" layout=\"row\" name=\"martialStatus\" required=\"\"><md-radio-button ng-value=\"option.value\" ng-repeat=\"option in regc.profileTemplate.martialStatusOptions.values | filter: {value: \'!\' + \'Any\'} : true\">{{option.value}}</md-radio-button></md-radio-group></div><div ng-messages=\"pDetailsForm.martialStatus.$error\" ng-if=\"pDetailsForm.martialStatus.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Martial Status is compulsory.</span></div><div layout-gt-sm=\"row\" class=\"mt30\" ng-if=\"regc.profile.martialStatus && regc.profile.martialStatus.indexOf(\'Never Married\') < 0\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>No Of Children</label> <input type=\"text\" name=\"noOfchildren\" ng-model=\"regc.profile.noOfchildren\" format=\"number\" maxlength=\"1\" required=\"\"></md-input-container></div><div ng-messages=\"pDetailsForm.noOfchildren.$error\" ng-if=\"pDetailsForm.noOfchildren.$dirty || pDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">No Of Children is compulsory.</span></div><div layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Religion</label><md-select name=\"religion\" ng-model=\"regc.profile.religion\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in main.notLoginData.shop.expertiseReligion\" ng-click=\"regc.getCasteOptions(option);regc.profile.caste=\'\'\">{{option}}</md-option></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.religion.$error\" ng-if=\"pDetailsForm.religion.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Religion is compulsory.</span></div><div layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Caste</label><md-select ng-change=\"regc.getSubCasteOptions(regc.profile.caste);regc.profile.subCaste=\'\';regc.profile.casteNoBar=regc.profile.caste==\'Intercaste\'?true:false\" name=\"caste\" ng-model=\"regc.profile.caste\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in main.notLoginData.shop.expertiseCaste | filter : \'!Any\' | orderBy\">{{option}}</md-option></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.caste.$error\" ng-if=\"pDetailsForm.caste.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Caste is compulsory.</span></div><div layout=\"\" ng-if=\"regc.profile.caste\"><md-checkbox ng-disabled=\"regc.profile.caste==\'Intercaste\'\" ng-model=\"regc.profile.casteNoBar\" aria-label=\"Checkbox 2\" flex=\"\"><span style=\"float: left;position: relative;left: -18px;\">Not particular about my Partner\'s Caste (Caste No Bar)</span></md-checkbox></div><div ng-if=\"regc.subCasteOptions && regc.subCasteOptions != \'\'\" layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub caste</label><md-select name=\"subCaste\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"regc.profile.subCaste\" ng-change=\"regc.getSubCasteSubOptions(regc.profile.subCaste);regc.profile.subCasteSub=\'\';regc.profile.otherSubCaste=\'\';regc.profile.gothram=\'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchSubcaste\" type=\"search\" placeholder=\"Search for a subcaste..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste\"><md-option ng-repeat=\"option in regc.subCasteOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:regc.searchSubcaste\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-gt-sm=\"\" class=\"mt20\" ng-if=\"regc.subCasteOptions == \'\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub caste</label> <input type=\"text\" ng-model=\"regc.profile.subCaste\" maxlength=\"20\"></md-input-container></div><div layout=\"\"><md-input-container flex=\"\" ng-if=\"regc.profile.subCaste.indexOf(\'Other\') == 0\"><label>Other Sub caste</label> <input type=\"text\" ng-model=\"regc.profile.otherSubCaste\" maxlength=\"20\"></md-input-container></div><div layout=\"\" ng-show=\"regc.profile.subCaste\"><md-checkbox ng-model=\"regc.profile.subCasteNoBar\" aria-label=\"Checkbox 2\" flex=\"\"><span style=\"float: left;position: relative;left: -18px;\">Not particular about my Partner\'s Sub Caste (Sub Caste No Bar)</span></md-checkbox></div><div layout-gt-sm=\"\" class=\"mt40\" ng-if=\"regc.subCasteSubOptions && regc.subCasteSubOptions != \'\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"chosen-label\">Sub caste division</label><md-select data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"regc.profile.subCasteSub\" ng-change=\"regc.profile.otherSubCasteSub=\'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchSubCasteSub\" type=\"search\" placeholder=\"Search for a subcaste division..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste division\"><md-option ng-repeat=\"option in regc.subCasteSubOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:regc.searchSubCasteSub\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"\" ng-if=\"regc.profile.caste.indexOf(\'Brahmin\') > -1 && regc.profile.subCaste && regc.profile.subCaste.indexOf(\'Other\') == -1 && regc.profile.subCaste.indexOf(\'Deshastha\') == -1 && regc.profile.subCaste.indexOf(\'Iyengar\') == -1 && regc.profile.subCaste.indexOf(\'Iyer\') == -1 && regc.profile.subCaste.indexOf(\'Madhwa\') == -1 && regc.profile.subCaste.indexOf(\'Smartha\') == -1\"><md-input-container flex=\"\"><label>Sub caste division</label> <input type=\"text\" ng-model=\"regc.profile.subCasteSub\" maxlength=\"20\"></md-input-container></div><div layout=\"\" ng-show=\"regc.profile.subCasteSub.indexOf(\'Other\') > -1\"><md-input-container flex=\"\"><label>Other Sub caste division</label> <input type=\"text\" ng-model=\"regc.profile.otherSubCasteSub\" maxlength=\"20\"></md-input-container></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Physical Details</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Height</label><md-select name=\"height\" ng-model=\"regc.profile.height\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in regc.profileTemplate.heightOptions.values track by option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.height.$error\" ng-if=\"pDetailsForm.height.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Height is compulsory.</span></div><div><label ng-class=\"{\'blue-color\' : regc.profile.physicalStatus}\">Physical Status</label><md-radio-group ng-model=\"regc.profile.physicalStatus\" layout=\"row\" name=\"physicalStatus\" required=\"\"><md-radio-button value=\"Normal\">Normal</md-radio-button><md-radio-button value=\"Physically Challenged\">Physically Challenged</md-radio-button></md-radio-group></div><div ng-messages=\"pDetailsForm.physicalStatus.$error\" ng-if=\"pDetailsForm.physicalStatus.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Physical Status is compulsory.</span></div></md-card-content></md-card><md-card ng-if=\"regc.profile.religion.indexOf(\'Muslim\') > -1\"><md-card-header><md-card-header-text><span class=\"md-title\">Religious Information</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-click=\"regc.getReligiousValueOptions()\"><label>Religious Value</label><md-select name=\"religiousValue\" ng-model=\"regc.profile.religiousValue\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option.value\" ng-repeat=\"option in regc.religiousValueOptions.values track by option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.religiousValue.$error\" ng-if=\"pDetailsForm.religiousValue.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Religious value is compulsory.</span></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : regc.profile.readQuran}\">Read Quran</label><md-radio-group ng-model=\"regc.profile.readQuran\" layout=\"row\"><md-radio-button value=\"Regularly\">Regularly</md-radio-button><md-radio-button value=\"Occasionally\">Occasionally</md-radio-button><md-radio-button value=\"Only jummah/Friday\">Only jummah/Friday</md-radio-button><md-radio-button value=\"Never read\">Never read</md-radio-button></md-radio-group></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Education and Occupation Details</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Highest Education</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"regc.clearSearchTerm()\" ng-model=\"regc.profile.highestEducation\" name=\"highestEducation\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchTerm\" type=\"search\" placeholder=\"Search for a education..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Highest Education\"><ul ng-repeat=\"(key, values) in regc.profileTemplate.educationOptions.values | groupBy:\'category\'\"><li ng-if=\"key.indexOf(\'Any\') == -1 && regc.checkIfExist(regc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:regc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.highestEducation.$error\" ng-if=\"pDetailsForm.highestEducation.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Highest Education is compulsory.</span></div><div layout=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>More Information about Education</label> <textarea ng-model=\"regc.profile.moreInfoAboutEducation\" columns=\"1\" md-maxlength=\"150\" rows=\"2\" maxlength=\"200\"></textarea></md-input-container></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : regc.profile.employedIn}\">Employed In</label><md-radio-group ng-model=\"regc.profile.employedIn\" layout=\"row\" name=\"employedIn\" required=\"\"><md-radio-button value=\"{{option.value}}\" ng-repeat=\"option in regc.profileTemplate.employedInOptions.values | filter: {value: \'!\' + \'Any\'}\">{{::option.value}}</md-radio-button></md-radio-group></div><div ng-messages=\"pDetailsForm.employedIn.$error\" ng-if=\"pDetailsForm.employedIn.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Employed In is compulsory.</span></div><div layout-gt-sm=\"\" ng-if=\"(regc.profile.employedIn && regc.profile.employedIn.indexOf(\'Student\')<0 && regc.profile.employedIn.indexOf(\'Not Working\')<0)\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Occupation</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"regc.clearSearchTerm()\" ng-model=\"regc.profile.occupation\" name=\"occupation\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchTerm\" type=\"search\" placeholder=\"Search for a occupation..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Highest Education\"><ul ng-repeat=\"(key, values) in regc.profileTemplate.occupationOptions.values | groupBy:\'category\'\"><li ng-if=\"key.indexOf(\'ANY\') == -1 && regc.checkIfExist(regc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:regc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.occupation.$error\" ng-if=\"pDetailsForm.occupation.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Occupation is compulsory.</span></div><div ng-if=\"regc.profile.occupation\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>More Information about Work</label> <textarea name=\"moreInfoAboutJob\" ng-model=\"regc.profile.moreInfoAboutJob\" columns=\"1\" md-maxlength=\"150\" rows=\"2\" maxlength=\"200\"></textarea></md-input-container></div><div layout-gt-sm=\"row\" class=\"mt30\" ng-if=\"regc.profile.occupation\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Annual Income (in India-Rupees)</label> <input type=\"text\" name=\"annualIncome\" ng-model=\"regc.profile.annualIncome\" format=\"number\" maxlength=\"11\" required=\"\"></md-input-container></div><div ng-messages=\"pDetailsForm.annualIncome.$error\" ng-if=\"pDetailsForm.annualIncome.$dirty || pDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Annual Income is compulsory.</span></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\"><span ng-if=\"regc.profile.gender.indexOf(\'Male\') > -1\">Groom\'s</span> <span ng-if=\"regc.profile.gender.indexOf(\'Female\') > -1\">Bride\'s</span> <span ng-if=\"(regc.profile.employedIn && regc.profile.employedIn.indexOf(\'Student\')<0 && regc.profile.employedIn.indexOf(\'Not Working\')<0)\">Work</span> Location</span></md-card-header-text></md-card-header><md-card-content><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>Country Living In/Working In</label><md-select name=\"currentLivingCountry\" ng-change=\"regc.getStates(regc.profile.currentLivingCountry); regc.profile.currentLivingState = \'\';regc.profile.currentLivingCity=\'\';regc.profile.residentStatus=\'\'\" required=\"\" ng-model=\"regc.profile.currentLivingCountry\" md-on-close=\"regc.clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchTerm\" type=\"search\" placeholder=\"Search for a country..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Bride/Groom Country Living In/Working In\"><md-option ng-value=\"country.value\" ng-repeat=\"country in regc.profileTemplate.countryOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:regc.searchTerm\">{{country.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Citizenship</label><md-select ng-model=\"regc.profile.citizenship\"><md-option ng-repeat=\"option in regc.profileTemplate.countryOptions.values | filter: {value: \'!\' + \'Any\'} : true\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.currentLivingCountry.$error\" ng-if=\"pDetailsForm.currentLivingCountry.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Current Living/Working Country is compulsory.</span></div><div layout-gt-sm=\"row\" ng-if=\"regc.profile.currentLivingCountry && regc.profile.currentLivingCountry != \'India\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Current Living/Working City</label> <input type=\"text\" ng-model=\"regc.profile.currentLivingCity\" name=\"currentResidingCity\" required=\"\" md-maxlength=\"30\" maxlength=\"30\" placeholder=\"Please enter state and city ...\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Resident Status</label><md-select name=\"residentStatus\" ng-model=\"regc.profile.residentStatus\" required=\"\"><md-option ng-repeat=\"option in regc.profileTemplate.residentStatusOptions.values | filter: {value: \'!\' + \'Any\'} : true\" ng-value=\"option.value\" required=\"\" name=\"residentStatus\">{{option.value}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\"><div ng-messages=\"pDetailsForm.currentResidingCity.$error\" ng-if=\"pDetailsForm.currentResidingCity.$dirty || pDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Current Living City is compulsory.</span> <span class=\"error\" ng-message=\"md-maxlength\">Current Living City is too long.</span></div><div ng-messages=\"pDetailsForm.residentStatus.$error\" ng-if=\"pDetailsForm.residentStatus.$dirty || pDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Resident Status is compulsory.</span></div></div><div layout-gt-sm=\"\" ng-if=\"regc.profile.currentLivingCountry == \'India\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>State Living In/Working In</label><md-select ng-model=\"regc.profile.currentLivingState\" name=\"currentLivingState\" md-on-close=\"regc.clearSearchTerm()\" ng-change=\"regc.profile.currentLivingCity=\'\';regc.cityOptions=\'\'\" required=\"\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchTerm\" type=\"search\" placeholder=\"Search for a state..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Bride/Groom Country Living In/Working In\"><md-option ng-repeat=\"option in regc.stateOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:regc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.currentLivingState.$error\" ng-if=\"regc.profile.currentLivingCountry == \'India\' && (pDetailsForm.currentLivingState.$dirty || pDetailsForm.$submitted)\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Current Living/Working State is compulsory.</span></div><div layout-gt-sm=\"\" ng-if=\"regc.profile.currentLivingState && regc.profile.currentLivingCountry == \'India\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>City(near) Living In/Working In India</label><md-select ng-model=\"regc.profile.currentLivingCity\" name=\"currentLivingCity\" md-on-close=\"regc.clearSearchTerm()\" ng-change=\"regc.profile.otherCurrentLivingCity=\'\'\" ng-click=\"regc.getCities(regc.profile.currentLivingState);\" required=\"\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchTerm\" type=\"search\" placeholder=\"Search for a city ..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Bride/Groom Country Living In/Working In\"><md-option ng-repeat=\"option in regc.cityOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:regc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.currentLivingCity.$error\" ng-if=\"pDetailsForm.currentLivingCity.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">City(near) Living In/Working In is compulsory.</span></div><div layout-gt-sm=\"row\" ng-if=\"regc.profile.currentLivingCity == \'Other\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Other Current Living/Working City</label> <input type=\"text\" ng-model=\"regc.profile.otherCurrentLivingCity\" name=\"otherCurrentLivingCity\" required=\"\" md-maxlength=\"30\"></md-input-container></div><div ng-messages=\"pDetailsForm.otherCurrentLivingCity.$error\" ng-if=\"pDetailsForm.otherCurrentLivingCity.$dirty || pDetailsForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Other Current Living City is compulsory.</span> <span class=\"error\" ng-message=\"md-maxlength\">Other Current Living City is too long.</span></div></md-card-content></md-card><md-card ng-if=\"regc.profile.religion.indexOf(\'Hindu\') > -1\"><md-card-header><md-card-header-text><span class=\"md-title\">Astrological Information</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Star</label><md-select data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"regc.profile.star\" name=\"star\"><md-select-header class=\"demo-select-header\"><input ng-model=\"regc.searchStar\" type=\"search\" placeholder=\"Search for a star..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Star\"><md-option ng-repeat=\"option in regc.profileTemplate.starOptions.values | orderBy: \'value\' | filter:regc.searchTerm\" ng-value=\"option.value\" ng-click=\"regc.getRaasi(option.value);regc.profile.raasi=\'\'\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Paadha</label> <input type=\"number\" ng-model=\"regc.profile.paadha\" maxlength=\"2\"></md-input-container></div><div ng-messages=\"pDetailsForm.star.$error\" ng-if=\"pDetailsForm.star.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Star is compulsory.</span></div><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Raasi/Moon Sign</label><md-select ng-disabled=\"!regc.profile.star\" ng-model=\"regc.profile.raasi\" name=\"raasi\"><md-option ng-repeat=\"option in regc.raasiOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"pDetailsForm.raasi.$error\" ng-if=\"pDetailsForm.raasi.$dirty || pDetailsForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Raasi is compulsory.</span></div><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Hour (Birth Time)</label><md-select ng-model=\"regc.birthTimeObj.hr\" name=\"time\"><md-option ng-repeat=\"item in regc.timeObj.hr\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Minute (Birth Time)</label><md-select ng-model=\"regc.birthTimeObj.min\" name=\"time\"><md-option ng-repeat=\"item in regc.timeObj.min\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>AM/PM (Birth Time)</label><md-select ng-model=\"regc.birthTimeObj.amOrPm\" name=\"time\"><md-option ng-repeat=\"item in regc.timeObj.amOrPm\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Something about You</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=\"md-block\"><label>Write about your personality or hobbies. Express yourself</label> <textarea ng-model=\"regc.profile.aboutProfile\" md-maxlength=\"250\" name=\"aboutProfile\" required=\"\"></textarea></md-input-container><div ng-messages=\"pDetailsForm.aboutProfile.$error\" ng-show=\"pDetailsForm.aboutProfile.$dirty || pDetailsForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"required\">This is required!</div><div class=\"error\" ng-message=\"md-maxlength\">That\'s too long!</div></div></md-card-content></md-card><div class=\"error\" ng-if=\"pDetailsForm.$submitted\"><div class=\"pt5\" ng-if=\"pDetailsForm.$error.required.length > 0\"><span>You have not filled required fields. Please go and fill it!</span> <span ng-repeat=\"error in pDetailsForm.$error.required\">{{error.$name}} <span ng-show=\"pDetailsForm.$error.required.length-1 != $index\">,</span></span></div><div class=\"pt5\" ng-if=\"pDetailsForm.$error.minlength.length > 0\"><span>You have not filled minimum length of fields. Please go and fill it!</span> <span ng-repeat=\"error in pDetailsForm.$error.minlength\">{{error.$name}} <span ng-show=\"pDetailsForm.$error.minlength.length-1 != $index\">,</span></span></div><div class=\"pt5\" ng-if=\"pDetailsForm.$error.maxlength.length > 0\"><span>You have exceeded maximum length of fields. Please go and fill it!</span> <span ng-repeat=\"error in pDetailsForm.$error.maxlength\">{{error.$name}} <span ng-show=\"pDetailsForm.$error.maxlength.length-1 != $index\">,</span></span></div></div><div layout=\"row\" layout-align=\"space-arround end\"><div style=\"position: relative; top: -24px;\" ng-init=\"regc.termsandprivacy=true\"><span><input style=\"position: relative; top: -7px;\" type=\"checkbox\" ng-model=\"regc.termsandprivacy\"></span> <span style=\"display: inline-block; font-size: 11px; line-height: 13px; width: 150px;\">I have read and agree to the <a href=\"/terms\" target=\"_blank\" class=\"link\">T&amp;C</a> and <a href=\"/privacy-policy\" target=\"_blank\" class=\"link\">Privacy Policy</a></span></div><div class=\"load\" dw-loading=\"createProfileBtn\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btn-new md-cornered md-primary\" type=\"submit\">Create Profile</md-button></div></div></form></div></div></md-content></div></div>");
$templateCache.put("app/compliance/privacypolicy.html","<div class=\"bdr1 paddl15 paddr15 paddt10 paddb10\"><div class=\"hdtxt1 boldtxt paddb10\">Privacy Policy of Matrimony</div><div class=\"payhbdr\"></div><div class=\"paddt15 paddb5 paddl5 paddr5 lheight18 txt-justify\"><p><span style=\"text-transform:capitalize;\">{{compc.host}}</span> is an online matrimonial portal endeavouring constantly to provide you with matrimonial services. This privacy statement is common to all the matrimonial Website/apps operated under <span style=\"text-transform:capitalize;\">{{compc.host}}</span> Since we are strongly committed to your right to privacy, we have drawn out a privacy statement with regard to the information we collect from you. You acknowledge that you are disclosing information voluntarily. By accessing /using the website/apps and/or by providing your information, you consent to the collection and use of the info you disclose on the website/apps in accordance with this Privacy Policy. If you do not agree for use of your information, please do not use or access this website/apps.</p><p class=\"boldtxt paddt15\">What information you need to give in to use this Website/apps?</p><p class=\"paddt15\">The information we gather from members and visitors who apply for the various services our website/apps offers includes, but may not be limited to, email address, name, date of birth, educational qualifications a user-specified password, mailing address, zip/pin code and telephone/mobile number or fax number.</p><p class=\"paddt15\">We use a secure server for credit card transactions to protect the credit card information of our users and Cookies are used to store the login information. Cookies are small files placed on your hard drive that will assist us in providing our services. You may also encounter Cookies or identical/related devices on certain pages of the website/apps that are placed by third parties. We do not control the use of cookies by third parties.</p><p class=\"paddt15\">If you establish a credit account with us to pay the fees we charge, some additional information, including a billing address, a credit/debit card number and a credit/debit card expiration date and tracking information from cheques or demand drafts is collected.</p><p class=\"paddt15\">The user information we collect depends on the context of your interactions with us and the website or Apps, the choices you make and the products and features you use. The User Information is used for authentication and account access, If a user registers using social networking platforms such as Facebook, Google, LinkedIn and others we may collect personal data you choose to allow us to access through their APIs. When the user accesses our websites or apps, data relating to device ID, log files ,Geographic Location, device Information/specification are also collected automatically.</p><p class=\"paddt15\">We may use also your personal information for analysis of data, usage trends and to evaluate and improve our site/App, marketing research , preventing of frauds. In our efforts to continually improve our product and service offerings, we collect and analyse demographic and profile data about our users\' activity on our website/apps. We identify and use your IP address to help diagnose problems with our server, and to administer our website/apps. Your IP address is also used to help identify you and to gather broad demographic information.</p><p class=\"paddt15 boldtxt\">How the website/apps uses the information it collects/tracks?</p><p class=\"paddt15\"><span style=\"text-transform:capitalize;\">{{compc.host}}</span> collects information for data analysis, identifying usage trends,determining the effectiveness of our promotional campaigns and to evaluate and improve our websites or apps, products, and services ,marketing research from our users primarily to ensure that we are able to fulfil your requirements and to deliver Personalised experience.</p><p class=\"paddt15 boldtxt\">For European Union Members (EU)</p><p class=\"paddt15 boldtxt\">With whom the website/apps shares the information it collects/tracks?</p><p class=\"paddt15\">We may share such identifiable information with our associates/affiliates/subsidiaries and such associates/affiliates/subsidiaries may market to you as a result of such sharing. Any information you give us is held with the utmost care and security. We are also bound to cooperate fully should a situation arise where we are required by law or legal process to provide information about a customer/visitor.</p><p class=\"paddt15\">Where required or permitted by law, information may be provided to others, such as regulators and law enforcement agencies or to protect the rights ,property or personal safety of other members or the general public . We may voluntarily share your information with law enforcement agencies / Gateway service providers / anti-fraud solution provider(s) if we feel that the transaction is of suspicious nature.</p><p class=\"paddt15\">From time to time, we may consider corporate transactions such as a merger, acquisition, reorganization, asset sale, or similar. In these instances, we may transfer or allow access to information to enable the assessment and undertaking of that transaction. If we buy or sell any business or assets, personal information may be transferred to third parties involved in the transaction.</p><p class=\"paddt15\">Our website/apps links to other website/apps that may collect personally identifiable information about you. We are not responsible for the privacy policy or the contents of those linked website/apps.</p><p class=\"paddt15 boldtxt\">How Long Do We Keep Your Information?</p><p class=\"paddt15\">As stipulated in the Privacy Policy we will retain the information we collect from users under the following circumstances:</p><p class=\"paddt15\">For as long as the users subscribe to our services to meet their suitable purpose(s) for which it was collected, for the sake of enforcing agreements, for performing audits, for resolving any form of disputes, for establishing legal defences, for pursuing legitimate businesses and to comply with the relevant applicable laws.</p><p class=\"paddt15 boldtxt\">What are the Security Precautions in respect of your personal information?</p><p class=\"paddt15\">We aim to protect your personal information through a system of organizational and technical security measures. We have implemented appropriate internal control measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure. Once your information is in our possession, we adhere to security guidelines protecting it against unauthorised access.</p><p class=\"paddt15 boldtxt\">Change of Privacy Policy</p><p class=\"paddt15\">We may change this Privacy Policy without notice from time to time without any notice to you. However, changes will be updated in the Privacy Policy page.</p><p class=\"paddt15\">The Grievance officer shall be available between 10 am to 6 pm IST from Monday to Saturday excluding Sunday\'s and Public Holidays in India.</p><p class=\"paddt15\">The Grievance officer is appointed as per Section 5 (9) of the Information Technology ( Reasonable Security &amp; Procedures and Sensitive Personal data or Information ) Rule, 2011.</p></div></div>");
$templateCache.put("app/compliance/termsofuse.html","<div class=\"terms\"><div layout=\"row\" layout-align=\"center center\" class=\"brownpopclr\"><div alink=\"#000000\" bgcolor=\"#ffffff\" link=\"#000000\" text=\"#000000\" vlink=\"#000000\" topmargin=\"0\" leftmargin=\"0\" marginwidth=\"0\" marginheight=\"0\"><table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" height=\"100%\"><tr><td valign=\"middle\" align=\"center\"><table bgcolor=\"#FFFFFF\" border=\"0\" cellspacing=\"0\" cellpadding=\"5\" width=\"500\"><tr><td valign=\"top\"><font face=\"arial, verdana\" size=\"2\"><br><font class=\"normaltxt1\" style=\"line-height:15px\"><center><b><span style=\"text-transform:capitalize;\">{{compc.host}}</span></b></center><br><center><b>Terms and Conditions Governing Membership<br><br>[Subject to revision by AM from time to time]<br>[Applicable for Paid and Free Services]</b></center><font class=\"headertxt\" style=\"line-height:15px\"><br>DEAR USER:</font><p class=\"normaltxt1\" style=\"line-height:15px\">PLEASE READ THESE TERMS AND CONDITIONS BEFORE REGISTRATION.<br>By registering on <span style=\"text-transform:capitalize;\">{{compc.host}}</span>, you explicitly understand and agree that:<ul class=\"normaltxt1\"><li>The minimum age for registering is 21Paid Memberships: Validity of your paid membership is based on days years for women and 21 years for men.</li><li>You are not disabled by any law from entering into a contract.</li><li>You have gone through the Terms and Conditions and agree to be bound by them.</li></ul><font class=\"subheadertxt\" style=\"line-height:15px\">Conditions of Use</font></p><p class=\"normaltxt1\" style=\"line-height:15px\">Welcome to <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> and its affiliates provide their services to you subject to the following conditions. If you visit or sign up at <span style=\"text-transform:capitalize;\">{{compc.host}}</span>, you accept these conditions. Please read them carefully. In addition, when you use any current or future <span style=\"text-transform:capitalize;\">{{compc.host}}</span> service or visit or any business affiliated with <span style=\"text-transform:capitalize;\">{{compc.host}}</span>, whether or not included in the <span style=\"text-transform:capitalize;\">{{compc.host}}</span> Web site, you also will be subject to the guidelines and conditions applicable to such service or business.</p><p class=\"subheadertxt\" style=\"line-height:15px\">PRIVACY</p><p class=\"normaltxt1\" style=\"line-height:15px\">Please review our Privacy Notice, which also governs your visit to <span style=\"text-transform:capitalize;\">{{compc.host}}</span>, to understand our practices. Members agree that their profile(s) may be crawled and indexed by search engines, where <span style=\"text-transform:capitalize;\">{{compc.host}}</span> and its network does not have any control over the search engines behaviour.</p><p class=\"subheadertxt\" style=\"line-height:15px\">ELECTRONIC COMMUNICATIONS</p><p class=\"normaltxt1\" style=\"line-height:15px\">When you visit <span style=\"text-transform:capitalize;\">{{compc.host}}</span> or send e-mails to us, you are communicating with us electronically. You consent to receive communications from us electronically. We will communicate with you by e-mail or by posting notices on this site. You agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.</p><p class=\"subheadertxt\" style=\"line-height:15px\">COPYRIGHT</p><p class=\"normaltxt1\" style=\"line-height:15px\">All content included on this site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the property of <span style=\"text-transform:capitalize;\">{{compc.host}}</span> or its content suppliers and protected by Indian and international copyright laws. The compilation of all content on this site is the exclusive property of <span style=\"text-transform:capitalize;\">{{compc.host}}</span> and protected by Indian and international copyright laws. All software used on this site is the property of <span style=\"text-transform:capitalize;\">{{compc.host}}</span> or its software suppliers and protected by Indian and international copyright laws.</p><p class=\"subheadertxt\" style=\"line-height:15px\">TRADEMARK<font class=\"normaltxt1\"><ul><li><span>{{compc.host}}</span></li></ul></font></p><p class=\"normaltxt1\" style=\"line-height:15px\">And other marks indicated on our site are registered trademarks of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>, or its subsidiaries, in the United States and other countries. Other <span style=\"text-transform:capitalize;\">{{compc.host}}</span> graphics, logos, page headers, button icons, scripts, and service names are trademarks or trade dress of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>, or its subsidiaries. <span style=\"text-transform:capitalize;\">{{compc.host}}</span>\'s trademarks and trade dress may not be used in connection with any product or service that is not <span style=\"text-transform:capitalize;\">{{compc.host}}</span>\'s, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. All other trademarks not owned by <span style=\"text-transform:capitalize;\">{{compc.host}}</span> or its subsidiaries that appear on this site are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by <span style=\"text-transform:capitalize;\">{{compc.host}}</span> or its subsidiaries.</p><p class=\"subheadertxt\" style=\"line-height:15px\">LICENSE AND SITE ACCESS</p><p class=\"normaltxt1\" style=\"line-height:15px\"><span style=\"text-transform:capitalize;\">{{compc.host}}</span> grants you a limited license to access and make personal use of this site and not to download (other than page caching) or modify it, or any portion of it, except with express written consent of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. This license does not include any resale or commercial use of this site or its contents; any collection and use of any product listings, descriptions, or prices; any derivative use of this site or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools. This site or any portion of this site may not be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without express written consent of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. You may not frame or utilize framing techniques to enclose any trademark, logo, or other proprietary information (including images, text, page layout, or form) of <span style=\"text-transform:capitalize;\">{{compc.host}}</span> and our affiliates without express written consent. You may not use any meta tags or any other \"hidden text\" utilizing <span style=\"text-transform:capitalize;\">{{compc.host}}</span>\'s name or trademarks without the express written consent of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. Any unauthorized use terminates the permission or license granted by <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. You may not use any <span style=\"text-transform:capitalize;\">{{compc.host}}</span> logo or other proprietary graphic or trademark as part of the link without express written permission.</p><p class=\"subheadertxt\" style=\"line-height:15px\">YOUR ACCOUNT</p><p class=\"normaltxt1\" style=\"line-height:15px\">If you use this site, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> and its affiliates reserve the right to refuse service, terminate accounts, remove or edit content, or cancel subscription in their sole discretion.</p><p class=\"subheadertxt\" style=\"line-height:15px\">MEMBERSHIP</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Mode</b>: By registering your profile through any of our domains [Listed in the Annexure] or by the remittance of fees you become a member of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>.</p><p class=\"normaltxt1\" style=\"line-height:15px\">For the convenience of all our users <span style=\"text-transform:capitalize;\">{{compc.host}}</span> has three different types of membership schemes, each with their own benefits. They are {{compc.plans}}.</p><p class=\"normaltxt1\" style=\"line-height:15px\">These package plans allows members to contact profiles in all language domains. Members will also receive a double share of verified phone numbers.Members can contact other members across all domains. Their profile will get a special highlighting and they will have access to verified phone numbers.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Membership is not automatic</b>: The right of admission vests with <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. You become a member upon due acceptance of the Profile/Payment by <span style=\"text-transform:capitalize;\">{{compc.host}}</span>. Membership and rights of admission is reserved solely for<ol type=\"a\" class=\"normaltxt1\"><li>Indian Nationals & Citizens</li><li>Persons of Indian Origin (PIO)</li><li>Non Resident Indians (NRI)</li><li>Persons of Indian Descent or Indian Heritage.</li></ol></p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Length of Membership</b>: You continue to be a member of <span style=\"text-transform:capitalize;\">{{compc.host}}</span> till:<ul class=\"normaltxt1\"><li><span style=\"text-transform:capitalize;\">{{compc.host}}</span> discharges its obligations to you by the rendering of its services to you; or The termination of the membership by either <span style=\"text-transform:capitalize;\">{{compc.host}}</span> or you.</li><li>Paid Memberships: Validity of your paid membership is based on days {{compc.days}}.</li></ul></p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Privity of Membership</b>: Your Membership is only for personal use. It is not to be assigned, transferred or licensed so as to be used by any other person/entity.</p><p class=\"normaltxt1\" style=\"line-height:15px\">Members are advised to make appropriate/thorough enquiries before acting upon any matrimonial advertisement. Our site does not vouch for or subscribe to the claims and representations made by advertisers regarding particulars of status, age, income of other members.</p><p class=\"normaltxt1\" style=\"line-height:15px\">Kindly note that, your membership in <span style=\"text-transform:capitalize;\">{{compc.host}}</span> is for your sole, personal use. You may not authorize others to use your membership and you may not assign or transfer your account to any other person or entity.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>About Cancellation:</b> MEMBERSHIP FEES ARE NOT REFUNDABLE if a member chooses to terminate the membership.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Online Conduct</b>: You are responsible for the content and information [including profile and photograph] you post or transmit through <span style=\"text-transform:capitalize;\">{{compc.host}}</span>\'s services. You will not post or transmit any content or information [in whatever form they may be contained] that is defamatory, blasphemous, abusive, obscene, sexually oriented, profane, intimidating, illegal or in violation of the rights of any person, including intellectual property rights. No content or information shall contain details or particulars of any of <span style=\"text-transform:capitalize;\">{{compc.host}}</span>\'s competitors, including their contact details. You will not use either your online or offline membership as a platform for any kind of promotional campaign, solicitation, advertising or dealing in any products or services or transmit any chain letters or junk mails.</p><p class=\"normaltxt1\" style=\"line-height:15px\">There is a limit to the number of profiles you are allowed to contact each day. Also, you cannot contact more than 3000 profiles in a period of 3 months.</p><p class=\"normaltxt1\" style=\"line-height:15px\">Being a free member you can express your interest to a limited number of members. This is valid for a limited period only. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> reserves the right to provide this feature to its members.</p><p class=\"normaltxt1\" style=\"line-height:15px\">Your membership will automatically be suspended if you send \"abusive, obscene or sexually oriented\" message/s to other members.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><span style=\"text-transform:capitalize;\">{{compc.host}}</span> has the right to suspend your profile without any prior notice.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><span style=\"text-transform:capitalize;\">{{compc.host}}</span> reserves the right to edit/delete your photo/horoscope if it\'s not a valid/clear/related one.</p><p class=\"normaltxt1\" style=\"line-height:15px\">If we find duplicate profiles then we have rights to suspend any of the profile or all the profiles.</p><p class=\"normaltxt1\" style=\"line-height:15px\">Messages sent to members of the opposite gender should be only for the purpose of finding a life partner. You are not allowed to misuse the service in the name of \"Dating\", \"Flirting\", \"Friendship\" etc.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><span style=\"text-transform:capitalize;\">{{compc.host}}</span> reserves the right to modify your profile if any prohibitive or objectionable content is found, or in the case of your contact details being entered in irrelevant fields. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> may also modify the profile for other reasons not mentioned herewith. If any abusive content is found in your video clipping, <span style=\"text-transform:capitalize;\">{{compc.host}}</span> has the right to suspend your profile.</p><p class=\"normaltxt1\" style=\"line-height:15px\">You will not post or transmit any content, information or trademarks without the prior consent of the person holding its proprietary or licensed rights. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> will not in any way be responsible or answerable to any action brought by any person arising out of your acts as described above.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><span style=\"text-transform:capitalize;\">{{compc.host}}</span> reserves the right but is not obligated, to edit, delete, eclipse or withhold display of such content or information as it deems fit in the light of the rules prescribed above.</p><p class=\"normaltxt1\" style=\"line-height:15px\">To enhance the security of its members, <span style=\"text-transform:capitalize;\">{{compc.host}}</span> has restricted copying and saving images and content from certain sections of the portal.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</b></p><p class=\"normaltxt1\" style=\"line-height:15px\">THIS SITE IS PROVIDED BY <span style=\"text-transform:capitalize;\">{{compc.host}}</span> ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THIS SITE OR THE INFORMATION, CONTENT, MATERIALS, OR PRODUCTS INCLUDED ON THIS SITE. YOU EXPRESSLY AGREE THAT YOUR USE OF THIS SITE IS AT YOUR SOLE RISK.</p><p class=\"normaltxt1\" style=\"line-height:15px\">TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, <span style=\"text-transform:capitalize;\">{{compc.host}}</span> DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> DOES NOT WARRANT THAT THIS SITE, ITS SERVERS, OR E-MAIL SENT FROM <span style=\"text-transform:capitalize;\">{{compc.host}}</span> ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS SITE, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>As to extraneous contents</b>: <span style=\"text-transform:capitalize;\">{{compc.host}}</span> hereby alerts and warns its members of the possibility of unauthorized posting of contents by any person including members and unauthorized users and advises discretion in access since such content, information or representation may not be suitable to you including being offensive. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> will not in any way be responsible for such content, information or representations. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> is also not responsible for alterations, modifications, deletion, reproduction, sale, transmission or any such misuse of data and content in the public domain by any user.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>REFUND OF FEE</b></p><p class=\"normaltxt1\" style=\"line-height:15px\">If you choose to terminate your membership, the MEMBERSHIP FEES ARE NOT REFUNDABLE under any circumstances.</p><p class=\"normaltxt1\" style=\"line-height:15px\">Your membership in the <span style=\"text-transform:capitalize;\">{{compc.host}}</span> service is for your sole, personal use. You may not authorize others to use your membership and you may not assign or transfer your account to any other person or entity.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>ROLE OF <span style=\"text-transform:capitalize;\">{{compc.host}}</span></b></p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Provision of Service</b>: <span style=\"text-transform:capitalize;\">{{compc.host}}</span> will provide the service[s] that are opted and paid for by the member. In addition, the member may also make use of the other free services that are applicable to them.</p><p class=\"normaltxt1\" style=\"line-height:15px\">A paid membership will allow you to contact profiles of the <b>opposite gender</b> of all the domains.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Medium of Interchange of Information</b>: Besides the provision of services, <span style=\"text-transform:capitalize;\">{{compc.host}}</span> acts as a platform for all its members to interchange information that would promote their common matrimonial objectives. It is to be distinctly understood that <span style=\"text-transform:capitalize;\">{{compc.host}}</span> will only provide contact between and among members within its service framework and not the direct contact details of such members. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> is not the agent of any member and does not partake in the interchange or the results thereof. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> will be a disinterested person in the event of disputes between or among the members, though it may facilitate an amicable resolution of such disputes.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Right to form Consortium/Associates</b>: While providing services, <span style=\"text-transform:capitalize;\">{{compc.host}}</span> may outsource any part thereof to any competent person or organization, with or without disclosing it to you. However, your membership rights and responsibilities continue as against <span style=\"text-transform:capitalize;\">{{compc.host}}</span> only and not against such persons or organizations.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>GENERAL PROVISIONS</b></p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Confidentiality:</b> <span style=\"text-transform:capitalize;\">{{compc.host}}</span> will maintain confidential, all personal information [other than that meant for posting or transmission] furnished by members. However, <span style=\"text-transform:capitalize;\">{{compc.host}}</span> may divulge such information if required by law.</p><p class=\"normaltxt1\" style=\"line-height:15px\">By agreeing to register at <span style=\"text-transform:capitalize;\">{{compc.host}}</span> and its consortium of portals, a user allows <span style=\"text-transform:capitalize;\">{{compc.host}}</span> to get in touch with him/her from time to time on events or offers. This could include exciting offers, information, as well as promotions. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> can use your email address and/or telephone number for this purpose.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Termination of Membership:</b> The membership may be terminated by either party by serving a written notice on the other. <span style=\"text-transform:capitalize;\">{{compc.host}}</span> reserves the right to terminate the membership, to suspend a profile or to disable access in respect of any member in breach of any of the terms. In no case will the Membership fees be refundable.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>Site Policies, Modification and Severability</b></p><p class=\"normaltxt1\" style=\"line-height:15px\">Please review our other policies, such as our pricing policy, posted on this site. These policies also govern your visit to www.<span style=\"text-transform:capitalize;\">{{compc.host}}</span> and consortium of portals. We reserve the right to make changes to our site, policies, and these Terms and Conditions of Use at any time. If any of these conditions shall be deemed invalid, void, or for any reason unenforceable, that condition shall be deemed severable and shall not affect the validity and enforceability of any remaining condition.</p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>APPLICABLE LAW</b></p><p class=\"normaltxt1\" style=\"line-height:15px\">The membership is deemed to have been entered into at Chennai, India and the laws of India will govern the membership. Disputes arising out of or in any way affecting the membership including interpretation of any of the terms are to be referred to arbitration under the Arbitration and Conciliation Act [Indian Act] at Chennai before a sole Arbitrator.</p><p align=\"center\" class=\"normaltxt1\"><b>ANNEXURE</b></p><p class=\"normaltxt1\" style=\"line-height:15px\"><b>APPLICABLE DOMAINS</b><ul type=\"square\" class=\"normaltxt1\"><font color=\"#BC0001\"><li class=\"li\"><span>{{compc.host}}</span></li></font></ul><center><a href=\"javascript:window.close();\"><b>Close</b></a></center></p></font></font></td></tr></table></td></tr></table></div></div></div>");
$templateCache.put("app/anchePedheMessage/anchePedheMessage.html","<div class=\"clr\"></div><div ng-cloak=\"\" class=\"anchepedhe-message\" layout=\"\" layout-align=\"center start\" flex=\"40\"><md-content ng-if=\"apmc.profile\"><div><h3 class=\"md-headline\">Hi Thanks for Creating Marriage Profile, We will get back to you soon regarding Profile Activation</h3></div></md-content><md-content class=\"md-padding mt60\" ng-if=\"apmc.shop\"><div><h1>Hi Thanks for Creating Marriage Shop, We will get back to you soon regarding Shop Activation</h1></div><a href=\"/login\">Login</a></md-content></div>");
$templateCache.put("app/home/home.html","<div style=\"min-width: 990px;\"><div ng-cloak=\"\" id=\"main-header\" class=\"main-header\"><div class=\"blue-bar\"><div layout=\"row\" class=\"container layout layout-row layout-fill layout-padding\"><div flex=\"\" class=\"fl flex\">For any website queries, please call @ <span>{{::main.currentSession.shop.mobileNo}}</span> <span ng-if=\"main.currentSession.shop.secondaryMobileNo\">{{::main.currentSession.shop.secondaryMobileNo}}</span></div><div flex=\"\" class=\"fr flex\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\')\"><a ng-href=\"/payment\">Upgrade Membership</a></div></div></div><div ncy-breadcrumb=\"\"></div><div id=\"user-detail\" class=\"user-detail\"><div class=\"container\"><div layout=\"row\" class=\"layout layout-row layout-fill layout-padding\"><div class=\"logo\" ng-if=\"main.currentSession.shop.logoUrl\"><img ng-src=\"{{::main.imageUrl}}{{hmc.getImagePath(main.currentSession.shop.logoUrl)}}\"></div><div flex=\"60\" class=\"element_center\" ng-if=\"main.currentSession.shop\"><h3 class=\"md-title shop-name shop-name-elipsis\"><a ng-click=\"main.changePath(\'/shop/\'+main.currentSession.shop.id, main.currentSession.shop.shopName)\">{{main.currentSession.shop.shopName}}</a><md-tooltip md-direction=\"right\">{{main.currentSession.shop.shopName}}</md-tooltip></h3></div><div flex=\"25\" ng-if=\"!main.currentSession.profileBasicInfo\"></div><div flex=\"20\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'SEARCH_PROFILE\')\" class=\"searh_profile element_center\" ui-sref=\"home.searchProfile\" layout=\"row\"><img src=\"../assets/images/new.png\" width=\"40\" height=\"40\"><div><i class=\"material-icons md-30 mr5 icon-color\">search</i></div><div><span>Search Profile</span></div></div><div flex=\"15\" class=\"profile-dropdown element_center\"><ul><li><div ng-if=\"!main.currentSession.profileBasicInfo\" layout=\"row\"><div><i class=\"material-icons md-36 blue\">account_circle</i></div><div class=\"shop-user-login-name\">{{main.currentSession.shop.shopName}}</div><div class=\"shop-caret\"><i class=\"material-icons md-24\">arrow_drop_down</i></div></div><div ng-if=\"main.currentSession.profileBasicInfo\" layout=\"row\"><img ng-src=\"{{main.imageUrl}}{{main.getImagePath(main.currentSession.profileBasicInfo.profileImages[0].originalImage)}}\" class=\"img-circle\" alt=\"Cinque Terre\" width=\"50\" height=\"50\"><div id=\"div2\" class=\"user-login-name\">{{main.currentSession.profileBasicInfo.profileName}}</div><div class=\"caret\"><i class=\"material-icons md-24\">arrow_drop_down</i></div></div><ul class=\"dropdown\"><li ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\')\"><a ng-href=\"/profile?matrimonyId={{main.currentSession.profileBasicInfo.matrimonyId}}&shopId={{main.currentSession.profileBasicInfo.shopId}}\">My Profile</a></li><li ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\')\"><a ng-href=\"/packagePlan\">My Package Plan</a></li><li ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_USER\')) && main.currentSession.permissions.includes(\'SETTINGS\')\"><a ng-href=\"/setting\">Account Settings</a></li><li ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\') && main.currentSession.permissions.includes(\'SUCCESS_STORIES\')\"><a ng-href=\"/success-story\">Success Stories</a></li><li ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'UPGRADE_MEMBERSHIP\')\"><a ng-href=\"/payment\">Upgrade Membership</a></li><li><a ng-click=\"main.logout()\">Logout</a></li></ul></li></ul></div></div></div></div></div><div class=\"clear\"></div><div class=\"main-container\"><div class=\"tool-bar-tabs\" ng-if=\"main.currentSession\"><div class=\"container\"><div ng-if=\"main.currentSession.shop || (main.currentSession.profileBasicInfo && main.currentSession.profileBasicInfo.profileStatus == \'Paid Member\')\"><div class=\"tabs\"><ul layout=\"row\" class=\"tabs-lineheight\" layout-align=\"center center\"><li class=\"prt0\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'PROFILE_MATCHES\')\"><a ui-sref=\".profileMatch\" ui-sref-active=\"tab-act\" ng-click=\"hmc.updateNotificationPopUp()\">Profile Matche\'s</a></li><li class=\"prt0\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'MYBUREAU_PROFILE\')\"><a ui-sref=\".myShopProfile\" ui-sref-active=\"tab-act\" ng-click=\"hmc.updateNotificationPopUp()\">Profiles</a></li><li class=\"prt0\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\') || main.currentSession.roles.includes(\'ROLE_USER\')) && main.currentSession.permissions.includes(\'INTEREST_DASHBOARD\')\"><a ui-sref=\".shopDashBoard\" ui-sref-active=\"tab-act\" ng-click=\"hmc.updateNotificationPopUp()\">Interest Dashboard</a> <span class=\"round green round-green-position\" ng-show=\"hmc.totalNotViewedNotification > 0\">{{hmc.totalNotViewedNotification}}</span></li><li class=\"prt0\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'SHORTLISTED_PROFILE\')\"><a ui-sref=\".profileShortListedByMe\" ui-sref-active=\"tab-act\" ng-click=\"hmc.updateNotificationPopUp()\">Profile Shortlisted By Me</a></li><li class=\"prt0\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'CREATE_PROFILE\')\"><a ui-sref=\".createProfile\" ui-sref-active=\"tab-act\" ng-click=\"hmc.updateNotificationPopUp()\">Create Profile</a></li><li class=\"prt0\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') || main.currentSession.roles.includes(\'ROLE_ADMIN\')\"><a ui-sref=\".payment\" ui-sref-active=\"tab-act\" ng-click=\"hmc.updateNotificationPopUp()\">Upgrade Membership</a></li></ul></div></div></div></div></div></div><div style=\"min-width: 990px;\" ui-view=\"\" class=\"tool-bar-form\"></div><script type=\"text/ng-template\" id=\"add-email.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"30\"> <md-dialog-content layout-padding> <p class=\"md-caption prb10 blue-color\"> <a style=\"position: absolute;right: 0;top: 0;\" ng-click=\"tc.logout()\">logout</a> </p> <h2>Please Add Your Email (Mandatory)</h2> <div class=\"outer-container1\"> <div class=\"F14\">Why You Need to Add Your Email?, You Will Be Notified When</div> <ul style=\"border-bottom: none\" class=\"F12\"> <li>* Any Member Shows Interests On You </li> <li>* Any Member Seen Your Profile</li> <li>* Any Member View Your Mobile Number</li> <li>* Any New Profile Added Based On Your Partner Preference</li> </ul> <form autocomplete=\"off\" class=\"reset-form\" name=\"addEmailForm\" novalidate=\"novalidate\" ng-submit=\"tc.addEmail(addEmailForm)\"> <api-validate></api-validate> <div ng-hide=\"tc.emailSaved\" class=\"row load\" dw-loading=\"addEmailBtn\" dw-loading-options=\"{text: \'Saving email...\'}\"> <input placeholder=\"Enter Email\" style=\"display: inline;width: 230px;\" type=\"email\" ng-model=\"tc.email\" class=\"textbox_sml\" validate-email name=\"email\" required/> <md-button type=\"submit\" class=\"md-primary\"> Save </md-button> </div> <div class=\"mt5\" style=\"color: #1E8449;font-size: 12px;\" ng-show=\"tc.emailSaved\"> <i class=\"material-icons md-24 prt5\">done</i> email saved successfully. </div> <div style=\"bottom: 20px;\" ng-messages=\"addEmailForm.email.$error\" ng-if=\"addEmailForm.email.$dirty || addEmailForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Email address is required.</span> <span class=\"error\" ng-message=\"email\">Your email address is invalid.</span> </div> </form> </div> </md-dialog-content> </md-dialog></script><script type=\"text/ng-template\" id=\"add-mobileno.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"30\"> <md-dialog-content layout-padding> <p class=\"md-caption prb10 blue-color\"> <a style=\"position: absolute;right: 0;top: 0;\" ng-click=\"tc.logout()\">logout</a> </p> <h2>Please Add Your Mobile Number (Mandatory)</h2> <div class=\"outer-container1\"> <div class=\"F14\">Why You Need to Add Your Mobile Number?, You Will Be Notified When</div> <ul style=\"border-bottom: none\" class=\"F12\"> <li>* Any Member Shows Interests On You </li> <li>* Any Member Seen Your Profile</li> <li>* Any New Profile Added Based On Your Partner Preference</li> </ul> <form autocomplete=\"off\" class=\"reset-form\" name=\"addMobileNoForm\" novalidate=\"novalidate\" ng-submit=\"tc.addMobileNo(addMobileNoForm)\"> <api-validate></api-validate> <div ng-hide=\"tc.emailSaved\" class=\"row load\" dw-loading=\"addEmailBtn\" dw-loading-options=\"{text: \'Saving email...\'}\"> <input placeholder=\"Enter Email\" style=\"display: inline;width: 230px;\" type=\"email\" ng-model=\"tc.email\" class=\"textbox_sml\" validate-email name=\"email\" required/> <md-button type=\"submit\" class=\"md-primary\"> Save </md-button> </div> <div class=\"mt5\" style=\"color: #1E8449;font-size: 12px;\" ng-show=\"tc.emailSaved\"> <i class=\"material-icons md-24 prt5\">done</i> email saved successfully. </div> <div style=\"bottom: 20px;\" ng-messages=\"addEmailForm.email.$error\" ng-if=\"addEmailForm.email.$dirty || addEmailForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Email address is required.</span> <span class=\"error\" ng-message=\"email\">Your email address is invalid.</span> </div> </form> </div> </md-dialog-content> </md-dialog></script><script type=\"text/ng-template\" id=\"mobileno-verify.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"30\"> <md-dialog-content layout-padding> <p class=\"md-caption prb10 blue-color\"> <a style=\"position: absolute;right: 0;top: 0;\" ng-click=\"main.logout()\">logout</a> </p> <h2>This Website is 100% Mobile Verified Website.</h2> <h3>For any query please call or what\'s ap to customer care number (+91) {{main.currentSession.shop.mobileNo}}.</h3> <div class=\"outer-container1 mt30\"> <div class=\"tab-content\"> <div class=\"tab-pane active\"> <h4>So Please Verify Your Mobile Number First, Before Using Our Services</h4> <div class=\"mt5\" style=\"color: #1E8449;font-size: 10px;\" ng-show=\"hmc.mobileNotVerified.verifyMobileOTPSuccess\"> <i class=\"material-icons md-24 prt5\">done</i> <span>Thanks for verifying your mobile number.</span>. </div> <form dw-loading=\"verifyMobileBtn\" dw-loading-options=\"{text: \'Sending OTP...\'}\" ng-hide=\"hmc.mobileNotVerified.showMobileOTPForm\" autocomplete=\"off\" class=\"reset-form load\" novalidate=\"novalidate\" ng-submit=\"hmc.sendOTPToMobile()\"> <div class=\"row\"> <input style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" value=\"+91 (India)\" ng-disabled=\"true\" required/> <input style=\"width: 130px;display: inline\" type=\"text\" class=\"textbox_sml\" name=\"newMobileNo\" ng-model=\"main.currentSession.profileBasicInfo.mobileNo\" ng-disabled=\"true\" numbers-only required/> <md-button type=\"submit\" class=\"md-primary\"> Send OTP </md-button> </div> </form> <form dw-loading=\"verifyMobileBtn\" dw-loading-options=\"{text: \'Verifying OTP...\'}\" ng-show=\"hmc.mobileNotVerified.showMobileOTPForm && !hmc.mobileNotVerified.verifyMobileOTPSuccess\" name=\"mobileVerifyOTPForm\" autocomplete=\"off\" class=\"reset-form load\" novalidate=\"novalidate\" ng-submit=\"hmc.verifyMobileNo(mobileVerifyOTPForm, hmc.otpNo)\"> <div class=\"mt5\" style=\"color: #1E8449;font-size: 10px;\"> OTP has sent successfully. </div> <div class=\"row\"> <input name=\"OTPNo\" placeholder=\"Enter OTP\" style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" ng-model=\"hmc.otpNo\" ng-click=\"hmc.mobileNotVerified.verifyMobileOTPFailure=false;\" numbers-only ng-minlength=\"4\" maxlength=\"4\" required/> <md-button type=\"submit\" class=\"md-primary\"> Verify OTP </md-button> </div> <div class=\"mt5\" ng-messages=\"mobileVerifyOTPForm.OTPNo.$error\" ng-if=\"mobileVerifyOTPForm.OTPNo.$dirty || mobileVerifyOTPForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">OTP Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">OTP Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter 4 numbers.</span> </div> <div class=\"error\" ng-if=\"hmc.mobileNotVerified.verifyMobileOTPFailure\">OTP didn\'t not match.</div> <!--<api-validate></api-validate>--> </form> </div> </div> </div> </md-dialog-content> </md-dialog></script><script type=\"text/ng-template\" id=\"add-profile-images.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"45\" style=\"top:-100px;\"> <md-dialog-content layout-padding> <p class=\"md-caption prb10 blue-color\"> <a style=\"position: absolute;right: 0;top: 0;\" ng-click=\"pi.logout()\">logout</a> </p> <h2>Please Add Profile Images (Mandatory)</h2> <div> <form autocomplete=\"off\" class=\"reset-form\" name=\"addImageForm\" novalidate=\"novalidate\" ng-submit=\"pi.uploadImage(addImageForm)\"> <md-card> <md-card-header> <md-card-header-text> <span class=\"md-title\">Add Profile Images (Only .jpeg, .jpg)</span> </md-card-header-text> </md-card-header> <md-card-content dw-loading=\"imageLoading\" class=\"load\" dw-loading-options=\"{text: \'Loading Image...\'}\"> <div class=\"up-buttons\"> <ul layout=\"row\" layout-align=\"space-around center\"> <li ng-repeat=\"item in pi.items\"> <div ng-if=\"item.invalidFile.$errorMessages\"> <span class=\"error\" ng-if=\"item.invalidFile.$errorMessages.minSize\">Please upload a higher resolution image.</span> <span class=\"error\" ng-if=\"item.invalidFile.$errorMessages.maxSize\">Please upload image lesser than 20MB.</span> </div> <div class=\"thumbnail\" ng-if=\"!item.photo\"> <div ng-if=\"item.image != \'./assets/images/no_image.png\'\"> <img ng-src=\"{{main.imageUrl}}{{item.image}}\"> <span ng-init=\"item.to=1\"></span> </div> <div ng-if=\"item.image == \'./assets/images/no_image.png\'\"> <img ng-src=\"{{item.image}}\"> <span ng-init=\"item.to=\'\'\"></span> </div> </div> <div class=\"thumbnail\"> <img ngf-thumbnail=\"item.photo\"> </div> <div ngf-select=\"pi.afterResizingImages($files)\" ngf-drop ng-model=\"item.photo\" ngf-model-invalid=\"item.invalidFile\" ngf-resize=\"{width: 500, height: 800}\" ngf-resize-if=\"{width: 500, height: 500}\" ngf-fix-orientation=\"true\" ngf-before-model-change=\"pi.beforeResizingImages($files)\" ngf-max-files=\"1\" accept=\"image/*\" ngf-accept=\"\'image/*\'\" ngf-pattern=\"\'.jpeg,.jpg,.png\'\" ngf-drop-available=\"dropAvailable\"> <span class=\"btn-small btn-primary cursor_default\" ng-if=\"(!item.photo) && item.to !=1\"> Select image <input type=\"file\" ng-model=\"item.to\" name=\"{{item.name}}\" style=\"visibility: hidden; position: absolute;\" required> </span> <span class=\"btn-small btn-primary cursor_default prt7\" ng-model=\"item.photo\" ng-if=\"(item.photo || item.to ==1) \" ng-click=\"item.photo=\'\';item.to=\'\'\"> Remove and Change </span> </div> </li> </ul> </div> <div layout=\"row\" layout-align=\"space-around center\"> <div flex=\"20\"> <div ng-messages=\"addImageForm.image1.$error\" ng-if=\"addImageForm.image1.$error || addImageForm.$submitted\" role=\"alert\"> <span class=\"error prr46\" ng-message=\"required\">Image 1 is compulsory.</span> </div> </div> <div flex=\"20\"> <div ng-messages=\"addImageForm.image2.$error\" ng-if=\"addImageForm.image2.$error || addImageForm.$submitted\" role=\"alert\"> <span class=\"error prr46\" ng-message=\"required\">Image 2 is compulsory.</span> </div> </div> </div> </md-card-content> </md-card> <md-card-action> <div class=\"load\" dw-loading=\"uploadImageBtn\" dw-loading-options=\"{text: \'Saving Image...\'}\" layout=\"row\" layout-align=\"center center\"> <md-button class=\"md-raised btn-new md-cornered md-primary\" type=\"submit\">Save Image</md-button> </div> </md-card-action> </form> </div> </md-dialog-content> </md-dialog></script><script type=\"text/ng-template\" id=\"canvas.tmpl.html\"><md-dialog id=\"print-section\"> <md-dialog-content> <canvas style=\"display:none\" id=\"myCanvas\" width=\"1000\" height=\"400\" style=\"border:1px solid #d3d3d3;\"> Your browser does not support the HTML5 canvas tag. </canvas> <img id=\"cImage\" alt=\"The Canvas Scream\" > </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> close </md-button> <md-button ng-click=\"print()\" class=\"md-primary\"> Print </md-button> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/login/login.html","<div class=\"newlogin\"><div class=\"first_page_container\" id=\"home\"><nav><div class=\"navigation_icon\" ng-click=\"vm.toggleMenu()\"></div><div class=\"logo_container\"><a ng-if=\"vm.reg.shop.websiteLogoUrl\" title=\"{{::vm.reg.shop.shopName}}\"><img class=\"web-logo\" ng-src=\"{{::main.imageUrl}}{{main.getImagePath(vm.reg.shop.websiteLogoUrl)}}\" alt=\"{{::vm.reg.shop.shopName}}\" title=\"{{::vm.reg.shop.shopName}}\"></a></div><div id=\"myTopnav\" class=\"nav_container\"><ul><li class=\"\"><a ng-href=\"/login#about\" title=\"ABOUT\">ABOUT</a></li><li class=\"\"><a href=\"/login#how-it-works\" title=\"HOW IT WORKS\">HOW IT WORKS</a></li><li class=\"\"><a href=\"/login#plans\" title=\"PLANS\">PLANS</a></li><li class=\"\"><a href=\"/register\" title=\"REGISTER\">REGISTER</a></li><li class=\"\"><a href=\"/login#contact\" title=\"CONTACT\">CONTACT US</a></li></ul></div></nav><div class=\"first_page_bg\"><img ng-if=\"vm.reg.shop.bannerUrl\" ng-src=\"{{::main.imageUrl}}{{main.getImagePath(vm.reg.shop.bannerUrl)}}\" class=\"block home_page_img\"> <img ng-if=\"!vm.reg.shop.bannerUrl\" src=\"../assets/14924313051491916240South-india-Bride4.jpg\" class=\"block home_page_img\"><div class=\"first_page_text\"></div><div align=\"center\" class=\"search-form-allign\"><div class=\"heading_wrapper\" style=\"margin-top: -10px;\"><div class=\"paddt20\" style=\"font:32px arial; text-transform:uppercase; color:#363636; opacity:0.90;filter: alpha(opacity=90); text-align:center;\"><h2 class=\"color-wh\" style=\"font: 34px arial;text-transform: capitalize;color: #363636;opacity: 0.90;filter: alpha(opacity=90);text-align: center;\">Find Your Perfect Partner</h2></div><div class=\"paddt20 paddb20\"><div class=\"paddb10\" id=\"quicksearchform\"><form class=\"prml110\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"vm.quickSearch()\" name=\"quicksearchform\"><div class=\"fleft\"><div class=\"fleft paddb10\"><div class=\"fleft paddt10\"><div class=\"fleft\" ng-click=\"vm.quickSrch.gender=\'Female\'\"><label for=\"Female\"><input type=\"radio\" ng-model=\"vm.quickSrch.gender\" checked=\"\" style=\"vertical-align:middle; display:inline; float:none; margin:-2px 10px 0px 0px;\" value=\"Female\" name=\"GENDER\"> <span class=\"clr7 color-wh\" style=\"font:15px arial;\">Bride</span></label></div><div class=\"fleft paddl30\" ng-click=\"vm.quickSrch.gender=\'Male\'\"><label for=\"Male\"><input type=\"radio\" ng-model=\"vm.quickSrch.gender\" style=\"vertical-align:middle; display:inline; float:none; margin:-2px 10px 0px 0px;\" value=\"Male\" name=\"GENDER\"> <span class=\"clr7 color-wh\" style=\"font:15px arial;\">Groom</span></label></div></div><div style=\"padding-top:10px;\" class=\"color-wh fleft paddl30 hdtxt1 clr7\">Age</div><div class=\"fleft paddl10\"><input type=\"text\" ng-model=\"vm.quickSrch.fAge\" size=\"2\" class=\"hp-quickform-txtfield\" style=\"\" maxlength=\"2\"></div><div style=\"padding-top:10px;\" class=\"color-wh fleft paddl10 hdtxt1 clr7\">to</div><div class=\"fleft paddl10\"><input type=\"text\" ng-model=\"vm.quickSrch.tAge\" size=\"2\" class=\"hp-quickform-txtfield\" style=\"\" maxlength=\"2\"></div></div><div class=\"fleft paddl30\"><div class=\"fleft paddl10 select-arw\"><span style=\"text-align:center;\"><select ng-model=\"vm.quickSrch.martialStatus\" style=\"width: 238px; padding-left: 10px; visibility: visible;\" size=\"1\"><option value=\"neverMarried\">Never Married</option><option value=\"married\">Divorced/ Widow(er)/ Awaiting Divorce</option></select><span id=\"CASTE_LOADING_IMAGE\"></span> <input type=\"hidden\" name=\"COUNTRYRIGHT\" value=\"0\"></span></div></div><div class=\"fleft paddl30\"><div class=\"fleft paddl10 select-arw\"><span style=\"text-align:center;\"><select ng-model=\"vm.quickSrch.caste\" style=\"width: 238px; padding-left: 10px; visibility: visible;\" size=\"1\"><option value=\"Any\" selected=\"\">Caste / Division - Any</option><option value=\"casteNoBar\">Caste No Bar</option><option ng-value=\"caste\" ng-repeat=\"caste in vm.reg.shop.expertiseCaste | orderBy\">{{caste}}</option></select></span></div></div><div class=\"fleft paddl30\"><input type=\"hidden\" name=\"orgform_val\" value=\"set\"> <input type=\"submit\" class=\"hp-button small\" value=\"Search\" style=\"width:93px; height:35px; text-transform:uppercase;\"></div><div class=\"clear\"></div></div></form></div><div class=\"clear\"></div></div></div></div><div class=\"md-padding account-form-allign\" flex=\"\" flex-md=\"20\"><div class=\"text-center frm_hdr1\">If you already a member. Please Login / <a ui-sref=\"account.register\" ng-if=\"vm.shopName\">Register for New User</a></div><form class=\"login mt20\" method=\"post\" id=\"loginForm\" name=\"loginForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"vm.authenticate()\"><div><span class=\"error btm-10px\" ng-show=\"errorStatus\">Please enter valid Username and Password.</span></div><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>Enter Registered Mobile Number / Matrimony ID</label> <input type=\"text\" ng-model=\"vm.user.name\" name=\"username\" required=\"\" maxlength=\"50\"></md-input-container></div><div ng-messages=\"loginForm.username.$error\" ng-if=\"loginForm.username.$dirty || loginForm.$submitted\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Mobile/Email is compulsory.</span></div><div layout=\"\"><md-input-container flex=\"\"><label>Password</label> <input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" ng-maxlength=\"30\" required=\"\"></md-input-container></div><div ng-messages=\"loginForm.password.$error\" ng-if=\"loginForm.password.$dirty || loginForm.$submitted\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Password is compulsory.</span></div><div layout=\"row\" layout-align=\"space-between center\"><div class=\"sign-up\"><a ui-sref=\"account.register\" ng-if=\"vm.shopName\">Register for New User</a></div><div class=\"forgot-password-text-new\"><a ui-sref=\"account.forgotPassword\">Forgot Password?/Create a new password</a></div></div><div class=\"load\" dw-loading=\"loginBtn\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Secure Login</md-button></div></form></div></div><div class=\"second_page_container\" id=\"about\"><div class=\"second_page_inner\"><div class=\"heading_wrapper\"><div class=\"page_heading_center\"><span class=\"purple\">{{vm.reg.shop.shopName}}</span> is a personalised matchmaking service brought to you by {{vm.toUpperCaseUrl(vm.reg.shop.websiteUrl)}}</div></div><div class=\"personalised_box_container\" style=\"height: 352px;\"><div class=\"personalised_box\" style=\"height: 295px; top: 0%; opacity: 1;\"><span class=\"assisted_icon\"></span><div class=\"box_heading\">Dedicated Advisor</div><div class=\"box_content\">Whether you are overwhelmed by the number of matches or unsure of how to progress, your dedicated Service Advisor will help you in the process.</div></div><div class=\"filler_div\"></div><div class=\"personalised_box_second\" style=\"height: 295px; top: 0%; opacity: 1;\"><span class=\"convenient_icon\"></span><div class=\"box_heading\">Handpicked Matches</div><div class=\"box_content\">Based on your preferences, the best matches are handpicked and sent to you for approval after going through thousands of profiles.</div></div><div class=\"filler_div\"></div><div class=\"personalised_box_third\" style=\"height: 295px; top: 0%; opacity: 1;\"><span class=\"personalised_icon\"></span><div class=\"box_heading\">Personal Introductions</div><div class=\"box_content\">Your Select Service Advisor will initiate communication with approved matches and organise meetings at a convenient time and location.</div></div></div></div></div><div class=\"third_page_container\" id=\"how-it-works\"><div class=\"third_page_inner\"><div class=\"howitwork_heading\">Your dedicated Service Advisor follows a meticulous step by step process to find you a <span class=\"red\">suitable match</span>.</div><div class=\"white_bdr\" style=\"height: 774px; overflow: hidden;\"><div class=\"tooltip_container_first\" style=\"left: -0.000774503%; opacity: 1;\"><div class=\"left_tooltip\"><div class=\"tooltip_right_arrow\"></div><div class=\"tooltip_left\"><span class=\"understanding_requirements_icon\"></span></div><div class=\"tooltip_right\"><div class=\"tooltip_heading\">Understanding Requirements</div><p>Your Select Service Advisor interacts with you to understand you &amp; your expectations from a life partner.</p></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div><div class=\"tooltip_container_red_first\" style=\"left: 49.4742%; opacity: 1;\"><div class=\"right_tooltip\"><div class=\"tooltip_left_arrow\"></div><div class=\"tooltip_left\"><span class=\"profile_creation_icon\"></span></div><div class=\"tooltip_right\"><div class=\"tooltip_heading\">Profile Creation</div><p>The feedback from the interaction is used to enhance your {{vm.toUpperCaseUrl(vm.reg.shop.websiteUrl)}} profile.</p></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div><div class=\"animation\"></div><div class=\"tooltip_container_second\" style=\"left: -0.000774503%; opacity: 1;\"><div class=\"left_tooltip\"><div class=\"tooltip_right_arrow\"></div><div class=\"tooltip_left\"><span class=\"finding_matches_icon\"></span></div><div class=\"tooltip_right\"><div class=\"tooltip_heading\">Finding Matches</div><p>The best matches are handpicked after screening thousands of profiles and are sent to you for approval.</p></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></div><div class=\"tooltip_container_red_second\" style=\"left: 49.4742%; opacity: 1;\"><div class=\"right_tooltip\"><div class=\"tooltip_left_arrow\"></div><div class=\"tooltip_left\"><span class=\"connecting_prospects_icon\"></span></div><div class=\"tooltip_right\"><div class=\"tooltip_heading\">Connecting with Prospects</div><p>Your Select Service Advisor connects with the prospects you are interested in &amp; obtains their feedback.</p></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div><div class=\"tooltip_container_third\" style=\"left: -0.000774503%; opacity: 1;\"><div class=\"left_tooltip\"><div class=\"tooltip_right_arrow\"></div><div class=\"tooltip_left\"><span class=\"arranging_meetings_icon\"></span></div><div class=\"tooltip_right\"><div class=\"tooltip_heading\">Arranging Meetings</div><p>Once both parties show mutual interest, your Select Service Advisor organizes a meeting at a convenient time and location.</p></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></div></div></div></div><div class=\"second_page_container\" id=\"contact\"><div class=\"second_page_inner\"><div class=\"heading_wrapper\"><div class=\"page_heading_center\"><span class=\"purple\">Contact Us.</span></div><div><span style=\"font-weight:bold\">Email ID:</span> {{::vm.reg.shop.email}}</div><div><span style=\"font-weight:bold\">Contact number:</span> {{::vm.reg.shop.mobileNo}}<span ng-if=\"vm.reg.shop.secondaryMobileNo\">, {{::vm.reg.shop.secondaryMobileNo}}</span></div><div><span style=\"font-weight:bold\">Address:</span> {{::vm.reg.shop.address.location}}</div></div></div></div><div class=\"fifth_page_container\" id=\"plans\"><div class=\"fifth_page_inner\"><div class=\"membership_heading\">Plans and Pricing</div><div class=\"membership_plan_bg\"><div class=\"membership_container\" ng-repeat=\"plan in ac.packageOptions | filter: {id: \'!\' + \'Free\'} | filter: {forMarriageBureau: \'!\' + true}\"><div class=\"membership_orange\" style=\"padding: 0 0 0.79%\">{{plan.category.noOfDaysValid}} days</div><div style=\"font-weight: 100; font-size: 1em; color: #f9991d;\">{{plan.category.noOfAskMobileNo}} Contacts</div><span class=\"rupees_icon_wrapper\"><span class=\"rupees_icon_white\"></span></span> <span class=\"membership_price\">{{plan.value}}/-</span></div><div class=\"clearfix\"></div></div><div class=\"benefit_container\"><span class=\"benefit_text\">{{vm.reg.shop.shopName}} Benefits</span></div><div class=\"feature_pad\"><div class=\"feature_container\"><div class=\"feature_left\"><span class=\"personalised_attention\"></span></div><div class=\"feature_right\">Personalised attention from a highly experienced &amp; qualified Select Service Advisor.</div><div class=\"clearfix\"></div></div><div class=\"feature_container\"><div class=\"feature_left\"><span class=\"profile_enhancement_icon\"></span></div><div class=\"feature_right\">Profile enhancement on {{vm.toUpperCaseUrl(vm.reg.shop.websiteUrl)}} to help you put your best foot forward.</div><div class=\"clearfix\"></div></div><div class=\"feature_container\"><div class=\"feature_left\"><span class=\"partner_search_icon\"></span></div><div class=\"feature_right\">Partner search driven by Select Service Advisor expertise combined with superior technology.</div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div><div class=\"feature_container\"><div class=\"feature_left\"><span class=\"handpick_icon\"></span></div><div class=\"feature_right\">Carefully handpicked matches that meet your unique partner preferences.</div><div class=\"clearfix\"></div></div><div class=\"feature_container\"><div class=\"feature_left\"><span class=\"telephone_icon\"></span></div><div class=\"feature_right\">Quicker responses from prospects to accelerate your partner search.</div><div class=\"clearfix\"></div></div><div class=\"feature_container\"><div class=\"feature_left\"><span class=\"meeting_icon\"></span></div><div class=\"feature_right\">Introductions and Meetings with interested prospects to take things forward.</div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></div></div></div><div class=\"footer_bg\"><div class=\"footer_inner\"><div class=\"footer_right\">{{vm.toUpperCaseUrl(vm.reg.shop.websiteUrl)}} Matchmaking Services Provider™<br><br><span><a href=\"/terms\" target=\"_blank\" title=\"Terms of Use\" class=\"blue\">Terms of Use</a>. <a href=\"/privacy-policy\" target=\"_blank\" title=\"Privacy Policy\" class=\"blue\">Privacy Policy</a>.</span></div><div class=\"clearfix\"></div><br><div class=\"hidden_div\"></div><div class=\"layer\" id=\"need_help_pos\" style=\"display:none;\"><a href=\"javascript:void(0);\" class=\"layer_close\"></a><div class=\"clearfix\"></div><div class=\"layer_content\"></div></div></div></div></div></div>");
$templateCache.put("app/login/profileList.html","");
$templateCache.put("app/main/main.html","<div ui-view=\"\"></div>");
$templateCache.put("app/otherShopOrIndividual/otherShopProfileOrIndividualProfile.html","<div ng-cloak=\"\" class=\"shop-profile\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><md-content flex=\"20\" class=\"ml10 mr15 ovf-hidden\"><div class=\"leftmenu\" ng-if=\"spc.shopProfileCount\"><ul><h1>Profile Created</h1><li><span>Within a day</span> <span class=\"badge bg-info\">{{::spc.shopProfileCount.withInDay}}</span></li><li><span>Within a week</span> <span class=\"badge bg-info\">{{::spc.shopProfileCount.withInWeek}}</span></li><li><span>Within a month</span> <span class=\"badge bg-info\">{{::spc.shopProfileCount.withInMonth}}</span></li></ul></div><div class=\"main-container\" layout=\"row\" flex=\"\" ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')\"><md-sidenav class=\"main-sidenav md-sidenav-left\" md-component-id=\"navigation-drawer\" md-is-locked-open=\"true\" layout=\"column\"><md-content md-scroll-y=\"\" flex=\"\" layout=\"column\"><md-sidemenu locked=\"true\"><md-sidemenu-group><md-subheader class=\"md-no-sticky\">Filter</md-subheader><md-sidemenu-content md-heading=\"Search By Name\" md-arrow=\"true\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><form class=\"reset-form\" name=\"searchNameForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"spc.searchProfile()\"><div class=\"row\"><input placeholder=\"Enter Name\" style=\"width: 254px;\" class=\"textbox_sml\" name=\"regex\" type=\"text\" ng-model=\"spc.regex\"></div><div layout=\"row\" class=\"mt5\" style=\"margin-bottom: 10px;margin-top: -23px;\" flex=\"80\"><md-button class=\"md-raised md-cornered\" type=\"submit\" style=\"color: #ffff;background-color: #0CB863\">Search</md-button><md-button class=\"md-raised md-cornered\" ng-click=\"spc.regex=\'\';searchNameForm[\'$submitted\']=false; spc.searchProfile()\">Clear</md-button></div><div ng-if=\"searchNameForm[\'$submitted\'] && spc.regex == \'\'\" ng-init=\"searchNameForm[\'$submitted\']=false; spc.searchProfile()\"></div></form></md-sidemenu-content><a style=\"position: relative;right: -16px;\" ng-click=\"spc.clearAllFilters()\">clear all filters</a><md-sidemenu-content md-heading=\"Profile Status\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'profileStatus\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Gender\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'gender\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Veg / Non Veg\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'vegOrNonVeg\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Martial Status\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'martialStatus\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Caste No Bar\" md-arrow=\"true\" ng-if=\"f.id == \'casteNoBar\'\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\' | filter:{ name: true }\"><span class=\"elips mt10\">Caste No Bar</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Mother Tongue\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'motherTongue\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Religion\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'religion\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Caste\" md-arrow=\"true\" ng-if=\"f.id == \'caste\'\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Sub Caste\" md-arrow=\"true\" ng-if=\"f.id == \'subCaste\'\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Age\" md-arrow=\"true\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><div layout=\"column\" flex=\"\"><div layout=\"\" flex=\"\" class=\"mt20\"><md-input-container flex=\"50\"><label>From</label><md-select ng-model=\"spc.fromAge\"><md-option ng-repeat=\"option in spc.ageOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>To</label><md-select ng-model=\"spc.toAge\"><md-option ng-repeat=\"option in spc.ageOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div class=\"load\" dw-loading=\"ageSubmit\" layout=\"row\" flex=\"30\"><md-button class=\"md-raised md-cornered\" ng-click=\"spc.submitAge()\" style=\"color: #ffff;background-color: #0CB863;width: 108px;margin-bottom: 10px;\">Submit</md-button></div></div></md-sidemenu-content><md-sidemenu-content md-heading=\"Height\" md-arrow=\"true\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><div layout=\"column\" flex=\"\"><div layout=\"\" flex=\"\" class=\"mt20\"><md-input-container flex=\"50\"><label>From</label><md-select ng-model=\"spc.fromHeight\"><md-option ng-repeat=\"option in spc.heightOptions.values\" ng-value=\"option.category\">{{::option.value}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>To</label><md-select ng-model=\"spc.toHeight\"><md-option ng-repeat=\"option in spc.heightOptions.values\" ng-value=\"option.category\">{{::option.value}}</md-option></md-select></md-input-container></div><div class=\"load\" dw-loading=\"ageSubmit\" layout=\"row\" flex=\"30\"><md-button class=\"md-raised md-cornered\" ng-click=\"spc.submitHeight()\" style=\"width: 108px; margin-bottom: 10px;color: #ffff;background-color: #0CB863\">Submit</md-button></div></div></md-sidemenu-content><md-sidemenu-content md-heading=\"Highest Education\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'highestEducation\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Employed In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'employedIn\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Occupation\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'occupation\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Country Living In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'currentLivingCountry\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"State Living In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'currentLivingState\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"City Living In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'currentLivingCity\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Star\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'star\') > -1\" ng-repeat=\"f in spc.filter\" ng-class=\"{checkmark: spc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"spc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content></md-sidemenu-group></md-sidemenu></md-content></md-sidenav></div></md-content><md-content dw-loading=\"otherShopProfiles\" class=\"md-padding mh-120\" flex=\"55\" layout=\"row\" layout-wrap=\"\"><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div><div flex=\"50\" ng-if=\"spc.profiles.length == 0\" flex-offset=\"30\"><h1>No Profiles are there</h1></div><div flex=\"50\" dir-paginate=\"profile in spc.profiles | itemsPerPage: spc.pageSize\" current-page=\"currentPage\" total-items=\"spc.total\"><md-card ng-init=\"spc.setCurrentImage(1, profile)\"><md-card-header><md-card-header-text><span class=\"md-title\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && !main.currentSession.packagePlan.paidMemberExpired\"><a ng-click=\"spc.changePath(\'home.profile\', profile.profileName, profile.matrimonyId, {matrimonyId: profile.matrimonyId, shopId: main.currentSession.shop.id, isOtherBureau: true})\">{{profile.profileName}}</a> <span ng-if=\"profile.martialStatus.indexOf(\'Never Married\') < 0\">({{::profile.martialStatus}})</span></span> <span class=\"md-title\" ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')\"><a ng-click=\"spc.changePath(\'home.profile\', profile.profileName, profile.matrimonyId, {matrimonyId: profile.matrimonyId, shopId: main.currentSession.shop.id, isOtherBureau: true})\">{{profile.profileName}}</a> <span ng-if=\"profile.martialStatus.indexOf(\'Never Married\') < 0\">({{::profile.martialStatus}})</span></span> <span class=\"md-caption\" ng-if=\"profile.shopId\"><div layout=\"row\" flex=\"\"><span flex=\"50\" ng-if=\"!main.currentSession.roles.includes(\'ROLE_SUPER_ADMIN\')\">Marriage Bureau Name</span> <span flex=\"80\" ng-if=\"main.currentSession.roles.includes(\'ROLE_SUPER_ADMIN\')\">Marriage Bureau Name <a>{{::profile.shopName}}</a></span> <span flex=\"45\" ng-if=\"!main.currentSession.roles.includes(\'ROLE_SUPER_ADMIN\')\"><img src=\"../assets/images/shop-name-lock.gif\" width=\"100\" height=\"100\" alt=\"Washed Out\"></span> <span flex=\"5\" class=\"mtm3\"><i class=\"material-icons md-24\">lock</i></span></div><span class=\"md-caption\" ng-if=\"!profile.shopId\">Individual Profile</span> <span class=\"md-caption pt6\" ng-if=\"profile.profileStatus == \'Paid Member\'\"><div class=\"TAG\"><div class=\"text\" style=\"background-color:#0DD4AC;\">+ {{:: profile.profileStatus}}</div><div class=\"img\"></div></div></span> <span class=\"md-caption date_time_format\" ng-if=\"profile.lastActive\">Last Active: {{profile.lastActive | date:\"dd MMMM yyyy \'at\' h:mma\"}}</span></span></md-card-header-text></md-card-header><md-card-content layout-wrap=\"\" style=\"padding: 0;\"><div style=\"position: relative;\" class=\"sc-gyhKFA\" data-test-selector=\"profile_photo_wrapper\"><div class=\"just-joined\" ng-show=\"spc.utilService._isRecentProfile(profile.profileCreatedOn)\"></div><div class=\"sc-cMOKGX eGkYNO\" type=\"profile\"><div class=\"sc-kYnif ktdCay\"><div class=\"sc-iclvYL igwvZs\" type=\"profile\"><div class=\"sc-chYKBT\" ng-style=\"profile.className\"></div><nav class=\"sc-mWPeY jfhRQb\" type=\"profile\" ng-if=\"profile.profileImages.length>1\"><button class=\"sc-beROAQ fvvGZu\" icon=\"prev\" ng-click=\"spc.setCurrentImage(profile.cur-1, profile)\"></button><div class=\"sc-bchHHi hKgVQm\">{{profile.cur}} of {{::profile.profileImages.length}}</div><button class=\"sc-beROAQ jUUwmB\" icon=\"next\" ng-click=\"spc.setCurrentImage(profile.cur+1, profile)\"></button></nav></div><div data-test-selector=\"FreeA plan_free\" class=\"sc-bMuqKn dEAsKZ\"></div><div class=\"sc-eQvJSV Xjvfb\"></div></div></div></div><div style=\"padding: 5px 5px 0 5px;\"><span class=\"col1\">Age:</span> <span class=\"col2\" ng-bind=\"main.getAge(profile.dob)\"></span> <span class=\"col1\">, Height:</span> <span class=\"col2\">{{profile.height.value}},</span> <span class=\"col1\">Caste:</span> <span class=\"col2\">{{profile.caste}} <span ng-if=\"profile.casteNoBar\" class=\"col2\">(Caste No Bar)</span>,</span> <span ng-show=\"(profile.subCaste && profile.subCaste.indexOf(\'Not Specified\') < 0) || profile.otherSubCaste\"><span class=\"col1\">Sub Caste:</span> <span class=\"col2\" ng-show=\"profile.subCaste.indexOf(\'Not Specified\') < 0 && profile.subCaste.indexOf(\'Other\') < 0\">{{::profile.subCaste}} <span ng-if=\"profile.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span> <span class=\"col2\" ng-show=\"profile.otherSubCaste\">{{::profile.otherSubCaste}},</span></span> <span class=\"col1\">Martial Status:</span> <span class=\"col2\">{{::profile.martialStatus}},</span> <span ng-show=\"profile.star && profile.star.indexOf(\'Not Specified\') < 0\"><span class=\"col1\" ng-show=\"profile.star && profile.star.indexOf(\'Not Specified\') < 0\">Star:</span> <span class=\"col2\">{{::profile.star}} ,</span></span><span class=\"col1\">Education:</span> <span class=\"col2\">{{::profile.highestEducation}},</span> <span class=\"col1\" ng-show=\"profile.occupation\">Working as:</span> <span class=\"col2\" ng-if=\"profile.occupation\">{{::profile.occupation}},</span> <span ng-show=\"profile.annualIncome && profile.annualIncome > 0\"><span class=\"col1\">Annual Income:</span> <span class=\"col2\">{{::main.getFormatAmount(profile.annualIncome)}},</span></span> <span ng-if=\"profile.caste.indexOf(\'Arya Vysya\') > -1 && profile.gothram\"><span class=\"col1\">Swa Gothra(m):</span> <span class=\"col2\">{{::profile.gothram}},</span></span> <span ng-if=\"profile.caste.indexOf(\'Arya Vysya\') > -1 && profile.mathula\"><span class=\"col1\">Mathula:</span> <span class=\"col2\">{{::profile.mathula}},</span></span> <span class=\"col1\" ng-if=\"profile.currentLivingCountry && profile.currentLivingCountry.indexOf(\'India\') < 0\"><span>Working/Living in Country:</span> <span class=\"col2\">{{::profile.currentLivingCountry}},</span></span> <span class=\"col1\" ng-if=\"profile.currentLivingState\"><span>Working/Living in State:</span> <span class=\"col2\">{{::profile.currentLivingState}},</span></span> <span class=\"col1\" ng-if=\"profile.currentLivingCity\"><span>Working/Living in City/Near City:</span> <span class=\"col2\">{{::profile.currentLivingCity}}</span></span></div></md-card-content><md-card-actions layout=\"row\"><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && !main.currentSession.packagePlan.paidMemberExpired\"><li class=\"afm\"><a href=\"\" ng-click=\"spc.changePath(\'home.profile\', profile.profileName, profile.matrimonyId, {matrimonyId: profile.matrimonyId, shopId: profile.shopId})\">Click here to See More Information or Send Interest</a></li></ul><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"spc.shareProfile(profile, main.currentSession.shop,$event)\"></li></ul><span ng-if=\"main.currentSession.packagePlan.paidMemberExpired\"><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></md-card-actions></md-card></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"spc.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-content></div>");
$templateCache.put("app/packagePlan/packagePlan.html","<div ng-cloak=\"\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content class=\"md-padding\" flex=\"50\"><div flex=\"\" layout=\"column\"><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Member Package</span></md-card-header-text></md-card-header><md-card-content><ul><li class=\"attributes h-25\" layout=\"row\"><span class=\"col1 w-250\">Member Package Plan</span> <span class=\"col2\">{{main.currentSession.packagePlan.memberPackage.id}}</span></li><li class=\"attributes h-25\" layout=\"row\"><span class=\"col1 w-250\">Package Amount</span> <span class=\"col2\">{{main.currentSession.packagePlan.memberPackage.value}}</span></li><li class=\"attributes h-25\" layout=\"row\"><span class=\"col1 w-250\">Offer Pacakage</span> <span class=\"col2\">{{main.currentSession.packagePlan.offeredPackage}}</span></li><li class=\"attributes h-25\" layout=\"row\"><span class=\"col1 w-250\">No. of Interest Remaining</span> <span class=\"col2\">{{main.currentSession.packagePlan.noOfIntererestRemaining}}</span></li><li class=\"attributes h-25\" layout=\"row\"><span class=\"col1 w-250\">No. of Mobile Number Request Remaining</span> <span class=\"col2\">{{main.currentSession.packagePlan.noOfMobileNoRequestRemaining}}</span></li><li class=\"attributes h-25\" layout=\"row\" ng-show=\"main.currentSession.packagePlan.memberPackage.value != \'Free\'\"><span class=\"col1 w-250\">Paid Membership Expires On</span> <span class=\"col2\">{{main.currentSession.packagePlan.paidMemberExpiresOn | date:\"dd MMMM yyyy\"}}</span></li><li class=\"attributes h-25\" layout=\"row\"><span class=\"col1 w-250\">No. of Days Valid</span> <span class=\"col2\">{{main.currentSession.packagePlan.noOfDaysValid}}</span></li><li class=\"attributes h-25\" layout=\"row\" ng-show=\"main.currentSession.packagePlan.memberPackage.value != \'Free\'\"><span class=\"col1 w-250\">Paid Membership Expired</span> <span class=\"col2\" ng-if=\"main.currentSession.packagePlan.paidMemberExpired\">Yes</span> <span class=\"col2\" ng-if=\"!main.currentSession.packagePlan.paidMemberExpired\">No</span></li></ul></md-card-content></md-card></div></md-content></div>");
$templateCache.put("app/profile/createUpdatePartnerPreference.html","<div flex=\"\" layout=\"row\" id=\"partnerPrefer\" layout-align=\"center center\" class=\"partnerPrefer\" ng-click=\"setActiveElement()\"><md-content dw-loading=\"partnerPrefer\" flex=\"60\" layout-padding=\"\"><div ng-if=\"cuppc.editPartnerPrefInfo\" style=\"height: 18px;margin-top: -25px;margin-left: -14px;\"><md-button style=\"min-height: 18px !important;\" class=\"md-hue-1\" ui-sref=\"home.profile({matrimonyId: cuppc.profile.matrimonyId, shopId: cuppc.profile.shopId})\"><span><i class=\"material-icons md-24 edit\">arrow_back</i></span></md-button></div><form method=\"post\" id=\"preferenceForm\" name=\"preferenceForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"cuppc.createUpdatePartnerPreference()\"><md-card><md-card-content><h1>Partner Preference</h1><div layout=\"\" layout-sm=\"column\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Age</div><div flex=\"70\" style=\"padding: 0 !important;margin-top: -16px;\"><rzslider rz-slider-model=\"cuppc.ageSlider.minValue\" rz-slider-high=\"cuppc.ageSlider.maxValue\" rz-slider-options=\"cuppc.ageSlider.options\"></rzslider></div></div><div layout=\"\" layout-sm=\"column\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Height</div><div flex=\"70\" style=\"padding: 0 !important;margin-top: -16px;\"><rzslider rz-slider-model=\"cuppc.heightSlider.minValue\" rz-slider-high=\"cuppc.heightSlider.maxValue\" rz-slider-options=\"cuppc.heightSlider.options\"></rzslider></div></div><div layout=\"\" layout-sm=\"column\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Mother Tongue</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select multiple=\"\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\" ng-model=\"cuppc.partnerPreference.motherTonguePref\" placeholder=\"Search for a mother tongue..\" name=\"motherTonguePref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a mother tongue..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Mother Tongue\"><ul ng-repeat=\"(key, values) in cuppc.partnerPreferenceTemplate.motherTongueOptions.values | groupBy:\'category\'\"><li ng-if=\"cuppc.checkIfExist(cuppc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:cuppc.searchTerm\" ng-value=\"option.value\" ng-click=\"cuppc.setMotherTonguePref(option.value)\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div ng-if=\"preferenceForm.motherTonguePref.$dirty || preferenceForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"preferenceForm.motherTonguePref.$error.required\">Mother Tongue is compulsory.</span></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Martial Status</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Search for a matial status..\" multiple=\"\" ng-model=\"cuppc.partnerPreference.martialStatusPref\" name=\"martialStatusPref\"><md-option ng-repeat=\"option in cuppc.partnerPreferenceTemplate.martialStatusOptions.values\" ng-value=\"option.value\" ng-click=\"cuppc.setMartialStatusPref(option.value)\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-if=\"preferenceForm.martialStatusPref.$dirty || preferenceForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"preferenceForm.martialStatusPref.$error.required\">Martial Status is compulsory.</span></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Caste</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select ng-disabled=\"!cuppc.casteNoBar\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\" multiple=\"\" ng-model=\"cuppc.partnerPreference.castePref\" name=\"castePref\" placeholder=\"Search for a caste..\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a caste..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"caste\"><md-option ng-repeat=\"option in main.currentSession.shop.expertiseCaste | filter:cuppc.searchTerm\" ng-value=\"option\" ng-click=\"cuppc.setCastePref(option)\">{{option}}</md-option></md-optgroup></md-select></md-input-container></div><div flex-offset=\"25\"><h6>If you want get enable caste dropdown,options please update profile by selecting casteNoBar checkbox.</h6></div><div ng-if=\"preferenceForm.castePref.$dirty || preferenceForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"preferenceForm.castePref.$error.required\">Caste is compulsory.</span></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\" ng-show=\"!cuppc.casteNoBar && !cuppc.subCasteNoBar && cuppc.subCasteOptions && cuppc.partnerPreference.castePref.length == 1\"><div flex=\"25\" class=\"labelhead\">Sub Caste</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select subcaste..\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\" multiple=\"\" ng-model=\"cuppc.partnerPreference.subCastePref\" name=\"subCastePref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a subcaste..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste\"><md-option ng-repeat=\"option in cuppc.subCasteOptions.values | filter:cuppc.searchTerm | filter: {value: \'!\' + \'Other\'}\" ng-value=\"option.value\" ng-click=\"cuppc.setSubCastePref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Education</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select education..\" multiple=\"\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\" ng-model=\"cuppc.partnerPreference.highestEducationPref\" name=\"highestEducationPref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Highest Education\"><ul ng-repeat=\"(key, values) in cuppc.partnerPreferenceTemplate.highestEducationPrefOptions.values | groupBy:\'category\'\"><li ng-if=\"cuppc.checkIfExist(cuppc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:cuppc.searchTerm\" ng-value=\"option.value\" ng-click=\"cuppc.setHighestEducationPref(option.value)\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Employed In</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select employed in..\" multiple=\"\" ng-model=\"cuppc.partnerPreference.employedInPref\" name=\"employedInPref\"><md-option ng-repeat=\"option in cuppc.partnerPreferenceTemplate.employedInPrefOptions.values\" ng-value=\"option.value\" ng-click=\"cuppc.setEmployedInPref(option.value)\">{{option.value}}</md-option></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Occupation</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select multiple=\"\" placeholder=\"Select occupation..\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\" ng-model=\"cuppc.partnerPreference.occupationPref\" name=\"occupationPref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a occupation..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Occupation\"><ul ng-repeat=\"(key, values) in cuppc.partnerPreferenceTemplate.occupationPrefOptions.values | groupBy:\'category\'\"><li ng-if=\"cuppc.checkIfExist(cuppc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:cuppc.searchTerm\" ng-value=\"option.value\" ng-click=\"cuppc.setOccupationPref(option.value)\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div class=\"labelhead\" flex=\"25\">Annual Income From</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select annual income..\" ng-model=\"cuppc.partnerPreference.annualIncomePreFrom\" name=\"annualIncomePreFrom\"><md-option ng-repeat=\"option in cuppc.partnerPreferenceTemplate.annualIncomePrefOptions.values\" ng-value=\"option.category\">{{option.value}}</md-option></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">Country</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select country..\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\" multiple=\"\" ng-model=\"cuppc.partnerPreference.countryPref\" name=\"countryPref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a country..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Partner Living/Working Country\"><md-option ng-repeat=\"option in cuppc.partnerPreferenceTemplate.countryOptions.values | filter:cuppc.searchTerm\" ng-value=\"option.value\" ng-click=\"cuppc.setCountryPref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><div flex=\"25\" class=\"labelhead\">State in India</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select state..\" multiple=\"\" ng-model=\"cuppc.partnerPreference.statePref\" name=\"statePref\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a state..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Partner Living/Working State in India\"><md-option ng-repeat=\"option in cuppc.stateOptions | filter:cuppc.searchTerm\" ng-value=\"option.value\" ng-click=\"cuppc.setStatePref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\" ng-if=\"cuppc.partnerPreference.countryPref.indexOf(\'India\') > -1 && cuppc.partnerPreference.statePref.indexOf(\'Any\') == -1 && cuppc.partnerPreference.statePref.length > 0\"><div flex=\"25\" class=\"labelhead\">City</div><md-input-container flex=\"70\" style=\"padding: 0 !important;margin-top: -10px;\"><label></label><md-select placeholder=\"Select city..\" multiple=\"\" ng-model=\"cuppc.partnerPreference.cityPref\" name=\"cityPref\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cuppc.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cuppc.searchTerm\" type=\"search\" placeholder=\"Search for a city..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste division(optional)\"><md-option ng-repeat=\"option in cuppc.cityOptions | filter:cuppc.searchTerm\" ng-value=\"option.value\" ng-click=\"cuppc.setCityPref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-sm=\"column\" layout=\"row\" class=\"mt45\"><md-input-container class=\"md-block\" flex=\"\"><label>Some Words About Partner</label> <textarea ng-model=\"cuppc.partnerPreference.aboutPartner\" name=\"aboutPartner\" columns=\"1\"></textarea></md-input-container></div><div class=\"error\" ng-if=\"preferenceForm.$submitted\"><div ng-if=\"preferenceForm.$error.required.length > 0\"><span>You have not filled required fields. Please go and fill it!</span> <span ng-repeat=\"error in preferenceForm.$error.required\">{{error.$name}} <span ng-show=\"preferenceForm.$error.required.length-1 != $index\">,</span></span> <span class=\"error\" ng-if=\"preferenceForm.fromAgePref.$error.lowerThan\"><span ng-if=\"preferenceForm.$error.required.length > 0\">,</span> From Age cannot exceed to To Age</span> <span class=\"error\" ng-if=\"preferenceForm.fromHeightPref.$error.lowerThan\"><span ng-if=\"preferenceForm.fromAgePref.$error.lowerThan\">,</span> From Height cannot exceed to To Height.</span></div></div><div class=\"load\" dw-loading=\"createUpdatePartnerPreferBtn\" layout=\"row\" layout-align=\"center center\" ng-if=\"!cuppc.editPartnerPrefInfo\"><md-button class=\"md-raised btn-new md-cornered md-primary\" type=\"submit\">Create Partner Preference</md-button></div><div class=\"load\" dw-loading=\"createUpdatePartnerPreferBtn\" layout=\"row\" layout-align=\"center center\" ng-if=\"cuppc.editPartnerPrefInfo\"><md-button class=\"md-raised md-cornered btn-new md-primary\" type=\"submit\">Update Partner Preference</md-button></div></md-card-content></md-card></form></md-content></div>");
$templateCache.put("app/profile/createUpdateProfile.html","<div dw-loading=\"createUpdateProfile\" ng-cloak=\"\" layout=\"row\" layout-wrap=\"\" class=\"createprofile tabsdemoDynamicHeight\" id=\"createprofile\" layout-align=\"center center\" ng-controller=\"CreateUpdateProfileController as cpuc\"><md-content class=\"md-padding overflow_hidden layout-padding flex-60\"><div ng-if=\"cpuc.editProfilelInfo\" style=\"height: 0; margin-top: -25px; margin-left: -14px;\"><md-button class=\"md-hue-1\" ui-sref=\"home.profile({matrimonyId: cpuc.profile.matrimonyId, shopId: cpuc.profile.shopId})\"><span><i class=\"material-icons md-24 edit\">arrow_back</i></span></md-button></div><api-validate></api-validate><form id=\"profileForm\" name=\"profileForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"cpuc.createUpdateProfile()\"><md-card ng-if=\"!cpuc.user.isAnchePedheUser\"><md-card-header><md-card-header-text><span class=\"md-title\">Basic Information</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Name</label> <input type=\"text\" ng-model=\"cpuc.profile.profileName\" name=\"profileName\" required=\"\" minlength=\"3\" md-maxlength=\"40\" maxlength=\"40\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Shop Profile Registered ID</label> <input type=\"text\" ng-model=\"cpuc.profile.shopProfileRegId\" minlength=\"3\" md-maxlength=\"15\" maxlength=\"15\"></md-input-container></div><div ng-messages=\"profileForm.profileName.$error\" ng-if=\"profileForm.profileName.$dirty || profileForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"required\">Name is compulsory.</div><div class=\"error\" ng-message=\"minlength\">Name is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Name is too long.</div></div><div><label ng-class=\"{\'blue-color\' : cpuc.profile.gender}\">Select Gender</label><md-radio-group ng-disabled=\"true && cpuc.editProfilelInfo\" ng-model=\"cpuc.profile.gender\" layout=\"\" name=\"gender\" required=\"\"><md-radio-button value=\"Male\">Male</md-radio-button><md-radio-button value=\"Female\">Female</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.gender.$error\" ng-if=\"profileForm.gender.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Gender type is compulsory.</span></div><div class=\"mt15\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.anchepedheMarriageBureau\"><label ng-class=\"{\'blue-color\' : cpuc.profile.gender}\">Don\'t no Date of Birth ?</label><md-radio-group ng-model=\"cpuc.profile.dontNoDOB\" layout=\"\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group></div><div layout=\"\" ng-if=\"cpuc.profile.dontNoDOB\" class=\"mt15\"><md-input-container class=\"md-block\" flex=\"\"><label>Age</label> <input type=\"text\" name=\"age\" ng-model=\"cpuc.age\" numbers-only=\"\" ng-minlength=\"2\" ng-maxlength=\"2\" maxlength=\"2\" required=\"\"></md-input-container></div><div ng-messages=\"profileForm.age.$error\" ng-if=\"profileForm.age.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Age is compulsory.</span></div><div ng-if=\"!cpuc.profile.dontNoDOB\" ng-init=\"cpuc.ageObj = cpuc.tempDontNoDOB? {} : cpuc.ageObj\" layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Day (Date of Birth)</label><md-select ng-model=\"cpuc.ageObj.date\" name=\"dob\" required=\"\" ng-disabled=\"main.currentSession.roles.includes(\'ROLE_USER\') && cpuc.editProfilelInfo\"><md-option ng-repeat=\"item in cpuc.dateObj.dd\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Month (Date of Birth)</label><md-select ng-model=\"cpuc.ageObj.month\" name=\"dob\" required=\"\" ng-disabled=\"main.currentSession.roles.includes(\'ROLE_USER\') && cpuc.editProfilelInfo\"><md-option ng-repeat=\"item in cpuc.dateObj.mm\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Year (Date of Birth)</label><md-select ng-model=\"cpuc.ageObj.year\" name=\"dob\" required=\"\" ng-disabled=\"main.currentSession.roles.includes(\'ROLE_USER\') && cpuc.editProfilelInfo\"><md-option ng-repeat=\"item in cpuc.dateObj.yyyy\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.dob.$error\" ng-if=\"profileForm.dob.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Date of birth is compulsory.</span></div><div layout-gt-sm=\"row\" ng-if=\"!cpuc.editProfilelInfo\"><md-input-container class=\"md-block\" flex=\"\"><label>Country Code {{cpuc.profile.countryCode}}</label><md-select ng-change=\"cpuc.profile.mobileNo=\'\'\" ng-model=\"cpuc.profile.countryCode\" name=\"countryCode\" required=\"\"><ul ng-repeat=\"(key, values) in cpuc.profileTemplate.countryCodeOptions.values | groupBy:\'category\'\"><li><span>{{key}}</span><md-option ng-repeat=\"option in values\" ng-value=\"option.value\">{{option.id}}</md-option></li></ul></md-select></md-input-container><div ng-if=\"cpuc.profile.countryCode.indexOf(\'+91\') > -1\" ng-init=\"cpuc.max=10;cpuc.min=10;\"></div><div ng-if=\"cpuc.profile.countryCode.indexOf(\'+91\') < 0\" ng-init=\"cpuc.max=12;cpuc.min=9;\"></div><md-input-container class=\"md-block\" flex=\"\"><label>Mobile Number</label> <input type=\"text\" name=\"mobileNo\" ng-model=\"cpuc.profile.mobileNo\" numbers-only=\"\" ng-minlength=\"cpuc.min\" ng-maxlength=\"cpuc.max\" required=\"\"></md-input-container></div><div ng-messages=\"profileForm.countryCode.$error\" ng-if=\"profileForm.countryCode.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Country Code is compulsory.</span></div><div ng-messages=\"profileForm.mobileNo.$error\" ng-if=\"profileForm.mobileNo.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter only a valid mobile number.</span> <span class=\"error\" ng-message=\"maxlength\">Enter only a valid mobile number.</span></div><div class=\"error-allign\" ng-if=\"profileForm.mobileNo.$dirty && cpuc.profile.mobileNo.length > 9\" ng-init=\"cpuc.createProfileValidation()\"><span class=\"error\" ng-if=\"cpuc.errorMsg != \'\'\">{{cpuc.errorMsg}}</span></div><div layout=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Mother Tongue</label><md-select ng-model=\"cpuc.profile.motherTongue\" name=\"motherTongue\" required=\"\"><ul ng-repeat=\"(key, values) in cpuc.profileTemplate.motherTongueOptions.values | groupBy:\'category\'\"><li ng-if=\"key.indexOf(\'ANY\') == -1\"><span>{{key}}</span><md-option ng-repeat=\"option in values\" ng-value=\"option.value\">{{option.value}}</md-option></li></ul></md-select></md-input-container></div><div ng-messages=\"profileForm.motherTongue.$error\" ng-if=\"profileForm.motherTongue.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Mother Tongue is mandatory.</span></div><div layout-gt-sm=\"row\" ng-if=\"!cpuc.editProfilelInfo && main.currentSession.shop.profileEmailRequired\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Email ID</label> <input type=\"email\" ng-model=\"cpuc.profile.email\" ng-disabled=\"cpuc.editProfilelInfo\" validate-email=\"\" name=\"email\"></md-input-container></div><div ng-messages=\"profileForm.email.$error\" ng-if=\"profileForm.email.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"email\">Your email address is invalid.</span></div><div><label ng-class=\"{\'blue-color\' : cpuc.profile.vegOrNonVeg}\">Veg Or Non Veg ?</label><md-radio-group ng-model=\"cpuc.profile.vegOrNonVeg\" layout=\"\" name=\"vegOrNonVeg\" required=\"\"><md-radio-button value=\"Veg\">Veg</md-radio-button><md-radio-button value=\"Nov-Veg\">Non Veg</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.vegOrNonVeg.$error\" ng-if=\"profileForm.vegOrNonVeg.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Veg Or Non Veg is compulsory.</span></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Add Profile Images (Only .jpeg, .jpg)</span></md-card-header-text></md-card-header><md-card-content dw-loading=\"imageLoading\" class=\"load\" dw-loading-options=\"{text: \'Loading Image...\'}\"><div class=\"up-buttons\"><ul layout=\"row\" layout-align=\"space-around center\"><li ng-repeat=\"item in cpuc.items\"><div ng-if=\"item.invalidFile.$errorMessages\"><span class=\"error\" ng-if=\"item.invalidFile.$errorMessages.minSize\">Please upload a higher resolution image.</span> <span class=\"error\" ng-if=\"item.invalidFile.$errorMessages.maxSize\">Please upload image lesser than 20MB.</span></div><div class=\"thumbnail\" ng-if=\"!item.photo\"><div ng-if=\"item.image != \'./assets/images/no_image.png\'\"><img ng-src=\"{{main.imageUrl}}{{cpuc.getImagePath(item.image)}}\"> <span ng-init=\"item.to=1\"></span></div><div ng-if=\"item.image == \'./assets/images/no_image.png\'\"><img ng-src=\"{{item.image}}\"> <span ng-init=\"item.to=\'\'\"></span></div></div><div class=\"thumbnail\"><img ngf-thumbnail=\"item.photo\"></div><div ngf-select=\"cpuc.afterResizingImages($files)\" ngf-drop=\"\" ng-model=\"item.photo\" ngf-model-invalid=\"item.invalidFile\" ngf-resize=\"{width: 500, height: 800}\" ngf-resize-if=\"{width: 500, height: 500}\" ngf-fix-orientation=\"true\" ngf-before-model-change=\"cpuc.beforeResizingImages($files)\" ngf-max-files=\"1\" accept=\"image/*\" ngf-accept=\"\'image/*\'\" ngf-pattern=\"\'.jpeg,.jpg,.png\'\" ngf-drop-available=\"dropAvailable\"><span class=\"btn-small btn-primary cursor_default\" ng-if=\"(!item.photo) && item.to !=1\">Select image <input ng-if=\"item.name==\'image1\'\" type=\"file\" ng-model=\"item.to\" name=\"{{item.name}}\" style=\"visibility: hidden; position: absolute;\" required=\"\"></span> <span class=\"btn-small btn-primary cursor_default prt7\" ng-model=\"item.photo\" ng-if=\"(item.photo || item.to ==1) && !cpuc.editProfilelInfo\" ng-click=\"item.photo=\'\';item.to=\'\'\">Remove and Change</span> <span class=\"btn-small btn-primary cursor_default prt7\" ng-model=\"item.photo\" ng-if=\"(item.photo || item.to ==1) && cpuc.editProfilelInfo\">Remove and Change</span></div></li></ul></div><div layout=\"row\" class=\"mt10\" flex-offset=\"10\" layout-align=\"start start\"><div flex=\"20\"><div ng-messages=\"profileForm.image1.$error\" ng-if=\"profileForm.image1.$error || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Image 1 is compulsory.</span></div></div></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">More Personal Details</span></md-card-header-text></md-card-header><md-card-content><div><label ng-class=\"{\'blue-color\' : cpuc.profile.martialStatus}\">Martial Status</label><md-radio-group ng-disabled=\"true && cpuc.editProfilelInfo\" ng-model=\"cpuc.profile.martialStatus\" layout=\"row\" name=\"martialStatus\" required=\"\"><md-radio-button ng-value=\"option.value\" ng-repeat=\"option in cpuc.profileTemplate.martialStatusOptions.values | filter: {value: \'!\' + \'Any\'} : true\">{{option.value}}</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.martialStatus.$error\" ng-if=\"profileForm.martialStatus.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Martial Status is compulsory.</span></div><div layout-gt-sm=\"row\" class=\"mt30\" ng-if=\"cpuc.profile.martialStatus && cpuc.profile.martialStatus.indexOf(\'Never Married\') < 0\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>No Of Children</label> <input type=\"text\" name=\"noOfchildren\" ng-model=\"cpuc.profile.noOfchildren\" format=\"number\" maxlength=\"1\" required=\"\"></md-input-container></div><div ng-messages=\"profileForm.noOfchildren.$error\" ng-if=\"profileForm.noOfchildren.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">No Of Children is compulsory.</span></div><div layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Religion</label><md-select ng-disabled=\"true && cpuc.editProfilelInfo\" name=\"religion\" ng-model=\"cpuc.profile.religion\" class=\"input-sm form-control\" required=\"\"><md-option ng-disabled=\"true && cpuc.editProfilelInfo\" ng-value=\"option\" ng-repeat=\"option in main.currentSession.shop.expertiseReligion\" ng-click=\"cpuc.getCasteOptions(option);cpuc.profile.caste=\'\'\">{{option}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.religion.$error\" ng-if=\"profileForm.religion.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Religion is compulsory.</span></div><div layout-gt-sm=\"\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Caste</label><md-select ng-disabled=\"cpuc.editProfilelInfo\" ng-change=\"cpuc.getSubCasteOptions(cpuc.profile.caste);cpuc.profile.subCaste=\'\';cpuc.profile.casteNoBar=cpuc.profile.caste==\'Intercaste\'?true:false\" name=\"caste\" ng-model=\"cpuc.profile.caste\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in main.currentSession.shop.expertiseCaste | filter : \'!Any\' | orderBy\">{{option}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.caste.$error\" ng-if=\"profileForm.caste.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Caste is compulsory.</span></div><div layout=\"\" class=\"caste-nobar\" ng-if=\"cpuc.profile.caste\"><md-checkbox ng-disabled=\"cpuc.profile.caste==\'Intercaste\'\" ng-model=\"cpuc.profile.casteNoBar\" aria-label=\"Checkbox 2\" flex=\"\"><span style=\"float: left;position: relative;left: -18px;\">Not particular about my Partner\'s Caste (Caste No Bar)</span></md-checkbox></div><div layout-gt-sm=\"\" class=\"mt20\" ng-if=\"cpuc.profile.caste && cpuc.subCasteOptions\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub caste</label><md-select name=\"subCaste\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.subCaste\" ng-change=\"cpuc.getSubCasteSubOptions(cpuc.profile.subCaste);cpuc.profile.subCasteSub=\'\';cpuc.profile.otherSubCaste=\'\';cpuc.profile.gothram=\'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a subcaste..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste\"><md-option ng-repeat=\"option in cpuc.subCasteOptions.values | filter: {value: \'!\' + \'Any\'} | filter: {value: \'!\' + \'Not Specified\'} | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-gt-sm=\"\" class=\"mt20\" ng-if=\"cpuc.profile.caste && !cpuc.subCasteOptions\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub caste</label> <input type=\"text\" ng-model=\"cpuc.profile.subCaste\" maxlength=\"40\"></md-input-container></div><div layout=\"\"><md-input-container flex=\"\" ng-if=\"cpuc.profile.subCaste.indexOf(\'Other\') > -1\"><label>Other Sub caste</label> <input type=\"text\" ng-model=\"cpuc.profile.otherSubCaste\" maxlength=\"20\"></md-input-container></div><div layout=\"\" class=\"caste-nobar\" ng-show=\"cpuc.profile.subCaste\"><md-checkbox ng-model=\"cpuc.profile.subCasteNoBar\" aria-label=\"Checkbox 2\" flex=\"\"><span style=\"float: left;position: relative;left: -18px;\">Not particular about my Partner\'s Sub Caste (Sub Caste No Bar)</span></md-checkbox></div><div layout-gt-sm=\"\" class=\"mt40\" ng-if=\"cpuc.profile.caste.indexOf(\'Brahmin\') > -1 && cpuc.profile.subCaste.indexOf(\'Deshastha\') == 0 || cpuc.profile.subCaste.indexOf(\'Iyengar\') == 0 || cpuc.profile.subCaste.indexOf(\'Iyer\') == 0 || cpuc.profile.subCaste.indexOf(\'Madhwa\') == 0 || cpuc.profile.subCaste.indexOf(\'Sarawat\') == 0 || cpuc.profile.subCaste.indexOf(\'Smartha\') == 0\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label class=\"chosen-label\">Sub caste division</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.subCasteSub\" ng-change=\"cpuc.profile.otherSubCasteSub=\'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a subcaste division..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste division\"><md-option ng-repeat=\"option in cpuc.subCasteSubOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-gt-sm=\"\" class=\"mt20\" ng-if=\"cpuc.profile.caste && cpuc.profile.subCaste && !cpuc.subCasteSubOptions\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub Caste Sub division</label> <input type=\"text\" ng-model=\"cpuc.profile.subCasteSub\" maxlength=\"40\"></md-input-container></div><div><label ng-class=\"{\'blue-color\' : cpuc.profile.lifeStyle}\">Life Style</label><md-radio-group ng-model=\"cpuc.profile.lifeStyle\" layout=\"row\" name=\"lifeStyle\"><md-radio-button value=\"Modern\">Modern</md-radio-button><md-radio-button value=\"Traditional\">Traditional</md-radio-button><md-radio-button value=\"Both (depend on situation)\">Both (depend on situation)</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.lifeStyle.$error\" ng-if=\"profileForm.lifeStyle.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Life Style is compulsory.</span></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Physical Details</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Height</label><md-select name=\"height\" ng-model=\"cpuc.profile.height\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in cpuc.profileTemplate.heightOptions.values track by option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container flex-gt-sm=\"\"><label>Weight (kg)</label> <input type=\"text\" name=\"weight\" ng-model=\"cpuc.profile.weight\" numbers-only=\"\" maxlength=\"3\"></md-input-container></div><div ng-messages=\"profileForm.height.$error\" ng-if=\"profileForm.height.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Height is compulsory.</span></div><div><label ng-class=\"{\'blue-color\' : cpuc.profile.physicalStatus}\">Physical Status</label><md-radio-group ng-model=\"cpuc.profile.physicalStatus\" layout=\"row\" name=\"physicalStatus\" required=\"\"><md-radio-button value=\"Normal\">Normal</md-radio-button><md-radio-button value=\"Physically Challenged\">Physically Challenged</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.physicalStatus.$error\" ng-if=\"profileForm.physicalStatus.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Physical Status is compulsory.</span></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : cpuc.profile.bodyType}\">Body Type</label><md-radio-group ng-model=\"cpuc.profile.bodyType\" layout=\"row\"><md-radio-button value=\"Average\">Average</md-radio-button><md-radio-button value=\"Athletic\">Athletic</md-radio-button><md-radio-button value=\"Slim\">Slim</md-radio-button><md-radio-button value=\"Heavy\">Heavy</md-radio-button><md-radio-button value=\"Gym\">Gym</md-radio-button></md-radio-group></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : cpuc.profile.complexionType}\">Complexion Type</label><md-radio-group ng-model=\"cpuc.profile.complexionType\" layout=\"row\"><md-radio-button value=\"Very Fair\">Very Fair</md-radio-button><md-radio-button value=\"Fair\">Fair</md-radio-button><md-radio-button value=\"Wheatish\">Wheatish</md-radio-button><md-radio-button value=\"Wheatish Brown\">Wheatish Brown</md-radio-button></md-radio-group></div></md-card-content></md-card><md-card ng-if=\"cpuc.profile.religion.indexOf(\'Muslim\') > -1\"><md-card-header><md-card-header-text><span class=\"md-title\">Religious Information</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-click=\"cpuc.getReligiousValueOptions()\"><label>Religious Value</label><md-select name=\"religiousValue\" ng-model=\"cpuc.profile.religiousValue\" class=\"input-sm form-control\" required=\"\"><md-option ng-value=\"option.value\" ng-repeat=\"option in cpuc.religiousValueOptions.values track by option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.religiousValue.$error\" ng-if=\"profileForm.religiousValue.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Religious value is compulsory.</span></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : cpuc.profile.readQuran}\">Read Quran</label><md-radio-group ng-model=\"cpuc.profile.readQuran\" layout=\"row\"><md-radio-button value=\"Regularly\">Regularly</md-radio-button><md-radio-button value=\"Occasionally\">Occasionally</md-radio-button><md-radio-button value=\"Only jummah/Friday\">Only jummah/Friday</md-radio-button><md-radio-button value=\"Never read\">Never read</md-radio-button></md-radio-group></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Education and Occupation Details</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Highest Education</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.highestEducation\" name=\"highestEducation\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a education..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Highest Education\"><ul ng-repeat=\"(key, values) in cpuc.profileTemplate.educationOptions.values | groupBy:\'category\'\"><li ng-if=\"key.indexOf(\'Any\') == -1 && cpuc.checkIfExist(cpuc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div ng-messages=\"profileForm.highestEducation.$error\" ng-if=\"profileForm.highestEducation.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Highest Education is compulsory.</span></div><div layout=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>More Information about Education</label> <textarea ng-model=\"cpuc.profile.moreInfoAboutEducation\" columns=\"1\" md-maxlength=\"150\" rows=\"2\" maxlength=\"150\"></textarea></md-input-container></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : cpuc.profile.employedIn}\">Employed In</label><md-radio-group ng-model=\"cpuc.profile.employedIn\" layout=\"row\" name=\"employedIn\" required=\"\"><md-radio-button value=\"{{option.value}}\" ng-repeat=\"option in cpuc.profileTemplate.employedInOptions.values | filter: {value: \'!\' + \'Any\'}\">{{::option.value}}</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.employedIn.$error\" ng-if=\"profileForm.employedIn.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Employed In is compulsory.</span></div><div layout-gt-sm=\"\" ng-if=\"(cpuc.profile.employedIn && cpuc.profile.employedIn.indexOf(\'Student\')<0 && cpuc.profile.employedIn.indexOf(\'Not Working\')<0)\" class=\"mt20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Occupation</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.occupation\" name=\"occupation\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a occupation..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Highest Education\"><ul ng-repeat=\"(key, values) in cpuc.profileTemplate.occupationOptions.values | groupBy:\'category\'\"><li ng-if=\"key.indexOf(\'ANY\') == -1 && cpuc.checkIfExist(cpuc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div ng-messages=\"profileForm.occupation.$error\" ng-if=\"profileForm.occupation.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Occupation is compulsory.</span></div><div ng-if=\"cpuc.profile.occupation\" class=\"mt40\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>More Information about Work</label> <textarea name=\"moreInfoAboutJob\" ng-model=\"cpuc.profile.moreInfoAboutJob\" columns=\"1\" md-maxlength=\"200\" rows=\"2\" maxlength=\"200\"></textarea></md-input-container></div><div layout-gt-sm=\"row\" class=\"mt30\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Annual Income (in India-Rupees)</label> <input type=\"text\" name=\"annualIncome\" ng-model=\"cpuc.profile.annualIncome\" format=\"number\" maxlength=\"11\"></md-input-container></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\"><span ng-if=\"cpuc.profile.gender.indexOf(\'Male\') > -1\">Groom\'s</span> <span ng-if=\"cpuc.profile.gender.indexOf(\'Female\') > -1\">Bride\'s</span> <span ng-if=\"(cpuc.profile.employedIn && cpuc.profile.employedIn.indexOf(\'Student\')<0 && cpuc.profile.employedIn.indexOf(\'Not Working\')<0)\">Work</span> Location</span></md-card-header-text></md-card-header><md-card-content><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>Country Living In/Working In</label><md-select name=\"currentLivingCountry\" ng-change=\"cpuc.getStates(cpuc.profile.currentLivingCountry); cpuc.profile.currentLivingState = \'\';cpuc.profile.currentLivingCity=\'\';cpuc.profile.residentStatus=\'\'\" required=\"\" ng-model=\"cpuc.profile.currentLivingCountry\" md-on-close=\"cpuc.clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a country..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Bride/Groom Country Living In/Working In\"><md-option ng-value=\"country.value\" ng-repeat=\"country in cpuc.profileTemplate.countryOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:cpuc.searchTerm\">{{country.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Citizenship</label><md-select ng-model=\"cpuc.profile.citizenship\"><md-option ng-repeat=\"option in cpuc.profileTemplate.countryOptions.values | filter: {value: \'!\' + \'Any\'} : true\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.currentLivingCountry.$error\" ng-if=\"profileForm.currentLivingCountry.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Current Living/Working Country is compulsory.</span></div><div layout-gt-sm=\"row\" ng-if=\"cpuc.profile.currentLivingCountry && cpuc.profile.currentLivingCountry != \'India\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Current Living/Working City</label> <input type=\"text\" ng-model=\"cpuc.profile.currentLivingCity\" name=\"currentResidingCity\" required=\"\" md-maxlength=\"30\" maxlength=\"30\" placeholder=\"Please enter state and city ...\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Resident Status</label><md-select ng-model=\"cpuc.profile.residentStatus\"><md-option ng-repeat=\"option in cpuc.profileTemplate.residentStatusOptions.values | filter: {value: \'!\' + \'Any\'} : true\" ng-value=\"option.value\" required=\"\" name=\"residentStatus\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.currentResidingCity.$error\" ng-if=\"profileForm.currentResidingCity.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Current Living City is compulsory.</span> <span class=\"error\" ng-message=\"md-maxlength\">Current Living City is too long.</span></div><div layout=\"\" flex=\"\" layout-gt-sm=\"\" ng-if=\"cpuc.profile.currentLivingCountry == \'India\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>State Living In/Working In</label><md-select ng-model=\"cpuc.profile.currentLivingState\" name=\"currentLivingState\" md-on-close=\"cpuc.clearSearchTerm()\" ng-change=\"cpuc.profile.currentLivingCity=\'\';cpuc.cityOptions=\'\'\" required=\"\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a state..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Bride/Groom Country Living In/Working In\"><md-option ng-repeat=\"option in cpuc.stateOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"cpuc.profile.currentLivingState\"><label>City(near) Living In/Working In India</label><md-select ng-model=\"cpuc.profile.currentLivingCity\" name=\"currentLivingCity\" md-on-close=\"cpuc.clearSearchTerm()\" ng-change=\"cpuc.profile.otherCurrentLivingCity=\'\'\" ng-click=\"cpuc.getCities(cpuc.profile.currentLivingState);\" required=\"\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a city ..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Bride/Groom Country Living In/Working In\"><md-option ng-repeat=\"option in cpuc.cityOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\" ng-if=\"cpuc.profile.currentLivingCity\"><label>Current Living Taluk</label> <input type=\"text\" ng-model=\"cpuc.profile.currentLivingTaluk\" name=\"currentLivingTaluk\" maxlength=\"30\" placeholder=\"Please enter taluk\"></md-input-container></div><div flex=\"\" layout=\"\" class=\"caste-nobar\" ng-if=\"!cpuc.editProfilelInfo && cpuc.profile.currentLivingState && cpuc.profile.currentLivingCity\"><md-checkbox aria-label=\"Checkbox 2\" flex=\"50\" ng-model=\"cpuc.isSameAsLoc\" ng-change=\"cpuc.sameAsFamilyLocation()\"><span style=\"float: left;position: relative;left: -18px;\">Same as family location</span></md-checkbox><md-checkbox aria-label=\"Checkbox 2\" flex=\"50\" ng-model=\"cpuc.isSameAsAncOrg\" ng-change=\"cpuc.sameAsAncestralOrigin()\"><span style=\"float: left;position: relative;left: -18px;\">Same as ancestral origin</span></md-checkbox></div><div ng-messages=\"profileForm.currentLivingState.$error\" ng-if=\"cpuc.profile.currentLivingCountry == \'India\' && (profileForm.currentLivingState.$dirty || profileForm.$submitted)\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Current Living/Working State is compulsory.</span></div><div ng-messages=\"profileForm.currentLivingCity.$error\" ng-if=\"profileForm.currentLivingCity.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">City(near) Living In/Working In is compulsory.</span></div><div layout-gt-sm=\"row\" ng-if=\"cpuc.profile.currentLivingCity == \'Other\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Other Current Living/Working City</label> <input type=\"text\" ng-model=\"cpuc.profile.otherCurrentLivingCity\" name=\"otherCurrentLivingCity\" required=\"\" md-maxlength=\"30\"></md-input-container></div><div ng-messages=\"profileForm.otherCurrentLivingCity.$error\" ng-if=\"profileForm.otherCurrentLivingCity.$dirty || profileForm.$submitted\" role=\"alert\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Other Current Living City is compulsory.</span> <span class=\"error\" ng-message=\"md-maxlength\">Other Current Living City is too long.</span></div></md-card-content></md-card><md-card ng-if=\"cpuc.profile.religion.indexOf(\'Hindu\') > -1 || cpuc.profile.religion.indexOf(\'Jain\') > -1\"><md-card-header><md-card-header-text><span class=\"md-title\">Astrological Information</span></md-card-header-text></md-card-header><md-card-content><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Star</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.star\" name=\"star\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a star..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Star\"><md-option ng-repeat=\"option in cpuc.profileTemplate.starOptions.values | filter: {value: \'!\' + \'Any\'} : true | orderBy: \'value\' | filter:cpuc.searchTerm\" ng-value=\"option.value\" ng-click=\"cpuc.getRaasi(option.value);cpuc.profile.raasi=\'\'\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Paadha</label> <input type=\"number\" ng-model=\"cpuc.profile.paadha\" maxlength=\"2\"></md-input-container></div><div ng-messages=\"profileForm.star.$error\" ng-if=\"profileForm.star.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Star is compulsory.</span></div><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Raasi/Moon Sign</label><md-select ng-disabled=\"!cpuc.profile.star\" ng-model=\"cpuc.profile.raasi\" name=\"raasi\"><md-option ng-repeat=\"option in cpuc.raasiOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"cpuc.gothramOptions\"><label>Gothra(m)</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.gothram\" name=\"gothram\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a gothra(m)..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Gothra(m)\"><md-option ng-repeat=\"option in cpuc.gothramOptions.values | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"!cpuc.gothramOptions\"><label>Gothra(m)</label><input type=\"text\" ng-model=\"cpuc.profile.gothram\"></md-input-container></div><div ng-messages=\"profileForm.raasi.$error\" ng-if=\"profileForm.raasi.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Raasi is compulsory.</span></div><div layout=\"\" ng-if=\"cpuc.profile.caste && cpuc.profile.caste.indexOf(\'Arya Vysya\') > -1\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Swa Gothra(m)</label> <input type=\"text\" ng-model=\"cpuc.profile.gothram\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Mathula</label> <input type=\"text\" ng-model=\"cpuc.profile.mathula\"></md-input-container></div><div ng-messages=\"profileForm.gothram.$error\" ng-if=\"profileForm.gothram.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Gothra(m) is compulsory.</span></div><div layout-gt-sm=\"\" flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><label>Birth name</label> <input type=\"text\" ng-model=\"cpuc.profile.birthName\" maxlength=\"25\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><label>Birth place</label> <input type=\"text\" ng-model=\"cpuc.profile.birthPlace\" maxlength=\"25\"></md-input-container></div><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Hour (Birth Time)</label><md-select ng-model=\"cpuc.birthTimeObj.hr\" name=\"time\" flex=\"33\"><md-option ng-repeat=\"item in cpuc.timeObj.hr\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Minute (Birth Time)</label><md-select ng-model=\"cpuc.birthTimeObj.min\" name=\"time\"><md-option ng-repeat=\"item in cpuc.timeObj.min\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>AM/PM (Birth Time)</label><md-select ng-model=\"cpuc.birthTimeObj.amOrPm\" name=\"time\"><md-option ng-repeat=\"item in cpuc.timeObj.amOrPm\" value=\"{{item}}\">{{item}}</md-option></md-select></md-input-container></div><div ng-messages=\"profileForm.time.$error\" ng-if=\"profileForm.time.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Birth Time is compulsory.</span></div><div layout=\"\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"50\"><label>Male God</label> <input type=\"text\" ng-model=\"cpuc.profile.maleGod\" maxlength=\"30\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Female God</label> <input type=\"text\" ng-model=\"cpuc.profile.femaleGod\" maxlength=\"30\"></md-input-container></div><div layout=\"\" ng-if=\"cpuc.profile.caste && cpuc.profile.caste.indexOf(\'Scheduled Caste (SC)\') > -1\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Kula</label> <input type=\"text\" ng-model=\"cpuc.profile.kula\" maxlength=\"20\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Bedagu</label> <input type=\"text\" ng-model=\"cpuc.profile.bedagu\" maxlength=\"20\"></md-input-container></div><div layout=\"\" flex=\"\" dw-loading=\"imageLoading\" class=\"load\" dw-loading-options=\"{text: \'Loading Image...\'}\"><div ng-if=\"(cpuc.horoImage.photo != false) || cpuc.horoImage.image\">Added Horoscope File: <img ng-if=\"!cpuc.horoImage.photo\" ng-src=\"{{main.imageUrl}}{{cpuc.horoImage.image}}\" width=\"50\" height=\"50\"> <img ng-if=\"cpuc.horoImage.photo\" ngf-src=\"cpuc.horoImage.photo\" width=\"50\" height=\"50\"></div><div ng-if=\"!cpuc.horoImage.photo && !cpuc.horoImage.image\">Add Horoscope File: <img ngf-src=\"cpuc.horoImage.photo\" width=\"50\" height=\"50\" alt=\"No File\"></div><div class=\"ml20\" type=\"file\" ngf-select=\"cpuc.afterResizingImages($files)\" ngf-max-files=\"1\" ng-model=\"cpuc.horoImage.photo\" ngf-resize=\"{width: 500, height: 500, quality: .8}\" ngf-resize-if=\"{width: 500, height: 500}\" ngf-accept=\"\'image/*\'\" ngf-validate=\"{size: {max: \'20MB\', min: \'10kb\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'5m\'}}\" ngf-pattern=\"\'.jpeg,.jpg,.png\'\" ngf-before-model-change=\"cpuc.beforeResizingImages($files)\" ngf-fix-orientation=\"true\"><span class=\"btn-small btn-primary cursor_default\" ng-if=\"!(cpuc.horoImage.photo) && !(cpuc.horoImage.image)\">Select image</span> <span class=\"btn-small btn-primary cursor_default prt7\" ng-if=\"cpuc.horoImage.photo || cpuc.horoImage.image\" ng-click=\"cpuc.horoImage.photo=\'\';\">Remove and Change</span></div></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Family Information</span></md-card-header-text></md-card-header><md-card-content><div class=\"mt20\" layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\" flex-gt-sm=\"\"><label>Father Status</label><md-select ng-model=\"cpuc.profile.fatherStatus\" name=\"fatherStatus\" required=\"\"><md-option ng-repeat=\"option in cpuc.profileTemplate.parentWorkStatus.values | filter: {value: \'!\' + \'Any\'} : true | filter: {value: \'!\' + \'Home Maker\'} : true | filter: {value: \'!\' + \'Business Woman\'} : true\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label ng-class=\"{\'blue-color\' : cpuc.profile.fatherName}\">Father Name</label> <input type=\"text\" ng-model=\"cpuc.profile.fatherName\" name=\"fatherName\" maxlength=\"30\"></md-input-container></div><div ng-messages=\"profileForm.fatherStatus.$error\" ng-if=\"profileForm.fatherStatus.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Father Status is compulsory.</span></div><div class=\"mt20\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label>Mother Status</label><md-select ng-model=\"cpuc.profile.motherStatus\" name=\"motherStatus\" required=\"\"><md-option ng-repeat=\"option in cpuc.profileTemplate.parentWorkStatus.values | filter: {value: \'!\' + \'Any\'} : true | filter: {value: \'!\' + \'Business Man\'} : true | filter: {value: \'!\' + \'Not Employed\'} : true\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label ng-class=\"{\'blue-color\' : cpuc.profile.motherName}\">Mother Name</label> <input type=\"text\" ng-model=\"cpuc.profile.motherName\" name=\"motherName\" maxlength=\"30\"></md-input-container></div><div ng-messages=\"profileForm.motherStatus.$error\" ng-if=\"profileForm.motherStatus.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Mother Status is compulsory.</span></div><div class=\"mt20\"><label ng-class=\"{\'blue-color\' : cpuc.profile.familyStatus}\">Family Status</label><md-radio-group ng-model=\"cpuc.profile.familyStatus\" layout=\"row\" name=\"familyStatus\" required=\"\"><md-radio-button value=\"Middle Class\">Middle Class</md-radio-button><md-radio-button value=\"Upper Middle Class\">Upper Middle Class</md-radio-button><md-radio-button value=\"Rich\">Rich</md-radio-button></md-radio-group></div><div ng-messages=\"profileForm.familyStatus.$error\" ng-if=\"profileForm.familyStatus.$dirty || profileForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Family Status is compulsory.</span></div><div ng-if=\"main.currentSession.shop.profileMobileNoRequired\"><div class=\"cursor_default mt20\"><label>Family Contact Information</label></div><div layout=\"\" ng-repeat=\"contact in cpuc.profile.familyContactInfo\"><md-input-container class=\"md-block\" flex=\"30\"><label ng-class=\"{\'blue-color\' : contact.relationShipType}\">Relationship Type</label><md-select ng-model=\"contact.relationShipType\"><md-option ng-repeat=\"option in cpuc.profileTemplate.relationshipTypeOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"35\"><label>Name</label> <input type=\"text\" ng-model=\"contact.name\" maxlength=\"30\" ng-change=\"cpuc.errorContactInfoShow=false\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>Mobile No</label> <input type=\"text\" ng-model=\"contact.mobileNo\" numbers-only=\"\" maxlength=\"12\" ng-change=\"cpuc.errorContactInfoShow=false\"></md-input-container></div><div class=\"error prb20\" ng-if=\"cpuc.errorContactInfoShow\">Please enter Relationship Type and 10 digits Mobile<no></no>is compulsory</div><div><a ng-click=\"cpuc.addOneMoreContact()\" class=\"plus_one\"><span><i class=\"material-icons md-48\">plus_one</i></span> <span class=\"plus_one_heading\">Contact Information</span></a></div></div><div class=\"cursor_default mt20\"><label>Siblings Information</label></div><div layout-gt-sm=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>No. of Brothers</label><div style=\"display: none\">{{cpuc.profile.noOfBrothers == 0 ? cpuc.profile.brothersMarried=0 : \'\'}}</div><md-select ng-model=\"cpuc.profile.noOfBrothers\" name=\"time\" flex=\"33\"><md-option ng-repeat=\"option in cpuc.profileTemplate.noOfSiblings.values\" ng-value=\"option.category\">{{option.id}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Brothers Married</label><md-select ng-model=\"cpuc.profile.brothersMarried\" ng-disabled=\"cpuc.profile.noOfBrothers == 0\"><md-option ng-repeat=\"option in cpuc.profileTemplate.noOfSiblings.values\" ng-value=\"option.category\">{{option.id}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>No. of Sisters</label><div style=\"display: none\">{{cpuc.profile.noOfSisters == 0 ? cpuc.profile.sistersMarried=0 : \'\'}}</div><md-select ng-model=\"cpuc.profile.noOfSisters\"><md-option ng-repeat=\"option in cpuc.profileTemplate.noOfSiblings.values\" ng-value=\"option.category\">{{option.id}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sisters Married</label><md-select ng-model=\"cpuc.profile.sistersMarried\" ng-disabled=\"cpuc.profile.noOfSisters == 0\"><md-option ng-repeat=\"option in cpuc.profileTemplate.noOfSiblings.values\" ng-value=\"option.category\">{{option.id}}</md-option></md-select></md-input-container></div><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>Family Residing State</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.familyResidingState\" ng-click=\"cpuc.profile.familyResidingDistrict=\'\';\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for state..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"state\"><md-option ng-repeat=\"option in cpuc.stateOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\" ng-if=\"cpuc.profile.familyResidingState\"><label>Family Residing District</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"cpuc.clearSearchTerm()\" ng-model=\"cpuc.profile.familyResidingDistrict\" ng-init=\"cpuc.getFamilyLeavingCities(cpuc.profile.familyResidingState);\"><md-select-header class=\"demo-select-header\"><input ng-model=\"cpuc.searchTerm\" type=\"search\" placeholder=\"Search for a district..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"District\"><md-option ng-repeat=\"option in cpuc.familyCityOptions.values | filter: {value: \'!\' + \'Any\'} : true | filter:cpuc.searchTerm\" ng-value=\"option.value\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\" ng-if=\"cpuc.profile.familyResidingDistrict\"><label>Family Residing Taluk</label> <input type=\"text\" ng-model=\"cpuc.profile.familyResidingTaluk\" name=\"familyResidingTaluk\" maxlength=\"30\" placeholder=\"Please enter taluk\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Family Residing Address</label> <textarea ng-model=\"cpuc.profile.address\" md-maxlength=\"100\" maxlength=\"100\"></textarea></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Ancestral Origin</label> <input type=\"text\" ng-model=\"cpuc.profile.ancestralOrigin\" name=\"ancestralOrigin\" maxlength=\"30\" placeholder=\"Please enter ancestral origin ...\"></md-input-container></div><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>More Information about family</label> <textarea ng-model=\"cpuc.profile.moreInfoAboutFamily\" maxlength=\"500\" md-maxlength=\"500\" rows=\"3\" name=\"moreInfoAboutFamily\"></textarea></md-input-container></div><div ng-messages=\"profileForm.moreInfoAboutFamily.$error\" ng-show=\"profileForm.moreInfoAboutFamily.$dirty || profileForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"md-maxlength\">That\'s too long!</div></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Property Details</span></md-card-header-text></md-card-header><md-card-content><div><label ng-class=\"{\'blue-color\' : cpuc.profile.havingProperty}\">Do You have Own House or Apartment or Villa or Site?</label><md-radio-group ng-model=\"cpuc.profile.havingProperty\" layout=\"row\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No</md-radio-button></md-radio-group></div><div layout-gt-sm=\"\" ng-repeat=\"property in cpuc.profile.propertyDetails\" class=\"mt15\" ng-if=\"cpuc.profile.havingProperty\"><md-input-container class=\"md-block\" flex=\"45\"><label>Propety Type</label><md-select ng-model=\"property.propertyType\" name=\"propertyType\" ng-change=\"cpuc.errorPropertyInfoShow = false\"><md-option ng-repeat=\"option in cpuc.profileTemplate.propertyTypeOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>More Information About Property</label> <input type=\"text\" ng-model=\"property.moreInfoAboutProperty\" name=\"moreInfoAboutProperty\" maxlength=\"100\"></md-input-container><md-input-container class=\"md-block\" flex=\"5\" ng-show=\"property.propertyType\"><a class=\"done\"><span><i class=\"material-icons md-24\">done</i></span></a></md-input-container></div><div class=\"error prb20\" ng-if=\"cpuc.errorPropertyInfoShow\">Property Type is compulsory</div><div ng-if=\"cpuc.profile.havingProperty\"><a ng-click=\"cpuc.addOneMoreProperty()\" class=\"plus_one\"><span><i class=\"material-icons md-48\">plus_one</i></span> <span class=\"plus_one_heading\">Property Information</span></a></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Something about You</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=\"md-block\"><label>Write about your personality or hobbies. Express yourself</label> <textarea ng-model=\"cpuc.profile.aboutProfile\" md-maxlength=\"800\" maxlength=\"800\" name=\"aboutProfile\"></textarea></md-input-container><div ng-messages=\"profileForm.aboutProfile.$error\" ng-show=\"profileForm.aboutProfile.$dirty || profileForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"md-maxlength\">That\'s too long!</div></div></md-card-content></md-card><div class=\"load\" dw-loading=\"createUpdateProfileBtn\" layout=\"row\" layout-align=\"center center\" ng-if=\"!cpuc.editProfilelInfo\"><md-button class=\"md-raised btn-new md-cornered md-primary\" type=\"submit\">Create Profile</md-button></div><div class=\"error\" ng-if=\"profileForm.$submitted\"><div class=\"pt5\" ng-if=\"profileForm.$error.required.length > 0\"><span>You have not filled required fields. Please go and fill it!</span> <span ng-repeat=\"error in profileForm.$error.required\">{{error.$name}} <span ng-show=\"profileForm.$error.required.length-1 != $index\">,</span></span></div><div class=\"pt5\" ng-if=\"profileForm.$error.minlength.length > 0\"><span>You have not filled minimum length of fields. Please go and fill it!</span> <span ng-repeat=\"error in profileForm.$error.minlength\">{{error.$name}} <span ng-show=\"profileForm.$error.minlength.length-1 != $index\">,</span></span></div><div class=\"pt5\" ng-if=\"profileForm.$error.maxlength.length > 0\"><span>You have exceeded maximum length of fields. Please go and fill it!</span> <span ng-repeat=\"error in profileForm.$error.maxlength\">{{error.$name}} <span ng-show=\"profileForm.$error.maxlength.length-1 != $index\">,</span></span></div></div><div class=\"load\" dw-loading=\"createUpdateProfileBtn\" layout=\"row\" layout-align=\"center center\" ng-if=\"cpuc.editProfilelInfo\"><md-button class=\"md-raised md-cornered btn-new md-primary\" type=\"submit\">Update Profile</md-button></div></form></md-content></div>");
$templateCache.put("app/profile/profile.html","<div ng-cloak=\"\" layout=\"row\" class=\"profile\" id=\"profile\" layout-wrap=\"\" layout-align=\"center center\" ng-controller=\"ProfileController as pc\"><md-content ng-if=\"pc.profileNoFound\" dw-loading=\"profile\" class=\"md-padding\" flex-sm=\"100\" ng-class=\"{\'flex-80\': isInterestInfo, \'flex-60\': !isInterestInfo}\"><h1>Profile Not Found</h1></md-content><md-content ng-if=\"!pc.profileNoFound\" dw-loading=\"profile\" class=\"md-padding\" flex-sm=\"100\" ng-class=\"{\'flex-80\': isInterestInfo, \'flex-60\': !isInterestInfo}\"><div class=\"clear\"></div><div flex=\"\" layout=\"row\" layout-align=\"space-between start\" ng-class=\"{\'h20\': !main.currentSession.shop.anchepedheMarriageBureau && !pc.editProfilelInfo && !pc.editPartnerPrefInfo, \'h70\': main.currentSession.shop.anchepedheMarriageBureau && main.currentSession.shop.id.indexOf(pc.profile.shopId) > -1 && !pc.editProfilelInfo && !pc.editPartnerPrefInfo}\"><div flex=\"50\"></div><div ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'ACTIVATE_PROFILE\') && main.currentSession.shop.id.indexOf(pc.profile.shopId) > -1 && (main.currentSession.shop.anchepedheMarriageBureau || main.currentSession.shop.id== \'5e5e1485cc3b8177d9f0bdab\' || pc.profile.profileStatus === \'Pending for Activation\')\"><form style=\"position: relative;\" name=\"pc.activateForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"pc.activateProfile(pc.profile.id)\"><api-validate></api-validate><div layout=\"50\" ng-if=\"pc.profileStatusOptions && pc.profileStatusOptions.length > 0\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Select Profile Status</label><md-select name=\"profileStatus\" required=\"\" ng-model=\"pc.profileStatus\"><md-option ng-repeat=\"item in pc.profileStatusOptions\" value=\"{{item.code}}\">{{item.code}}</md-option></md-select></md-input-container></div><div style=\"margin-top: -28px;position: absolute;\" ng-if=\"pc.activateForm.profileStatus.$error || pc.activateForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"pc.activateForm.profileStatus.$error.required\">Please select Profile Status.</span></div><div class=\"load\" dw-loading=\"activateProfile\" dw-loading-options=\"{text: \'Activating Profile...\'}\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warn md-cornered md-primary btn-new\" style=\"height: 35px;\" type=\"submit\">Activate Profile</md-button></div></form></div><div class=\"sc-didJYH\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_SUPER_ADMIN\') && main.currentSession.permissions.includes(\'DELETE_OTHERBUREAU_PROFILE\') && (main.currentSession.shop.id.indexOf(\'588df074cc3b812f3aaba015\') > -1 || (main.currentSession.shop.id.indexOf(\'5e9eaa7bcc3b8103fdee37ca\') > -1 && pc.profile.caste.indexOf(\'Lingayath\') > -1))) || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.id.indexOf(pc.profile.shopId) > -1 || main.currentSession.profileBasicInfo.matrimonyId == pc.profile.matrimonyId)\"><md-menu><md-button style=\"width: 40px !important;\" aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"pc.openMenu($mdMenu, $event)\"><span><i class=\"material-icons md-36 edit\">keyboard_arrow_down</i></span></md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"main.currentSession.permissions.includes(\'EDIT_PROFILE\')\"><md-button ng-click=\"pc.editProfile()\"><span><i class=\"material-icons md-24 edit\">perm_identity</i></span> <span>Edit Profile</span></md-button></md-menu-item><md-menu-divider ng-if=\"main.currentSession.permissions.includes(\'EDIT_PARTNER_PREFERENCE\')\"></md-menu-divider><md-menu-item ng-if=\"main.currentSession.permissions.includes(\'EDIT_PARTNER_PREFERENCE\')\"><md-button ng-click=\"pc.editPartnerPreference($event)\"><span><i class=\"material-icons md-24 edit\">face</i></span> <span>Edit Partner Preference</span></md-button></md-menu-item><md-menu-item ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\') && main.currentSession.permissions.includes(\'EDIT_PROFILE_PASSWORD\') && (pc.profile.profileStatus === \'Free Member\' || pc.profile.profileStatus === \'Paid Member\')\"><md-button ng-click=\"pc.openChangePasswordDialog()\"><span><i class=\"material-icons md-24 edit\">info_outline</i></span> <span>Edit Password</span></md-button></md-menu-item><md-menu-divider ng-if=\"main.currentSession.permissions.includes(\'DELETE_PROFILE\')\"></md-menu-divider><md-menu-item ng-if=\"main.currentSession.permissions.includes(\'DELETE_PROFILE\')\"><md-button ng-click=\"pc.deleteProfile()\"><span><i class=\"material-icons md-24 edit\">delete_forever</i></span> <span>Delete Profile</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-if=\"!pc.editProfilelInfo && !pc.editPartnerPrefInfo\" class=\"CoreContent\" style=\"position: relative;flex: 1 1 0%;margin-top: 100px;\"><div class=\"CoreMain\" style=\"position: relative;z-index: 1;flex: 1 1 0%;display: flex;flex-flow: column nowrap;max-height: 100%;height: 100%;box-sizing: border-box;\"><div><div class=\"sc-ifzvzx ilEjRh\"><div class=\"sc-kxyuPp\"><md-card style=\"height: 320px;\"><md-card-content layout=\"\" flex=\"\"><div flex=\"44\" style=\"position: relative; top: -72px;\" class=\"sc-gyhKFA\" data-test-selector=\"profile_photo_wrapper\"><div class=\"just-joined\" ng-show=\"pc.utilService._isRecentProfile(pc.profile.profileCreatedOn)\"></div><div class=\"sc-cMOKGX eGkYNO\" type=\"profile\"><div class=\"sc-kYnif ktdCay\"><div style=\"height:400px !important;\" class=\"sc-iclvYL igwvZs\" type=\"profile\"><div class=\"sc-chYKBT\" ng-style=\"pc.currentImage\"></div><nav class=\"sc-mWPeY jfhRQb\" type=\"profile\" ng-if=\"pc.profile.profileImages.length>1\"><button class=\"sc-beROAQ fvvGZu\" icon=\"prev\" ng-click=\"pc.setCurrentImage(pc.cur-1)\"></button><div class=\"sc-bchHHi hKgVQm\">{{pc.cur}} of {{::pc.profile.profileImages.length}}</div><button class=\"sc-beROAQ jUUwmB\" icon=\"next\" ng-click=\"pc.setCurrentImage(pc.cur+1)\"></button></nav></div><div data-test-selector=\"FreeA plan_free\" class=\"sc-bMuqKn dEAsKZ\"></div><div class=\"sc-eQvJSV Xjvfb\"></div></div></div></div><div flex=\"60\" style=\"padding-left: 40px;\"><ul><li><span class=\"md-headline\">{{::pc.profile.profileName}}</span> <span>({{::pc.profile.matrimonyId}})</span> <span ng-if=\"pc.profile.shopProfileRegId && (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.id.indexOf(pc.profile.shopId) > -1\">({{::pc.profile.shopProfileRegId}})</span><md-button ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\') && (pc.profile.profileStatus === \'Free Member\' || pc.profile.profileStatus === \'Paid Member\') && main.currentSession.shop.id.indexOf(pc.profile.shopId) > -1\" class=\"md-raised\" ng-href=\"/payment?matrimonyId={{pc.profile.matrimonyId}}\">Continue Payment</md-button></li><li><span class=\"sc-bGbZqa hevShD md-subhead\" ng-if=\"pc.profile.profileStatus !== \'Pending for Activation\' && pc.profile.profileStatus !== \'Delete Profile\' && (pc.profile.profileStatus === \'Free Member\' || pc.profile.profileStatus === \'Paid Member\' || main.currentSession.shop.anchepedheMarriageBureau)\">{{pc.profile.profileStatus}}</span></li><li><span class=\"sc-bGbZqa hevShD\" style=\"background: red\" ng-if=\"pc.profile.profileStatus === \'Pending for Activation\' || pc.profile.profileStatus === \'Delete Profile\'\">{{pc.profile.profileStatus}}</span></li></ul><ul style=\"padding: 0px; margin: 0px; line-height: 23px; font-size: 13px;\"><li title=\"Age / Height Info\"><span class=\"basic-details-name\">{{main.getAge(pc.profile.dob)}}</span>, <span>{{::pc.profile.height.value}}</span>, <span>{{::pc.profile.martialStatus}}</span></li><li title=\"Religion Info\"><span class=\"basic-details-religion\">{{::pc.profile.religion}}</span></li><li title=\"Caste\"><span class=\"basic-details-caste\">{{::pc.profile.caste}}</span><span ng-if=\"pc.profile.casteNoBar\" class=\"\">(Caste No Bar)</span></li><li title=\"Location\"><span class=\"basic-details-location\"><span ng-if=\"pc.profile.currentLivingCity != \'Other\'\">{{pc.profile.currentLivingCity}},</span> <span ng-if=\"pc.profile.currentLivingCity == \'Other\'\">{{pc.profile.otherCurrentLivingCity}},</span> <span ng-if=\"pc.profile.currentLivingState\">{{::pc.profile.currentLivingState}},</span> <span>{{::pc.profile.currentLivingCountry}}</span></span></li><li title=\"Education\"><span class=\"basic-details-education\">{{::pc.profile.highestEducation}}</span></li><li title=\"Occupation Info\"><span class=\"basic-details-profession\" ng-if=\"pc.profile.occupation && pc.profile.occupation.indexOf(\'Other\') != 0\">{{::pc.profile.occupation}}</span></li><li><span class=\"basic-details-income\"><span ng-if=\"pc.profile.annualIncome > 0\">Earns Upto INR {{main.getFormatAmount(pc.profile.annualIncome)}} annually</span> <span ng-if=\"pc.profile.employedIn.indexOf(\'Not Working\') < 0 && pc.profile.annualIncome===0\">Doesn\'t wish to specify <span ng-switch=\"pc.profile.gender\"><span ng-switch-when=\"Male\">his</span> <span ng-switch-when=\"Female\">her</span></span> income</span></span></li></ul></div></md-card-content></md-card><div class=\"mt40\"></div><md-card layout=\"column\" ng-if=\"!main.currentSession.packagePlan.offeredPackage && main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'VIEW_CONTACTNO_BUTTON\') && (main.currentSession.profileBasicInfo.shopId.indexOf(pc.profile.shopId) > -1 || (main.currentSession.shop.anchepedheMarriageBureau && pc.profile.anchepedheMarriageBureau)) && main.currentSession.profileBasicInfo.gender != pc.profile.gender && main.currentSession.profileBasicInfo.matrimonyId != pc.profile.matrimonyId\"><div layout=\"row\"><div class=\"heading\" flex=\"70\">Profile Interest</div></div><md-card-header><md-card-header-text><div ng-show=\"errorDetails\"><span class=\"md-subhead\">Sorry, This member looking the following things are mandatory in partner.</span><div ng-repeat=\"error in errorDetails\"><span class=\"error\">{{::error.code}}.</span></div></div><span class=\"md-subhead\"><span ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.profileBasicInfo.matrimonyId != pc.profile.matrimonyId && (!pc.profileInterest || pc.profileInterest.interestStatus.length == 0)\">Like this member?. Take the next step by expressing interest.</span> <span ng-if=\"main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId\">You have expressed interest to this member.</span> <span ng-if=\"(pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 900 || pc.profileInterest.interestStatus[0].id == 700) && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].toMatrimonyId\">This member has expressed interest. <span ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2000 || pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2100\">Say yes to communicate further.</span></span> <span ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 800 && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId\">Sorry Your profile did not match with this member\'s expectations.</span> <span ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 800 && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].toMatrimonyId\">You declined this member\'s interest.</span></span></md-card-header-text></md-card-header><md-card-content><div layout=\"column\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.profileBasicInfo.matrimonyId != pc.profile.matrimonyId && !pc.profileInterest.id\"><div ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [700]\"><md-button class=\"load md-hue-1\" dw-loading=\"interestBtn\" dw-loading-options=\"{text: \'\',spinnerOptions: {}}\" ng-click=\"pc.createUpdateInterest(option, main.currentSession.profileBasicInfo.matrimonyId, pc.profile.matrimonyId, $event)\"><span><i class=\"material-icons md-24 edit\">favorite_border</i></span> <span class=\"col2\">{{::option.shortCode}}</span></md-button></div></div><div ng-if=\"pc.profileInterest.id && (pc.profileInterest.interestStatus[0].id == 700 && pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id != 800 && pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id != 900) && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId\" ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [700]\"><md-button ng-disabled=\"true\"><span><i class=\"material-icons md-24 edit\">favorite</i></span> <span class=\"col2\">{{::option.code}}</span> <span><i class=\"material-icons md-24 edit\">done</i></span></md-button></div><div layout=\"\"><md-button ng-disabled=\"true\" ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 900 && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].toMatrimonyId\"><span><i class=\"material-icons md-24 edit\">compare_arrows</i></span> <span class=\"col2\">You Accepted this member\'s Interest With Wish to meet</span></md-button><md-button ng-disabled=\"true\" ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 900 && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId\"><span><i class=\"material-icons md-24 edit\">compare_arrows</i></span> <span class=\"col2\">This member accepted your Interest With Wish to meet</span></md-button><md-button ng-disabled=\"true\" ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2500\"><span><i class=\"material-icons md-24 edit\">compare_arrows</i></span> <span class=\"col2\">{{pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].code}}</span></md-button><md-button ng-disabled=\"true\" ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 800 && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId\"><span><i class=\"material-icons md-24 edit\">swap_horiz</i></span> <span class=\"col2\">Not Interested</span></md-button><md-button ng-disabled=\"true\" ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2300\"><span><i class=\"material-icons md-24 edit\">swap_horiz</i></span> <span class=\"col2\">{{pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].code}}</span></md-button><md-button ng-disabled=\"true\" ng-if=\"pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2400\"><span><i class=\"material-icons md-24 edit\">swap_horiz</i></span> <span class=\"col2\">{{pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].code}}</span></md-button></div><div layout=\"row\" ng-if=\"(pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2100 || pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].id == 2000) && main.currentSession.profileBasicInfo.matrimonyId == pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].toMatrimonyId\" class=\"load\" dw-loading=\"interestAcceptDecline\" dw-loading-options=\"{text: \'Updating Interest\',spinnerOptions: {}}\"><md-button ng-click=\"pc.createUpdateInterest(option, pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId, pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].toMatrimonyId, $event)\" ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [900]\"><span><i class=\"material-icons md-24 edit\">favorite</i></span> <span class=\"col2\">Accept Interest</span></md-button><md-button ng-click=\"pc.declineInterest($event, option, pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].fromMatrimonyId, pc.profileInterest.interestStatus[pc.profileInterest.interestStatus.length-1].toMatrimonyId)\" ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [800]\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2\">Decline Interest</span></md-button></div></md-card-content></md-card><md-card ng-if=\"(main.currentSession.roles.includes(\'ROLE_SUPER_ADMIN\') && main.currentSession.permissions.includes(\'VIEW_OTHERBUREAU_PROFILE_CONTACT\') && (main.currentSession.shop.id.indexOf(\'588df074cc3b812f3aaba015\') > -1 || (main.currentSession.shop.id.indexOf(\'5e9eaa7bcc3b8103fdee37ca\') > -1 && pc.profile.caste.indexOf(\'Lingayath\') > -1))) || (((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'VIEW_PROFILE_CONTACT\') && pc.profile.shopId.indexOf(main.currentSession.shop.id) > -1) || main.currentSession.userId.indexOf(pc.profile.userId) > -1)\" layout=\"column\" style=\"margin-top: 60px;\"><md-card-content><div class=\"biggertxt paddt5 clr9 paddb10\">Contact Details</div><div layout=\"column\" flex=\"\" style=\"display: flex; border-width: 1px; border-style: solid; border-color: rgb(246, 245, 230); border-image: initial; background: rgb(253, 253, 244); padding: 9px 26px;\"><div>Primary Contact Number <span><a ng-href=\"tel:{{::pc.profile.mobileNo}}\">{{::pc.profile.countryCode}} {{::pc.profile.mobileNo}}</a></span> <span style=\"padding: 0 5px 0 5px;\" ng-repeat=\"contact in pc.profile.familyContactInfo\"><span>{{::contact.relationShipType}}</span> <span ng-if=\"contact.name\">{{::contact.name}}</span> <span><a ng-href=\"tel:{{::contact.mobileNo}}\">{{::contact.mobileNo}}</a></span></span></div><div ng-if=\"pc.profile.email\" style=\"padding-top: 5px;\"><a>{{::pc.profile.email}}</a></div></div></md-card-content></md-card><md-card layout=\"column\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'VIEW_CONTACTNO_BUTTON\') && main.currentSession.profileBasicInfo.gender != pc.profile.gender && main.currentSession.profileBasicInfo.matrimonyId != pc.profile.matrimonyId && ((main.currentSession.profileBasicInfo.caste != pc.profile.caste && (pc.profile.casteNoBar || main.currentSession.partnerPreference.showAllProfiles)) || (main.currentSession.profileBasicInfo.caste == pc.profile.caste))\"><div layout=\"row\"><div class=\"heading\" flex=\"70\">View Mobile Number</div><div dw-loading=\"shortListBtn\" flex=\"30\" class=\"load cursor_pointer\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\')\" ng-click=\"pc.shortListProfile()\"><div ng-if=\"main.currentSession.permissions.includes(\'SHORTLIST_BUTTON\') && (!pc.profileShortList || !pc.profileShortList.shortListed) && !(main.currentSession.packagePlan.paidMemberExpired)\"><span class=\"prt7\"><i class=\"material-icons md-24 icon-color\">grade</i></span><md-tooltip>Click here to shortlist this member</md-tooltip><span class=\"col2\">Short List</span></div><div ng-if=\"main.currentSession.permissions.includes(\'SHORTLIST_BUTTON\') && !pc.profileShortList && (main.currentSession.packagePlan.paidMemberExpired)\"><span class=\"prt7\"><i class=\"material-icons md-24 icon-color\">grade</i></span><md-tooltip>Upgrade Your Membership to shortlist this profile</md-tooltip><span class=\"col2\">Short List</span></div><div ng-if=\"main.currentSession.permissions.includes(\'SHORTLIST_BUTTON\') && pc.profileShortList.shortListed\"><span class=\"prt7\"><i class=\"material-icons md-24 p_shortlisted\">grade</i></span> <span class=\"col2\">Already Shortlisted</span><md-tooltip>This member you already shortlisted</md-tooltip></div></div></div><md-card-header><md-card-header-text><div ng-show=\"errorDetails\"><span class=\"md-subhead\">Sorry, This member looking the following things are mandatory in partner.</span><div ng-repeat=\"error in errorDetails\"><span class=\"error\">{{::error.code}}.</span></div></div><span class=\"md-subhead\"></span></md-card-header-text></md-card-header><md-card-content dw-loading=\"mobileNoBtn\" class=\"\"><div layout=\"\" layout-align=\"space-between start\"><div layout=\"column\" ng-if=\"!pc.mobileNoRequest\" ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [2600]\"><md-button ng-click=\"pc.viewContactNumber(option, $event, pc.profile.matrimonyId)\"><span><i class=\"material-icons md-24 edit\">smartphone</i></span> <span class=\"col2\">{{::option.shortCode}}</span></md-button></div><div ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && (pc.mobileNoRequest && pc.mobileNoRequest.mobileNoRequestStatus[pc.mobileNoRequest.mobileNoRequestStatus.length-1].id == 1300)\" layout=\"column\" ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [1500]\"><md-button ng-disabled=\"true\"><span><i class=\"material-icons md-24 edit\">info_outline</i></span> <span class=\"col2\">Your</span> <span class=\"col2\">{{::option.shortCode}}</span> <span><i class=\"material-icons md-24 edit\">done</i></span></md-button><span class=\"ask\">to your marriage bureau. By that they will send you the mobile No.</span></div><div ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && pc.mobileNoRequest\" layout=\"column\" ng-repeat=\"option in pc.profileInterestTemplate.interestStatusOptions | statusFilter: [1700]\"><span><span class=\"col2\" ng-repeat=\"mobileStatus in pc.mobileNoRequest.mobileNoRequestStatus\"><span ng-bind-html=\"mobileStatus.msg\"></span></span></span></div><div ng-if=\"pc.mobileNoRequest\"><md-button class=\"md-raised md-warn\" ng-click=\"pc.reportContactNoIssue($event)\"><span><i style=\"color: #ffff;\" class=\"material-icons md-24 edit\">error</i></span> Report Contact Number Issue</md-button></div></div></md-card-content></md-card><md-card style=\"margin-top: 37px;\"><div class=\"sc-duVqjH\" style=\"box-shadow: rgba(43, 59, 93, 0.29) 0px 1px 2px;\"><div class=\"sc-jOnSTu kPWjE\"><div class=\"sc-doidfC hIrwXL\"><div class=\"sc-jpYMuy kmMnwB\">Detailed Profile</div><a class=\"sc-bwNswr jiaSMv\" ng-click=\"pc.goto(\'horoscope\')\">Horoscope Details</a> <a class=\"sc-bwNswr jiaSMv\" ng-click=\"pc.goto(\'preference\')\">Partner Preference</a></div><div class=\"sc-iaAMwK jedZrk\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'SHARE_WHATSAPP_IMAGE\')\"><a ng-click=\"pc.shareWhatsApImage(pc.profile,$event)\" class=\"sc-cApOHT\"><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\"></a></div></div></div><md-card-content><div style=\"width:720px;\"><div class=\"newvp-aboutinfo-icon fleft\" style=\"width:45px; height:45px;\"></div><div id=\"softtagwchg\" style=\"margin: 0px 10px; width: 600px;\" class=\"fleft\"><div class=\"biggertxt pt5 clr9 pdb40\">About {{::pc.profile.profileName}} <a style=\"margin-top:-60px; display:block;\" class=\"absolute\" name=\"AboutInfo\"></a></div><div class=\"hdtxt lheight120\" style=\"margin-top: 77px;\"><div id=\"profilesubstrdesc\" ng-if=\"pc.profile.aboutProfile\">{{::pc.profile.aboutProfile}}</div><div ng-if=\"!pc.profile.aboutProfile\">Not Specified</div></div></div><div class=\"fleft\"></div><div class=\"clear\"></div></div><div style=\"width:720px;margin-top: 20px;\"><div class=\"newvp-basicinfo-icon fleft\" style=\"width:45px; height:45px;\"></div><div style=\"width:405px;margin-left:10px;\" class=\"fleft\"><div class=\"biggertxt paddt5 clr9 paddb10\">Basic Details</div><div class=\"fleft hdtxt\" style=\"width:655px;\"><div class=\"paddl2 paddt5\"><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Name</div><div class=\"fleft colon paddl15 width175\">{{::pc.profile.profileName}}</div></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Physical Status</div><div class=\"fleft colon paddl15\" style=\"width:165px;\">{{::pc.profile.physicalStatus}}</div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Age</div><div class=\"fleft colon paddl15 width175\">{{main.getAge(pc.profile.dob)}}</div></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Eating Habits</div><div class=\"fleft colon paddl15\" style=\"width:165px;\"><div>{{::pc.profile.vegOrNonVeg}}</div></div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Height</div><div class=\"fleft colon paddl15 width175\"><span class=\"htprimary\">{{::pc.profile.height.value}}</span></div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Weight</div><div class=\"fleft colon paddl15 width175\"><span class=\"\" ng-if=\"pc.profile.weight\">{{::pc.profile.weight}} Kgs</span> <span ng-if=\"!pc.profile.weight\">Not Specified</span></div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Mother Tongue</div><div class=\"fleft colon paddl15 width175\"><span class=\"htprimary\">{{::pc.profile.motherTongue}}</span></div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Marital Status</div><div class=\"fleft colon paddl15 width175\">{{::pc.profile.martialStatus}}</div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\" ng-if=\"pc.profile.martialStatus.indexOf(\'Never Married\') < 0\"><div class=\"fleft width140\">No.of Children</div><div class=\"fleft colon paddl15 width175\"><span ng-switch=\"pc.profile.noOfchildren > 0\"><span ng-switch-when=\"false\">None</span> <span ng-switch-when=\"true\">{{::pc.profile.noOfchildren}}</span></span></div></div></div></div><div class=\"clear paddb4\"></div><br><br></div><div class=\"clear\"></div></div><div style=\"width:720px;\"><div class=\"newvp-relgninfo-icon fleft\" style=\"width:45px; height:45px;\"></div><div style=\"width:665px;float:left;margin-left:10px;position: relative;\"><div class=\"biggertxt paddt5 clr9 paddb10\">Background</div><div class=\"fleft hdtxt\" style=\"width:430px;\"><div class=\"paddl2 paddt5\"><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Religion</div><div class=\"fleft colon paddl15\" style=\"width: 270px;\"><span class=\"htreligious\">{{::pc.profile.religion}}</span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Caste / Sub Caste</div><div class=\"fleft colon paddl15\" style=\"width: 270px;\"><span class=\"htreligious\">{{::pc.profile.caste}} <span ng-if=\"pc.profile.casteNoBar\">(Caste No Bar)</span><span class=\"\">/</span> <span class=\"\">{{::pc.profile.subCaste}}</span><span ng-if=\"pc.profile.subCasteNoBar\">(Subcaste No Bar)</span></span></div><div class=\"clear\"></div></div></div></div><div class=\"fleft\"></div></div><div class=\"clear\"></div></div><div style=\"width:720px;\" class=\"mt20\" id=\"horoscope\"><div class=\"newvp-horoscope-icon fleft\" style=\"width:45px; height:45px;\"></div><div style=\"width:665px;float:left;margin-left:10px;position: relative;\"><div class=\"biggertxt paddt5 clr9 paddb10\">Horoscope Details</div><div class=\"fleft hdtxt\" style=\"width:430px;\"><div class=\"paddl2 paddt5\"><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Gothram</div><div class=\"fleft colon paddl15\" style=\"width: 270px;\"><span class=\"htreligious\"><span ng-if=\"pc.profile.gothram\">{{::pc.profile.gothram}}</span> <span ng-if=\"!pc.profile.gothram\">Not Specified</span></span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Star / Raasi</div><div class=\"fleft colon paddl15\" style=\"width: 270px;\"><span class=\"htreligious\">{{::pc.profile.star}} <span class=\"\">/</span> {{::pc.profile.raasi}}</span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Dosh</div><div class=\"fleft colon paddl15\" style=\"width: 270px;\">Not Specified</div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\" ng-if=\"pc.profile.horoscopeImage\"><div class=\"fleft width140\">Horoscope</div><div class=\"fleft colon paddl15\" style=\"width: 270px;\"><span class=\"col2\"><a ng-click=\"showAdvanced($event, pc.profile.horoscopeImage.originalImage)\">Click here View Horoscope</a></span></div><div class=\"clear\"></div></div><div class=\"sc-emDGWR dgtmcL\" ng-if=\"!pc.profile.dontNoDOB || pc.profile.birthTime.indexOf(\'undefined\') < 0\"><div class=\"sc-fLcSlx hkiENw\"><span ng-if=\"!pc.profile.dontNoDOB\" class=\"sc-kVIJgn bXpyaj\"><span style=\"padding-right: 3px;\">Born</span> <span ng-if=\"pc.profile.birthPlace\" style=\"padding-right: 3px;\">in {{::pc.profile.birthPlace}}</span> <span>on {{::pc.profile.dateOfBirth}}</span></span> <span ng-if=\"pc.profile.birthTime.indexOf(undefined) < 0\">at {{::pc.profile.birthTime}}</span></div></div></div></div><div class=\"fleft\"></div></div><div class=\"clear\"></div></div><div style=\"width:720px;\" class=\"mt20\"><div class=\"newvp-locinfo-icon fleft\" style=\"width:45px; height:45px;\"></div><div style=\"width:405px;float:left;margin-left:10px;\"><div class=\"biggertxt paddt5 clr9 paddb10\"><span ng-switch=\"pc.profile.gender\"><span ng-switch-when=\"Male\">Groom\'s</span> <span ng-switch-when=\"Female\">Bride\'s</span></span> Location</div><div class=\"fleft hdtxt\" style=\"width:655px;\"><div class=\"paddl2 paddt5\"><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Country</div><div class=\"fleft colon paddl15 width175\"><div class=\"fleft paddr5\">{{::pc.profile.currentLivingCountry}}</div></div><div class=\"clear\"></div></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">Citizenship</div><div class=\"fleft colon paddl15\" style=\"width:153px;\"><div class=\"fleft paddr5\">{{::pc.profile.citizenship}}</div></div><div class=\"clear\"></div></div><div class=\"clear\"></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">State</div><div class=\"fleft colon paddl15 width175\"><div class=\"fleft paddr5\" ng-if=\"pc.profile.currentLivingState\">{{::pc.profile.currentLivingState}}</div><div class=\"fleft paddr5\" ng-if=\"!pc.profile.currentLivingState\">Not Specified</div></div><div class=\"clear\"></div></div><div class=\"fleft paddt5 paddb5\"><div class=\"fleft width140\">City</div><div class=\"fleft colon paddl15\" style=\"width:153px;\"><div class=\"fleft paddr5\">{{::pc.profile.currentLivingCity}}</div><div class=\"relative fleft\"><div class=\"vp-loc paddt10 paddb10 absolute bgclr3\" style=\"display:none; left:-230px;\" id=\"contactinfo\"></div></div></div><div class=\"clear\"></div></div><div class=\"clear\"></div></div></div><div class=\"clear paddb4\"></div><br><br></div><div class=\"clear\"></div></div><div style=\"width:720px;\"><div class=\"newvp-profinfo-icon fleft\" style=\"width:45px; height:45px;\"></div><div style=\"width:405px;float:left;margin-left:10px;\"><div class=\"biggertxt paddt5 clr9 paddb10\">Professional Information</div><div class=\"fleft hdtxt\" style=\"width:655px;\"><div class=\"paddl2 paddt5\"><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Education</div><div class=\"fleft colon paddl15 width400\"><span style=\"display:inline;\">{{::pc.profile.highestEducation}}</span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">College / Institution</div><div class=\"fleft colon paddl15 width400\"><span style=\"display:inline;\">Not Specified</span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Education in Detail</div><div class=\"fleft colon paddl15 width400\"><span ng-if=\"pc.profile.moreInfoAboutEducation\">{{::pc.profile.moreInfoAboutEducation}}</span> <span ng-if=\"!pc.profile.moreInfoAboutEducation\">Not Specified</span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Employed in</div><div class=\"fleft colon paddl15 width400\"><span class=\"htprofessional\"><span style=\"display:inline;\">{{::pc.profile.employedIn}}</span></span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Occupation</div><div class=\"fleft colon paddl15 width400\"><span class=\"htprofessional\"><span style=\"display:inline;\">{{::pc.profile.occupation}}</span></span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Occupation in Detail</div><div class=\"fleft colon paddl15 width400\"><span ng-if=\"pc.profile.moreInfoAboutJob\">{{::pc.profile.moreInfoAboutJob}}</span> <span ng-if=\"!pc.profile.moreInfoAboutJob\">Not Specified</span></div><div class=\"clear\"></div></div><div class=\"paddt5 paddb5\"><div class=\"fleft width140\">Annual Income</div><div class=\"fleft colon paddl15 width400\"><span class=\"htprofessional\"><span ng-if=\"pc.profile.annualIncome > 0\">{{main.getFormatAmount(pc.profile.annualIncome)}}</span> <span ng-if=\"!pc.profile.annualIncome > 0\">Doesn\'t wish to specify <span ng-switch=\"pc.profile.gender\"><span ng-switch-when=\"Male\">his</span> <span ng-switch-when=\"Female\">her</span></span> income.</span></span></div><div class=\"clear\"></div></div></div><div id=\"linkedindisplay\" style=\"display: block;\"></div></div><div class=\"clear paddb4\"></div><br><br></div><div class=\"clear\"></div></div><div style=\"width:720px;\"><div class=\"newvp-famlyinfo-icon fleft\" style=\"width:45px; height:45px;\"></div><div style=\"width:405px;margin-left:10px;\" class=\"fleft\"><div class=\"biggertxt paddt5 clr9 paddb10\" style=\"margin-bottom:10px;\">Family Details</div><div class=\"fleft hdtxt\" style=\"width:655px;\"><div class=\"relative\"><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Family Status</div><div class=\"fleft colon paddl15 width175\"><span ng-if=\"pc.profile.familyStatus\">{{::pc.profile.familyStatus}}</span> <span ng-if=\"!pc.profile.familyStatus\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Ancestral Origin</div><div class=\"fleft colon paddl15\"><span ng-if=\"pc.profile.ancestralOrigin\">{{::pc.profile.ancestralOrigin}}</span> <span ng-if=\"!pc.profile.ancestralOrigin\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"clear\"></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Father Status</div><div class=\"fleft colon paddl15 width175\"><span ng-if=\"pc.profile.familyStatus\">{{::pc.profile.fatherStatus}}</span> <span ng-if=\"!pc.profile.familyStatus\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Father Name</div><div class=\"fleft colon paddl15\"><span ng-if=\"pc.profile.fatherName\">{{::pc.profile.fatherName}}</span> <span ng-if=\"!pc.profile.fatherName\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"clear\"></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Mother Status</div><div class=\"fleft colon paddl15 width175\"><span ng-if=\"pc.profile.motherStatus\">{{::pc.profile.motherStatus}}</span> <span ng-if=\"!pc.profile.motherStatus\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Mother Name</div><div class=\"fleft colon paddl15\"><span ng-if=\"pc.profile.motherName\">{{::pc.profile.motherName}}</span> <span ng-if=\"!pc.profile.motherName\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"clear\"></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">No. of Brother(s)</div><div class=\"fleft colon paddl15 width175\"><span style=\"display:inline;\">{{pc.profile.noOfBrothers == null ? \"Not Specified\":pc.profile.noOfBrothers == 0 ? \"None\" : pc.profile.noOfBrothers}} {{pc.profile.noOfBrothers == null ? \"\" : (pc.profile.noOfBrothers == 0 ? \"\" : \" / \"+(pc.profile.brothersMarried==0 ? \"Not Married\" : pc.profile.brothersMarried != null ? pc.profile.brothersMarried +\" Married\" : \"Not Specified\"))}}</span></div><div class=\"clear paddb4\"></div></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">No. of Sister(s)</div><div class=\"fleft colon paddl15\"><span style=\"display:inline;\">{{pc.profile.noOfSisters == null ? \"Not Specified\":pc.profile.noOfSisters == 0 ? \"None\" : pc.profile.noOfSisters}} {{pc.profile.noOfSisters == null ? \"\": (pc.profile.noOfSisters == 0 ? \"\" : \" / \"+(pc.profile.sistersMarried==0 ? \"Not Married\" : pc.profile.sistersMarried != null ?pc.profile.sistersMarried+\" Married\" : \"Not Specified\"))}}</span></div><div class=\"clear paddb4\"></div></div><div class=\"clear\"></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Family Residing State</div><div class=\"fleft colon paddl15 width175\"><span ng-if=\"pc.profile.familyResidingState\">{{::pc.profile.familyResidingState}}</span> <span ng-if=\"!pc.profile.familyResidingState\">Not Specified</span></div><div class=\"clear paddb4\"></div></div><div class=\"fleft\"><div class=\"fleft width140 paddb5\">Family Residing District</div><div class=\"fleft colon paddl15\"><span ng-if=\"pc.profile.familyResidingDistrict\">{{::pc.profile.familyResidingDistrict}}</span> <span ng-if=\"!pc.profile.familyResidingDistrict\">Not Specified</span> <span ng-if=\"pc.profile.familyResidingTaluk\">/ {{::pc.profile.familyResidingTaluk}} (Taluk)</span></div><div class=\"clear paddb4\"></div></div></div><div class=\"clear\"></div><div class=\"paddt10\" ng-if=\"pc.profile.propertyDetails.length > 0\"><div class=\"boldtxt hdtxt1 paddb10\">About Property</div><div class=\"txt-justify lheight18\"><span style=\"display:inline;\" ng-repeat=\"propertyDetail in pc.profile.propertyDetails\"><span>{{::propertyDetail.propertyType}}</span> <span ng-if=\"propertyDetail.moreInfoAboutProperty\"><span>{{::propertyDetail.moreInfoAboutProperty}}</span></span></span><div class=\"clear\"></div></div></div><div class=\"clear paddb10\"></div><div class=\"paddt10\"><div class=\"boldtxt hdtxt1 paddb10\">About My Family</div><div class=\"txt-justify lheight18\"><span style=\"display:inline;\" ng-if=\"pc.profile.moreInfoAboutFamily\">{{::pc.profile.moreInfoAboutFamily}}</span> <span ng-if=\"!pc.profile.moreInfoAboutFamily\">Not Specified</span><div class=\"clear\"></div></div></div><div class=\"clear\"></div><div class=\"paddt20\" ng-if=\"pc.profile.address\"><div class=\"boldtxt hdtxt1 paddb10\">Family Address</div><div class=\"txt-justify lheight18\"><span style=\"display:inline;\">{{::pc.profile.address}}</span><div class=\"clear\"></div></div></div></div><div class=\"clear paddt5\"></div></div><div class=\"clear\"></div></div><div id=\"preference\" style=\"color: #76b05a;font-size: 30px;margin: 20px 0;padding: 10px 0px 20px 0px; border-bottom:1px solid #dedede;\" class=\"txtopac\"><span ng-switch=\"pc.profile.gender\"><span ng-switch-when=\"Male\">His</span><span ng-switch-when=\"Female\">Her</span></span> Partner Preferences</div><div style=\"margin-left: 40px\" flex=\"\"><div style=\"margin:0px 10px;\"><div class=\"paddb20 fleft\"><div class=\"biggertxt paddt10 clr9 paddb10\">Basic Preferences</div><div class=\"fleft\"><div class=\"paddl2 paddt5 hdtxt\"><div class=\"paddt5\"><div class=\"fleft width125\"><span ng-switch=\"pc.profile.gender\"><span ng-switch-when=\"Male\">Bride\'s</span> <span ng-switch-when=\"Female\">Groom\'s</span></span> Age</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"\">{{pc.getAgeByYear(pc.partnerPreference.fYearPref,0,1)}} - {{pc.getAgeByYear(pc.partnerPreference.tYearPref)}}</span> Yrs</div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Height</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"\">{{main.getHeightByCm(pc.partnerPreference.fHeightPref)[\'value\']}} - {{main.getHeightByCm(pc.partnerPreference.tHeightPref)[\'value\']}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Marital Status</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"martialStatus in pc.partnerPreference.martialStatusPref\">{{::martialStatus}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Mother Tongue</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"motherTongue in pc.partnerPreference.motherTonguePref\">{{::motherTongue}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Physical Status</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Eating Habits</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Smoking Habits</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Drinking Habits</div><div class=\"fleft colon paddl20 paddr5\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div></div></div></div><div class=\"clear\"></div><div class=\"paddb20\"><div class=\"biggertxt paddt10 clr9 paddb10\">Religious Preferences</div><div class=\"fleft\"><div class=\"paddl2 paddt5 hdtxt\"><div class=\"paddt5\"><div class=\"fleft width125\">Religion</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\">{{::pc.profile.religion}}</div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Caste</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"prefCaste in pc.partnerPreference.castePref\">{{::prefCaste}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Sub Caste</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"prefSubcaste in pc.partnerPreference.subCastePref\">{{::prefSubcaste}}</span> <span ng-if=\"pc.partnerPreference.subCastePref.length===0\">Any</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Gothram</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"\">All (Except my gothra)</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Star</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Kuja Dosham</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div></div></div><div class=\"clear\"></div></div><div class=\"paddb20\"><div class=\"biggertxt paddt10 clr9 paddb10\">Professional Preferences</div><div class=\"fleft\"><div class=\"paddl2 paddt5 hdtxt\"><div class=\"paddt5\"><div class=\"fleft width125\">Education</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"prefEducation in pc.partnerPreference.highestEducationPref\">{{::prefEducation}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Occupation</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span ng-repeat=\"prefOccupation in pc.partnerPreference.occupationPref\" class=\"pr15\">{{::prefOccupation}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Annual Income</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span ng-if=\"pc.partnerPreference.annualIncomePreFrom !== 0\" ng-bind=\"main.getFormatAmount(pc.partnerPreference.annualIncomePreFrom)\"></span> <span ng-if=\"pc.partnerPreference.annualIncomePreFrom === 0\">Not Specified</span> <span ng-if=\"pc.partnerPreference.annualIncomePreFrom === 1\">Any</span></div></div><div class=\"clear paddb4\"></div></div></div></div><div class=\"clear\"></div></div><div class=\"paddb20\"><div class=\"biggertxt paddt10 clr9 paddb10\">Location Preferences</div><div class=\"fleft\"><div class=\"paddl2 paddt5 hdtxt\"><div class=\"paddt5\"><div class=\"fleft width125\">Country</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"prefCountry in pc.partnerPreference.countryPref\">{{::prefCountry}}</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Residing State</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"prefState in pc.partnerPreference.statePref\">{{::prefState}}</span> <span ng-if=\"pc.partnerPreference.countryPref.indexOf(\'Any\') > -1\">Any</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\" ng-if=\"pc.partnerPreference.countryPref.indexOf(\'Any\') < 0\"><div class=\"fleft width125\">Residing City</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\"><span class=\"pr15\" ng-repeat=\"prefCity in pc.partnerPreference.cityPref\">{{::prefCity}}</span> <span ng-if=\"pc.partnerPreference.countryPref.indexOf(\'Any\') > -1\">Any</span></div></div><div class=\"clear paddb4\"></div></div><div class=\"paddt5\"><div class=\"fleft width125\">Citizenship</div><div class=\"fleft colon paddl20\" style=\"width:465px;\"><div class=\"paddb5\">Not Specified</div></div><div class=\"clear paddb4\"></div></div></div></div><div class=\"clear\"></div><div id=\"mc\" style=\"display:none;\"></div><div class=\"clear\"></div><div class=\"biggertxt paddt10 clr9 paddb10\">What I am Looking For</div><div class=\"txt-justify lheight18 mediumhdrtxt\" ng-if=\"pc.partnerPreference.aboutPartner\" style=\"font-size:14px;\">{{::pc.partnerPreference.aboutPartner}}</div><div ng-if=\"!pc.partnerPreference.aboutPartner\">Not Specified</div><div class=\"paddt15\"></div><div class=\"clear\"></div><div class=\"sc-didJYH dvVdek\"><button class=\"sc-iNwVbF bnTwtV\" ng-click=\"pc.goToTop()\">Back to Top</button><div class=\"sc-hnzTLG bnQMQY\"></div></div></div></div></div></md-card-content></md-card></div></div></div></div></div></md-content></div><script type=\"text/ng-template\" id=\"changepassword.tmpl.html\"><md-dialog aria-label=\"Change Password\" flex=\"30\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Change Password</h2> </div> </md-toolbar> <md-dialog-content style=\"padding:20px\"> <div class=\"outer-container1 mt30\"> <form layout=\"column\" name=\"pc.changePasswordForm\" autocomplete=\"off\" class=\"reset-form \" novalidate=\"novalidate\" ng-submit=\"pc.changePassword()\"> <div class=\"row\"> <label class=\"uplbl activeLbl\" style=\"display: block;\">New Password</label> <input type=\"text\" class=\"textbox_sml\" ng-model=\"pc.newPassword\" maxlength=\"15\" ng-minlength=\"4\" ng-maxlength=\"15\" name=\"newPassword\" required/> </div> <div class=\"mt5\" ng-messages=\"pc.changePasswordForm.newPassword.$error\" ng-if=\"pc.changePasswordForm.newPassword.$dirty || pc.changePasswordForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Password is required.</span> <span class=\"error\" ng-message=\"minlength\">Password should be minimum 4 characters.</span> <span class=\"error\" ng-message=\"maxlength\">Password should be maximum 15 characters.</span> </div> <!-- <div class=\"load\" dw-loading=\"settingBtn\" layout=\"row\" layout-align=\"start center\" > <md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Save</md-button> </div> --> <md-dialog-actions layout=\"row\"> <div class=\"load\" dw-loading=\"settingBtn\"> <md-button class=\"md-raised md-cornered md-primary\" type=\"submit\">Save</md-button> <md-button ng-click=\"cancel()\"> Close </md-button> </div> </md-dialog-actions> </form> </div> </md-dialog-content> </md-dialog></script><script type=\"text/ng-template\" id=\"changemobileno.tmpl.html\"><div class=\"mt30\"> <form layout=\"column\" name=\"pc.resetMobileNoForm\" autocomplete=\"off\" class=\"reset-form\" novalidate=\"novalidate\" ng-submit=\"pc.changeMobileNo()\"> <api-validate></api-validate> <input type=\"hidden\" name=\"guid\" value=\"3134921\"> <input type=\"hidden\" name=\"deleteAllMobileToken\" id=\"deleteAllMobileToken\" value=\"false\"> <!-- Fake fields are a workaround for chrome autofill getting the wrong fields --> <input style=\"display:none\" type=\"text\" name=\"fakeusernameremembered\"> <input style=\"display:none\" type=\"password\" name=\"fakepasswordremembered\"> <!-- Fake fields end--> <div layout-gt-sm=\"row\"> <md-input-container class=\"md-block mr10\" flex=\"40\"> <label>Country Code</label> <input type=\"text\" ng-disabled=\"true\" ng-model=\"pc.profile.countryCode\"/> </md-input-container> <md-input-container class=\"md-block\" flex=\"50\"> <label>Mobile Number</label> <input type=\"text\" name=\"mobileNo\" ng-disabled=\"true\" ng-model=\"pc.profile.mobileNo\"/> </md-input-container> </div> <div layout=\"row\"> <md-input-container class=\"md-block mr10\" flex=\"40\"> <label>Country Code</label> <md-select ng-change=\"pc.newMobileNo=\'\'\" ng-model=\"pc.newCountryCode\" name=\"newCountryCode\" required=\"\"> <ul ng-repeat=\"(key, values) in pc.countryCodeOptions.values | groupBy:\'category\'\"> <li><span>{{key}}</span> <md-option ng-repeat=\"option in values\" ng-value=\"option.value\"> {{option.id}} </md-option> </li> </ul> </md-select> </md-input-container> <div ng-if=\"pc.newCountryCode.indexOf(\'+91\') > -1\" ng-init=\"pc.max=10;pc.min=10;\"></div> <div ng-if=\"pc.newCountryCode.indexOf(\'+91\') < 0\" ng-init=\"pc.max=12;pc.min=9;\"></div> <md-input-container class=\"md-block\" flex=\"50\"> <label>New Mobile Number</label> <input type=\"text\" name=\"newMobileNo\" ng-model=\"pc.newMobileNo\" numbers-only ng-minlength=\"pc.min\" ng-maxlength=\"pc.max\" required/> </md-input-container> </div> <div ng-messages=\"pc.resetMobileNoForm.newCountryCode.$error\" ng-if=\"pc.resetMobileNoForm.newCountryCode.$dirty || pc.resetMobileNoForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Country Code is compulsory.</span> </div> <div ng-messages=\"pc.resetMobileNoForm.newMobileNo.$error\" ng-if=\"pc.resetMobileNoForm.newMobileNo.$dirty || pc.resetMobileNoForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter only a valid mobile number.</span> <span class=\"error\" ng-message=\"maxlength\">Enter only a valid mobile number.</span> </div> <div class=\"error\" ng-show=\"pc.msg\">Old Mobile No. and New Mobile No. shouldn\'t be same.</div> <div class=\"load\" dw-loading=\"settingBtn\" layout=\"row\" layout-align=\"start center\" > <md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Save</md-button> </div> </form> </div></script><script type=\"text/ng-template\" id=\"horoscope.tmpl.html\"><md-dialog aria-label=\"Horoscope\" flex=\"50\"> <form ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Horoscope</h2> </div> </md-toolbar> <md-dialog-content> <div class=\"md-dialog-content\" layout=\"row\" layout-align=\"center center\"> <img width=\"600\" height=\"600\" alt=\"Lush mango tree\" ng-src=\"{{main.imageUrl}}{{imagePath}}\"> </div> </md-dialog-content> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"answer(\'not useful\')\"> Close </md-button> </md-dialog-actions> </form> </md-dialog></script><script type=\"text/ng-template\" id=\"profile-interest.tmpl.html\"><md-dialog aria-label=\"List dialog\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Send Profile Interest</h2> </div> </md-toolbar> <md-dialog-content layout-padding> <form name=\"profileInterestForm\" novalidate=\"novalidate\" autocomplete=\"off\"> <div class=\"md-dialog-content\"> <div layout=\"\"> <md-input-container flex> <p>Have you checked Astrology?</p> <md-radio-group class=\"mt10\" ng-model=\"dc.astrologyChecked\" layout=\"row\" name=\"astrologyChecked\" required> <md-radio-button value=\"Yes\">Yes</md-radio-button> <md-radio-button value=\"No\">No</md-radio-button> <md-radio-button value=\"I Personally Don\'t Believe Astrology\">I Personally Don\'t Believe Astrology</md-radio-button> </md-radio-group> </md-input-container> </div> <div ng-if=\"profileInterestForm.astrologyChecked.$error || profileInterestForm.$submitted\" role=\"alert\"> <span class=\"error\" ng-show=\"profileInterestForm.astrologyChecked.$error.required\">Please select Astrology Checked.</span> </div> <!--<div ng-messages=\"profileInterest.astrologyChecked.$error\" ng-if=\"profileInterest.astrologyChecked.$dirty || profileInterest.$submitted\" role=\"alert\"> <span class=\"error\" ng-message=\"required\">Life Style is compulsory.</span> </div>--> <div layout=\"\" ng-show=\"dc.astrologyChecked.indexOf(\'Yes\') > -1\"> <md-input-container flex> <p>Is Astrology Matched ?</p> <md-checkbox ng-model=\"dc.astrologyMatched\" aria-label=\"Checkbox 1\"> <!--Is Astrology Matched ?--> </md-checkbox> </md-input-container> </div> </div> </form> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> Cancel </md-button> <md-button ng-click=\"saveProfileInterest()\" class=\"md-primary\"> Send Interest </md-button> </md-dialog-actions> </md-dialog></script><script type=\"text/ng-template\" id=\"know-more-info.tmpl.html\"><div class=\"md-dialog-container\"> <md-dialog> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Ask Your Marriage Bureau To Call You Regarding this Member</h2> </div> </md-toolbar> <md-dialog-content layout-padding> <form name=\"askMoreInfoForm\" novalidate=\"novalidate\" autocomplete=\"off\"> <div class=\"md-dialog-content\" ng-init=\"kc.mobileNo=main.currentSession.profileBasicInfo.mobileNo\"> <div layout=\"column\"> <md-input-container flex> <p>I Expect call to this Mobile Number From My Marriage Brueau?</p> <input type=\"text\" ng-model=\"kc.mobileNo\" required name=\"mobileNo\" numbers-only ng-minlength=\"10\" md-maxlength=\"10\" maxlength=\"10\"/> <a class=\"col1\" ng-click=\"kc.mobileNo=\'\'\">Change Mobile Number</a> </md-input-container> <div ng-messages=\"askMoreInfoForm.mobileNo.$error\" ng-if=\"askMoreInfoForm.mobileNo.$dirty || askMoreInfoForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter 10 numbers.</span> </div> </div> </div> </form> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> Cancel </md-button> <md-button ng-click=\"saveKnowMoreInfo()\" class=\"md-primary\"> Call Me </md-button> </md-dialog-actions> </md-dialog> </div></script><script type=\"text/ng-template\" id=\"profile-decline-interest.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"50\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Decline Interest</h2> </div> </md-toolbar> <md-dialog-content layout-padding> <form name=\"declineInterestForm\" novalidate=\"novalidate\" autocomplete=\"off\"> <div class=\"md-dialog-content\"> <div layout=\"\"> <md-input-container class=\"md-block\" flex-gt-sm=\"\"> <label>Decline Reason</label> <md-select name=\"declineReason\" required ng-model=\"dc.declineReason\"> <md-option ng-repeat=\"item in pc.profileInterestTemplate.reasonMessageTypeOptions | filter: {id: \'!\' + \'600\'} : true | filter: {id: \'!\' + \'700\'} : true | filter: {id: \'!\' + \'800\'} : true | filter: {id: \'!\' + \'900\'} : true | filter: {id: \'!\' + \'1000\'} : true | filter: {id: \'!\' + \'1100\'} : true | filter: {id: \'!\' + \'1200\'} : true\" value=\"{{item.value}}\"> {{item.code}} </md-option> </md-select> </md-input-container> </div> <div ng-if=\"declineInterestForm.declineReason.$error || declineInterestForm.$submitted\" role=\"alert\"> <span class=\"error\" ng-show=\"declineInterestForm.declineReason.$error.required\">Please select Decline Reason.</span> </div> </div> </form> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> Cancel </md-button> <md-button ng-click=\"declineInterest(dc.declineReason)\" class=\"md-primary\"> Decline Interest </md-button> </md-dialog-actions> </md-dialog></script><script type=\"text/ng-template\" id=\"report-issue.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"50\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Report Contact Number Issue</h2> </div> </md-toolbar> <md-dialog-content layout-padding dw-loading=\"mobileNoIssueBtn\" class=\"load\"> <div ng-if=\"pc.reportIssue.issueStatus.indexOf(\'Pending For Validation\') > -1\"> <h4>we will validate your reported issue, please give us some time</h4> </div> <div ng-if=\"pc.reportIssue.issueStatus.indexOf(\'Invalid Contact Number\') > -1\"> <h4>we have validated your reported issue, this member contact number is invalid {{pc.reportIssue.msg}}</h4> </div> <div ng-if=\"pc.reportIssue.issueStatus.indexOf(\'Valid Contact Number\') > -1\"> <h4>we have validated your reported issue, but this member contact number is valid {{pc.reportIssue.msg}}</h4> </div> <form name=\"reportIssueForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-show=\"!pc.reportIssue\"> <h4>Not a valid mobile number? Kindly select the reason and submit.</h4> <div class=\"md-dialog-content\"> <div layout=\"\"> <md-input-container class=\"md-block\" flex-gt-sm=\"\"> <label>Issue reason</label> <md-select name=\"issueReason\" required ng-model=\"dc.issueReason\"> <md-option ng-repeat=\"item in pc.profileInterestTemplate.contactNumberIssueTypeOptions\" value=\"{{item.code}}\"> {{item.code}} </md-option> </md-select> </md-input-container> </div> <div ng-if=\"reportIssueForm.issueReason.$error || reportIssueForm.$submitted\" role=\"alert\"> <span class=\"error\" ng-show=\"reportIssueForm.issueReason.$error.required\">Please select issue reason</span> </div> </div> </form> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\" ng-if=\"pc.reportIssue\"> Ok </md-button> <md-button ng-click=\"closeDialog()\" class=\"md-primary\" ng-if=\"!pc.reportIssue\"> Cancel </md-button> <md-button ng-if=\"!pc.reportIssue\" ng-click=\"reportContactNumberIssue(dc.issueReason)\" class=\"md-primary\"> Submit </md-button> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/payment/payment.html","<div ng-cloak=\"\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content dw-loading=\"payment\" class=\"md-padding mh-120 overflow_hidden\" flex=\"60\"><h1>Upgrade Membership</h1><md-divider></md-divider><form ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\')\" dw-loading=\"profile\" dw-loading-options=\"{text: \'Fetching Profile...\'}\" name=\"profileForm\" class=\"load reset-form\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"payc.getProfileByMatrimonyId(profileForm)\"><input name=\"matrimonyId\" placeholder=\"Enter Matrimony ID.\" style=\"margin-right: 35px;width:160px;display: inline-block\" type=\"text\" class=\"textbox_sml\" ng-model=\"payc.selectedMatrimonyId\" required=\"\"><md-button type=\"submit\" class=\"md-primary\">Submit</md-button></form><h4 style=\"color: green;margin: 15px 2px;\" ng-if=\"main.currentSession.shop.showMobileNoInPaymentScreen\">Since website payment is in under maintenance, you can proceed payment to Marriage Bureau via Gpay / Phonepe {{main.currentSession.shop.mobileNo}}</h4><md-radio-group ng-model=\"payc.selectedPackage.id\" class=\"md-padding radioButtondemoMultiColumn\"><div ng-repeat=\"package in payc.packageOptions | filter: {id: \'!\' + \'Free\'}\" class=\"row\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && !package.forMarriageBureau\"><div flex=\"\" style=\"max-width:200px;\">{{package.id}}</div><md-radio-button flex=\"\" ng-value=\"package.id\" class=\"md-primary\" ng-click=\"payc.selectPackage(package.id)\"><span>{{package.value}} Rs For {{package.category.noOfDaysValid}} days</span> <span ng-if=\"package.id.indexOf(\'Platinum\') > -1\">(recommended)</span></md-radio-button></div><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\" ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\')\"><div flex=\"\" style=\"max-width:200px;\">{{package.id}}</div><md-radio-button flex=\"\" ng-value=\"package.id\" class=\"md-primary\" ng-click=\"payc.selectPackage(package.id)\"><span>Pay {{package.convenienceAmnt}} Rs of {{package.value}} Rs For {{package.category.noOfDaysValid}} days</span> <span ng-if=\"package.id.indexOf(\'Platinum\') > -1\">(recommended)</span></md-radio-button></div></div></md-radio-group><md-divider></md-divider><div class=\"summary radioButtondemoMultiColumn mt10\" flex=\"\" layout=\"column\" ng-if=\"payc.packageOptions\"><div flex-initial=\"\"><span class=\"title\">Benefits of Package</span>: <span class=\"md-checked\">{{payc.selectedPackage.id}}</span></div><div><ul><li class=\"mt10\"><h3>1)You will be able to send only {{payc.selectedPackage.category.noOfInterest}} interests to Interested members. This feature is not just sending a normal interest mail message to their Interested Profile mail box. We believe still this mail is not enough to tell about yourself to your Interested Profile. So What your Marriage Bureau will do is after you will send interest for interested profile, this Website will send notification to your Marriage Bureau, and later your Marriage Bureau will call and tell to your Interested Profile about all your information what your Marriage Bureau have both online and offline. When your Interest accepts by your Interested Profile, Then your marriage bureau will arrange face to face meeting.</h3></li><li class=\"mt10\"><h3>2)You will be able to View {{payc.selectedPackage.category.noOfAskMobileNo}} Mobile Number (s) of Interested Profile.</h3></li></ul></div></div><div class=\"error\" ng-if=\"!main.currentSession.shop.razorpayMerchantId\"><div>Important Notice* For Marriage Bureau</div><h1><p><b>Please add marriage bureau bank account details, to enable this payment button.</b></p></h1></div><div class=\"load mt20\" dw-loading=\"paymentBtn\" layout=\"row\" layout-align=\"center center\" ng-if=\"payc.packageOptions\"><md-button ng-disabled=\"!main.currentSession.shop.razorpayMerchantId\" class=\"md-raised btn-new md-cornered md-primary\" ng-click=\"payc.makePayment()\">Make Payment</md-button></div></md-content></div><div ng-show=\"false\" ng-bind-html=\"paymentHtml\"></div>");
$templateCache.put("app/profileInterest/profileInterest.html","<div ng-cloak=\"\" class=\"profile-interest\" layout=\"row\" layout-margin=\"\" layout-align=\"start start\"><md-content flex=\"5\"></md-content><md-content flex=\"15\" class=\"btm-15px ovf-hidden\"><div class=\"leftmenu\"><ul><h1>Messages</h1><li ng-click=\"pic.getInboxProfileInterests();pic.linkClicked=true\" ng-class=\"{mailbox_option_active: 0 == pic.selected}\"><a>Inbox</a></li><li ng-click=\"pic.getSentProfileInterests();pic.linkClicked=true\" ng-class=\"{mailbox_option_active: 1 == pic.selected}\"><a>Sent</a></li></ul></div></md-content><md-content dw-loading=\"profileInterests\" ng-class=\"{load: pic.linkClicked}\" class=\"btm-15px md-padding mh-120\" flex=\"50\" layout=\"row\" layout-wrap=\"\"><div flex=\"50\" ng-if=\"pic.profileInterests.length == 0\" flex-offset=\"30\"><h1>No Interests are there</h1></div><div flex=\"50\" dir-paginate=\"profileInterest in pic.profileInterests | orderBy:\'-interestStatus[0].createdOn\' | itemsPerPage: pic.pageSize\" total-items=\"pic.totalProfileInterest\"><md-card ng-init=\"t = pic.findInterestSentOrReceiveMember(profileInterest)\" flex=\"100\"><md-card-header><md-card-header-text><span class=\"md-title\"><a ng-click=\"pic.changePath(\'home.profile\', t.profileName, t.matrimonyId, {matrimonyId: t.matrimonyId, shopId: t.shopId}, profileInterest.interestInValid)\">{{t.profileName}}</a></span></md-card-header-text></md-card-header><div ng-if=\"!profileInterest.interestInValid\" class=\"image-detail-banner\" ng-style=\"{\'background-image\':\'url({{::main.imageUrl}}{{::main.getImagePath(t.profileImages[0].originalImage)}})\',\'height\':\'200px\'}\" alt=\"Washed Out\"></div><div ng-if=\"profileInterest.interestInValid && main.currentSession.profileBasicInfo.gender == \'Male\'\"><img src=\"../assets/images/female-profile-deleted.gif\" width=\"350\" height=\"200\"></div><div ng-if=\"profileInterest.interestInValid && main.currentSession.profileBasicInfo.gender == \'Female\'\"><img src=\"../assets/images/male-profile-deleted.gif\" width=\"350\" height=\"200\"></div><md-card-content layout=\"column\" layout-wrap=\"\" layout-fill=\"\" style=\"min-height: 100px;\"><div ng-if=\"!profileInterest.interestInValid\"><md-button class=\"md-icon-button\" aria-label=\"Settings\"><span ng-if=\"profileInterest.interestStatus[0]._id == 700 && profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24\">flight_takeoff</i></span> <span ng-if=\"profileInterest.interestStatus[0]._id == 700 && profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24 icon-color\">flight_land</i></span> <span ng-if=\"(profileInterest.interestStatus[0]._id == 800 ||profileInterest.interestStatus[0]._id == 900 || profileInterest.interestStatus[0]._id == 1000 || profileInterest.interestStatus[0]._id == 1100) && profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24 icon-color\">flight_land</i></span> <span ng-if=\"(profileInterest.interestStatus[0]._id == 800 || profileInterest.interestStatus[0]._id == 900 || profileInterest.interestStatus[0]._id == 1000 || profileInterest.interestStatus[0]._id == 1100) && profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24\">flight_takeoff</i></span></md-button><span class=\"col1\">Current Interest Status:</span> <span ng-if=\"profileInterest.interestStatus[0]._id == 700 && profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">You</span> <span ng-if=\"profileInterest.interestStatus[0]._id == 700 && profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">Member</span> <span ng-if=\"(profileInterest.interestStatus[0]._id == 800 ||profileInterest.interestStatus[0]._id == 900 || profileInterest.interestStatus[0]._id == 1000 || profileInterest.interestStatus[0]._id == 1100) && profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">Member</span> <span ng-if=\"(profileInterest.interestStatus[0]._id == 800 || profileInterest.interestStatus[0]._id == 900 || profileInterest.interestStatus[0]._id == 1000 || profileInterest.interestStatus[0]._id == 1100) && profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">You</span> <span class=\"col2\">{{profileInterest.interestStatus[0].code}}</span> <span class=\"md-caption\" ng-if=\"profileInterest.interestStatusTotal != 1\"><a ng-click=\"pic.changePath(\'home.profileInterestDetail\', t.profileName, t.matrimonyId, {fromMatrimonyId: profileInterest.fromProfile.matrimonyId, toMatrimonyId:profileInterest.toProfile.matrimonyId})\">{{profileInterest.interestStatusTotal-1}} More Conversation</a></span><p class=\"padding10 date_time_format md-caption\">{{profileInterest.interestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}}</p></div><div ng-if=\"profileInterest.interestInValid && main.currentSession.profileBasicInfo.gender == \'Male\'\"><span class=\"col1\">This Memberhas deleted her profile</span></div><div ng-if=\"profileInterest.interestInValid && main.currentSession.profileBasicInfo.gender == \'Female\'\"><span class=\"col1\">This Memberhas deleted his profile</span></div></md-card-content></md-card></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"pic.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-content></div>");
$templateCache.put("app/profileInterest/profileInterestDetail.html","<div ng-cloak=\"\" class=\"profile-interest-detail\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\" layout-xs=\"column\"><md-content dw-loading=\"profileInterestDetail\" class=\"md-padding mh-120\" flex=\"50\" layout-align=\"center start\" layout=\"row\" layout-wrap=\"\"><md-card flex=\"\" ng-if=\"pidc.profileInterest\"><md-card-title><md-card-title-text ng-if=\"pidc.profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><span class=\"md-headline\"><a href=\"\" ng-click=\"pidc.changePath(\'home.profile\', pidc.profileInterest.fromProfile.profileName, pidc.profileInterest.fromProfile.matrimonyId, {matrimonyId: pidc.profileInterest.fromProfile.matrimonyId})\">{{pidc.profileInterest.fromProfile.profileName}}</a></span></md-card-title-text><md-card-title-text ng-if=\"pidc.profileInterest.toProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><span class=\"md-headline\"><a href=\"\" ng-click=\"pidc.changePath(\'home.profile\', pidc.profileInterest.toProfile.profileName, pidc.profileInterest.toProfile.matrimonyId, {matrimonyId: pidc.profileInterest.toProfile.matrimonyId})\">{{pidc.profileInterest.toProfile.profileName}}</a></span></md-card-title-text></md-card-title><md-card-content layout=\"row\"><div flex=\"50\"><div ng-if=\"pidc.profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><img ng-src=\"{{main.imageUrl}}{{pidc.profileInterest.fromProfile.profileImages[0].originalImage}}\" class=\"md-card-image\" alt=\"Washed Out\"></div><div ng-if=\"pidc.profileInterest.toProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><img ng-src=\"{{main.imageUrl}}{{pidc.profileInterest.toProfile.profileImages[0].originalImage}}\" class=\"md-card-image\" alt=\"Washed Out\"></div></div><div flex=\"50\"><md-list-item class=\"md-3-line padding10\" ng-repeat=\"interest in pidc.profileInterest.interestStatus | orderBy:\'-interestStatusCreatedOn\'\"><div class=\"md-list-item-text\"><md-button class=\"md-icon-button cursor_text\" aria-label=\"Settings\"><span ng-if=\"interest.id == 700 && pidc.profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24\">flight_takeoff</i></span><span ng-if=\"interest.id == 700 && pidc.profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24 icon-color\">flight_land</i></span> <span ng-if=\"(interest.id == 800 ||interest.id == 900 || interest.id == 1000 || interest.id == 1100) && pidc.profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24 icon-color\">flight_land</i></span> <span ng-if=\"(interest.id == 800 || interest.id == 900 || interest.id == 1000 || interest.id == 1100) && pidc.profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\"><i class=\"material-icons md-24\">flight_takeoff</i></span></md-button><h3><span ng-if=\"interest.id == 700 && pidc.profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">You</span> <span ng-if=\"interest.id == 700 && pidc.profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">Member</span> <span ng-if=\"(interest.id == 800 ||interest.id == 900 || interest.id == 1000 || interest.id == 1100) && pidc.profileInterest.fromProfile.matrimonyId == main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">Member</span> <span ng-if=\"(interest.id == 800 || interest.id == 900 || interest.id == 1000 || interest.id == 1100) && pidc.profileInterest.fromProfile.matrimonyId != main.currentSession.profileBasicInfo.matrimonyId\" class=\"col2\">You</span> <span>{{interest.code}}</span></h3><p class=\"date_time_format md-caption\">{{interest.createdOn | dateTime}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></div></md-card-content></md-card></md-content></div>");
$templateCache.put("app/profileMatch/profileMatch.html","<div ng-cloak=\"\" class=\"profile-match\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><md-content flex=\"15\" class=\"mr15 ml10 ovf-hidden\"><div class=\"leftmenu\" ng-if=\"pmc.shopProfileCount\"><ul><h1>Profile Created</h1><li><span>Within a day</span> <span class=\"badge bg-info\">{{::pmc.shopProfileCount.withInDay}}</span></li><li><span>Within a week</span><span class=\"badge bg-info\">{{::pmc.shopProfileCount.withInWeek}}</span></li><li><span>Within a month</span><span class=\"badge bg-info\">{{::pmc.shopProfileCount.withInMonth}}</span></li></ul></div></md-content><md-content dw-loading=\"profileMatches\" class=\"md-padding mh-120\" flex=\"55\" layout=\"row\" layout-wrap=\"\"><div flex=\"95\" layout=\"row\" layout-align=\"end end\" ng-if=\"pmc.profileMatches.length > 0\"><input style=\"border: 1px solid rgb(127, 127, 138); width: 55px; height: 40px; box-sizing: border-box; padding: 8px;\" class=\"mr10\" type=\"text\" ng-model=\"pmc.submitPageNo\" minlength=\"1\" maxlength=\"4\"><md-button class=\"md-raised md-cornered md-secondary mr10\" ng-click=\"pmc.getMatchingProfilesByPageNo()\" ng-disabled=\"!pmc.submitPageNo\">Page no.</md-button><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"pmc.previous()\" ng-disabled=\"(pmc.page < 1)\"><i class=\"material-icons md-24 edit\">keyboard_arrow_left</i>Previous</md-button><div style=\"padding: 10px;\">{{\"Page \"+(pmc.page+1)+\" Of \"+pmc.total}}</div><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"pmc.next()\" ng-disabled=\"(pmc.page+1) == pmc.total\">Next<i class=\"material-icons md-24 edit\">keyboard_arrow_right</i></md-button></div><div flex=\"50\" ng-if=\"pmc.profileMatches.length == 0\" flex-offset=\"30\"><h1>No Matching Profiles are there</h1></div><div flex=\"50\" ng-repeat=\"profileMatch in pmc.profileMatches\"><md-card ng-init=\"pmc.setCurrentImage(1, profileMatch)\"><md-card-header><md-card-header-text><span class=\"md-title\" ng-if=\"!main.currentSession.packagePlan.paidMemberExpired\"><a ng-click=\"pmc.changePath(\'home.profile\', profileMatch.profileName, profileMatch.matrimonyId, {matrimonyId: profileMatch.matrimonyId, shopId: main.currentSession.shop.id})\">{{profileMatch.profileName}}</a> <span ng-if=\"profileMatch.martialStatus.indexOf(\'Never Married\') < 0\">({{::profileMatch.martialStatus}})</span></span> <span class=\"md-caption\" ng-if=\"profileMatch.shopId && (main.currentSession.profileBasicInfo.shopId.indexOf(profileMatch.shopId) > -1 || (main.currentSession.shop.anchepedheMarriageBureau && profileMatch.anchepedheMarriageBureau))\">Marriage Bureau Name <a ng-click=\"pmc.changePath(\'/shop/\'+profileMatch.shopId, profileMatch.shopName, \'( Marriage Shop )\')\">{{profileMatch.shopName}}</a></span> <span class=\"md-caption\" ng-if=\"profileMatch.shopId && (!(main.currentSession.shop.anchepedheMarriageBureau && profileMatch.anchepedheMarriageBureau) && main.currentSession.profileBasicInfo.shopId.indexOf(profileMatch.shopId) == -1)\"><div layout=\"row\" flex=\"\"><span flex=\"50\">Marriage Bureau Name</span> <span flex=\"45\"><img src=\"../assets/images/shop-name-lock.gif\" width=\"100\" height=\"100\" alt=\"Washed Out\"></span> <span flex=\"5\" class=\"mtm3\"><i class=\"material-icons md-24\">lock</i></span></div></span> <span class=\"md-caption\" ng-if=\"!profileMatch.shopId\">Individual Profile</span> <span class=\"md-caption pt6\" ng-if=\"profileMatch.profileStatus == \'Paid Member\'\"><div class=\"TAG\"><div class=\"text\" style=\"background-color: #0DD4AC !important;\">+ {{:: profileMatch.profileStatus}}</div><div class=\"img\"></div></div></span></md-card-header-text></md-card-header><md-card-content layout-wrap=\"\" style=\"padding: 0;\"><div style=\"position: relative;\" class=\"sc-gyhKFA\" data-test-selector=\"profile_photo_wrapper\"><div class=\"just-joined\" ng-show=\"pmc.utilService._isRecentProfile(profileMatch.profileCreatedOn)\"></div><div class=\"sc-cMOKGX eGkYNO\" type=\"profile\"><div class=\"sc-kYnif ktdCay\"><div class=\"sc-iclvYL igwvZs\" type=\"profile\"><div class=\"sc-chYKBT\" ng-style=\"profileMatch.className\"></div><nav class=\"sc-mWPeY jfhRQb\" type=\"profile\"><button class=\"sc-beROAQ fvvGZu\" icon=\"prev\" ng-click=\"pmc.setCurrentImage(profileMatch.cur-1, profileMatch)\"></button><div class=\"sc-bchHHi hKgVQm\">{{profileMatch.cur}} of {{::profileMatch.profileImages.length}}</div><button class=\"sc-beROAQ jUUwmB\" icon=\"next\" ng-click=\"pmc.setCurrentImage(profileMatch.cur+1, profileMatch)\"></button></nav></div><div data-test-selector=\"FreeA plan_free\" class=\"sc-bMuqKn dEAsKZ\"></div><div class=\"sc-eQvJSV Xjvfb\"></div></div></div></div><div style=\"padding: 5px 5px 0 5px;\"><span class=\"col1\">Age:</span><span class=\"col2\" ng-bind=\"main.getAge(profileMatch.dob)\"></span> <span class=\"col1\">, Height:</span><span class=\"col2\">{{::profileMatch.height.value}},</span> <span class=\"col1\">Caste:</span><span class=\"col2\">{{::profileMatch.caste}} <span ng-if=\"profileMatch.casteNoBar\" class=\"col2\">(Caste No Bar)</span>,</span> <span ng-show=\"(profileMatch.subCaste && profileMatch.subCaste.indexOf(\'Not Specified\') < 0) || profileMatch.otherSubCaste\"><span class=\"col1\">Sub Caste:</span> <span class=\"col2\" ng-show=\"profileMatch.subCaste.indexOf(\'Not Specified\') < 0 && profileMatch.subCaste.indexOf(\'Other\') < 0\">{{::profileMatch.subCaste}} <span ng-if=\"profileMatch.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span> <span class=\"col2\" ng-show=\"profileMatch.otherSubCaste\">{{::profileMatch.otherSubCaste}} <span ng-if=\"profileMatch.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span></span> <span class=\"col1\">Martial Status:</span><span class=\"col2\">{{::profileMatch.martialStatus}} ,</span> <span ng-show=\"profileMatch.star && profileMatch.star.indexOf(\'Not Specified\') < 0\"><span class=\"col1\">Star:</span> <span class=\"col2\">{{::profileMatch.star}} ,</span></span><span class=\"col1\">Education:</span><span class=\"col2\">{{::profileMatch.highestEducation}},</span> <span class=\"col1\" ng-show=\"profileMatch.occupation\">Working as:</span> <span class=\"col2\" ng-if=\"profileMatch.occupation\">{{::profileMatch.occupation}},</span> <span ng-show=\"profileMatch.annualIncome && profileMatch.annualIncome > 0\"><span class=\"col1\">Annual Income:</span> <span class=\"col2\">{{::main.getFormatAmount(profileMatch.annualIncome)}},</span></span> <span ng-if=\"profileMatch.caste.indexOf(\'Arya Vysya\') > -1 && profileMatch.gothram\"><span class=\"col1\">Swa Gothra(m):</span><span class=\"col2\">{{::profileMatch.gothram}},</span></span> <span ng-if=\"profileMatch.caste.indexOf(\'Arya Vysya\') > -1 && profileMatch.mathula\"><span class=\"col1\">Mathula:</span><span class=\"col2\">{{::profileMatch.mathula}},</span></span> <span class=\"col1\" ng-if=\"profileMatch.currentLivingCountry && profileMatch.currentLivingCountry.indexOf(\'India\') < 0\"><span>Working/Living in Country:</span><span class=\"col2\">{{::profileMatch.currentLivingCountry}},</span></span> <span class=\"col1\" ng-if=\"profileMatch.currentLivingState\"><span>Working/Living in State:</span> <span class=\"col2\">{{::profileMatch.currentLivingState}},</span></span> <span class=\"col1\" ng-if=\"profileMatch.currentLivingCity\"><span>Working/Living in City/Near City:</span> <span class=\"col2\">{{::profileMatch.currentLivingCity}}</span></span></div></md-card-content><md-card-actions layout=\"row\"><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && !main.currentSession.packagePlan.paidMemberExpired\"><li class=\"afm\"><a href=\"\" ng-click=\"pmc.changePath(\'home.profile\', profileMatch.profileName, profileMatch.matrimonyId, {matrimonyId: profileMatch.matrimonyId, shopId: profileMatch.shopId})\">Click here to See More Information or Send Interest</a> <i style=\"top: 4px; position: relative;\" class=\"material-icons md-24 icon-color\">smartphone</i></li></ul><span ng-if=\"main.currentSession.packagePlan.paidMemberExpired\"><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></md-card-actions></md-card></div><div flex=\"95\" layout=\"row\" layout-align=\"end end\" ng-if=\"pmc.profileMatches.length > 0\"><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"pmc.previous()\" ng-disabled=\"(pmc.page < 1)\"><i class=\"material-icons md-24 edit\">keyboard_arrow_left</i>Previous</md-button><div style=\"padding: 10px;\">{{\"Page \"+(pmc.page+1)+\" Of \"+pmc.total}}</div><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"pmc.next()\" ng-disabled=\"(pmc.page+1) == pmc.total\">Next<i class=\"material-icons md-24 edit\">keyboard_arrow_right</i></md-button></div></md-content><md-content flex=\"25\" class=\"mr15 ml10 ovf-hidden\" style=\"margin-top: 40px; border: solid 1px #737777;\" ng-if=\"pmc.offer\"><div class=\"rightmenu\"><ul><h1>Offer</h1><li><span>Coupon Code</span><span class=\"coupon-code pad2\">{{::pmc.offer.couponCode}}</span></li><li ng-repeat=\"v in pmc.offer.values\"><span>{{::v.value}} Rs For</span> <span>{{::v.category.noOfAskMobileNo}} Contacts Numbers</span> <span>Valid For {{::v.category.noOfDaysValid}} days</span></li><li><span>Offer End Date</span><span class=\"coupon-code\">{{::pmc.offer.endDate | date:\"dd MMMM yyyy\"}}</span></li><li><span><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></li></ul></div></md-content></div>");
$templateCache.put("app/profileShortList/profileShortListedByMe.html","<div ng-cloak=\"\" class=\"profile-interest\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content dw-loading=\"profileShortListedByMe\" class=\"md-padding mh-120\" flex=\"55\" layout=\"row\" layout-wrap=\"\"><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div><div flex=\"50\" ng-if=\"psbmc.profileShortListedByMe.length == 0\" flex-offset=\"30\"><h1>No Profile Shortlisted Yet</h1></div><div flex=\"50\" dir-paginate=\"profileShortList in psbmc.profileShortListedByMe | itemsPerPage: psbmc.pageSize | orderBy:\'-shortListedOn\'\" total-items=\"psbmc.totalProfileShortListedByMe\"><md-card><md-card-header><md-card-header-text><span class=\"md-title\" ng-if=\"!main.currentSession.packagePlan.paidMemberExpired\"><a ng-click=\"psbmc.changePath(\'home.profile\', profileShortList.toProfile.profileName, profileShortList.toProfile.matrimonyId, {matrimonyId: profileShortList.toProfile.matrimonyId, shopId: profileShortList.toProfile.shopId}, profileShortList.shortListInvalid)\">{{profileShortList.toProfile.profileName}}</a></span><span class=\"md-caption\" ng-if=\"profileShortList.toProfile.shopId && main.currentSession.profileBasicInfo.shopId.indexOf(profileShortList.toProfile.shopId) > -1\">Marriage Bureau Name <a ng-click=\"pmc.changePath(\'/shop/\'+profileMatch.shopId, profileMatch.shopName, \'( Marriage Shop )\')\">{{main.currentSession.profileBasicInfo.shopName}}</a></span> <span class=\"md-caption\" ng-if=\"profileShortList.toProfile.shopId && main.currentSession.profileBasicInfo.shopId.indexOf(profileShortList.toProfile.shopId) == -1\"><div layout=\"row\" flex=\"\"><span flex=\"50\">Marriage Bureau Name</span> <span flex=\"45\"><img src=\"../assets/images/shop-name-lock.gif\" width=\"100\" height=\"100\" alt=\"Washed Out\"></span> <span flex=\"5\" class=\"mtm3\"><i class=\"material-icons md-24\">lock</i></span></div></span></md-card-header-text></md-card-header><div ng-if=\"!(profileShortList.shortListInvalid)\" class=\"image-detail-banner\" ng-style=\"{\'background-image\':\'url({{::main.imageUrl}}{{::main.getImagePath(profileShortList.toProfile.profileImages[0].originalImage)}})\',\'max-height\':\'400px\', \'max-width\':\'400px\'}\" alt=\"Washed Out\"></div><div ng-if=\"profileShortList.shortListInvalid && main.currentSession.profileBasicInfo.gender == \'Male\'\"><img src=\"../assets/images/female-profile-deleted.gif\" width=\"350\" height=\"200\"></div><div ng-if=\"profileShortList.shortListInvalid && main.currentSession.profileBasicInfo.gender == \'Female\'\"><img src=\"../assets/images/male-profile-deleted.gif\" width=\"350\" height=\"200\"></div><md-card-content layout=\"row\" layout-wrap=\"\"><div ng-if=\"!profileShortList.shortListInvalid\"><span ng-if=\"!main.currentSession.packagePlan.paidMemberExpired\"><span class=\"col1\">Age:</span><span class=\"col2\" ng-bind=\"main.getAge(profileShortList.toProfile.dob)\"></span> <span class=\"col1\">, Height:</span><span class=\"col2\">{{profileShortList.toProfile.height.value}},</span></span> <span class=\"col1\">Caste:</span><span class=\"col2\">{{profileShortList.toProfile.caste}},</span> <span class=\"col1\">Sub Caste:</span><span class=\"col2\">{{profileShortList.toProfile.subCaste}},</span> <span class=\"col1\">Highest Education:</span><span class=\"col2\">{{profileShortList.toProfile.highestEducation}}</span> <span class=\"col1\" ng-show=\"profileShortList.toProfile.occupation\">,Working as:</span><span class=\"col2\">{{profileShortList.toProfile.occupation}},</span> <span class=\"col1\" ng-show=\"profileShortList.toProfile.occupation\">Annual Income:</span><span class=\"col2\" ng-bind=\"main.getFormatAmount(profileShortList.toProfile.annualIncome)\">,</span></div><div ng-if=\"profileShortList.shortListInvalid && main.currentSession.profileBasicInfo.gender == \'Male\'\"><span class=\"col1\">This Memberhas deleted her profile</span></div><div ng-if=\"profileShortList.shortListInvalid && main.currentSession.profileBasicInfo.gender == \'Female\'\"><span class=\"col1\">This Memberhas deleted his profile</span></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"!profileShortList.shortListInvalid\"><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && !main.currentSession.packagePlan.paidMemberExpired\"><li class=\"afm\"><a href=\"\" ng-click=\"psbmc.changePath(\'home.profile\', profileShortList.toProfile.profileName, profileShortList.toProfile.matrimonyId, {matrimonyId: profileShortList.toProfile.matrimonyId, shopId: profileShortList.toProfile.shopId})\">Click here to See More Information or Send Interest</a></li></ul><span ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.packagePlan.paidMemberExpired\"><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></md-card-actions></md-card></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"psbmc.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-content></div>");
$templateCache.put("app/search/searchProfile.html","<div ng-cloak=\"\" layout=\"row\" class=\"search-profile\" layout-align=\"center center\" style=\"margin-left: -93px;\"><md-content dw-loading=\"searchProfile\" class=\"md-padding\" flex=\"50\" ng-if=\"!spc.profileMatches\"><form method=\"post\" id=\"preferenceForm\" name=\"spc.preferenceForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"spc.searchSubmit()\"><md-card><md-card-content><h1>Partner Preference</h1><div layout=\"\" layout-sm=\"column\" class=\"mt15\"><md-input-container flex=\"30\"><label>From Age</label><md-select lower-than=\"{{spc.partnerPreference.toYearPref}}\" ng-model=\"spc.partnerPreference.fromYearPref\" name=\"fromAgePref\" required=\"\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.agePrefOptions.values\" ng-value=\"option.category\">{{option.value}} Yrs</md-option></md-select></md-input-container><md-input-container flex=\"30\"><label>To Age</label><md-select ng-model=\"spc.partnerPreference.toYearPref\" name=\"toAgePref\" required=\"\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.agePrefOptions.values\" ng-value=\"option.category\">{{option.value}} Yrs</md-option></md-select></md-input-container></div><div layout=\"row\"><span class=\"error\" ng-show=\"spc.preferenceForm.fromAgePref.$error.lowerThan\">From Age cannot exceed To Age.</span></div><div layout=\"\" layout-sm=\"column\"><md-input-container flex=\"30\"><label>From Height</label><md-select lower-than=\"{{spc.partnerPreference.tHeightPref}}\" ng-model=\"spc.partnerPreference.fHeightPref\" name=\"fromHeightPref\" required=\"\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.heightPrefOptions.values\" ng-value=\"option.category\">{{option.value}}</md-option></md-select></md-input-container><md-input-container flex=\"30\"><label>To Height</label><md-select ng-model=\"spc.partnerPreference.tHeightPref\" name=\"toHeightPref\" required=\"\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.heightPrefOptions.values\" ng-value=\"option.category\">{{option.value}}</md-option></md-select></md-input-container></div><div layout=\"row\"><span class=\"error\" ng-show=\"spc.preferenceForm.fromHeightPref.$error.lowerThan\">From Height cannot exceed To Height.</span></div><div layout=\"\" layout-sm=\"column\"><md-input-container flex=\"60\"><label>Mother Tongue</label><md-select multiple=\"\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\" ng-model=\"spc.partnerPreference.motherTonguePref\" name=\"motherTonguePref\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a mother tongue..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Mother Tongue\"><ul ng-repeat=\"(key, values) in spc.partnerPreferenceTemplate.motherTongueOptions.values | groupBy:\'category\'\"><li ng-if=\"spc.checkIfExist(spc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:spc.searchTerm\" ng-value=\"option.value\" ng-click=\"spc.setMotherTonguePref(option.value)\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div ng-if=\"spc.preferenceForm.motherTonguePref.$dirty || spc.preferenceForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"spc.preferenceForm.motherTonguePref.$error.required\">Mother Tongue is compulsory.</span></div><div layout=\"row\"><md-input-container flex=\"60\"><label>Martial Status</label><md-select multiple=\"\" ng-model=\"spc.partnerPreference.martialStatusPref\" name=\"martialStatusPref\" required=\"\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.martialStatusOptions.values\" ng-value=\"option.value\" ng-click=\"spc.setMartialStatusPref(option.value)\">{{option.value}}</md-option></md-select></md-input-container></div><div ng-if=\"spc.preferenceForm.martialStatusPref.$dirty || spc.preferenceForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"spc.preferenceForm.martialStatusPref.$error.required\">Martial Status is compulsory.</span></div><div layout=\"\"><md-input-container flex=\"60\"><label>Caste</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\" multiple=\"\" ng-model=\"spc.partnerPreference.castePref\" name=\"castePref\" required=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a caste..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"caste\"><md-option ng-repeat=\"option in main.currentSession.shop.expertiseCaste | filter:spc.searchTerm\" ng-value=\"option\" ng-click=\"spc.setCastePref(option)\">{{option}}</md-option></md-optgroup></md-select></md-input-container></div><div ng-if=\"spc.preferenceForm.castePref.$dirty || spc.preferenceForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"spc.preferenceForm.castePref.$error.required\">Caste is compulsory.</span></div><div layout=\"\"><md-checkbox ng-model=\"spc.partnerPreference.casteNoBar\" aria-label=\"Checkbox 2\" flex=\"\"><span style=\"float: left;position: relative;left: -18px;\"><span ng-if=\"main.currentSession.profileBasicInfo.gender.indexOf(\'Male\') > -1\">Bride</span> <span ng-if=\"main.currentSession.profileBasicInfo.gender.indexOf(\'Male\') < 0\">Groom</span> not particular about Partner\'s Caste (Caste No Bar)</span></md-checkbox></div><div layout=\"\" ng-if=\"spc.subCasteOptions\"><md-input-container flex=\"60\"><label>Sub caste</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\" multiple=\"\" ng-model=\"spc.partnerPreference.subCastePref\" name=\"subCastePref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a subcaste..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste\"><md-option ng-repeat=\"option in spc.subCasteOptions.values | filter:spc.searchTerm | filter: {value: \'!\' + \'Other\'}\" ng-value=\"option.value\" ng-click=\"spc.setSubCastePref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"\" layout-sm=\"column\"><md-input-container flex=\"60\"><label>Highest Education</label><md-select multiple=\"\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\" ng-model=\"spc.partnerPreference.highestEducationPref\" name=\"highestEducationPref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a education..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Highest Education\"><ul ng-repeat=\"(key, values) in spc.partnerPreferenceTemplate.highestEducationPrefOptions.values | groupBy:\'category\'\"><li ng-if=\"spc.checkIfExist(spc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:spc.searchTerm\" ng-value=\"option.value\" ng-click=\"spc.setHighestEducationPref(option.value)\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div layout=\"\"><md-input-container flex=\"60\"><label>Employed In</label><md-select multiple=\"\" ng-model=\"spc.partnerPreference.employedInPref\" name=\"employedInPref\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.employedInPrefOptions.values\" ng-value=\"option.value\" ng-click=\"spc.setEmployedInPref(option.value)\">{{option.value}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-sm=\"column\"><md-input-container flex=\"60\"><label>Occupation</label><md-select multiple=\"\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\" ng-model=\"spc.partnerPreference.occupationPref\" name=\"occupationPref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a education..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Occupation\"><ul ng-repeat=\"(key, values) in spc.partnerPreferenceTemplate.occupationPrefOptions.values | groupBy:\'category\'\"><li ng-if=\"spc.checkIfExist(spc.searchTerm, values)\">{{key}}<md-option ng-repeat=\"option in values | filter:spc.searchTerm\" ng-value=\"option.value\" ng-click=\"spc.setOccupationPref(option.value)\">{{option.value}}</md-option></li></ul></md-optgroup></md-select></md-input-container></div><div layout=\"\"><md-input-container flex=\"60\"><label>Partner Living/Working Country</label><md-select data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\" multiple=\"\" ng-model=\"spc.partnerPreference.countryPref\" name=\"countryPref\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a country..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Partner Living/Working Country\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.countryOptions.values | filter:spc.searchTerm\" ng-value=\"option.value\" ng-click=\"spc.setCountryPref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"\"><md-input-container flex=\"60\"><label>Partner Living/Working State in India</label><md-select multiple=\"\" ng-model=\"spc.partnerPreference.statePref\" name=\"statePref\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a state..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Partner Living/Working State in India\"><md-option ng-repeat=\"option in spc.stateOptions | filter:spc.searchTerm\" ng-value=\"option.value\" ng-click=\"spc.setStatePref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"\" ng-if=\"spc.partnerPreference.countryPref.indexOf(\'India\') > -1 && spc.partnerPreference.statePref.indexOf(\'Any\') == -1 && spc.partnerPreference.statePref.length > 0\"><md-input-container flex=\"60\"><label>Partner Living/Working City (or near) in India</label><md-select multiple=\"\" ng-model=\"spc.partnerPreference.cityPref\" name=\"cityPref\" data-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"spc.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"spc.searchTerm\" type=\"search\" placeholder=\"Search for a city..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation($event)\"> <i class=\"material-icons\">search</i></md-select-header><md-optgroup label=\"Sub caste division(optional)\"><md-option ng-repeat=\"option in spc.cityOptions | filter:spc.searchTerm\" ng-value=\"option.value\" ng-click=\"spc.setCityPref(option.value)\">{{option.value}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"error\" ng-if=\"spc.preferenceForm.$submitted\"><div ng-if=\"spc.preferenceForm.$error.required.length > 0\"><span>You have not filled required fields. Please go and fill it!</span> <span ng-repeat=\"error in spc.preferenceForm.$error.required\">{{error.$name}} <span ng-show=\"spc.preferenceForm.$error.required.length-1 != $index\">,</span></span> <span class=\"error\" ng-if=\"spc.preferenceForm.fromAgePref.$error.lowerThan\"><span ng-if=\"spc.preferenceForm.$error.required.length > 0\">,</span> From Age cannot exceed to To Age</span> <span class=\"error\" ng-if=\"spc.preferenceForm.fromHeightPref.$error.lowerThan\"><span ng-if=\"spc.preferenceForm.fromAgePref.$error.lowerThan\">,</span> From Height cannot exceed to To Height.</span></div></div><div layout=\"\"><md-input-container flex=\"60\"><label>Star</label><md-select multiple=\"\" ng-model=\"spc.partnerPreference.starPref\"><md-option ng-repeat=\"option in spc.partnerPreferenceTemplate.starOptions.values\" ng-value=\"option.value\" ng-click=\"spc.setStarPref(option.value)\">{{option.value}}</md-option></md-select></md-input-container></div><div class=\"load\" dw-loading=\"searchProfileBtn\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btn-new md-cornered md-primary\" type=\"submit\">Search Profiles</md-button></div></md-card-content></md-card></form></md-content></div><div dw-loading=\"searchProfile\" style=\"margin-left: -93px;\" ng-cloak=\"\" layout=\"row\" class=\"search-profile\" layout-align=\"center center\" ng-if=\"spc.profileMatches\"><div layout=\"column\" flex=\"50\"><md-content class=\"md-padding\" layout=\"column\" layout-align=\"center center\" ng-if=\"spc.totalProfileMatch > 0\"><div><h1>Search Matched Profiles ({{spc.totalProfileMatch}})</h1></div><div class=\"mt20\"><a href=\"\" ng-click=\"spc.profileMatches= !spc.profileMatches;spc.callInit(spc.profileMatches)\">Click here to change the query</a></div></md-content><md-content layout=\"column\" class=\"md-padding mt20\" ng-show=\"spc.profileMatches.length == 0\"><div><h1>Sorry No Profiles Matched for your Search Query... Please Change the Search Query</h1></div><div class=\"mt20\"><a href=\"\" ng-click=\"spc.profileMatches= !spc.profileMatches;spc.callInit(spc.profileMatches)\">Click here to change the query</a></div></md-content><md-content class=\"md-padding mt20\" layout=\"row\" layout-wrap=\"\" ng-show=\"spc.profileMatches.length > 0\"><div flex=\"95\" layout=\"row\" layout-align=\"end end\"><input style=\"border: 1px solid rgb(127, 127, 138); width: 55px; height: 40px; box-sizing: border-box; padding: 8px;\" class=\"mr10\" type=\"text\" ng-model=\"spc.submitPageNo\" minlength=\"1\" maxlength=\"4\"><md-button class=\"md-raised md-cornered md-secondary mr10\" ng-click=\"spc.getMatchingProfilesByPageNo()\" ng-disabled=\"!spc.submitPageNo\">Page no.</md-button><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"spc.previous()\" ng-disabled=\"(spc.page < 1)\"><i class=\"material-icons md-24 edit\">keyboard_arrow_left</i>Previous</md-button><div style=\"padding: 10px;\">{{\"Page \"+(spc.page+1)+\" Of \"+spc.total}}</div><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"spc.next()\" ng-disabled=\"(spc.page+1) == spc.total\">Next<i class=\"material-icons md-24 edit\">keyboard_arrow_right</i></md-button></div><div flex=\"50\" ng-repeat=\"profileMatch in spc.profileMatches\"><md-card ng-init=\"spc.setCurrentImage(1, profileMatch)\"><md-card-header><md-card-header-text><span class=\"md-title\" ng-if=\"!main.currentSession.packagePlan.paidMemberExpired\"><a ng-click=\"spc.changePath(\'home.profile\', profileMatch.profileName, profileMatch.matrimonyId, {matrimonyId: profileMatch.matrimonyId, shopId: profileMatch.shopId})\">{{profileMatch.profileName}}</a> <span ng-if=\"profileMatch.martialStatus.indexOf(\'Never Married\') < 0\">({{::profileMatch.martialStatus}})</span></span> <span class=\"md-caption\" ng-if=\"profileMatch.shopId && main.currentSession.profileBasicInfo.shopId.indexOf(profileMatch.shopId) > -1\">Marriage Bureau Name <a ng-click=\"spc.changePath(\'/shop/\'+profileMatch.shopId, profileMatch.shopName, \'( Marriage Shop )\')\">{{main.currentSession.profileBasicInfo.shopName}}</a></span> <span class=\"md-caption\" ng-if=\"profileMatch.shopId && main.currentSession.profileBasicInfo.shopId.indexOf(profileMatch.shopId) == -1\"><div layout=\"row\" flex=\"\"><span flex=\"50\">Marriage Bureau Name</span> <span flex=\"45\"><img src=\"../assets/images/shop-name-lock.gif\" width=\"100\" height=\"100\" alt=\"Washed Out\"></span> <span flex=\"5\" class=\"mtm3\"><i class=\"material-icons md-24\">lock</i></span></div></span> <span class=\"md-caption\" ng-if=\"!profileMatch.shopId\">Individual Profile</span> <span class=\"md-caption pt6\" ng-if=\"profileMatch.profileStatus == \'Paid Member\'\"><div class=\"TAG\"><div class=\"text\">+ {{:: profileMatch.profileStatus}}</div><div class=\"img\"></div></div></span> <span class=\"md-caption date_time_format\" ng-if=\"profileMatch.lastActive\">Last Active: {{profileMatch.lastActive | date:\"dd MMMM yyyy \'at\' h:mma\"}}</span></md-card-header-text></md-card-header><md-card-content layout-wrap=\"\" style=\"padding: 0;\"><div class=\"sc-gyhKFA\" data-test-selector=\"profile_photo_wrapper\"><div class=\"sc-cMOKGX eGkYNO\" type=\"profile\"><div class=\"sc-kYnif ktdCay\"><div class=\"sc-iclvYL igwvZs\" type=\"profile\"><div class=\"sc-chYKBT\" ng-style=\"profileMatch.className\"></div><nav class=\"sc-mWPeY jfhRQb\" type=\"profile\" ng-if=\"profileMatch.profileImages.length>1\"><button class=\"sc-beROAQ fvvGZu\" icon=\"prev\" ng-click=\"spc.setCurrentImage(profileMatch.cur-1, profileMatch)\"></button><div class=\"sc-bchHHi hKgVQm\">{{profileMatch.cur}} of {{::profileMatch.profileImages.length}}</div><button class=\"sc-beROAQ jUUwmB\" icon=\"next\" ng-click=\"spc.setCurrentImage(profileMatch.cur+1, profileMatch)\"></button></nav></div><div data-test-selector=\"FreeA plan_free\" class=\"sc-bMuqKn dEAsKZ\"></div><div class=\"sc-eQvJSV Xjvfb\"></div></div></div></div><div><span class=\"col1\">Age:</span><span class=\"col2\" ng-bind=\"main.getAge(profileMatch.dob)\"></span> <span class=\"col1\">, Height:</span><span class=\"col2\">{{profileMatch.height.value}},</span> <span class=\"col1\">Caste:</span><span class=\"col2\">{{profileMatch.caste}} <span ng-if=\"profileMatch.casteNoBar\" class=\"col2\">(Caste No Bar)</span>,</span> <span ng-show=\"(profileMatch.subCaste && profileMatch.subCaste.indexOf(\'Not Specified\') < 0) || profileMatch.otherSubCaste\"><span class=\"col1\">Sub Caste:</span> <span class=\"col2\" ng-show=\"profileMatch.subCaste.indexOf(\'Not Specified\') < 0 && profileMatch.subCaste.indexOf(\'Other\') < 0\">{{::profileMatch.subCaste}} <span ng-if=\"profileMatch.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span> <span class=\"col2\" ng-show=\"profileMatch.otherSubCaste\">{{::profileMatch.otherSubCaste}} <span ng-if=\"profileMatch.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span></span> <span class=\"col1\">Martial Status:</span><span class=\"col2\">{{::profileMatch.martialStatus}},</span> <span class=\"col1\" ng-show=\"profileMatch.star && profileMatch.star.indexOf(\'Not Specified\') < 0\">Star:</span> <span class=\"col2\">{{::profileMatch.star}} ,</span> <span class=\"col1\">Education:</span><span class=\"col2\">{{::profileMatch.highestEducation}},</span> <span class=\"col1\" ng-show=\"profileMatch.occupation\">Working as:</span> <span class=\"col2\" ng-if=\"profileMatch.occupation\">{{::profileMatch.occupation}},</span> <span ng-show=\"profileMatch.annualIncome && profileMatch.annualIncome > 0\"><span class=\"col1\">Annual Income:</span> <span class=\"col2\">{{::main.getFormatAmount(profileMatch.annualIncome)}},</span></span> <span ng-if=\"profileMatch.caste.indexOf(\'Arya Vysya\') > -1 && profileMatch.gothram\"><span class=\"col1\">Swa Gothra(m):</span><span class=\"col2\">{{::profileMatch.gothram}},</span></span> <span ng-if=\"profileMatch.caste.indexOf(\'Arya Vysya\') > -1 && profileMatch.mathula\"><span class=\"col1\">Mathula:</span><span class=\"col2\">{{::profileMatch.mathula}},</span></span> <span class=\"col1\" ng-if=\"profileMatch.currentLivingCountry && profileMatch.currentLivingCountry.indexOf(\'India\') < 0\"><span>Working/Living in Country:</span><span class=\"col2\">{{::profileMatch.currentLivingCountry}},</span></span> <span class=\"col1\" ng-if=\"profileMatch.currentLivingState\"><span>Working/Living in State:</span> <span class=\"col2\">{{::profileMatch.currentLivingState}},</span></span> <span class=\"col1\" ng-if=\"profileMatch.currentLivingCity\"><span>Working/Living in City/Near City:</span> <span class=\"col2\">{{::profileMatch.currentLivingCity}}</span></span></div></md-card-content><md-card-actions layout=\"row\"><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && !main.currentSession.packagePlan.paidMemberExpired\"><li class=\"afm\"><a href=\"\" ng-click=\"spc.changePath(\'home.profile\', profileMatch.profileName, profileMatch.matrimonyId, {matrimonyId: profileMatch.matrimonyId, shopId: profileMatch.shopId})\">Click here to See More Information or Send Interest</a></li></ul><span ng-if=\"main.currentSession.packagePlan.paidMemberExpired\"><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></md-card-actions></md-card></div><div flex=\"95\" layout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"spc.previous()\" ng-disabled=\"(spc.page < 1)\"><i class=\"material-icons md-24 edit\">keyboard_arrow_left</i>Previous</md-button><div style=\"padding: 10px;\">{{\"Page \"+(spc.page+1)+\" Of \"+spc.total}}</div><md-button class=\"md-raised md-cornered md-secondary\" ng-click=\"spc.next()\" ng-disabled=\"(spc.page+1) == spc.total\">Next<i class=\"material-icons md-24 edit\">keyboard_arrow_right</i></md-button></div></md-content></div></div><div><md-content class=\"md-padding\" layout=\"column\" style=\"top: 0; position: absolute; right: 75px; width: 321px;\"><div><h2>Search By Matrimony ID</h2><form class=\"reset-form\" name=\"searchByMatrimonyIDForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"spc.searchByMatrimonyId()\"><div class=\"row\"><input required=\"\" placeholder=\"Enter Matrimony ID\" style=\"width: 254px;text-transform: uppercase;\" class=\"textbox_sml\" name=\"matrimonyId\" type=\"text\" ng-model=\"spc.matrimonyId\" minlength=\"4\" maxlength=\"11\"></div><div ng-messages=\"searchByMatrimonyIDForm.matrimonyId.$error\" ng-if=\"searchByMatrimonyIDForm.$submitted\"><div class=\"error\" ng-message=\"required\">Matrimony Id is compulsory.</div><div class=\"error\" ng-message=\"minlength\">Matrimony Id is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Matrimony Id is too long.</div></div><div layout=\"row\" class=\"mt5\" style=\"margin-bottom: 10px;margin-top: -23px;\" flex=\"80\"><md-button class=\"md-raised md-cornered\" type=\"submit\" style=\"color: #ffff;background-color: #0CB863\">Search</md-button></div></form></div></md-content></div>");
$templateCache.put("app/search/searchProfileNotLoggedIn.html","<div class=\"newlogin\"><div class=\"first_page_container\" id=\"home\"><nav><div class=\"navigation_icon\" ng-click=\"vm.toggleMenu()\"></div><div class=\"logo_container\"><a ng-if=\"spnlic.host.indexOf(\'anchepedhematrimony\') > -1\" ui-sref=\"account.login\" title=\"Matrimony\"><img src=\"../assets/anchepdhe-matrimony-LOGO-small.png\" alt=\"SELECT\" title=\"SELECT\"></a></div><div id=\"myTopnav\" class=\"nav_container\"><ul><li class=\"\"><a ng-href=\"/login#about\" title=\"ABOUT\">ABOUT</a></li><li class=\"\"><a href=\"/login#how-it-works\" title=\"HOW IT WORKS\">HOW IT WORKS</a></li><li class=\"\"><a href=\"/login#plans\" title=\"PLANS\">PLANS</a></li><li class=\"\"><a href=\"/login\" title=\"LOG IN\">LOGIN</a></li><li class=\"\"><a href=\"/register\" title=\"REGISTER\">REGISTER</a></li><li class=\"\"><a href=\"/login#contact\" title=\"CONTACT\">CONTACT US</a></li></ul></div></nav></div></div><div style=\"min-width: 990px;\" ng-cloak=\"\" class=\"shop-profile\" dw-loading=\"searchNotProfileBtn\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><md-content flex=\"20\" class=\"ml10 mr15 ovf-hidden\"></md-content><md-content id=\"loadingProfifle\" class=\"md-padding mh-120 load\" flex=\"55\" layout=\"row\" layout-wrap=\"\"><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div><div flex=\"50\" ng-show=\"spnlic.profileMatches.length == 0\" flex-offset=\"30\"><h1>Sorry No Profiles Matched for your Search Query... Please Change the Search Query</h1></div><div flex=\"50\" dir-paginate=\"shopProfile in spnlic.profileMatches | itemsPerPage: spnlic.pageSize\" current-page=\"currentPage\" total-items=\"spnlic.totalProfileMatch\"><md-card ng-init=\"spnlic.setCurrentImage(1, shopProfile)\"><md-card-header></md-card-header><canvas style=\"display:none\" id=\"{{\'canvas\'+shopProfile.id}}\" width=\"400\" height=\"260\">Your browser does not support the HTML5 canvas tag.</canvas><md-card-content layout-wrap=\"\" style=\"padding: 0;\"><div style=\"position: relative;\" class=\"sc-gyhKFA\" data-test-selector=\"profile_photo_wrapper\"><div class=\"just-joined\" ng-show=\"mspc.utilService._isRecentProfile(shopProfile.profileCreatedOn)\"></div><div class=\"sc-cMOKGX eGkYNO\" type=\"profile\"><div class=\"sc-kYnif ktdCay\"><div class=\"sc-iclvYL igwvZs\" type=\"profile\"><div class=\"sc-chYKBT\" ng-style=\"shopProfile.className\"></div><nav class=\"sc-mWPeY jfhRQb\" type=\"profile\" ng-if=\"shopProfile.profileImages.length>1\"><button class=\"sc-beROAQ fvvGZu\" icon=\"prev\" ng-click=\"mspc.setCurrentImage(shopProfile.cur-1, shopProfile)\"></button><div class=\"sc-bchHHi hKgVQm\">{{shopProfile.cur}} of {{::shopProfile.profileImages.length}}</div><button class=\"sc-beROAQ jUUwmB\" icon=\"next\" ng-click=\"mspc.setCurrentImage(shopProfile.cur+1, shopProfile)\"></button></nav></div><div data-test-selector=\"FreeA plan_free\" class=\"sc-bMuqKn dEAsKZ\"></div><div class=\"sc-eQvJSV Xjvfb\"></div></div></div></div><div style=\"padding: 5px 5px 0 5px;\"><span class=\"col1\">Age:</span><span class=\"col2\" ng-bind=\"main.getAge(shopProfile.dob)\"></span> <span class=\"col1\">, Height:</span><span class=\"col2\">{{::shopProfile.height.value}},</span> <span class=\"col1\">Caste:</span><span class=\"col2\">{{::shopProfile.caste}} <span ng-if=\"shopProfile.casteNoBar\" class=\"col2\">(Caste No Bar)</span>,</span> <span ng-show=\"(shopProfile.subCaste && shopProfile.subCaste.indexOf(\'Not Specified\') < 0) || shopProfile.otherSubCaste\"><span class=\"col1\">Sub Caste:</span> <span class=\"col2\" ng-show=\"shopProfile.subCaste.indexOf(\'Not Specified\') < 0 && shopProfile.subCaste.indexOf(\'Other\') < 0\">{{::shopProfile.subCaste}} <span ng-if=\"shopProfile.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span> <span class=\"col2\" ng-show=\"shopProfile.otherSubCaste\">{{::shopProfile.otherSubCaste}},</span></span> <span class=\"col1\">Martial Status:</span><span class=\"col2\">{{::shopProfile.martialStatus}},</span> <span ng-show=\"shopProfile.star && shopProfile.star.indexOf(\'Not Specified\') < 0\"><span class=\"col1\">Star:</span> <span class=\"col2\">{{::shopProfile.star}},</span></span> <span class=\"col1\">Education:</span><span class=\"col2\">{{::shopProfile.highestEducation}},</span> <span class=\"col1\" ng-show=\"shopProfile.occupation\">Working as:</span> <span class=\"col2\" ng-if=\"shopProfile.occupation\">{{::shopProfile.occupation}},</span> <span ng-show=\"shopProfile.annualIncome && shopProfile.annualIncome > 0\"><span class=\"col1\">Annual Income:</span> <span class=\"col2\">{{::main.getFormatAmount(shopProfile.annualIncome)}},</span></span> <span ng-if=\"shopProfile.caste.indexOf(\'Arya Vysya\') > -1 && shopProfile.gothram\"><span class=\"col1\">Swa Gothra(m):</span><span class=\"col2\">{{::shopProfile.gothram}},</span></span> <span ng-if=\"shopProfile.caste.indexOf(\'Arya Vysya\') > -1 && shopProfile.mathula\"><span class=\"col1\">Mathula:</span><span class=\"col2\">{{::shopProfile.mathula}},</span></span> <span class=\"col1\" ng-if=\"shopProfile.currentLivingCountry && shopProfile.currentLivingCountry.indexOf(\'India\') < 0\"><span>Working/Living in Country:</span><span class=\"col2\">{{::shopProfile.currentLivingCountry}},</span></span> <span class=\"col1\" ng-if=\"shopProfile.currentLivingState\"><span>Working/Living in State:</span> <span class=\"col2\">{{::shopProfile.currentLivingState}},</span></span> <span class=\"col1\" ng-if=\"shopProfile.currentLivingCity\"><span>Working/Living in City/Near City:</span> <span class=\"col2\">{{::shopProfile.currentLivingCity}}</span></span></div></md-card-content><md-card-actions layout=\"row\"><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && (!main.currentSession.packagePlan.paidMemberExpired)\"><li class=\"afm\"><a href=\"\" ng-click=\"mspc.changePath(\'home.profile\', shopProfile.profileName, shopProfile.matrimonyId, {matrimonyId: shopProfile.matrimonyId, shopId: shopProfile.shopId})\">Click here to See More Information or Send Interest</a></li></ul><span ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.packagePlan.paidMemberExpired\"><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></md-card-actions></md-card></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"spnlic.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-content></div><script type=\"text/ng-template\" id=\"login.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"30\"> <md-dialog-content layout-padding> <div class=\"text-center frm_hdr1\">If you already a member. Please Login</div> <form class=\"login mt20\" method=\"post\" id=\"loginForm\" name=\"loginForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"nlc.authenticate(loginForm)\"> <div layout> <!-- <md-input-container class=\"md-block\" flex=\"25\"> <input type=\"text\" value=\"+91 (India)\" ng-disabled=\"true\"/> </md-input-container> --> <md-input-container class=\"md-block\" flex> <label>Enter Registered Mobile Number / Matrimony ID</label> <input type=\"text\" ng-model=\"nlc.user.name\" name=\"username\" required maxlength=\"50\"/> </md-input-container> </div> <div ng-messages=\"loginForm.username.$error\" ng-if=\"loginForm.username.$dirty || loginForm.$submitted\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Mobile/Email is compulsory.</span> </div> <div layout> <md-input-container flex> <label>Password</label> <input type=\"password\" name=\"password\" ng-model=\"nlc.user.password\" ng-maxlength=\"30\" required> </md-input-container> </div> <div ng-messages=\"loginForm.password.$error\" ng-if=\"loginForm.password.$dirty || loginForm.$submitted\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">Password is compulsory.</span> </div> <div> <span class=\"error btm-10px\" ng-show=\"nlc.errorStatus\">Please enter valid Username and Password.</span> </div> <div layout=\"row\" layout-align=\"space-between center\"> <div class=\"sign-up\" ng-click=\"nlc.diaglog.hide()\"><a ui-sref=\"account.register\">Register</a></div> <div class=\"forgot-password-text-new\"><a ui-sref=\"account.forgotPassword\">Forgot Password?/Create a new password</a></div> </div> <div class=\"load\" dw-loading=\"loginBtn\" layout=\"row\" layout-align=\"center center\" > <md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Secure Login</md-button> </div> </form> </div> </md-dialog-content> </md-dialog></script>");
$templateCache.put("app/resetPassword/forgotPassword.html","<div class=\"newlogin\"><div ng-show=\"!main.currentSession\" class=\"forgot-password-form md-padding pb20\" flex=\"\" flex-md=\"20\"><form method=\"post\" ng-if=\"!otpForm.showResetPasswordForm && !otpForm.showPasswordChangeSuccess\" id=\"forgotPasswordForm\" name=\"forgotPasswordForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"rpc.forgotPassword($event, forgotPasswordForm)\" class=\"reset-form\"><h3 class=\"md-headline\">Password Assistance</h3><h3 style=\"padding: 15px 0 0 0;\">For any query please call or what\'s ap to customer care number (+91) {{rpc.reg.shop.mobileNo}}.</h3><div class=\"md-subhead F14\" style=\"padding: 15px 0 0 0;\">Let’s find your account</div><div ng-show=\"rpc.errorUser\" class=\"error F12 mt10\">Sorry, we’re unable to find any account registered to this Mobile Number.</div><div class=\"row\" ng-hide=\"rpc.showSuccessMsg\"><label class=\"uplbl activeLbl\" style=\"display: block;\">Enter Mobile Number</label> <input style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" value=\"+91 (India)\" ng-disabled=\"true\" required=\"\"> <input style=\"width: 195px;display: inline\" type=\"text\" class=\"textbox_sml\" name=\"mobileNo\" ng-model=\"rpc.mobileNo\" numbers-only=\"\" ng-minlength=\"10\" maxlength=\"10\" required=\"\"></div><div ng-messages=\"forgotPasswordForm.mobileNo.$error\" ng-if=\"forgotPasswordForm.mobileNo.$dirty || forgotPasswordForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Enter mobile number.</span> <span class=\"error\" ng-message=\"parse\">Enter mobile number.</span> <span class=\"error\" ng-message=\"minlength\">Enter 10 numbers.</span></div><div class=\"load\" dw-loading=\"continueBtn\" dw-loading-options=\"{text: \'Sending OTP...\'}\" ng-hide=\"rpc.showSuccessMsg\" layout=\"row\" layout-align=\"start start\"><md-button class=\"md-raised md-cornered md-primary btn-new\" type=\"submit\">Continue</md-button></div><div layout=\"row\" layout-align=\"end end\" class=\"forgot-password-text-new\"><a href=\"/login\">Click here to login</a></div></form><form method=\"post\" ng-if=\"otpForm.showResetPasswordForm && !otpForm.showPasswordChangeSuccess\" id=\"resetPasswordForm\" name=\"resetPasswordForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"rpc.resetPassword(resetPasswordForm)\" class=\"reset-form\"><h3 class=\"md-headline\">Create new password</h3><div class=\"md-subhead F14\" style=\"padding: 15px 0 0 0;\">We\'ll ask for this password whenever you sign in.</div><div class=\"row\"><label class=\"uplbl activeLbl\" style=\"display: block;\">Enter New Password</label> <input style=\"width: 300px;display: inline\" type=\"text\" ng-model=\"rpc.newPassword\" class=\"textbox_sml\" name=\"password\" maxlength=\"15\" ng-minlength=\"4\" ng-maxlength=\"15\" required=\"\"><div class=\"md-headline F12\">Passwords must be at least 4 characters.</div></div><div ng-if=\"resetPasswordForm.password.$dirty || resetPasswordForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"resetPasswordForm.password.$error.required\">New Password is required.</span> <span class=\"error\" ng-show=\"resetPasswordForm.password.$error.minlength\">Password should be minimum 4 characters.</span> <span class=\"error\" ng-show=\"resetPasswordForm.password.$error.maxlength\">Password should be maximum 15 characters.</span></div><div class=\"load\" layout=\"row\" layout-align=\"start start\"><md-button class=\"md-raised md-cornered md-primary btn-new\" type=\"submit\">Change</md-button></div></form><div ng-show=\"otpForm.showPasswordChangeSuccess\"><h3><a href=\"/login\">Your password has now been successfully reset. Click here to log in</a></h3></div></div></div><script type=\"text/ng-template\" id=\"otp-verify.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"30\"> <md-dialog-content layout-padding> <h3 class=\"md-headline\">Authentication required</h3> <p>For your security, we need to authenticate your request. We\'ve sent an OTP to the mobile number +91{{::otp.mobileNo}}. Please enter it below to complete verification.</p> <div class=\"outer-container1 mt30\"> <div class=\"tab-content\"> <div class=\"tab-pane active\"> <form dw-loading=\"otpVerifyBtn\" dw-loading-options=\"{text: \'Verifying OTP...\'}\" name=\"mobileVerifyOTPForm\" autocomplete=\"off\" class=\"reset-form load\" novalidate=\"novalidate\" ng-submit=\"otp.verifyOtp(mobileVerifyOTPForm)\"> <div class=\"row\"> <input name=\"OTPNo\" placeholder=\"Enter OTP\" style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" ng-model=\"otp.otpNo\" numbers-only ng-minlength=\"4\" maxlength=\"4\" required/> <md-button type=\"submit\" class=\"md-primary\"> Verify OTP </md-button> <md-button ng-click=\"otp.cancel()\"> Cancel </md-button> </div> <div class=\"mt5\" ng-messages=\"mobileVerifyOTPForm.OTPNo.$error\" ng-if=\"mobileVerifyOTPForm.OTPNo.$dirty || mobileVerifyOTPForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">OTP Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">OTP Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter 4 numbers.</span> </div> <div class=\"error\" ng-if=\"otp.errorMsg\">OTP didn\'t not match.</div> <!--<api-validate></api-validate>--> </form> </div> </div> </div> </md-dialog-content> </md-dialog></script>");
$templateCache.put("app/resetPassword/resetPassword.html","<div class=\"clr\"></div><section class=\"banner-bg\"><div class=\"banner\"><div class=\"container\"><div flex=\"\"><div class=\"bannerCaption\"><div class=\"txt1\" ng-if=\"rpc.shopName\">{{rpc.shopName}} Partner with Marriage Bureaus.</div><div class=\"txt2\">This Matrimony will help you to reach all profiles across all Marriage Bureaus at one place!.</div><div class=\"txt1\">Perfect place for your</div><div class=\"txt2\">perfect match!</div></div></div></div><div class=\"clr\"></div></div></section><div class=\"clr\"></div><section class=\"mobview\"><div id=\"mobview-frm\" style=\"display:block;\"><div class=\"mob_banner_form\" style=\"position:relative;\"></div></div></section><div ng-show=\"!main.currentSession\" class=\"forgot-password md-padding account-form-allign\"><h3 class=\"md-headline\">Reset Password</h3><form method=\"post\" id=\"resetPasswordForm\" name=\"resetPasswordForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"rpc.resetPassword()\"><div ng-if=\"rpc.otpNotMatched\" class=\"error mb10\">OTP has Not Matched</div><div ng-show=\"rpc.showSuccessMsg\"><div class=\"forgot-password-text-new\"><a href=\"/login\">Your password has now been successfully reset. Click here to log in</a></div></div><div layout=\"\" ng-hide=\"rpc.showSuccessMsg\"><md-input-container flex=\"\"><label>New Password</label> <input name=\"password\" ng-model=\"rpc.password\" type=\"password\" maxlength=\"15\" ng-minlength=\"5\" ng-maxlength=\"15\" ng-pattern=\"/((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{5,15})/\" required=\"\"></md-input-container></div><div ng-if=\"resetPasswordForm.password.$dirty || resetPasswordForm.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"resetPasswordForm.password.$error.required\">New Password is required.</span> <span class=\"error\" ng-show=\"resetPasswordForm.password.$error.pattern || resetPasswordForm.password.$error.minLength || resetPasswordForm.password.$error.maxLength\">Password should be 5-15 length, atleast 1 number/1 alphabet/ 1 caps alphabet.</span></div><div class=\"load\" ng-hide=\"rpc.showSuccessMsg\" layout=\"row\" layout-align=\"start start\"><md-button class=\"md-raised md-cornered md-primary btn-new\" type=\"submit\">Update</md-button></div></form></div>");
$templateCache.put("app/server-error/server-error.html","<div><h1>Maintenance is being performed.</h1><h3>Untill monday morning we will not be available, sorry for the inconvenience. <a href=\"/login\" title=\"LOG IN\">LOGIN</a></h3></div>");
$templateCache.put("app/setting/setting.html","<div ng-cloak=\"\" class=\"settings login\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content flex=\"80\" class=\"md-padding\"><h1>Settings</h1><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"md-default-theme\"><md-tab id=\"tab3\" class=\"login\" ng-if=\"main.currentSession.roles.includes(\'ROLE_ADMIN\')\" ng-init=\"sc.getEmployees();sc.getShopRolePermissions()\"><md-tab-body><h2 style=\"margin: 12px; font-weight: 600;\">Users</h2><div ng-if=\"main.currentSession.permissions.includes(\'CREATE_EMPLOYEE\')\"><md-button class=\"md-raised md-cornered\" style=\"background: #0CB863;color: #ffff;\" ng-click=\"sc.initAddUser()\">Add User</md-button></div><div class=\"row\" ng-if=\"sc.user && sc.user.action.includes(\'CREATE_EMPLOYEE\') && !sc.user.done\"><form dw-loading=\"createUserBtn\" dw-loading-options=\"{text: \'Creating user...\'}\" name=\"adduserForm\" class=\"load reset-form\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"sc.onboardEmployee(adduserForm, $event)\"><input name=\"mobileNo\" placeholder=\"Enter User Mobile No.\" style=\"margin-right: 35px;width: 160px;display: inline\" type=\"text\" class=\"textbox_sml\" ng-model=\"sc.user.mobileNo\" numbers-only=\"\" maxlength=\"10\" required=\"\"><select ng-model=\"sc.user.roleName\" ng-change=\"sc.getPermissions(sc.user.roleName)\" size=\"1\" style=\"margin-right: 35px;visibility: visible;height: 40px;border: 1px solid #DADADA;border-radius: 3px;font-size: 14px;font-weight: 500;color: #555;\"><option value=\"\" selected=\"\">---Select Role---</option><option ng-repeat=\"rolePermission in sc.rolePermissions\" value=\"{{rolePermission.roleName}}\">{{rolePermission.roleName}}</option></select><input name=\"password\" placeholder=\"Enter Password\" style=\"margin-right: 35px;width:160px;display: inline\" type=\"text\" class=\"textbox_sml\" ng-model=\"sc.user.password\" maxlength=\"7\" required=\"\"><md-button type=\"submit\" class=\"md-primary\">Save</md-button></form><api-validate></api-validate></div><div style=\"display: flex;margin: 20px 0 20px 0;\"><div style=\"font-weight: 600;font-size: 12px;width: 200px;\">Mobile Number</div><div style=\"font-weight: 600;font-size: 12px;width: 200px;\">Roles</div><div style=\"font-weight: 600;font-size: 12px;width: 200px;\">Action</div></div><div ng-repeat=\"user in sc.userList\"><div class=\"row\" ng-if=\"sc.user && !sc.user.done && main.currentSession.permissions.includes(\'EDIT_EMPLOYEE\') && sc.selectedUserId==user.id\"><form dw-loading=\"createUserBtn\" dw-loading-options=\"{text: \'Updating user...\'}\" name=\"resetPasswordForm\" class=\"load reset-form\" novalidate=\"\" autocomplete=\"off\" ng-submit=\"sc.changeEmployeePassword(resetPasswordForm, $event)\"><input name=\"mobileNo\" placeholder=\"Enter User Mobile No.\" style=\"width: 160px;display: inline;margin-right: 35px;\" type=\"text\" class=\"textbox_sml\" ng-model=\"sc.user.mobileNo\" numbers-only=\"\" maxlength=\"10\" disabled=\"\" required=\"\"><select ng-model=\"sc.user.roleName\" size=\"1\" disabled=\"\" style=\"margin-right: 35px;visibility: visible;height: 40px;border: 1px solid #DADADA;border-radius: 3px;font-size: 14px;font-weight: 500;color: #555;\"><option value=\"\" selected=\"\">---Select Role---</option><option ng-repeat=\"rolePermission in sc.rolePermissions\" value=\"{{rolePermission.roleName}}\">{{rolePermission.roleName}}</option></select><input name=\"password\" placeholder=\"Enter Password\" style=\"margin-right: 35px;width:160px;display: inline\" type=\"text\" class=\"textbox_sml\" ng-model=\"sc.user.password\" maxlength=\"20\" required=\"\"><md-button type=\"submit\" ng-click=\"sc.selectedUserId=\'\'\">cancel</md-button><md-button type=\"submit\" class=\"md-primary\">Change Password</md-button></form><api-validate></api-validate></div><div style=\"display: flex;margin:5px 0 5px 0;\" ng-hide=\"sc.selectedUserId==user.id\"><div style=\"font-size: 14px;width: 200px;\">{{user.mobileNo.length > 10 ? user.mobileNo.substring(user.mobileNo.length-10, user.mobileNo.length): user.mobileNo}}</div><div style=\"font-size: 14px;width: 200px;\">{{user.roles}}</div><div ng-if=\"main.currentSession.permissions.includes(\'EDIT_EMPLOYEE_PASSWORD\')\"><span><a href=\"\" ng-click=\"sc.initEditUser(user)\">change password</a></span></div></div></div></md-tab-body></md-tab><md-tab class=\"login\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'EDIT_EMPLOYEE_PASSWORD\')\"><md-tab-label>CHANGE PASSWORD</md-tab-label><md-tab-body><div class=\"outer-container1 mt30\"><div class=\"tab-content\"><div class=\"tab-pane active\"><form name=\"resetPassform\" autocomplete=\"off\" class=\"reset-form\" novalidate=\"novalidate\" ng-submit=\"sc.changePassword(resetPassform)\"><div class=\"row\"><label class=\"uplbl activeLbl\" style=\"display: block;\">New Password</label> <input placeholder=\"Enter New Password\" id=\"newPassword\" name=\"newPassword\" ng-model=\"sc.newPassword\" type=\"text\" maxlength=\"15\" ng-minlength=\"4\" ng-maxlength=\"15\" class=\"textbox_sml\" required=\"\"> <span ng-if=\"resetPassform.newPassword.$dirty || resetPassform.$submitted\" role=\"alert\"><span class=\"error\" ng-show=\"resetPassform.newPassword.$error.required\">New Password is required.</span> <span class=\"error\" ng-show=\"resetPassform.newPassword.$error.minlength\">Password should be minimum 4 characters.</span> <span class=\"error\" ng-show=\"resetPassform.newPassword.$error.maxlength\">Password should be maximum 15 characters.</span></span></div><div class=\"mt5\" style=\"color: #1E8449;font-size: 10px;\" ng-show=\"sc.passwordSaveSuccess\"><i class=\"material-icons md-24 prt5\">done</i> password changed successfully, so please login again.</div><api-validate></api-validate><div class=\"load\" dw-loading=\"settingBtn\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Save</md-button></div></form></div></div></div></md-tab-body></md-tab><md-tab class=\"login\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'EDIT_MOBILENO\')\" ng-init=\"sc.oldMobileNo=main.currentSession.profileBasicInfo.mobileNo\"><md-tab-label>CHANGE MOBILE NUMBER</md-tab-label><md-tab-body><div class=\"outer-container1 mt30\"><div class=\"tab-content\"><div class=\"tab-pane active\"><form name=\"resetMobileNoForm\" autocomplete=\"off\" class=\"reset-form\" novalidate=\"novalidate\" ng-submit=\"sc.changeMobileNo(resetMobileNoForm, $event)\"><div class=\"row\"><label class=\"uplbl activeLbl\" style=\"display: block;\">Old Mobile Number</label> <input style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" value=\"+91 (India)\" ng-disabled=\"true\" required=\"\"> <input style=\"width: 190px;display: inline\" type=\"text\" class=\"textbox_sml\" name=\"oldMobileNo\" ng-model=\"sc.oldMobileNo\" ng-disabled=\"true\" numbers-only=\"\" ng-minlength=\"10\" maxlength=\"10\" required=\"\"></div><div class=\"mt5\" ng-messages=\"resetMobileNoForm.oldMobileNo.$error\" ng-if=\"resetMobileNoForm.oldMobileNo.$dirty || resetMobileNoForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Old Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">OldMobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter 10 numbers.</span></div><div class=\"row\"><label class=\"uplbl activeLbl\" style=\"display: block;\">New Mobile Number</label> <input style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" value=\"+91 (India)\" ng-disabled=\"true\" required=\"\"> <input placeholder=\"Enter New Mobile Number\" style=\"width: 190px;display: inline\" type=\"text\" class=\"textbox_sml\" name=\"newMobileNo\" ng-model=\"sc.newMobileNo\" ng-click=\"sc.msg=false;sc.mobileNoExist=false;\" numbers-only=\"\" ng-minlength=\"10\" maxlength=\"10\" required=\"\"></div><div class=\"mt5\" ng-messages=\"resetMobileNoForm.newMobileNo.$error\" ng-if=\"resetMobileNoForm.newMobileNo.$dirty || resetMobileNoForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">New Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">New Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter 10 numbers.</span></div><div ng-if=\"sc.newMobileNo.length == 10\"></div><div class=\"error\" ng-show=\"sc.mobileNoExist\">Mobile Number Already exist.</div><div class=\"load\" dw-loading=\"settingBtn\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-cornered md-primary btn-new mt10\" ng-disabled=\"sc.mobileNoExist\" type=\"submit\">Save</md-button></div></form></div></div></div></md-tab-body></md-tab><md-tab id=\"tab1\" class=\"login\" ng-if=\"main.currentSession.profileBasicInfo.email && main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.permissions.includes(\'EDIT_EMAIL\')\" ng-init=\"sc.oldEmail=main.currentSession.profileBasicInfo.email\"><md-tab-label>CHANGE EMAIL</md-tab-label><md-tab-body><div class=\"outer-container1 mt30\"><div class=\"tab-content\"><div class=\"tab-pane active\"><form name=\"resetEmailForm\" autocomplete=\"off\" class=\"reset-form\" novalidate=\"novalidate\" ng-submit=\"sc.changeEmail(resetEmailForm)\"><div class=\"row\"><label class=\"uplbl activeLbl\" style=\"display: block;\">Old Email</label> <input type=\"email\" class=\"textbox_sml\" ng-model=\"sc.oldEmail\" ng-disabled=\"true\" validate-email=\"\" name=\"oldEmail\" required=\"\"></div><div class=\"mt5\" ng-messages=\"resetEmailForm.oldEmail.$error\" ng-if=\"resetEmailForm.oldEmail.$dirty || resetEmailForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">You did not enter your email address.</span> <span class=\"error\" ng-message=\"email\">Your email address is invalid.</span></div><div class=\"row\"><label class=\"uplbl activeLbl\" style=\"display: block;\">New Email</label> <input placeholder=\"Enter New Email\" type=\"email\" class=\"textbox_sml\" ng-model=\"sc.newEmail\" validate-email=\"\" name=\"newEmail\" required=\"\"></div><div class=\"mt5\" ng-messages=\"resetEmailForm.newEmail.$error\" ng-if=\"resetEmailForm.newEmail.$dirty || resetEmailForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Please enter your email address.</span> <span class=\"error\" ng-message=\"email\">Your email address is invalid.</span></div><div class=\"error\" ng-show=\"sc.msg\">Old Email and New Email shouldn\'t be same.</div><div class=\"mt5\" style=\"color: #1E8449;font-size: 10px;\" ng-show=\"sc.emailSaveSuccess\"><i class=\"material-icons md-24 prt5\">done</i> email saved successfully.</div><div class=\"load\" dw-loading=\"settingBtn\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Save</md-button></div></form></div></div></div></md-tab-body></md-tab></md-tabs></md-content></div><script type=\"text/ng-template\" id=\"mobileno-change-verify.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"30\"> <md-dialog-content layout-padding> <h2>To Change Your Mobile Number, Please Verify First.</h2> <div class=\"outer-container1 mt30\"> <div class=\"tab-content\"> <div class=\"tab-pane active\"> <h4>Verify through SMS</h4> <div class=\"mt5\" style=\"color: #1E8449;font-size: 10px;\" ng-show=\"sc.otpCond.verifyMobileOTPSuccess\"> <i class=\"material-icons md-24 prt5\">done</i> Your New Mobile Number +91 {{sc.newMobileNo}} saved successfully. So please login again with new mobile number. </div> <form ng-hide=\"sc.otpCond.showMobileOTPForm\" autocomplete=\"off\" class=\"reset-form\" novalidate=\"novalidate\" ng-submit=\"sc.sendOTPToMobile()\"> <div class=\"row\"> <input style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" value=\"+91 (India)\" ng-disabled=\"true\" required/> <input style=\"width: 130px;display: inline\" type=\"text\" class=\"textbox_sml\" name=\"newMobileNo\" ng-model=\"sc.newMobileNo\" ng-disabled=\"true\" numbers-only required/> <md-button type=\"submit\" class=\"md-primary\"> Send OTP </md-button> </div> </form> <form ng-show=\"sc.otpCond.showMobileOTPForm && !sc.otpCond.verifyMobileOTPSuccess\" name=\"MobileOTPForm\" autocomplete=\"off\" class=\"reset-form\" novalidate=\"novalidate\" ng-submit=\"sc.verifyMobileOTP()\"> <div class=\"mt5\" style=\"color: #1E8449;font-size: 10px;\"> OTP has sent successfully. </div> <div class=\"row\"> <input name=\"OTPNo\" placeholder=\"Enter OTP\" style=\"width: 100px;display: inline\" type=\"text\" class=\"textbox_sml\" ng-model=\"sc.OTPNo\" ng-click=\"sc.otpCond.verifyMobileOTPFailure=false;\" numbers-only ng-minlength=\"4\" maxlength=\"4\" required/> <md-button type=\"submit\" class=\"md-primary\"> Verify OTP </md-button> </div> <div class=\"mt5\" ng-messages=\"MobileOTPForm.OTPNo.$error\" ng-if=\"MobileOTPForm.OTPNo.$dirty || MobileOTPForm.$submitted\" role=\"alert\" class=\"error-allign\"> <span class=\"error\" ng-message=\"required\">OTP Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">OTP Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Enter 4 numbers.</span> </div> <div class=\"error\" ng-if=\"sc.otpCond.verifyMobileOTPFailure\">OTP didn\'t not match.</div> <api-validate></api-validate> </form> </div> </div> </div> </md-dialog-content> </md-dialog></script>");
$templateCache.put("app/shop/shop.html","<div ng-controller=\"ShopController as sc\"><div ng-cloak=\"\" class=\"shop-profile\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content dw-loading=\"shop\" class=\"md-padding mh-120\" flex-gt-sm=\"50\" flex-sm=\"100\"><ul><h3 class=\"md-headline\">{{::sc.shop.shopName}}</h3></ul><ul><li class=\"attributes\"><span class=\"col1\">Created On</span> <span class=\"col2 date_time_format md-caption\">{{::sc.shop.shopCreatedOn | date:\"dd MMMM yyyy\"}}</span></li><li class=\"attributes\"><span class=\"col1\">Mobile No</span> <span class=\"col2 date_time_format md-caption\">{{::sc.shop.mobileNo}}</span></li><li class=\"attributes\"><span class=\"col1\">Located Cities</span> <span class=\"col2 date_time_format md-caption\">{{::sc.shop.locatedCities}}</span></li></ul></md-content></div></div>");
$templateCache.put("app/shopDashBoard/shopDashBoard.html","<div ng-cloak=\"\" class=\"dash-board\" layout=\"row\" layout-wrap=\"\" layout-align=\"center start\"><md-content flex=\"95\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"md-default-theme\"><md-tab md-on-select=\"sdc.showProfileInterestInfo = true\"><md-tab-label><h5>PROFILE INTEREST\'S <span class=\"round green\" ng-show=\"hmc.notification.interestStatusCount > 0\">{{hmc.notification.interestStatusCount}}</span></h5></md-tab-label><md-tab-body><div ng-if=\"sdc.showProfileInterestInfo\" data-ng-include=\"\'app/shopDashBoard/profileInterestInfo/profileInterestInfo.html\'\"></div></md-tab-body></md-tab><md-tab md-on-select=\"sdc.showMobileNoInfo = true\"><md-tab-label><h5>MOBILE NUMBER REQUEST<span class=\"round green\" ng-show=\"hmc.notification.mobileNoRequestStatusCount > 0\">{{::hmc.notification.mobileNoRequestStatusCount}}</span></h5></md-tab-label><md-tab-body><div ng-if=\"sdc.showMobileNoInfo\" data-ng-include=\"\'app/shopDashBoard/mobileNoInfo/mobileNoInfo.html\'\"></div></md-tab-body></md-tab><md-tab md-on-select=\"sdc.showContactNumberIssue = true\"><md-tab-label><h5>CONTACT NUMBER ISSUE<span class=\"round green\" ng-show=\"hmc.notification.contactNoIssueCount > 0\">{{::hmc.notification.contactNoIssueCount}}</span></h5></md-tab-label><md-tab-body><div ng-if=\"sdc.showContactNumberIssue\" data-ng-include=\"\'app/shopDashBoard/contactNoIssue/contactNoIssue.html\'\"></div></md-tab-body></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/shopProfile/shopProfile.html","<div ng-cloak=\"\" class=\"shop-profile\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><md-content flex=\"20\" class=\"ml10 mr15 ovf-hidden\"><div ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'DELETE_PROFILE\') && main.currentSession.shop.defaultShowBureauProfilesType == \'My\'\"><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" aria-label=\"Checkbox 1\" ng-model=\"mspc.isShowDeletedProfile\" ng-change=\"mspc.reset()\"><span class=\"elips mt10\">Show Deleted Profile</span></md-checkbox></div><div></div><div style=\"margin-left: 25px; margin-top: 10px;\"><label ng-class=\"{\'blue-color\' : main.currentSession.shop.defaultShowBureauProfilesType}\">Show Bureau Profiles</label><md-radio-group ng-model=\"main.currentSession.shop.defaultShowBureauProfilesType\" ng-change=\"mspc.defaultShowBureauProfilesTypeChange()\" layout=\"\" name=\"vegOrNonVeg\"><md-radio-button value=\"All\" style=\"width: 80px;\"><span style=\"display: block; position: relative; left: 15px;\">All</span></md-radio-button><md-radio-button value=\"My\" style=\"width: 100px;\"><span style=\"display: block; position: relative; left: 15px;\">Self</span></md-radio-button><md-radio-button value=\"Other\" style=\"width: 100px;\"><span style=\"display: block; position: relative; left: 15px;\">Other</span></md-radio-button></md-radio-group></div><div class=\"leftmenu\" ng-if=\"mspc.shopProfileCount\"><ul><h1>Profile Created</h1><li><span>Within a day</span> <span class=\"badge bg-info\">{{::mspc.shopProfileCount.withInDay}}</span></li><li><span>Within a week</span><span class=\"badge bg-info\">{{::mspc.shopProfileCount.withInWeek}}</span></li><li><span>Within a month</span><span class=\"badge bg-info\">{{::mspc.shopProfileCount.withInMonth}}</span></li></ul></div><div ng-if=\"((main.currentSession.roles.includes(\'ROLE_ADMIN\') && main.currentSession.permissions.includes(\'WHATSAP_PROFILE_MOBILENO\')) || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" aria-label=\"Checkbox 1\" ng-model=\"mspc.addMobileno\"><span class=\"elips mt10\">WhatsAp MobileNo</span></md-checkbox></div><div class=\"main-container\" layout=\"row\" flex=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'MYBUREAU_SIDE_FILTER\') && !mspc.isShowDeletedProfile\"><md-sidenav class=\"main-sidenav md-sidenav-left\" md-component-id=\"navigation-drawer\" md-is-locked-open=\"true\" layout=\"column\"><md-content md-scroll-y=\"\" flex=\"\" layout=\"column\"><md-sidemenu locked=\"true\"><md-sidemenu-group><md-subheader class=\"md-no-sticky\">Filter</md-subheader><md-sidemenu-content md-heading=\"Search By Name\" md-arrow=\"true\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><form class=\"reset-form\" name=\"searchNameForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"mspc.searchProfile()\"><div class=\"row\"><input placeholder=\"Enter Name\" style=\"width: 254px;\" class=\"textbox_sml\" name=\"regex\" type=\"text\" ng-model=\"mspc.regex\"></div><div layout=\"row\" class=\"mt5\" style=\"margin-bottom: 10px;margin-top: -23px;\" flex=\"80\"><md-button class=\"md-raised md-cornered\" type=\"submit\" style=\"color: #ffff;background-color: #0CB863\">Search</md-button><md-button class=\"md-raised md-cornered\" ng-click=\"mspc.regex=\'\';searchNameForm[\'$submitted\']=false; mspc.searchProfile()\">Clear</md-button></div><div ng-if=\"searchNameForm[\'$submitted\'] && mspc.regex == \'\'\" ng-init=\"searchNameForm[\'$submitted\']=false; mspc.searchProfile()\"></div></form></md-sidemenu-content><a style=\"position: relative;right: -16px;\" ng-click=\"mspc.clearAllFilters()\">clear all filters</a><md-sidemenu-content md-heading=\"Member Type\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'memberType\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Profile Status\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'profileStatus\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Gender\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'gender\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Veg / Non Veg\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'vegOrNonVeg\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Martial Status\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'martialStatus\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Caste No Bar\" md-arrow=\"true\" ng-if=\"f.id == \'casteNoBar\'\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\' | filter:{ name: true }\"><span class=\"elips mt10\">Caste No Bar</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Mother Tongue\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'motherTongue\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Religion\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'religion\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Caste\" md-arrow=\"true\" ng-if=\"f.id == \'caste\'\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Sub Caste\" md-arrow=\"true\" ng-if=\"f.id == \'subCaste\'\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Age\" md-arrow=\"true\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><div layout=\"column\" flex=\"\"><div layout=\"\" flex=\"\" class=\"mt20\"><md-input-container flex=\"50\"><label>From</label><md-select ng-model=\"mspc.fromAge\"><md-option ng-repeat=\"option in mspc.ageOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>To</label><md-select ng-model=\"mspc.toAge\"><md-option ng-repeat=\"option in mspc.ageOptions.values\" ng-value=\"option.value\">{{option.value}}</md-option></md-select></md-input-container></div><div class=\"load\" dw-loading=\"ageSubmit\" layout=\"row\" flex=\"30\"><md-button class=\"md-raised md-cornered\" ng-click=\"mspc.submitAge()\" style=\"color: #ffff;background-color: #0CB863;width: 108px;margin-bottom: 10px;\">Submit</md-button></div></div></md-sidemenu-content><md-sidemenu-content md-heading=\"Height\" md-arrow=\"true\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><div layout=\"column\" flex=\"\"><div layout=\"\" flex=\"\" class=\"mt20\"><md-input-container flex=\"50\"><label>From</label><md-select ng-model=\"mspc.fromHeight\"><md-option ng-repeat=\"option in mspc.heightOptions.values\" ng-value=\"option.category\">{{::option.value}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>To</label><md-select ng-model=\"mspc.toHeight\"><md-option ng-repeat=\"option in mspc.heightOptions.values\" ng-value=\"option.category\">{{::option.value}}</md-option></md-select></md-input-container></div><div class=\"load\" dw-loading=\"ageSubmit\" layout=\"row\" flex=\"30\"><md-button class=\"md-raised md-cornered\" ng-click=\"mspc.submitHeight()\" style=\"width: 108px; margin-bottom: 10px;color: #ffff;background-color: #0CB863\">Submit</md-button></div></div></md-sidemenu-content><md-sidemenu-content md-heading=\"Highest Education\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'highestEducation\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Employed In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'employedIn\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Occupation\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'occupation\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Country Living In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'currentLivingCountry\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"State Living In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'currentLivingState\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"City Living In\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'currentLivingCity\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content><md-sidemenu-content md-heading=\"Star\" md-arrow=\"true\" ng-if=\"f.id.indexOf(\'star\') > -1\" ng-repeat=\"f in mspc.filter\" ng-class=\"{checkmark: mspc.checkIfExist(f, true)}\" class=\"load\" dw-loading=\"filter\"><div ng-init=\"$parent.$mdSidemenuContent.visible = true\" ng-hide=\"\"></div><md-checkbox style=\"min-height: 40px;\" class=\"ml25\" ng-model=\"k.isChecked\" ng-change=\"mspc.filterChange(f.id, k)\" aria-label=\"Checkbox 1\" ng-repeat=\"k in f.values | orderBy:\'name\'\"><span class=\"elips mt10\">{{k.name}}</span> <span class=\"ptm9\">({{k.total}})</span></md-checkbox></md-sidemenu-content></md-sidemenu-group></md-sidemenu></md-content></md-sidenav></div></md-content><md-content id=\"loadingProfifle\" dw-loading=\"shopProfile\" class=\"md-padding mh-120 load\" flex=\"55\" layout=\"row\" layout-wrap=\"\"><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div><div flex=\"50\" ng-if=\"mspc.shopProfiles.length == 0\" flex-offset=\"30\"><h1>No Profiles are there</h1></div><div flex=\"50\" dir-paginate=\"shopProfile in mspc.shopProfiles | itemsPerPage: mspc.pageSize\" current-page=\"currentPage\" total-items=\"mspc.total\"><md-card ng-init=\"mspc.setCurrentImage(1, shopProfile)\"><md-card-header><md-card-header-text><span class=\"md-title\" ng-if=\"((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) || !main.currentSession.packagePlan.paidMemberExpired)\"><a ng-click=\"mspc.changePath(\'home.profile\', shopProfile.profileName, shopProfile.matrimonyId, {matrimonyId: shopProfile.matrimonyId, shopId: main.currentSession.shop.id}, shopProfile.profileStatus)\">{{::shopProfile.profileName}}</a> <span class=\"md-subhead msg-alert\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && shopProfile.profileStatus== \'Delete Profile\'\">(Deleted)</span> <span ng-if=\"shopProfile.martialStatus.indexOf(\'Never Married\') < 0\">({{::shopProfile.martialStatus}})</span></span><span class=\"md-caption\" ng-if=\"main.currentSession.roles.includes(\'ROLE_SUPER_ADMIN\')\">Marriage Bureau Name <a ng-click=\"mspc.changePath(\'home.shop\', shopProfile.shopName, \'Marriage Shop\', {shopId: shopProfile.shopId})\">{{::shopProfile.shopName}}</a></span> <span ng-if=\"shopProfile.profileStatus == \'Pending for Activation\'\" class=\"md-caption msg-alert\">( Profile Pending for Activation )</span> <span ng-if=\"shopProfile.profileStatus == \'Invalid\'\" class=\"md-caption msg-alert\">( Invalid )</span> <span ng-if=\"shopProfile.profileStatus == \'Not Interested in Site\'\" class=\"md-caption msg-alert\">( Not Interested in Site )</span> <span class=\"md-caption pt6\" ng-if=\"shopProfile.profileStatus == \'Paid Member\'\"><div class=\"TAG\"><div class=\"text\" style=\"background-color:#0DD4AC;\">+ {{:: shopProfile.profileStatus}}</div><div class=\"img\"></div></div></span> <span class=\"md-caption pt6\" ng-if=\"shopProfile.profileStatus == \'Free Member\' && main.currentSession.shop && (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><div class=\"TAG\"><div class=\"text\">+ {{:: shopProfile.profileStatus}}</div><div class=\"img\"></div></div></span> <span ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\" class=\"F12 mt5\">({{::shopProfile.memberType}})</span> <span class=\"md-caption date_time_format\" ng-if=\"shopProfile.lastActive\">Last Active: {{::shopProfile.lastActive | date:\"dd MMMM yyyy \'at\' h:mma\"}}</span></md-card-header-text></md-card-header><canvas style=\"display:none\" id=\"{{\'canvas\'+shopProfile.id}}\" width=\"400\" height=\"260\">Your browser does not support the HTML5 canvas tag.</canvas><md-card-content layout-wrap=\"\" style=\"padding: 0;\"><div style=\"position: relative;\" class=\"sc-gyhKFA\" data-test-selector=\"profile_photo_wrapper\"><div class=\"just-joined\" ng-show=\"mspc.utilService._isRecentProfile(shopProfile.profileCreatedOn)\"></div><div class=\"sc-cMOKGX eGkYNO\" type=\"profile\"><div class=\"sc-kYnif ktdCay\"><div class=\"sc-iclvYL igwvZs\" type=\"profile\"><div class=\"sc-chYKBT\" ng-style=\"shopProfile.className\"></div><nav class=\"sc-mWPeY jfhRQb\" type=\"profile\" ng-if=\"shopProfile.profileImages.length>1\"><button class=\"sc-beROAQ fvvGZu\" icon=\"prev\" ng-click=\"mspc.setCurrentImage(shopProfile.cur-1, shopProfile)\"></button><div class=\"sc-bchHHi hKgVQm\">{{shopProfile.cur}} of {{::shopProfile.profileImages.length}}</div><button class=\"sc-beROAQ jUUwmB\" icon=\"next\" ng-click=\"mspc.setCurrentImage(shopProfile.cur+1, shopProfile)\"></button></nav></div><div data-test-selector=\"FreeA plan_free\" class=\"sc-bMuqKn dEAsKZ\"></div><div class=\"sc-eQvJSV Xjvfb\"></div></div></div></div><div style=\"padding: 5px 5px 0 5px;\"><span class=\"col1\">Age:</span><span class=\"col2\" ng-bind=\"main.getAge(shopProfile.dob)\"></span> <span class=\"col1\">, Height:</span><span class=\"col2\">{{::shopProfile.height.value}},</span> <span class=\"col1\">Caste:</span><span class=\"col2\">{{::shopProfile.caste}} <span ng-if=\"shopProfile.casteNoBar\" class=\"col2\">(Caste No Bar)</span>,</span> <span ng-show=\"(shopProfile.subCaste && shopProfile.subCaste.indexOf(\'Not Specified\') < 0) || shopProfile.otherSubCaste\"><span class=\"col1\">Sub Caste:</span> <span class=\"col2\" ng-show=\"shopProfile.subCaste.indexOf(\'Not Specified\') < 0 && shopProfile.subCaste.indexOf(\'Other\') < 0\">{{::shopProfile.subCaste}} <span ng-if=\"shopProfile.subCasteNoBar\" class=\"col2\">(Subcaste No Bar)</span>,</span> <span class=\"col2\" ng-show=\"shopProfile.otherSubCaste\">{{::shopProfile.otherSubCaste}},</span></span> <span class=\"col1\">Martial Status:</span><span class=\"col2\">{{::shopProfile.martialStatus}},</span> <span ng-show=\"shopProfile.star && shopProfile.star.indexOf(\'Not Specified\') < 0\"><span class=\"col1\">Star:</span> <span class=\"col2\">{{::shopProfile.star}},</span></span> <span class=\"col1\">Education:</span><span class=\"col2\">{{::shopProfile.highestEducation}},</span> <span class=\"col1\" ng-show=\"shopProfile.occupation\">Working as:</span> <span class=\"col2\" ng-if=\"shopProfile.occupation\">{{::shopProfile.occupation}},</span> <span ng-show=\"shopProfile.annualIncome && shopProfile.annualIncome > 0\"><span class=\"col1\">Annual Income:</span> <span class=\"col2\">{{::main.getFormatAmount(shopProfile.annualIncome)}},</span></span> <span ng-if=\"shopProfile.caste.indexOf(\'Arya Vysya\') > -1 && shopProfile.gothram\"><span class=\"col1\">Swa Gothra(m):</span><span class=\"col2\">{{::shopProfile.gothram}},</span></span> <span ng-if=\"shopProfile.caste.indexOf(\'Arya Vysya\') > -1 && shopProfile.mathula\"><span class=\"col1\">Mathula:</span><span class=\"col2\">{{::shopProfile.mathula}},</span></span> <span class=\"col1\" ng-if=\"shopProfile.currentLivingCountry && shopProfile.currentLivingCountry.indexOf(\'India\') < 0\"><span>Working/Living in Country:</span><span class=\"col2\">{{::shopProfile.currentLivingCountry}},</span></span> <span class=\"col1\" ng-if=\"shopProfile.currentLivingState\"><span>Working/Living in State:</span> <span class=\"col2\">{{::shopProfile.currentLivingState}},</span></span> <span class=\"col1\" ng-if=\"shopProfile.currentLivingCity\"><span>Working/Living in City/Near City:</span> <span class=\"col2\">{{::shopProfile.currentLivingCity}}</span></span></div></md-card-content><md-card-actions layout=\"row\"><ul ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && (!main.currentSession.packagePlan.paidMemberExpired)\"><li class=\"afm\"><a href=\"\" ng-click=\"mspc.changePath(\'home.profile\', shopProfile.profileName, shopProfile.matrimonyId, {matrimonyId: shopProfile.matrimonyId, shopId: shopProfile.shopId})\">Click here to See More Information or Send Interest</a></li></ul><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.permissions.includes(\'SHARE_WHATSAPP_IMAGE\')\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"mspc.shareProfile(shopProfile, main.currentSession.shop,$event)\"></li></ul><span ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.packagePlan.paidMemberExpired\"><md-button ng-href=\"/payment\" class=\"blue-color\"><span><i class=\"material-icons md-18 edit\">lock</i></span> <span class=\"F9\">Upgrade Membership To Unlock More Information</span></md-button></span></md-card-actions></md-card></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"mspc.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-content></div><div ui-view=\"\"></div>");
$templateCache.put("app/shopPayment/shopPayment.html","<div ng-cloak=\"\" layout=\"row\" class=\"shop-payment\" layout-wrap=\"\" layout-align=\"center start\"><md-content dw-loading=\"shopProfileCount\" class=\"md-padding\" flex=\"50\"><ul><h3 class=\"md-headline\">Total Shop Profile</h3></ul><ul><li class=\"attributes\" ng-repeat=\"status in spc.shopProfileCount\"><span class=\"col1\"><a ui-sref=\"home.profileStatus({profileStatus: status.profileStatus, currentMonthProfile: false})\">{{::status.profileStatus}}</a></span> <span class=\"col2\">{{::status.total}}</span></li></ul></md-content></div><div ng-cloak=\"\" layout=\"row\" class=\"shop-payment mt10\" layout-wrap=\"\" layout-align=\"center start\"><md-content dw-loading=\"currentMonthShopProfileCounts\" class=\"md-padding\" flex=\"50\"><ul><h3 class=\"md-headline\">Current Month Total Shop Profile</h3></ul><ul><li class=\"attributes\" ng-repeat=\"count in spc.currentMonthShopProfileCounts\"><span class=\"col1\"><a ui-sref=\"home.profileStatus({profileStatus: count.profileStatus, currentMonthProfile: true})\">{{::count.profileStatus}}</a></span> <span class=\"col2\">{{::count.total}}</span></li></ul></md-content></div>");
$templateCache.put("app/signUp/signUp.html","<div class=\"clr\"></div><section class=\"banner-bg\"><div class=\"banner\"><div class=\"container\"><div flex=\"\"><div class=\"bannerCaption\"><div class=\"txt1\">Partner with Marriage Bureaus.</div><div class=\"txt2\">This Matrimony will help you to reach all profiles across all Matrimony bureaus!</div><div class=\"txt1\">Perfect place for your</div><div class=\"txt2\">perfect match!</div></div></div></div><div class=\"clr\"></div></div></section><div class=\"clr\"></div><section class=\"mobview\"><div id=\"mobview-frm\" style=\"display:block;\"><div class=\"mob_banner_form\" style=\"position:relative;\"></div></div></section><div ng-cloak=\"\" class=\"md-padding account-form-allign\" id=\"signup\"><div class=\"text-center frm_hdr1\">SignUp For Marriage Bureaus</div><form class=\"login\" method=\"post\" id=\"signUpShopForm\" name=\"signUpShopForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"suc.createAccountAndShop()\"><div layout=\"\"><md-input-container flex=\"\"><label>Email ID</label> <input type=\"email\" ng-model=\"suc.shop.email\" validate-email=\"\" name=\"email\" maxlength=\"50\" md-maxlength=\"50\" required=\"\"></md-input-container></div><div ng-messages=\"signUpShopForm.email.$error\" ng-show=\"signUpShopForm.email.$dirty || signUpShopForm.$submitted\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">You did not enter your email address.</span> <span class=\"error\" ng-message=\"email\">Your email address is invalid.</span> <span class=\"error\" ng-message=\"md-maxlength\">Your email address is too long.</span></div><div layout=\"\"><md-input-container flex=\"\"><label>Shop Mobile Number</label> <input type=\"text\" name=\"mobileNo\" ng-model=\"suc.shop.mobileNo\" numbers-only=\"\" ng-minlength=\"10\" md-maxlength=\"10\" maxlength=\"10\" required=\"\"></md-input-container></div><div ng-messages=\"signUpShopForm.mobileNo.$error\" ng-show=\"signUpShopForm.mobileNo.$dirty || signUpShopForm.$submitted\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"parse\">Mobile Number is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Please enter 10 digit numbers.</span></div><div class=\"fnt-clr\">(Shop information)</div><div layout=\"\"><md-input-container flex=\"\"><label>Shop Name</label> <input type=\"text\" ng-model=\"suc.shop.shopName\" name=\"shopName\" required=\"\" ng-minlength=\"5\" md-maxlength=\"50\"></md-input-container></div><div ng-messages=\"signUpShopForm.shopName.$error\" ng-show=\"signUpShopForm.shopName.$dirty || signUpShopForm.$submitted\" class=\"error-allign\"><span class=\"error\" ng-message=\"required\">Shop name is compulsory.</span> <span class=\"error\" ng-message=\"minlength\">Shop name is too short.</span> <span class=\"error\" ng-message=\"md-maxlength\">Shop name is too long.</span></div><div layout=\"\"><md-input-container flex=\"\"><label>Shop Address (optional)</label> <textarea ng-model=\"suc.shop.address.location\" columns=\"1\" md-maxlength=\"190\" name=\"shopLocation\"></textarea></md-input-container></div><div ng-messages=\"signUpShopForm.shopLocation.$error\" ng-show=\"signUpShopForm.shopLocation.$dirty || signUpShopForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"md-maxlength\">Shop Address is too long.</div></div><div layout=\"\"><md-input-container flex=\"\"><label>Pin Code (optional)</label> <input name=\"pinCode\" ng-model=\"suc.shop.address.pinCode\" placeholder=\"570010\" minlength=\"6\" numbers-only=\"\" maxlength=\"6\" ng-pattern=\"/^[0-9]{6}$/\" md-maxlength=\"6\"></md-input-container></div><div ng-messages=\"signUpShopForm.pinCode.$error\" ng-show=\"signUpShopForm.pinCode.$dirty || signUpShopForm.$submitted\" class=\"error-allign\"><span class=\"error\" ng-message=\"pattern\">Please enter a valid postal code(6 digit No\'s).</span> <span class=\"error\" ng-message=\"minlength\">Enter 6 No\'s.</span></div><div ng-if=\"signUpShopForm.pinCode.$dirty || signUpShopForm.$submitted\"></div><p class=\"md-caption prb10 blue-color\"><a href=\"/login\">If you already registered ? please click here to Login.</a></p><div class=\"load\" dw-loading=\"signUp\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-cornered btn-new md-primary mt10\" type=\"submit\">Create Shop</md-button></div></form></div><div class=\"clr\"></div>");
$templateCache.put("app/successStory/successStory.html","<div ng-cloak=\"\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content flex=\"70\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"stc.tabValue\"><md-tab label=\"Success Stories\"><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div><div flex=\"50\" ng-if=\"stc.successStory.length == 0\" flex-offset=\"30\"><h1>No Success Story Yet.</h1></div><div dir-paginate=\"story in stc.successStory | itemsPerPage: stc.pageSize\" current-page=\"currentPage\" total-items=\"stc.totalSuccessStory\" class=\"innerwrapper\" style=\"height:400px;\"><div class=\"fleft\" style=\"width:410px;\"><div class=\"fleft hm-suc-imgbg\"><div id=\"SSIMG\"><img ng-src=\"{{main.imageUrl}}{{story.imageURL}}\" width=\"364\" height=\"238\" border=\"0\" alt=\"\" style=\"padding:22px 20px;\"></div></div><div class=\"clear\"></div></div><div class=\"fleft\" style=\"width:550px;margin:60px 0px 0px 40px;\"><div id=\"SSCOUPLENAMES\" class=\"hm-name-caption\">{{::story.groomName}} &amp; {{::story.brideName}}</div><div class=\"hm-loc-caption\"></div><div class=\"hm-caption-txt\" id=\"SSSTORY\">\"{{::story.message}}.\"</div><br></div><div class=\"clear\"></div></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"stc.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-tab><md-tab label=\"Post New Story\"><md-content layout-padding=\"\"><div><form name=\"successStoryForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"stc.saveSuccessStory()\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Groom name</label> <input ng-model=\"stc.successStoryJson.groomName\" name=\"groomName\" required=\"\" minlength=\"3\" md-maxlength=\"40\" maxlength=\"40\"></md-input-container></div><div ng-messages=\"successStoryForm.groomName.$error\" ng-if=\"successStoryForm.groomName.$dirty || successStoryForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"required\">Groom Name is compulsory.</div><div class=\"error\" ng-message=\"minlength\">Groom Name is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Groom Name is too long.</div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Bride name</label> <input ng-model=\"stc.successStoryJson.brideName\" name=\"brideName\" required=\"\" minlength=\"3\" md-maxlength=\"40\" maxlength=\"40\"></md-input-container></div><div ng-messages=\"successStoryForm.brideName.$error\" ng-if=\"successStoryForm.brideName.$dirty || successStoryForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"required\">Bride Name is compulsory.</div><div class=\"error\" ng-message=\"minlength\">Bride Name is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Bride Name is too long.</div></div><md-input-container class=\"md-block\"><label>Message</label> <textarea name=\"msg\" ng-model=\"stc.successStoryJson.message\" md-maxlength=\"500\" rows=\"2\" md-select-on-focus=\"\" minlength=\"20\" required=\"\"></textarea></md-input-container><div ng-messages=\"successStoryForm.msg.$error\" ng-if=\"successStoryForm.msg.$dirty || successStoryForm.$submitted\" class=\"error-allign\"><div class=\"error\" ng-message=\"required\">Message is compulsory.</div><div class=\"error\" ng-message=\"minlength\">Message is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Message is too long.</div></div><div layout=\"\" flex=\"\" dw-loading=\"imageLoading\" class=\"load\" dw-loading-options=\"{text: \'Loading Image...\'}\"><div ng-if=\"(stc.successStoryImage.photo != false) || stc.successStoryImage.image\">Added Success Story Image: <img ng-if=\"!stc.successStoryImage.photo\" ng-src=\"{{main.imageUrl}}{{stc.successStoryImage.image}}\" width=\"50\" height=\"50\"> <img ng-if=\"stc.successStoryImage.photo\" ngf-src=\"stc.successStoryImage.photo\" width=\"50\" height=\"50\"></div><div ng-if=\"!stc.successStoryImage.photo && !stc.successStoryImage.image\">Add Success Story Image: <img ngf-src=\"stc.successStoryImage.photo\" width=\"50\" height=\"50\" alt=\"No File\"></div><div class=\"ml20\" type=\"file\" ngf-select=\"stc.afterResizingImages($files)\" ngf-max-files=\"1\" ng-model=\"stc.successStoryImage.photo\" ngf-resize=\"{width: 500, height: 500, quality: .8}\" ngf-resize-if=\"{width: 500, height: 500}\" ngf-accept=\"\'image/*\'\" ngf-validate=\"{size: {max: \'20MB\', min: \'10kb\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'5m\'}}\" ngf-pattern=\"\'.jpeg,.jpg,.png\'\" ngf-before-model-change=\"stc.beforeResizingImages($files)\" ngf-fix-orientation=\"true\"><span class=\"btn-small btn-primary cursor_default\" ng-if=\"!(stc.successStoryImage.photo) && !(stc.successStoryImage.image)\">Select image <input type=\"file\" ng-model=\"stc.successStoryImage.to\" name=\"{{stc.successStoryImage.name}}\" style=\"display: none; position: absolute;\" required=\"\"></span> <span class=\"btn-small btn-primary cursor_default prt7\" ng-if=\"stc.successStoryImage.photo || stc.successStoryImage.image\" ng-click=\"stc.successStoryImage.photo=\'\';\">Remove and Change</span></div></div><div ng-messages=\"successStoryForm.image3.$error\" ng-if=\"successStoryForm.$submitted\" role=\"alert\"><span class=\"error\" ng-message=\"required\">Success Story Image is compulsory.</span></div><div class=\"load\" dw-loading=\"successStoryBtn\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-cornered md-primary btn-new mt10\" type=\"submit\">Save</md-button></div></form></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/notification/notification.html","<div ng-cloak=\"\" class=\"notification\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-content dw-loading=\"notification\" class=\"md-padding mh-120\" flex=\"50\" layout-align=\"center start\" layout=\"row\" layout-wrap=\"\"><div flex=\"40\" ng-if=\"nc.notifications.length == 0\"><h1>No Notifications are there</h1></div><div flex=\"70\" dir-paginate=\"notification in nc.notifications | itemsPerPage: nc.pageSize\" total-items=\"nc.totalNotifications\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\"><a ng-click=\"hmc.changePathFromNotification(\'home.profile\', notification.fromProfileInfo.profileName, notification.fromProfileInfo.matrimonyId, {matrimonyId: notification.fromProfileInfo.matrimonyId, shopId: notification.fromProfileInfo.shopId}, notification.id, notification.viewed, notification.notificationInvalid)\">{{notification.fromProfileInfo.profileName}}</a></span> <span class=\"md-subhead\">{{notification.fromProfileInfo.matrimonyId}}</span> <span class=\"md-caption\" ng-if=\"!notification.notificationInvalid\">{{notification.statusMsg}}</span></md-card-title-text><md-card-title-media><div class=\"card-media\" ng-if=\"!notification.notificationInvalid\"><img ng-src=\"{{main.imageUrl}}{{notification.fromProfileInfo.profileImages[0].originalImage}}\" width=\"100\" height=\"100\" alt=\"Washed Out\"></div><div class=\"card-media\" ng-if=\"notification.notificationInvalid && main.currentSession.profileBasicInfo.gender == \'Male\'\"><img src=\"../assets/images/female-profile-deleted.gif\" width=\"100\" height=\"100\" alt=\"Washed Out\"></div><div class=\"card-media\" ng-if=\"notification.notificationInvalid && main.currentSession.profileBasicInfo.gender == \'Female\'\"><img src=\"../assets/images/male-profile-deleted.gif\" width=\"100\" height=\"100\" alt=\"Washed Out\"></div></md-card-title-media></md-card-title><md-card-content layout=\"column\"><div ng-if=\"!notification.notificationInvalid\"><span class=\"col1\">Age:</span><span class=\"col2\" ng-bind=\"main.getAge(notification.fromProfileInfo.dob)\"></span> <span class=\"col1\">Height:</span><span class=\"col2\">{{::notification.fromProfileInfo.height.value}},</span> <span class=\"col1\">Caste:</span><span class=\"col2\">{{::notification.fromProfileInfo.caste}} ,</span> <span class=\"col1\">Sub Caste:</span><span class=\"col2\">{{::notification.fromProfileInfo.subCaste}},</span> <span class=\"col1\">Hightest Education:</span><span class=\"col2\">{{::notification.fromProfileInfo.highestEducation}},</span> <span class=\"col1\">Working as:</span><span class=\"col2\">{{::notification.fromProfileInfo.occupation}},</span> <span ng-if=\"notification.fromProfileInfo.annualIncome\"><span class=\"col1\">Annual Income:</span> <span class=\"col2\" ng-bind=\"main.getFormatAmount(notification.fromProfileInfo.annualIncome)\"></span> <span>,</span></span> <span class=\"col1\" ng-if=\"notification.fromProfileInfo.currentLivingCountry\"><span>Current Working in Country:</span><span class=\"col2\">{{::notification.fromProfileInfo.currentLivingCountry}},</span></span> <span class=\"col1\" ng-if=\"notification.fromProfileInfo.currentLivingState\"><span>Current Working in State:</span><span class=\"col2\">{{::notification.fromProfileInfo.currentLivingState}},</span></span> <span class=\"col1\" ng-if=\"notification.fromProfileInfo.currentLivingCity\"><span>Current Working in City/Near City:</span><span class=\"col2\">{{::notification.fromProfileInfo.currentLivingCity}},</span></span> <span class=\"col1\">Ancestral Origin:</span><span class=\"col2\">{{::notification.fromProfileInfo.ancestralOrigin}}</span></div><div ng-if=\"notification.notificationInvalid && main.currentSession.profileBasicInfo.gender == \'Male\'\"><span class=\"col1\">This Member ({{notification.fromProfileInfo.matrimonyId}}) has deleted her profile</span></div><div ng-if=\"notification.notificationInvalid && main.currentSession.profileBasicInfo.gender == \'Female\'\"><span class=\"col1\">This Member ({{notification.fromProfileInfo.matrimonyId}}) has deleted his profile</span></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end end\"><div ng-if=\"!notification.viewed\" class=\"cursor_pointer\"><i class=\"material-icons md-24 icon-color\" ng-click=\"nc.updateNotificationById(notification.id)\">visibility</i><md-tooltip md-direction=\"right\">Mark as Read</md-tooltip></div><div ng-if=\"notification.viewed\"><i class=\"material-icons md-24 icon-color\">visibility_off</i><md-tooltip md-direction=\"right\">Read</md-tooltip></div></md-card-actions></md-card></div><div flex=\"80\" layout=\"row\" layout-align=\"center start\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"nc.pageChangeHandler(newPageNumber)\" template-url=\"app/components/pagination/dirPagination.tpl.html\"></dir-pagination-controls></div></md-content></div>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=\"row\" layout-align=\"center center\"><md-button href=\"https://github.com/Swiip/generator-gulp-angular\">Gulp Angular</md-button><section flex=\"\" layout=\"row\" layout-align=\"left center\"><md-button href=\"#\" class=\"md-raised\">Home</md-button><md-button href=\"#\" class=\"md-raised\">About</md-button><md-button href=\"#\" class=\"md-raised\">Contact</md-button></section><md-button class=\"acme-navbar-text\">Application was created {{ vm.relativeDate }}.</md-button></md-toolbar>");
$templateCache.put("app/components/pagination/dirPagination.tpl.html","<ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\">&raquo;</a></li></ul>");
$templateCache.put("app/components/pagination/withOutPageNoPagination.tpl.html","<ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li></ul>");
$templateCache.put("app/shopDashBoard/contactNoIssue/contactNoIssue.html","<div ng-controller=\"contactNoIssueController as cnisc\"><md-toolbar><div flex=\"\" class=\"md-toolbar-tools\"><span flex=\"40\" class=\"F12\">Pending For Validation</span> <span flex=\"40\" class=\"F12\">Invalid Issue</span> <span flex=\"40\" class=\"F12\">Valid Issue</span></div></md-toolbar><md-content flex=\"\" class=\"mh-120 load layout-padding contact-issue-dashboard\" dw-loading=\"contactNoIssues\" layout=\"column\"><div infinite-scroll-container=\'\".contact-issue-dashboard\"\' infinite-scroll-parent=\"true\" infinite-scroll=\"contactNoIssueInfo.nextPage()\" infinite-scroll-disabled=\"contactNoIssueInfo.busy\" infinite-scroll-distance=\"3\"><div layout=\"\" ng-repeat=\"issue in cnisc.contactNoIssues\"><div flex=\"30\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"issue.issueStatus.indexOf(\'Pending For Validation\') > -1\"><div layout=\"\" layout-align=\"center center\"><span><img ng-src=\"{{::main.imageUrl}}{{::issue.fromProfileImageUrl}}\" width=\"100\" height=\"100\"></span> <span class=\"pl50 w-130px\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::issue.toProfileImageUrl}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" flex=\"100\" class=\"F14\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.fromMatrimonyId)\"><a>{{::issue.fromMatrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.fromMatrimonyId)\"><a>{{::issue.fromProfileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, issue.fromShopId)\"><a>{{::issue.fromShopName}}</a></span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.toMatrimonyId)\"><a>{{::issue.toMatrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.toMatrimonyId)\"><a>{{::issue.toProfileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, issue.toShopId)\"><a>{{::issue.toShopName}}</a></span></div></div><div layout=\"column\"><h5>{{::issue.issueType}}</h5><h6><span ng-bind-html=\"issue.toContactNumber\"></span></h6></div><div layout=\"\"><p class=\"padding10 date_time_format md-caption\">{{issue.updatedDate | date:\"dd MMMM yyyy \'at\' h:mma\"}}</p></div></md-whiteframe></div><div flex=\"30\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"issue.issueStatus.indexOf(\'Invalid Issue\') > -1\"><div layout=\"\" layout-align=\"center center\"><span><img ng-src=\"{{::main.imageUrl}}{{::issue.fromProfileImageUrl}}\" width=\"100\" height=\"100\"></span> <span class=\"pl50 w-130px\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::issue.toProfileImageUrl}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" flex=\"100\" class=\"F14\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.fromMatrimonyId)\"><a>{{::issue.fromMatrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.fromMatrimonyId)\"><a>{{::issue.fromProfileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, issue.fromShopId)\"><a>{{::issue.fromShopName}}</a></span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.toMatrimonyId)\"><a>{{::issue.toMatrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.toMatrimonyId)\"><a>{{::issue.toProfileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, issue.toShopId)\"><a>{{::issue.toShopName}}</a></span></div></div><div layout=\"column\"><h5>{{::issue.issueType}}</h5><h6>{{::issue.msg}}</h6><h6><span ng-bind-html=\"issue.toContactNumber\"></span></h6></div><div layout=\"\"><h5>we have verified, {{::issue.toProfileName}} mobile number is valid</h5></div><div layout=\"\"><p class=\"padding10 date_time_format md-caption\">{{issue.updatedDate | date:\"dd MMMM yyyy \'at\' h:mma\"}}</p></div></md-whiteframe></div><div flex=\"30\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"issue.issueStatus.indexOf(\'Valid Issue\') > -1\"><div layout=\"\" layout-align=\"center center\"><span><img ng-src=\"{{::main.imageUrl}}{{::issue.fromProfileImageUrl}}\" width=\"100\" height=\"100\"></span> <span class=\"pl50 w-130px\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::issue.toProfileImageUrl}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" flex=\"100\" class=\"F14\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.fromMatrimonyId)\"><a>{{::issue.fromMatrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.fromMatrimonyId)\"><a>{{::issue.fromProfileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, issue.fromShopId)\"><a>{{::issue.fromShopName}}</a></span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.toMatrimonyId)\"><a>{{::issue.toMatrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, issue.toMatrimonyId)\"><a>{{::issue.toProfileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, issue.toShopId)\"><a>{{::issue.toShopName}}</a></span></div></div><div layout=\"column\"><h5>{{::issue.issueType}}</h5><h6>{{::issue.msg}}</h6><h6><span ng-bind-html=\"issue.toContactNumber\"></span></h6></div><div layout=\"\"><h5>contact number ({{::issue.credit}}) added to <b>{{::issue.fromProfileName}}</b> package plan</h5></div><div layout=\"\"><p class=\"padding10 date_time_format md-caption\">{{issue.updatedDate | date:\"dd MMMM yyyy \'at\' h:mma\"}}</p></div></md-whiteframe></div></div></div></md-content></div><script type=\"text/ng-template\" id=\"contact-no-issue-status-change.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"50\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Change Contact Number Issue Status</h2> </div> </md-toolbar> <md-dialog-content layout-padding> <form name=\"reportIssueForm\" novalidate=\"novalidate\" autocomplete=\"off\"> <div class=\"md-dialog-content\"> <div layout=\"\"> <md-input-container class=\"md-block\" flex-gt-sm=\"\"> <label>Issue Status</label> <md-select name=\"issueReason\" required ng-model=\"dc.type\"> <md-option ng-repeat=\"item in cnisc.profileInterestTemplate.contactNumberIssueStatusOptions\" value=\"{{item.code}}\"> {{item.code}} </md-option> </md-select> </md-input-container> </div> <div ng-if=\"reportIssueForm.issueReason.$error || reportIssueForm.$submitted\" role=\"alert\"> <span class=\"error\" ng-show=\"reportIssueForm.issueReason.$error.required\">Please select issue reason</span> </div> <div layout=\"\"> <md-input-container class=\"md-block\" flex-gt-sm=\"\"> <label>Write more about issue</label> <textarea ng-model=\"dc.msg\" md-maxlength=\"800\" maxlength=\"800\"></textarea> </md-input-container> </div> </div> </form> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> Cancel </md-button> <md-button ng-if=\"!pc.reportIssue\" ng-click=\"updateContactNumberIssue(dc.type, dc.msg)\" class=\"md-primary\"> Submit </md-button> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/shopDashBoard/knowMoreInfo/knowMoreInfo.html","<div ng-controller=\"KnowMoreInfoController as kmc\"><md-content flex=\"\" class=\"mh-120 load layout-padding\" dw-loading=\"knowMoreInfoInterests\" layout=\"column\" infinite-scroll=\"knowMoreInfo.nextPage()\" infinite-scroll-disabled=\"knowMoreInfo.busy\"><div layout=\"\"><div flex=\"40\">Asking To Call</div><div flex=\"40\">Call Request Completed</div></div><div layout=\"\" ng-repeat=\"interest in kmc.knowMoreInfoInterests\"><div flex=\"40\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].id==\'1200\'\"><div layout=\"\" layout-align=\"center start\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromMatrimonyId==interest[\'fromProfile\'].matrimonyId\"><span><img ng-src=\"{{::main.imageUrl}}{{::interest.fromProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::interest.toProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromMatrimonyId!=interest[\'fromProfile\'].matrimonyId\"><span><img ng-src=\"{{::main.imageUrl}}{{::interest.toProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::interest.fromProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span></div><div layout=\"column\" flex=\"100\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromMatrimonyId==interest[\'fromProfile\'].matrimonyId\"><div layout=\"\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.fromProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.fromProfile.profileName}}</span> <span class=\"text-center\">{{::interest.fromProfile.shopName}}</span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.toProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.toProfile.profileName}}</span> <span class=\"text-center\">{{::interest.toProfile.shopName}}</span></div></div><div class=\"F12 mt5\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && (interest.fromProfile.matrimonyId.indexOf(interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].toMatrimonyId) > -1 && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1) )\">{{::interest.fromProfile.profileName}} has raised a Call Request to their Marriage Bureau regarding {{::interest.toProfile.profileName}}.</div></div><div layout=\"column\" flex=\"100\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromMatrimonyId !=interest[\'fromProfile\'].matrimonyId\"><div layout=\"\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.toProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.toProfile.profileName}}</span> <span class=\"text-center\">{{::interest.toProfile.shopName}}</span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.fromProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.fromProfile.profileName}}</span> <span class=\"text-center\">{{::interest.fromProfile.shopName}}</span></div></div><div class=\"F12 mt5\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && (interest.toProfile.matrimonyId.indexOf(interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].toMatrimonyId) > -1 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1))\">{{::interest.toProfile.profileName}} has raised a Call Request to their Marriage Bureau regarding {{::interest.fromProfile.profileName}}.</div></div><div layout=\"\" layout-align=\"center center\"><ul><li class=\"attributes\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && ((interest.fromProfile.matrimonyId.indexOf(interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromMatrimonyId) > -1 && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1) || (interest.toProfile.matrimonyId.indexOf(interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromMatrimonyId) > -1 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1))\"><span class=\"col1\">I Expect Call to this Mobile Number</span> <span class=\"col2\">{{::interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].msg}}</span></li><li class=\"attributes\"><span class=\"col1\">Interest Created On</span> <span class=\"col2\">{{::interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].createdOn | date:\'medium\'}}</span></li><li><span></span></li></ul></div><div ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\" ng-repeat=\"option in kmc.profileInterestTemplate.interestStatusOptions | statusFilter: [1600]\"><md-button class=\"md-hue-3\" ng-click=\"kmc.updateKnowMoreInfo(option, interest)\"><span><i class=\"material-icons md-24 prt5\">record_voice_over</i></span> <span class=\"col2\">click here to say {{::option.shortCode}}</span></md-button></div></md-whiteframe></div><div flex=\"40\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].id==\'1600\'\"><div layout=\"\" layout-align=\"center start\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromProfileId==interest[\'fromProfile\'].id\"><span><img ng-src=\"{{::main.imageUrl}}{{::interest.fromProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::interest.toProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromProfileId!=interest[\'fromProfile\'].id\"><span><img ng-src=\"{{::main.imageUrl}}{{::interest.toProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::interest.fromProfile.profileImages[0].originalImage}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" flex=\"100\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromProfileId==interest[\'fromProfile\'].id\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.fromProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.fromProfile.profileName}}</span> <span class=\"text-center\">{{::interest.fromProfile.shopName}}</span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.toProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.toProfile.profileName}}</span> <span class=\"text-center\">{{::interest.toProfile.shopName}}</span></div></div><div layout=\"\" flex=\"100\" ng-show=\"interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].fromProfileId!=interest[\'fromProfile\'].id\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.toProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.toProfile.profileName}}</span> <span class=\"text-center\">{{::interest.toProfile.shopName}}</span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center\">{{::interest.fromProfile.matrimonyId}}</span> <span class=\"text-center\">{{::interest.fromProfile.profileName}}</span> <span class=\"text-center\">{{::interest.fromProfile.shopName}}</span></div></div><div layout=\"\" layout-align=\"center center\"><ul><li class=\"attributes\"><span class=\"col1\">I Expect Call to this Mobile Number</span> <span class=\"col2\">{{::interest.moreInfoRequestStatus.msg}}</span></li><li class=\"attributes\"><span class=\"col1\">Interest Created On</span> <span class=\"col2\">{{::interest.moreInfoRequestStatus[interest.moreInfoRequestStatus.length-1].createdOn | date:\'medium\'}}</span></li></ul></div><div ng-repeat=\"option in kmc.profileInterestTemplate.interestStatusOptions | statusFilter: [1600]\"><md-button class=\"md-hue-3\" ng-disable=\"true\"><span><i class=\"material-icons md-24 prt5\">done_all</i></span> <span class=\"col2\">{{::option.shortCode}}</span></md-button></div></md-whiteframe></div></div></md-content></div>");
$templateCache.put("app/shopDashBoard/mobileNoInfo/mobileNoInfo.html","<div ng-controller=\"MobileNoInfoController as mni\"><md-toolbar><div flex=\"\" class=\"md-toolbar-tools\"><span flex=\"40\" class=\"F12\">Mobile Number Request</span> <span flex=\"40\" class=\"F12\">Mobile Number Sent</span></div></md-toolbar><md-content flex=\"\" class=\"mh-120 load layout-padding mob-dashboard\" dw-loading=\"mobileNoInfoInterests\" layout=\"column\"><div infinite-scroll-container=\'\".mob-dashboard\"\' infinite-scroll-parent=\"true\" infinite-scroll=\"mobileNoInfo.nextPage()\" infinite-scroll-disabled=\"mobileNoInfo.busy\" infinite-scroll-distance=\"3\"><div layout=\"\" ng-repeat=\"interest in mni.mobileNoInfoInterests\"><div flex=\"40\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"interest.mobileNoRequestStatus[interest.mobileNoRequestStatus.length-1].id==\'1300\'\"><div layout=\"\" layout-align=\"center center\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"pl50 w-130px\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" flex=\"100\" class=\"F14\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span></div></div><div ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.id.indexOf(interest.toProfile.shopId) > -1\" flex=\"\" layout=\"\" layout-align=\"center center\" ng-repeat=\"option in mni.profileInterestTemplate.interestStatusOptions | statusFilter: [1700]\"><md-button type=\"submit\" class=\"md-hue-3\" ng-disable=\"true\" ng-click=\"mni.updateMobileNoInfo(option, interest)\"><span><i class=\"material-icons md-24 prt5\">send</i></span> <span class=\"col2\">click here to say {{::option.shortCode}}</span></md-button></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && !main.currentSession.shop.anchepedheMarriageBureau && interest.toProfile.memberType.indexOf(\'APW Member\') > -1\"><span class=\"col2\">Waiting for Anchepedhe Matrimony to send {{::interest.toProfile.profileName}} contact information to {{::interest.fromProfile.profileName}}.</span></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\')\"><span class=\"col2\">Waiting for <span ng-if=\"interest.toProfile.memberType.indexOf(\'APW Member\') > -1\">Anchepedhe Matrimony to send</span> <span ng-if=\"interest.toProfile.memberType.indexOf(\'APW Member\') < 0\">your marriage bureau to send</span> {{::interest.toProfile.profileName}} contact information to {{::interest.fromProfile.profileName}}.</span></div><div layout=\"\" layout-align=\"center center\"><ul><li class=\"attributes\"><span class=\"col1\">Interest Created On</span> <span class=\"col2 date_time_format\">{{interest.mobileNoRequestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"((main.currentSession.roles.includes(\'ROLE_USER\') && interest.fromProfile.matrimonyId.indexOf(main.currentSession.profileBasicInfo.matrimonyId) < 0) || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && interest.mobileNoRequestStatus[0].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></span></li></ul></div></md-whiteframe></div><div flex=\"40\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" layout-align=\"space-around\" ng-if=\"interest.mobileNoRequestStatus[interest.mobileNoRequestStatus.length-1].id==\'1700\' || interest.mobileNoRequestStatus[interest.mobileNoRequestStatus.length-1].id==\'2600\'\"><div layout=\"\" layout-align=\"center center\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"pl50 w-130px\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" flex=\"100\" class=\"F14\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, interest.toProfile.shopId, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, interest.toProfile.shopId, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span></div></div><div layout=\"\" layout-align=\"center center\"><ul><li class=\"attributes F12\"><span ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.id == interest.toProfile.shopId)\" ng-bind-html=\"interest.mobileNoRequestStatus[interest.mobileNoRequestStatus.length-1].msg\"></span></li><li class=\"attributes\"><span class=\"col1\">Interest Created On</span> <span class=\"col2 date_time_format\">{{interest.mobileNoRequestStatus[interest.mobileNoRequestStatus.length-1].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && interest.mobileNoRequestStatus[interest.mobileNoRequestStatus.length-1].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></span></li></ul></div><div ng-repeat=\"option in mni.profileInterestTemplate.interestStatusOptions | statusFilter: [1700] | statusFilter: [2600]\"><md-button class=\"md-hue-3\" ng-disable=\"true\"><span><i class=\"material-icons md-24 prt5\">done_all</i></span> <span class=\"col2\">{{::option.shortCode}}</span></md-button></div></md-whiteframe></div></div></div></md-content></div><script type=\"text/ng-template\" id=\"profile.tmpl.html\"><md-dialog aria-label=\"Profile\" flex> <div data-ng-include=\"\'app/profile/profile.html\'\"></div> </md-dialog></script><script type=\"text/ng-template\" id=\"shop.tmpl.html\"><md-dialog aria-label=\"Shop\" flex> <div flex data-ng-include=\"\'app/shop/shop.html\'\"></div> </md-dialog></script>");
$templateCache.put("app/shopDashBoard/profileInterestInfo/profileInterestInfo.html","<div class=\"profileInterestInfo\" ng-controller=\"ProfileInterestInfoController as piic\"><div><form layout=\"row\" class=\"reset-form\" name=\"searchByMatrimonyIDForm\" novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"piic.searchInterestByMatrimonyId()\"><div style=\"margin: 10px;\" layout=\"column\"><input placeholder=\"Enter From Matrimony ID\" style=\"width: 254px;text-transform: uppercase;margin: unset;\" class=\"textbox_sml\" name=\"fromMatrimonyId\" type=\"text\" ng-model=\"piic.fromMatrimonyId\" minlength=\"4\" maxlength=\"11\"><div ng-messages=\"searchByMatrimonyIDForm.fromMatrimonyId.$error\" ng-if=\"searchByMatrimonyIDForm.$submitted\"><div class=\"error\" ng-message=\"minlength\">Matrimony Id is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Matrimony Id is too long.</div></div></div><div style=\"margin: 10px;\" layout=\"column\"><input placeholder=\"Enter To Matrimony ID\" style=\"width: 254px;text-transform: uppercase;margin: unset;\" class=\"textbox_sml\" name=\"fromMatrimonyId\" type=\"text\" ng-model=\"piic.toMatrimonyId\" minlength=\"4\" maxlength=\"11\"><div ng-messages=\"searchByMatrimonyIDForm.toMatrimonyId.$error\" ng-if=\"searchByMatrimonyIDForm.$submitted\"><div class=\"error\" ng-message=\"minlength\">Matrimony Id is too short.</div><div class=\"error\" ng-message=\"md-maxlength\">Matrimony Id is too long.</div></div></div><div style=\"margin: 6px;\"><md-button class=\"md-raised md-cornered\" type=\"submit\" style=\"color: #ffff;background-color: #0CB863\">Submit</md-button></div><div style=\"margin: 6px;\"><md-button class=\"md-raised md-cornered md-cancel-button\" ng-click=\"piic.clearSearchInterestByMatrimonyId()\">Clear</md-button></div></form></div><md-toolbar><div flex=\"\" class=\"md-toolbar-tools\"><span flex=\"20\" class=\"F12\">Interest Sent</span> <span flex=\"20\" class=\"F12\">Interest Sender Information, Shared to Interest Receiver Marriage Bureau</span> <span flex=\"20\" class=\"F12\">Interest Sender Information, Shared to Interest Receiver By their Marriage Bureau</span> <span flex=\"20\" class=\"F12\">Interest Accepted</span> <span flex=\"20\" class=\"F12\">Interest Declined</span></div></md-toolbar><md-content class=\"mh-120 load constrained\" dw-loading=\"shopDashBoardInterests\" layout=\"column\"><div class=\"\" infinite-scroll-container=\'\".constrained\"\' infinite-scroll-parent=\"true\" infinite-scroll=\"profileInterest.nextPage()\" infinite-scroll-disabled=\"profileInterest.busy\"><div class=\"load\" dw-loading=\"updatingInterest\" dw-loading-options=\"{text: \'Updating Interest\',spinnerOptions: {}}\"><div layout=\"\" ng-repeat=\"interest in piic.profileInterests\" flex=\"\" style=\"overflow-x: hidden\"><div flex=\"20\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'700\'\"><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.fromProfile.dob)\"></span>, {{::interest.fromProfile.highestEducation}}</span> <span class=\"\">{{::interest.fromProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.toProfile.dob)\"></span>, {{::interest.toProfile.highestEducation}}</span> <span class=\"\">{{::interest.toProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div></div><div layout=\"\" layout-wrap=\"\" layout-align=\"space-between start\" class=\"mt5\"><p class=\"F10\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].msg && !interest.editInterestStatusMsg\">{{interest.interestStatus[interest.interestStatus.length-1].msg}} <span style=\"position: relative;top: -3px;\" class=\"cursor_pointer\" ng-click=\"interest.editInterestStatusMsg = !interest.editInterestStatusMsg\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1\"><i class=\"material-icons md-18 edit\">mode_edit</i></span></p></div><div class=\"mtm20\" ng-if=\"(!interest.interestStatus[interest.interestStatus.length-1].msg || interest.editInterestStatusMsg) && (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select placeholder=\"Select\" class=\"md-no-underline\" ng-model=\"interest.interestStatus[interest.interestStatus.length-1].msg\" ng-change=\"piic.updateInterestStatusMsg(interest.id, interest.interestStatus[interest.interestStatus.length-1]) ;interest.editInterestStatusMsg=false;\"><md-option ng-repeat=\"item in piic.profileInterestTemplate.reasonMessageTypeOptions.values | filter: {id: \'!\' + \'100\'} : true | filter: {id: \'!\' + \'200\'} : true | filter: {id: \'!\' + \'300\'} : true | filter: {id: \'!\' + \'400\'} : true | filter: {id: \'!\' + \'500\'} : true | filter: {id: \'!\' + \'1200\'} : true\" value=\"{{item.value}}\">{{item.value}}</md-option></md-select></md-input-container></div><div class=\"F12 mt5\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2100]\"><a ng-click=\"piic.updateProfileInterest(option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\">{{::option.shortCode}}</a></div><div class=\"F12 mt5\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && ((interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1 && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1) && (interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) < 0))\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [1900]\"><a ng-click=\"piic.updateProfileInterest(option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\">{{::option.shortCode}}</a></div><div class=\"F12 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2300]\"><span ng-click=\"piic.declineInterest($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div><div class=\"F12 mt5\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(interest.toProfile.shopId) < 0 && ((interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1 && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1) || (interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1))\"><span>Waiting For Interest Sender Marriage Bureau to Share Interest Sender Information</span></div><div class=\"F12 mt5\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && (main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1 || main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1)\"><span>Waiting For Interest Sender Marriage Bureau to Share Interest Sender Information</span></div><p class=\"padding10 date_time_format md-caption\">{{interest.interestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"(main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) < 0 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && interest.interestStatus[0].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></p></md-whiteframe></div><div style=\"position: relative;left: 40px;\" flex=\"20\"><md-whiteframe class=\"md-whiteframe-1dp\" layout=\"column\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'1900\'\" style=\"position: relative;left: -46px;\"><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.fromProfile.dob)\"></span>, {{::interest.fromProfile.highestEducation}}</span> <span class=\"\">{{::interest.fromProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.toProfile.dob)\"></span>, {{::interest.toProfile.highestEducation}}</span> <span class=\"\">{{::interest.toProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div></div><div layout=\"\" layout-wrap=\"\" layout-align=\"space-between start\" class=\"mt5 ml10\"><p class=\"F10\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].msg && !interest.editInterestStatusMsg\">{{interest.interestStatus[interest.interestStatus.length-1].msg}} <span style=\"position: relative;top: -3px;\" class=\"cursor_pointer\" ng-click=\"interest.editInterestStatusMsg = !interest.editInterestStatusMsg\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\"><i class=\"material-icons md-18 edit\">mode_edit</i></span></p></div><div class=\"mtm20\" ng-if=\"(!interest.interestStatus[interest.interestStatus.length-1].msg || interest.editInterestStatusMsg) && (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select placeholder=\"Select\" class=\"md-no-underline\" ng-model=\"interest.interestStatus[interest.interestStatus.length-1].msg\" ng-change=\"piic.updateInterestStatusMsg(interest.id, interest.interestStatus[interest.interestStatus.length-1]) ;interest.editInterestStatusMsg=false;\"><md-option ng-repeat=\"item in piic.profileInterestTemplate.reasonMessageTypeOptions.values | filter: {id: \'!\' + \'100\'} : true | filter: {id: \'!\' + \'200\'} : true | filter: {id: \'!\' + \'300\'} : true | filter: {id: \'!\' + \'400\'} : true | filter: {id: \'!\' + \'500\'} : true | filter: {id: \'!\' + \'1200\'} : true\" value=\"{{item.value}}\">{{item.value}}</md-option></md-select></md-input-container></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2000]\"><a ng-click=\"piic.updateProfileInterest(option, interest, interest.fromProfile.matrimonyId, interest.toProfile.matrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\">{{::option.shortCode}}</a></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || main.currentSession.roles.includes(\'ROLE_USER\')\"><span>Waiting For Interest Receiver Marriage Bureau to Share Interest Sender Information to Interest Receiver</span></div><div class=\"F12 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2400]\"><span ng-click=\"piic.declineInterest($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div><p class=\"padding10 date_time_format md-caption\">{{interest.interestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"(main.currentSession.roles.includes(\'ROLE_USER\') || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.id.indexOf(interest.interestStatus[0].fromShopId) < 0)) && interest.interestStatus[0].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></p></md-whiteframe></div><div style=\"position: relative;left: 70px;\" flex=\"20\"><md-whiteframe style=\"left: -72px;position: relative;\" class=\"md-whiteframe-1dp\" layout=\"column\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'2000\' || interest.interestStatus[interest.interestStatus.length-1].id==\'2100\'\"><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.fromProfile.dob)\"></span>, {{::interest.fromProfile.highestEducation}}</span> <span class=\"\">{{::interest.fromProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.toProfile.dob)\"></span>, {{::interest.toProfile.highestEducation}}</span> <span class=\"\">{{::interest.toProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div></div><div layout=\"\" layout-wrap=\"\" layout-align=\"space-between start\" class=\"mt5 ml10\"><p class=\"F10\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].msg && !interest.editInterestStatusMsg\">{{interest.interestStatus[interest.interestStatus.length-1].msg}} <span style=\"position: relative;top: -3px;\" class=\"cursor_pointer\" ng-click=\"interest.editInterestStatusMsg = !interest.editInterestStatusMsg\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\"><i class=\"material-icons md-18 edit\">mode_edit</i></span></p></div><div class=\"mtm20\" ng-if=\"(!interest.interestStatus[interest.interestStatus.length-1].msg || interest.editInterestStatusMsg) && (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select placeholder=\"Select\" class=\"md-no-underline\" ng-model=\"interest.interestStatus[interest.interestStatus.length-1].msg\" ng-change=\"piic.updateInterestStatusMsg(interest.id, interest.interestStatus[interest.interestStatus.length-1]) ;interest.editInterestStatusMsg=false;\"><md-option ng-repeat=\"item in piic.profileInterestTemplate.reasonMessageTypeOptions.values | filter: {id: \'!\' + \'100\'} : true | filter: {id: \'!\' + \'200\'} : true | filter: {id: \'!\' + \'300\'} : true | filter: {id: \'!\' + \'400\'} : true | filter: {id: \'!\' + \'500\'} : true | filter: {id: \'!\' + \'1200\'} : true\" value=\"{{item.value}}\">{{item.value}}</md-option></md-select></md-input-container></div><div class=\"F12 mt5 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) || (main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1)\"><span ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1\">Waiting For {{::interest.fromProfile.profileName}} Response</span> <span ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1\">Waiting For {{::interest.toProfile.profileName}} Response</span></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"main.currentSession.roles.includes(\'ROLE_USER\') && main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) > -1\"><span>Please respond to this interest by going to <a ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\" ng-click=\"piic.changePath(\'home.profile\', interest.fromProfile.profileName, interest.fromProfile.matrimonyId, {matrimonyId: interest.fromProfile.matrimonyId, shopId: interest.fromProfile.shopId})\">{{::interest.fromProfile.profileName}}</a> <a ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\" ng-click=\"piic.changePath(\'home.profile\', interest.toProfile.profileName, interest.toProfile.matrimonyId, {matrimonyId: interest.toProfile.matrimonyId, shopId: interest.toProfile.shopId})\">{{::interest.toProfile.profileName}}</a> profile.</span></div><div layout=\"\"><div class=\"F12 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) < 0 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2400]\"><span ng-click=\"piic.declineInterest($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div><div class=\"F10 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2300]\"><span ng-click=\"piic.declineInterest($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div><div class=\"F10 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2500]\"><span ng-click=\"piic.showInterestAcceptConfirm($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId, main.currentSession.shop.id, interest.toProfile.shopId)\"><span><i class=\"material-icons md-24 edit\">favorite</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div></div><p class=\"padding10 date_time_format md-caption\">{{interest.interestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"((main.currentSession.roles.includes(\'ROLE_USER\') && (interest.fromProfile.id.indexOf(main.currentSession.profileBasicInfo.id) > -1 || interest.toProfile.id.indexOf(main.currentSession.profileBasicInfo.id) > -1)) || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && main.currentSession.shop.id.indexOf(interest.interestStatus[0].fromShopId) < 0)) && interest.interestStatus[0].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></p></md-whiteframe></div><div style=\"position: relative;left: 80px;\" flex=\"20\"><md-whiteframe style=\"left: -92px;position: relative;\" class=\"md-whiteframe-1dp\" layout=\"column\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'900\' || interest.interestStatus[interest.interestStatus.length-1].id==\'2500\'\"><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.fromProfile.dob)\"></span>, {{::interest.fromProfile.highestEducation}}</span> <span class=\"\">{{::interest.fromProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.toProfile.dob)\"></span>, {{::interest.toProfile.highestEducation}}</span> <span class=\"\">{{::interest.toProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId.indexOf(interest.fromProfile.matrimonyId) > -1\"><span><span ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==2500\">(Marriage Bureau Behalf of)</span>{{::interest.fromProfile.profileName}} Accepted Interest. Further, Marriage Bureau will arrange Face to Face meeting.</span></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId.indexOf(interest.toProfile.matrimonyId) > -1\"><span><span ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==2500\">(Marriage Bureau Behalf of)</span>{{::interest.toProfile.profileName}} Accepted Interest. Further, Marriage Bureau will arrange Face to Face meeting.</span></div><div class=\"F10 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2300]\"><span ng-click=\"piic.declineInterest($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId)\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div><div class=\"F10 cursor_pointer mb10 ml10\" flex=\"\" layout=\"\" layout-wrap=\"\" ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) < 0 && interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1\" ng-repeat=\"option in piic.profileInterestTemplate.interestStatusOptions | statusFilter: [2400]\"><span ng-click=\"piic.declineInterest($event, option, interest, interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId, interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId)\"><span><i class=\"material-icons md-24 edit\">highlight_off</i></span> <span class=\"col2 F10\">{{::option.shortCode}}</span></span></div><p class=\"padding10 date_time_format md-caption\">{{interest.interestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"(main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) < 0 || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && ((interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 && (interest.interestStatus[interest.interestStatus.length-1].id == \'900\' || interest.interestStatus[interest.interestStatus.length-1].id == \'2500\')) || (interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 && interest.interestStatus[interest.interestStatus.length-1].id == \'900\') ))) && interest.interestStatus[0].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></p></md-whiteframe></div><div style=\"position: relative;left: 41px;\" flex=\"20\"><md-whiteframe style=\"position: relative;left: -49px;\" class=\"md-whiteframe-1dp\" layout=\"column\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'800\' || interest.interestStatus[interest.interestStatus.length-1].id==\'2300\' || interest.interestStatus[interest.interestStatus.length-1].id==\'2400\'\"><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div layout=\"\" layout-align=\"center start\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.toProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span> <span class=\"prt36\"><i class=\"material-icons md-24 edit\">arrow_forward</i></span> <span><img ng-src=\"{{::main.imageUrl}}{{::main.getImagePath(interest.fromProfile.profileImages[0].originalImage)}}\" width=\"100\" height=\"100\"></span></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.fromProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.fromProfile.dob)\"></span>, {{::interest.fromProfile.highestEducation}}</span> <span class=\"\">{{::interest.fromProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"\"><span ng-bind=\"main.getAge(interest.toProfile.dob)\"></span>, {{::interest.toProfile.highestEducation}}</span> <span class=\"\">{{::interest.toProfile.caste}}</span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div></div><div class=\"F12\" layout=\"\" flex=\"100\" ng-if=\"interest.toProfile.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].fromMatrimonyId) > -1\"><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.toProfile.matrimonyId)\"><a>{{::interest.toProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.toProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.toProfile.shopId)\"><a>{{::interest.toProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.toProfile, $event)\"></li></ul></div><div layout=\"column\" flex=\"50\" layout-align=\"center center\"><span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.matrimonyId}}</a></span> <span class=\"text-center cursor_pointer\" ng-click=\"showProfile($event, main.currentSession.shop.id, interest.fromProfile.matrimonyId)\"><a>{{::interest.fromProfile.profileName}}</a></span> <span class=\"text-center\" ng-click=\"(interest.fromProfile.shopId.indexOf(main.currentSession.shop.id) > -1 || (main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))) && showShop($event, interest.fromProfile.shopId)\"><a>{{::interest.fromProfile.shopName}}</a></span><ul ng-if=\"(main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\'))\"><li><img src=\"../assets/images/WhatsApp-icon.png\" width=\"30\" height=\"30\" alt=\"Washed Out\" ng-click=\"piic.shareProfile(interest.fromProfile, $event)\"></li></ul></div></div><div layout=\"\" layout-wrap=\"\" class=\"ml15\"><p class=\"F10\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].msg && !piic.editInterestStatusMsg\">{{interest.interestStatus[interest.interestStatus.length-1].msg}}</p></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId.indexOf(interest.fromProfile.matrimonyId) > -1\"><span>Sorry {{::interest.fromProfile.profileName}} has Declined Interest.</span></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'800\' && interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId.indexOf(interest.toProfile.matrimonyId) > -1\"><span>Sorry {{::interest.toProfile.profileName}} has Declined Interest.</span></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'2300\' && interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId.indexOf(interest.toProfile.matrimonyId) > -1\"><span>Sorry ({{::interest.fromProfile.profileName}}) Marriage Bureau has Declined Interest Sender Interest.</span></div><div class=\"F12\" flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" ng-if=\"interest.interestStatus[interest.interestStatus.length-1].id==\'2400\' && interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId.indexOf(interest.toProfile.matrimonyId) > -1\"><span>Sorry ({{::interest.toProfile.profileName}}) Marriage Bureau has Declined Interest Sender Interest.</span></div><p class=\"padding10 date_time_format md-caption\">{{interest.interestStatus[0].createdOn | date:\"dd MMMM yyyy \'at\' h:mma\"}} <span ng-if=\"(main.currentSession.profileBasicInfo.matrimonyId.indexOf(interest.interestStatus[interest.interestStatus.length-1].toMatrimonyId) < 0 || ((main.currentSession.roles.includes(\'ROLE_ADMIN\') || main.currentSession.roles.includes(\'ROLE_EMPLOYEE\')) && interest.interestStatus[interest.interestStatus.length-1].id != \'2300\' && interest.interestStatus[interest.interestStatus.length-1].id != \'2400\')) && interest.interestStatus[0].createdOn > hmc.notification.notificationPopUp.lastActive\"><img src=\"../assets/images/wpe786aff4.gif\" width=\"40\" height=\"40\"></span></p></md-whiteframe></div></div></div></div><div ng-show=\"profileInterest.busy\">Loading data...</div></md-content></div><script type=\"text/ng-template\" id=\"profile.tmpl.html\"><md-dialog aria-label=\"Profile\" flex> <div data-ng-include=\"\'app/profile/profile.html\'\"></div> </md-dialog></script><script type=\"text/ng-template\" id=\"shop.tmpl.html\"><md-dialog aria-label=\"Shop\" flex> <div flex data-ng-include=\"\'app/shop/shop.html\'\"></div> </md-dialog></script><script type=\"text/ng-template\" id=\"decline-interest.tmpl.html\"><md-dialog aria-label=\"List dialog\" flex=\"50\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Decline Interest</h2> </div> </md-toolbar> <md-dialog-content layout-padding> <form name=\"declineInterestForm\" novalidate=\"novalidate\" autocomplete=\"off\"> <div class=\"md-dialog-content\"> <div layout=\"\"> <md-input-container class=\"md-block\" flex-gt-sm=\"\"> <label>Decline Reason</label> <md-select name=\"declineReason\" required ng-model=\"dc.declineReason\"> <md-option ng-repeat=\"item in piic.profileInterestTemplate.reasonMessageTypeOptions.values | filter: {id: \'!\' + \'600\'} : true | filter: {id: \'!\' + \'700\'} : true | filter: {id: \'!\' + \'800\'} : true | filter: {id: \'!\' + \'900\'} : true | filter: {id: \'!\' + \'1000\'} : true | filter: {id: \'!\' + \'1100\'} : true\" value=\"{{item.value}}\"> {{item.value}} </md-option> </md-select> </md-input-container> </div> <div ng-if=\"declineInterestForm.declineReason.$error || declineInterestForm.$submitted\" role=\"alert\"> <span class=\"error\" ng-show=\"declineInterestForm.declineReason.$error.required\">Please select Decline Reason.</span> </div> </div> </form> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> Cancel </md-button> <md-button ng-click=\"declineInterest(dc.declineReason)\" class=\"md-primary\"> Decline Interest </md-button> </md-dialog-actions> </md-dialog></script>");}]);